import { defineComponent as ht, ref as Fe, onMounted as Ct, watch as Qn, createElementBlock as de, createCommentVNode as it, openBlock as ae, createElementVNode as j, createTextVNode as ft, computed as Sn, normalizeClass as Ce, toDisplayString as ce, normalizeStyle as Rl, unref as Na, getCurrentScope as l1, onScopeDispose as d1, watchEffect as f1, getCurrentInstance as h1, reactive as Pl, createBlock as Kn, Fragment as pt, renderList as Yr, shallowRef as Fl, h as ju, onUnmounted as b1, toRaw as Gu, nextTick as x1, version as m1, isProxy as Hl, createVNode as p1 } from "vue";
var ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rs(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function g1(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(s) {
    var r = Object.getOwnPropertyDescriptor(t, s);
    Object.defineProperty(n, s, r.get ? r : {
      enumerable: !0,
      get: function() {
        return t[s];
      }
    });
  }), n;
}
var Ul = { exports: {} };
(function(t, e) {
  (function(n, s) {
    t.exports = s();
  })(ie, function() {
    var n = 1e3, s = 6e4, r = 36e5, i = "millisecond", u = "second", a = "minute", o = "hour", c = "day", l = "week", f = "month", h = "quarter", x = "year", m = "date", p = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(P) {
      var R = ["th", "st", "nd", "rd"], F = P % 100;
      return "[" + P + (R[(F - 20) % 10] || R[F] || R[0]) + "]";
    } }, _ = function(P, R, F) {
      var V = String(P);
      return !V || V.length >= R ? P : "" + Array(R + 1 - V.length).join(F) + P;
    }, T = { s: _, z: function(P) {
      var R = -P.utcOffset(), F = Math.abs(R), V = Math.floor(F / 60), W = F % 60;
      return (R <= 0 ? "+" : "-") + _(V, 2, "0") + ":" + _(W, 2, "0");
    }, m: function P(R, F) {
      if (R.date() < F.date()) return -P(F, R);
      var V = 12 * (F.year() - R.year()) + (F.month() - R.month()), W = R.clone().add(V, f), K = F - W < 0, Q = R.clone().add(V + (K ? -1 : 1), f);
      return +(-(V + (F - W) / (K ? W - Q : Q - W)) || 0);
    }, a: function(P) {
      return P < 0 ? Math.ceil(P) || 0 : Math.floor(P);
    }, p: function(P) {
      return { M: f, y: x, w: l, d: c, D: m, h: o, m: a, s: u, ms: i, Q: h }[P] || String(P || "").toLowerCase().replace(/s$/, "");
    }, u: function(P) {
      return P === void 0;
    } }, C = "en", y = {};
    y[C] = g;
    var v = "$isDayjsObject", N = function(P) {
      return P instanceof B || !(!P || !P[v]);
    }, O = function P(R, F, V) {
      var W;
      if (!R) return C;
      if (typeof R == "string") {
        var K = R.toLowerCase();
        y[K] && (W = K), F && (y[K] = F, W = K);
        var Q = R.split("-");
        if (!W && Q.length > 1) return P(Q[0]);
      } else {
        var L = R.name;
        y[L] = R, W = L;
      }
      return !V && W && (C = W), W || !V && C;
    }, w = function(P, R) {
      if (N(P)) return P.clone();
      var F = typeof R == "object" ? R : {};
      return F.date = P, F.args = arguments, new B(F);
    }, S = T;
    S.l = O, S.i = N, S.w = function(P, R) {
      return w(P, { locale: R.$L, utc: R.$u, x: R.$x, $offset: R.$offset });
    };
    var B = function() {
      function P(F) {
        this.$L = O(F.locale, null, !0), this.parse(F), this.$x = this.$x || F.x || {}, this[v] = !0;
      }
      var R = P.prototype;
      return R.parse = function(F) {
        this.$d = function(V) {
          var W = V.date, K = V.utc;
          if (W === null) return /* @__PURE__ */ new Date(NaN);
          if (S.u(W)) return /* @__PURE__ */ new Date();
          if (W instanceof Date) return new Date(W);
          if (typeof W == "string" && !/Z$/i.test(W)) {
            var Q = W.match(b);
            if (Q) {
              var L = Q[2] - 1 || 0, Y = (Q[7] || "0").substring(0, 3);
              return K ? new Date(Date.UTC(Q[1], L, Q[3] || 1, Q[4] || 0, Q[5] || 0, Q[6] || 0, Y)) : new Date(Q[1], L, Q[3] || 1, Q[4] || 0, Q[5] || 0, Q[6] || 0, Y);
            }
          }
          return new Date(W);
        }(F), this.init();
      }, R.init = function() {
        var F = this.$d;
        this.$y = F.getFullYear(), this.$M = F.getMonth(), this.$D = F.getDate(), this.$W = F.getDay(), this.$H = F.getHours(), this.$m = F.getMinutes(), this.$s = F.getSeconds(), this.$ms = F.getMilliseconds();
      }, R.$utils = function() {
        return S;
      }, R.isValid = function() {
        return this.$d.toString() !== p;
      }, R.isSame = function(F, V) {
        var W = w(F);
        return this.startOf(V) <= W && W <= this.endOf(V);
      }, R.isAfter = function(F, V) {
        return w(F) < this.startOf(V);
      }, R.isBefore = function(F, V) {
        return this.endOf(V) < w(F);
      }, R.$g = function(F, V, W) {
        return S.u(F) ? this[V] : this.set(W, F);
      }, R.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, R.valueOf = function() {
        return this.$d.getTime();
      }, R.startOf = function(F, V) {
        var W = this, K = !!S.u(V) || V, Q = S.p(F), L = function(Ge, ve) {
          var Xe = S.w(W.$u ? Date.UTC(W.$y, ve, Ge) : new Date(W.$y, ve, Ge), W);
          return K ? Xe : Xe.endOf(c);
        }, Y = function(Ge, ve) {
          return S.w(W.toDate()[Ge].apply(W.toDate("s"), (K ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ve)), W);
        }, $ = this.$W, q = this.$M, ne = this.$D, re = "set" + (this.$u ? "UTC" : "");
        switch (Q) {
          case x:
            return K ? L(1, 0) : L(31, 11);
          case f:
            return K ? L(1, q) : L(0, q + 1);
          case l:
            var De = this.$locale().weekStart || 0, te = ($ < De ? $ + 7 : $) - De;
            return L(K ? ne - te : ne + (6 - te), q);
          case c:
          case m:
            return Y(re + "Hours", 0);
          case o:
            return Y(re + "Minutes", 1);
          case a:
            return Y(re + "Seconds", 2);
          case u:
            return Y(re + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, R.endOf = function(F) {
        return this.startOf(F, !1);
      }, R.$set = function(F, V) {
        var W, K = S.p(F), Q = "set" + (this.$u ? "UTC" : ""), L = (W = {}, W[c] = Q + "Date", W[m] = Q + "Date", W[f] = Q + "Month", W[x] = Q + "FullYear", W[o] = Q + "Hours", W[a] = Q + "Minutes", W[u] = Q + "Seconds", W[i] = Q + "Milliseconds", W)[K], Y = K === c ? this.$D + (V - this.$W) : V;
        if (K === f || K === x) {
          var $ = this.clone().set(m, 1);
          $.$d[L](Y), $.init(), this.$d = $.set(m, Math.min(this.$D, $.daysInMonth())).$d;
        } else L && this.$d[L](Y);
        return this.init(), this;
      }, R.set = function(F, V) {
        return this.clone().$set(F, V);
      }, R.get = function(F) {
        return this[S.p(F)]();
      }, R.add = function(F, V) {
        var W, K = this;
        F = Number(F);
        var Q = S.p(V), L = function(q) {
          var ne = w(K);
          return S.w(ne.date(ne.date() + Math.round(q * F)), K);
        };
        if (Q === f) return this.set(f, this.$M + F);
        if (Q === x) return this.set(x, this.$y + F);
        if (Q === c) return L(1);
        if (Q === l) return L(7);
        var Y = (W = {}, W[a] = s, W[o] = r, W[u] = n, W)[Q] || 1, $ = this.$d.getTime() + F * Y;
        return S.w($, this);
      }, R.subtract = function(F, V) {
        return this.add(-1 * F, V);
      }, R.format = function(F) {
        var V = this, W = this.$locale();
        if (!this.isValid()) return W.invalidDate || p;
        var K = F || "YYYY-MM-DDTHH:mm:ssZ", Q = S.z(this), L = this.$H, Y = this.$m, $ = this.$M, q = W.weekdays, ne = W.months, re = W.meridiem, De = function(ve, Xe, tt, Re) {
          return ve && (ve[Xe] || ve(V, K)) || tt[Xe].slice(0, Re);
        }, te = function(ve) {
          return S.s(L % 12 || 12, ve, "0");
        }, Ge = re || function(ve, Xe, tt) {
          var Re = ve < 12 ? "AM" : "PM";
          return tt ? Re.toLowerCase() : Re;
        };
        return K.replace(E, function(ve, Xe) {
          return Xe || function(tt) {
            switch (tt) {
              case "YY":
                return String(V.$y).slice(-2);
              case "YYYY":
                return S.s(V.$y, 4, "0");
              case "M":
                return $ + 1;
              case "MM":
                return S.s($ + 1, 2, "0");
              case "MMM":
                return De(W.monthsShort, $, ne, 3);
              case "MMMM":
                return De(ne, $);
              case "D":
                return V.$D;
              case "DD":
                return S.s(V.$D, 2, "0");
              case "d":
                return String(V.$W);
              case "dd":
                return De(W.weekdaysMin, V.$W, q, 2);
              case "ddd":
                return De(W.weekdaysShort, V.$W, q, 3);
              case "dddd":
                return q[V.$W];
              case "H":
                return String(L);
              case "HH":
                return S.s(L, 2, "0");
              case "h":
                return te(1);
              case "hh":
                return te(2);
              case "a":
                return Ge(L, Y, !0);
              case "A":
                return Ge(L, Y, !1);
              case "m":
                return String(Y);
              case "mm":
                return S.s(Y, 2, "0");
              case "s":
                return String(V.$s);
              case "ss":
                return S.s(V.$s, 2, "0");
              case "SSS":
                return S.s(V.$ms, 3, "0");
              case "Z":
                return Q;
            }
            return null;
          }(ve) || Q.replace(":", "");
        });
      }, R.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, R.diff = function(F, V, W) {
        var K, Q = this, L = S.p(V), Y = w(F), $ = (Y.utcOffset() - this.utcOffset()) * s, q = this - Y, ne = function() {
          return S.m(Q, Y);
        };
        switch (L) {
          case x:
            K = ne() / 12;
            break;
          case f:
            K = ne();
            break;
          case h:
            K = ne() / 3;
            break;
          case l:
            K = (q - $) / 6048e5;
            break;
          case c:
            K = (q - $) / 864e5;
            break;
          case o:
            K = q / r;
            break;
          case a:
            K = q / s;
            break;
          case u:
            K = q / n;
            break;
          default:
            K = q;
        }
        return W ? K : S.a(K);
      }, R.daysInMonth = function() {
        return this.endOf(f).$D;
      }, R.$locale = function() {
        return y[this.$L];
      }, R.locale = function(F, V) {
        if (!F) return this.$L;
        var W = this.clone(), K = O(F, V, !0);
        return K && (W.$L = K), W;
      }, R.clone = function() {
        return S.w(this.$d, this);
      }, R.toDate = function() {
        return new Date(this.valueOf());
      }, R.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, R.toISOString = function() {
        return this.$d.toISOString();
      }, R.toString = function() {
        return this.$d.toUTCString();
      }, P;
    }(), M = B.prototype;
    return w.prototype = M, [["$ms", i], ["$s", u], ["$m", a], ["$H", o], ["$W", c], ["$M", f], ["$y", x], ["$D", m]].forEach(function(P) {
      M[P[1]] = function(R) {
        return this.$g(R, P[0], P[1]);
      };
    }), w.extend = function(P, R) {
      return P.$i || (P(R, B, w), P.$i = !0), w;
    }, w.locale = O, w.isDayjs = N, w.unix = function(P) {
      return w(1e3 * P);
    }, w.en = y[C], w.Ls = y, w.p = {}, w;
  });
})(Ul);
var E1 = Ul.exports;
const ue = /* @__PURE__ */ rs(E1);
var Yl = { exports: {} };
(function(t, e) {
  (function(n, s) {
    t.exports = s();
  })(ie, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, s = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d/, i = /\d\d/, u = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, o = {}, c = function(b) {
      return (b = +b) + (b > 68 ? 1900 : 2e3);
    }, l = function(b) {
      return function(E) {
        this[b] = +E;
      };
    }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(b) {
      (this.zone || (this.zone = {})).offset = function(E) {
        if (!E || E === "Z") return 0;
        var g = E.match(/([+-]|\d\d)/g), _ = 60 * g[1] + (+g[2] || 0);
        return _ === 0 ? 0 : g[0] === "+" ? -_ : _;
      }(b);
    }], h = function(b) {
      var E = o[b];
      return E && (E.indexOf ? E : E.s.concat(E.f));
    }, x = function(b, E) {
      var g, _ = o.meridiem;
      if (_) {
        for (var T = 1; T <= 24; T += 1) if (b.indexOf(_(T, 0, E)) > -1) {
          g = T > 12;
          break;
        }
      } else g = b === (E ? "pm" : "PM");
      return g;
    }, m = { A: [a, function(b) {
      this.afternoon = x(b, !1);
    }], a: [a, function(b) {
      this.afternoon = x(b, !0);
    }], Q: [r, function(b) {
      this.month = 3 * (b - 1) + 1;
    }], S: [r, function(b) {
      this.milliseconds = 100 * +b;
    }], SS: [i, function(b) {
      this.milliseconds = 10 * +b;
    }], SSS: [/\d{3}/, function(b) {
      this.milliseconds = +b;
    }], s: [u, l("seconds")], ss: [u, l("seconds")], m: [u, l("minutes")], mm: [u, l("minutes")], H: [u, l("hours")], h: [u, l("hours")], HH: [u, l("hours")], hh: [u, l("hours")], D: [u, l("day")], DD: [i, l("day")], Do: [a, function(b) {
      var E = o.ordinal, g = b.match(/\d+/);
      if (this.day = g[0], E) for (var _ = 1; _ <= 31; _ += 1) E(_).replace(/\[|\]/g, "") === b && (this.day = _);
    }], w: [u, l("week")], ww: [i, l("week")], M: [u, l("month")], MM: [i, l("month")], MMM: [a, function(b) {
      var E = h("months"), g = (h("monthsShort") || E.map(function(_) {
        return _.slice(0, 3);
      })).indexOf(b) + 1;
      if (g < 1) throw new Error();
      this.month = g % 12 || g;
    }], MMMM: [a, function(b) {
      var E = h("months").indexOf(b) + 1;
      if (E < 1) throw new Error();
      this.month = E % 12 || E;
    }], Y: [/[+-]?\d+/, l("year")], YY: [i, function(b) {
      this.year = c(b);
    }], YYYY: [/\d{4}/, l("year")], Z: f, ZZ: f };
    function p(b) {
      var E, g;
      E = b, g = o && o.formats;
      for (var _ = (b = E.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(w, S, B) {
        var M = B && B.toUpperCase();
        return S || g[B] || n[B] || g[M].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(P, R, F) {
          return R || F.slice(1);
        });
      })).match(s), T = _.length, C = 0; C < T; C += 1) {
        var y = _[C], v = m[y], N = v && v[0], O = v && v[1];
        _[C] = O ? { regex: N, parser: O } : y.replace(/^\[|\]$/g, "");
      }
      return function(w) {
        for (var S = {}, B = 0, M = 0; B < T; B += 1) {
          var P = _[B];
          if (typeof P == "string") M += P.length;
          else {
            var R = P.regex, F = P.parser, V = w.slice(M), W = R.exec(V)[0];
            F.call(S, W), w = w.replace(W, "");
          }
        }
        return function(K) {
          var Q = K.afternoon;
          if (Q !== void 0) {
            var L = K.hours;
            Q ? L < 12 && (K.hours += 12) : L === 12 && (K.hours = 0), delete K.afternoon;
          }
        }(S), S;
      };
    }
    return function(b, E, g) {
      g.p.customParseFormat = !0, b && b.parseTwoDigitYear && (c = b.parseTwoDigitYear);
      var _ = E.prototype, T = _.parse;
      _.parse = function(C) {
        var y = C.date, v = C.utc, N = C.args;
        this.$u = v;
        var O = N[1];
        if (typeof O == "string") {
          var w = N[2] === !0, S = N[3] === !0, B = w || S, M = N[2];
          S && (M = N[2]), o = this.$locale(), !w && M && (o = g.Ls[M]), this.$d = function(V, W, K, Q) {
            try {
              if (["x", "X"].indexOf(W) > -1) return new Date((W === "X" ? 1e3 : 1) * V);
              var L = p(W)(V), Y = L.year, $ = L.month, q = L.day, ne = L.hours, re = L.minutes, De = L.seconds, te = L.milliseconds, Ge = L.zone, ve = L.week, Xe = /* @__PURE__ */ new Date(), tt = q || (Y || $ ? 1 : Xe.getDate()), Re = Y || Xe.getFullYear(), Ye = 0;
              Y && !$ || (Ye = $ > 0 ? $ - 1 : Xe.getMonth());
              var Ht, Ut = ne || 0, Qt = re || 0, Yt = De || 0, fn = te || 0;
              return Ge ? new Date(Date.UTC(Re, Ye, tt, Ut, Qt, Yt, fn + 60 * Ge.offset * 1e3)) : K ? new Date(Date.UTC(Re, Ye, tt, Ut, Qt, Yt, fn)) : (Ht = new Date(Re, Ye, tt, Ut, Qt, Yt, fn), ve && (Ht = Q(Ht).week(ve).toDate()), Ht);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(y, O, v, g), this.init(), M && M !== !0 && (this.$L = this.locale(M).$L), B && y != this.format(O) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
        } else if (O instanceof Array) for (var P = O.length, R = 1; R <= P; R += 1) {
          N[1] = O[R - 1];
          var F = g.apply(this, N);
          if (F.isValid()) {
            this.$d = F.$d, this.$L = F.$L, this.init();
            break;
          }
          R === P && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else T.call(this, C);
      };
    };
  });
})(Yl);
var _1 = Yl.exports;
const T1 = /* @__PURE__ */ rs(_1);
var ql = { exports: {} };
(function(t, e) {
  (function(n, s) {
    t.exports = s();
  })(ie, function() {
    var n = "minute", s = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(i, u, a) {
      var o = u.prototype;
      a.utc = function(p) {
        var b = { date: p, utc: !0, args: arguments };
        return new u(b);
      }, o.utc = function(p) {
        var b = a(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? b.add(this.utcOffset(), n) : b;
      }, o.local = function() {
        return a(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = o.parse;
      o.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), c.call(this, p);
      };
      var l = o.init;
      o.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else l.call(this);
      };
      var f = o.utcOffset;
      o.utcOffset = function(p, b) {
        var E = this.$utils().u;
        if (E(p)) return this.$u ? 0 : E(this.$offset) ? f.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(C) {
          C === void 0 && (C = "");
          var y = C.match(s);
          if (!y) return null;
          var v = ("" + y[0]).match(r) || ["-", 0, 0], N = v[0], O = 60 * +v[1] + +v[2];
          return O === 0 ? 0 : N === "+" ? O : -O;
        }(p), p === null)) return this;
        var g = Math.abs(p) <= 16 ? 60 * p : p, _ = this;
        if (b) return _.$offset = g, _.$u = p === 0, _;
        if (p !== 0) {
          var T = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (_ = this.local().add(g + T, n)).$offset = g, _.$x.$localOffset = T;
        } else _ = this.utc();
        return _;
      };
      var h = o.format;
      o.format = function(p) {
        var b = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return h.call(this, b);
      }, o.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, o.isUTC = function() {
        return !!this.$u;
      }, o.toISOString = function() {
        return this.toDate().toISOString();
      }, o.toString = function() {
        return this.toDate().toUTCString();
      };
      var x = o.toDate;
      o.toDate = function(p) {
        return p === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : x.call(this);
      };
      var m = o.diff;
      o.diff = function(p, b, E) {
        if (p && this.$u === p.$u) return m.call(this, p, b, E);
        var g = this.local(), _ = a(p).local();
        return m.call(g, _, b, E);
      };
    };
  });
})(ql);
var A1 = ql.exports;
const $l = /* @__PURE__ */ rs(A1);
var Wl = { exports: {} };
(function(t, e) {
  (function(n, s) {
    t.exports = s();
  })(ie, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, s = {};
    return function(r, i, u) {
      var a, o = function(h, x, m) {
        m === void 0 && (m = {});
        var p = new Date(h), b = function(E, g) {
          g === void 0 && (g = {});
          var _ = g.timeZoneName || "short", T = E + "|" + _, C = s[T];
          return C || (C = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: E, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: _ }), s[T] = C), C;
        }(x, m);
        return b.formatToParts(p);
      }, c = function(h, x) {
        for (var m = o(h, x), p = [], b = 0; b < m.length; b += 1) {
          var E = m[b], g = E.type, _ = E.value, T = n[g];
          T >= 0 && (p[T] = parseInt(_, 10));
        }
        var C = p[3], y = C === 24 ? 0 : C, v = p[0] + "-" + p[1] + "-" + p[2] + " " + y + ":" + p[4] + ":" + p[5] + ":000", N = +h;
        return (u.utc(v).valueOf() - (N -= N % 1e3)) / 6e4;
      }, l = i.prototype;
      l.tz = function(h, x) {
        h === void 0 && (h = a);
        var m, p = this.utcOffset(), b = this.toDate(), E = b.toLocaleString("en-US", { timeZone: h }), g = Math.round((b - new Date(E)) / 1e3 / 60), _ = 15 * -Math.round(b.getTimezoneOffset() / 15) - g;
        if (!Number(_)) m = this.utcOffset(0, x);
        else if (m = u(E, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(_, !0), x) {
          var T = m.utcOffset();
          m = m.add(p - T, "minute");
        }
        return m.$x.$timezone = h, m;
      }, l.offsetName = function(h) {
        var x = this.$x.$timezone || u.tz.guess(), m = o(this.valueOf(), x, { timeZoneName: h }).find(function(p) {
          return p.type.toLowerCase() === "timezonename";
        });
        return m && m.value;
      };
      var f = l.startOf;
      l.startOf = function(h, x) {
        if (!this.$x || !this.$x.$timezone) return f.call(this, h, x);
        var m = u(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return f.call(m, h, x).tz(this.$x.$timezone, !0);
      }, u.tz = function(h, x, m) {
        var p = m && x, b = m || x || a, E = c(+u(), b);
        if (typeof h != "string") return u(h).tz(b);
        var g = function(y, v, N) {
          var O = y - 60 * v * 1e3, w = c(O, N);
          if (v === w) return [O, v];
          var S = c(O -= 60 * (w - v) * 1e3, N);
          return w === S ? [O, w] : [y - 60 * Math.min(w, S) * 1e3, Math.max(w, S)];
        }(u.utc(h, p).valueOf(), E, b), _ = g[0], T = g[1], C = u(_).utcOffset(T);
        return C.$x.$timezone = b, C;
      }, u.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, u.tz.setDefault = function(h) {
        a = h;
      };
    };
  });
})(Wl);
var y1 = Wl.exports;
const zl = /* @__PURE__ */ rs(y1);
var me;
(function(t) {
  t.Root = "root", t.Text = "text", t.Directive = "directive", t.Comment = "comment", t.Script = "script", t.Style = "style", t.Tag = "tag", t.CDATA = "cdata", t.Doctype = "doctype";
})(me || (me = {}));
function C1(t) {
  return t.type === me.Tag || t.type === me.Script || t.type === me.Style;
}
const Ia = me.Root, Vl = me.Text, D1 = me.Directive, jl = me.Comment, v1 = me.Script, S1 = me.Style, Xu = me.Tag, w1 = me.CDATA, N1 = me.Doctype;
class Gl {
  constructor() {
    this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
  }
  // Read-write aliases for properties
  /**
   * Same as {@link parent}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get parentNode() {
    return this.parent;
  }
  set parentNode(e) {
    this.parent = e;
  }
  /**
   * Same as {@link prev}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get previousSibling() {
    return this.prev;
  }
  set previousSibling(e) {
    this.prev = e;
  }
  /**
   * Same as {@link next}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nextSibling() {
    return this.next;
  }
  set nextSibling(e) {
    this.next = e;
  }
  /**
   * Clone this node, and optionally its children.
   *
   * @param recursive Clone child nodes as well.
   * @returns A clone of the node.
   */
  cloneNode(e = !1) {
    return Ws(this, e);
  }
}
class Oa extends Gl {
  /**
   * @param data The content of the data node
   */
  constructor(e) {
    super(), this.data = e;
  }
  /**
   * Same as {@link data}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get nodeValue() {
    return this.data;
  }
  set nodeValue(e) {
    this.data = e;
  }
}
class $s extends Oa {
  constructor() {
    super(...arguments), this.type = me.Text;
  }
  get nodeType() {
    return 3;
  }
}
class Ba extends Oa {
  constructor() {
    super(...arguments), this.type = me.Comment;
  }
  get nodeType() {
    return 8;
  }
}
class ka extends Oa {
  constructor(e, n) {
    super(n), this.name = e, this.type = me.Directive;
  }
  get nodeType() {
    return 1;
  }
}
class La extends Gl {
  /**
   * @param children Children of the node. Only certain node types can have children.
   */
  constructor(e) {
    super(), this.children = e;
  }
  // Aliases
  /** First child of the node. */
  get firstChild() {
    var e;
    return (e = this.children[0]) !== null && e !== void 0 ? e : null;
  }
  /** Last child of the node. */
  get lastChild() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : null;
  }
  /**
   * Same as {@link children}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get childNodes() {
    return this.children;
  }
  set childNodes(e) {
    this.children = e;
  }
}
class Xl extends La {
  constructor() {
    super(...arguments), this.type = me.CDATA;
  }
  get nodeType() {
    return 4;
  }
}
class wn extends La {
  constructor() {
    super(...arguments), this.type = me.Root;
  }
  get nodeType() {
    return 9;
  }
}
let Ma = class extends La {
  /**
   * @param name Name of the tag, eg. `div`, `span`.
   * @param attribs Object mapping attribute names to attribute values.
   * @param children Children of the node.
   */
  constructor(e, n, s = [], r = e === "script" ? me.Script : e === "style" ? me.Style : me.Tag) {
    super(s), this.name = e, this.attribs = n, this.type = r;
  }
  get nodeType() {
    return 1;
  }
  // DOM Level 1 aliases
  /**
   * Same as {@link name}.
   * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
   */
  get tagName() {
    return this.name;
  }
  set tagName(e) {
    this.name = e;
  }
  get attributes() {
    return Object.keys(this.attribs).map((e) => {
      var n, s;
      return {
        name: e,
        value: this.attribs[e],
        namespace: (n = this["x-attribsNamespace"]) === null || n === void 0 ? void 0 : n[e],
        prefix: (s = this["x-attribsPrefix"]) === null || s === void 0 ? void 0 : s[e]
      };
    });
  }
};
function ee(t) {
  return C1(t);
}
function di(t) {
  return t.type === me.CDATA;
}
function Pt(t) {
  return t.type === me.Text;
}
function fi(t) {
  return t.type === me.Comment;
}
function Qu(t) {
  return t.type === me.Directive;
}
function cn(t) {
  return t.type === me.Root;
}
function Me(t) {
  return Object.prototype.hasOwnProperty.call(t, "children");
}
function Ws(t, e = !1) {
  let n;
  if (Pt(t))
    n = new $s(t.data);
  else if (fi(t))
    n = new Ba(t.data);
  else if (ee(t)) {
    const s = e ? Hi(t.children) : [], r = new Ma(t.name, { ...t.attribs }, s);
    s.forEach((i) => i.parent = r), t.namespace != null && (r.namespace = t.namespace), t["x-attribsNamespace"] && (r["x-attribsNamespace"] = { ...t["x-attribsNamespace"] }), t["x-attribsPrefix"] && (r["x-attribsPrefix"] = { ...t["x-attribsPrefix"] }), n = r;
  } else if (di(t)) {
    const s = e ? Hi(t.children) : [], r = new Xl(s);
    s.forEach((i) => i.parent = r), n = r;
  } else if (cn(t)) {
    const s = e ? Hi(t.children) : [], r = new wn(s);
    s.forEach((i) => i.parent = r), t["x-mode"] && (r["x-mode"] = t["x-mode"]), n = r;
  } else if (Qu(t)) {
    const s = new ka(t.name, t.data);
    t["x-name"] != null && (s["x-name"] = t["x-name"], s["x-publicId"] = t["x-publicId"], s["x-systemId"] = t["x-systemId"]), n = s;
  } else
    throw new Error(`Not implemented yet: ${t.type}`);
  return n.startIndex = t.startIndex, n.endIndex = t.endIndex, t.sourceCodeLocation != null && (n.sourceCodeLocation = t.sourceCodeLocation), n;
}
function Hi(t) {
  const e = t.map((n) => Ws(n, !0));
  for (let n = 1; n < e.length; n++)
    e[n].prev = e[n - 1], e[n - 1].next = e[n];
  return e;
}
const M0 = {
  withStartIndices: !1,
  withEndIndices: !1,
  xmlMode: !1
};
class I1 {
  /**
   * @param callback Called once parsing has completed.
   * @param options Settings for the handler.
   * @param elementCB Callback whenever a tag is closed.
   */
  constructor(e, n, s) {
    this.dom = [], this.root = new wn(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof n == "function" && (s = n, n = M0), typeof e == "object" && (n = e, e = void 0), this.callback = e ?? null, this.options = n ?? M0, this.elementCB = s ?? null;
  }
  onparserinit(e) {
    this.parser = e;
  }
  // Resets the handler back to starting state
  onreset() {
    this.dom = [], this.root = new wn(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
  }
  // Signals the handler that parsing is done
  onend() {
    this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
  }
  onerror(e) {
    this.handleCallback(e);
  }
  onclosetag() {
    this.lastNode = null;
    const e = this.tagStack.pop();
    this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
  }
  onopentag(e, n) {
    const s = this.options.xmlMode ? me.Tag : void 0, r = new Ma(e, n, void 0, s);
    this.addNode(r), this.tagStack.push(r);
  }
  ontext(e) {
    const { lastNode: n } = this;
    if (n && n.type === me.Text)
      n.data += e, this.options.withEndIndices && (n.endIndex = this.parser.endIndex);
    else {
      const s = new $s(e);
      this.addNode(s), this.lastNode = s;
    }
  }
  oncomment(e) {
    if (this.lastNode && this.lastNode.type === me.Comment) {
      this.lastNode.data += e;
      return;
    }
    const n = new Ba(e);
    this.addNode(n), this.lastNode = n;
  }
  oncommentend() {
    this.lastNode = null;
  }
  oncdatastart() {
    const e = new $s(""), n = new Xl([e]);
    this.addNode(n), e.parent = n, this.lastNode = e;
  }
  oncdataend() {
    this.lastNode = null;
  }
  onprocessinginstruction(e, n) {
    const s = new ka(e, n);
    this.addNode(s);
  }
  handleCallback(e) {
    if (typeof this.callback == "function")
      this.callback(e, this.dom);
    else if (e)
      throw e;
  }
  addNode(e) {
    const n = this.tagStack[this.tagStack.length - 1], s = n.children[n.children.length - 1];
    this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), n.children.push(e), s && (e.prev = s, s.next = e), e.parent = n, this.lastNode = null;
  }
}
const R0 = /["&'<>$\x80-\uFFFF]/g, O1 = /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [39, "&apos;"],
  [60, "&lt;"],
  [62, "&gt;"]
]), B1 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  String.prototype.codePointAt != null ? (t, e) => t.codePointAt(e) : (
    // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
    (t, e) => (t.charCodeAt(e) & 64512) === 55296 ? (t.charCodeAt(e) - 55296) * 1024 + t.charCodeAt(e + 1) - 56320 + 65536 : t.charCodeAt(e)
  )
);
function Ql(t) {
  let e = "", n = 0, s;
  for (; (s = R0.exec(t)) !== null; ) {
    const r = s.index, i = t.charCodeAt(r), u = O1.get(i);
    u !== void 0 ? (e += t.substring(n, r) + u, n = r + 1) : (e += `${t.substring(n, r)}&#x${B1(t, r).toString(16)};`, n = R0.lastIndex += +((i & 64512) === 55296));
  }
  return e + t.substr(n);
}
function Kl(t, e) {
  return function(s) {
    let r, i = 0, u = "";
    for (; r = t.exec(s); )
      i !== r.index && (u += s.substring(i, r.index)), u += e.get(r[0].charCodeAt(0)), i = r.index + 1;
    return u + s.substring(i);
  };
}
const k1 = Kl(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), L1 = Kl(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), M1 = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((t) => [t.toLowerCase(), t])), R1 = new Map([
  "definitionURL",
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((t) => [t.toLowerCase(), t])), P1 = /* @__PURE__ */ new Set([
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
]);
function F1(t) {
  return t.replace(/"/g, "&quot;");
}
function H1(t, e) {
  var n;
  if (!t)
    return;
  const s = ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) === !1 ? F1 : e.xmlMode || e.encodeEntities !== "utf8" ? Ql : k1;
  return Object.keys(t).map((r) => {
    var i, u;
    const a = (i = t[r]) !== null && i !== void 0 ? i : "";
    return e.xmlMode === "foreign" && (r = (u = R1.get(r)) !== null && u !== void 0 ? u : r), !e.emptyAttrs && !e.xmlMode && a === "" ? r : `${r}="${s(a)}"`;
  }).join(" ");
}
const P0 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]);
function hi(t, e = {}) {
  const n = "length" in t ? t : [t];
  let s = "";
  for (let r = 0; r < n.length; r++)
    s += U1(n[r], e);
  return s;
}
function U1(t, e) {
  switch (t.type) {
    case Ia:
      return hi(t.children, e);
    case N1:
    case D1:
      return W1(t);
    case jl:
      return j1(t);
    case w1:
      return V1(t);
    case v1:
    case S1:
    case Xu:
      return $1(t, e);
    case Vl:
      return z1(t, e);
  }
}
const Y1 = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignObject",
  "desc",
  "title"
]), q1 = /* @__PURE__ */ new Set(["svg", "math"]);
function $1(t, e) {
  var n;
  e.xmlMode === "foreign" && (t.name = (n = M1.get(t.name)) !== null && n !== void 0 ? n : t.name, t.parent && Y1.has(t.parent.name) && (e = { ...e, xmlMode: !1 })), !e.xmlMode && q1.has(t.name) && (e = { ...e, xmlMode: "foreign" });
  let s = `<${t.name}`;
  const r = H1(t.attribs, e);
  return r && (s += ` ${r}`), t.children.length === 0 && (e.xmlMode ? (
    // In XML mode or foreign mode, and user hasn't explicitly turned off self-closing tags
    e.selfClosingTags !== !1
  ) : (
    // User explicitly asked for self-closing tags, even in HTML mode
    e.selfClosingTags && P0.has(t.name)
  )) ? (e.xmlMode || (s += " "), s += "/>") : (s += ">", t.children.length > 0 && (s += hi(t.children, e)), (e.xmlMode || !P0.has(t.name)) && (s += `</${t.name}>`)), s;
}
function W1(t) {
  return `<${t.data}>`;
}
function z1(t, e) {
  var n;
  let s = t.data || "";
  return ((n = e.encodeEntities) !== null && n !== void 0 ? n : e.decodeEntities) !== !1 && !(!e.xmlMode && t.parent && P1.has(t.parent.name)) && (s = e.xmlMode || e.encodeEntities !== "utf8" ? Ql(s) : L1(s)), s;
}
function V1(t) {
  return `<![CDATA[${t.children[0].data}]]>`;
}
function j1(t) {
  return `<!--${t.data}-->`;
}
function Zl(t, e) {
  return hi(t, e);
}
function G1(t, e) {
  return Me(t) ? t.children.map((n) => Zl(n, e)).join("") : "";
}
function Lr(t) {
  return Array.isArray(t) ? t.map(Lr).join("") : ee(t) ? t.name === "br" ? `
` : Lr(t.children) : di(t) ? Lr(t.children) : Pt(t) ? t.data : "";
}
function Zn(t) {
  return Array.isArray(t) ? t.map(Zn).join("") : Me(t) && !fi(t) ? Zn(t.children) : Pt(t) ? t.data : "";
}
function qr(t) {
  return Array.isArray(t) ? t.map(qr).join("") : Me(t) && (t.type === me.Tag || di(t)) ? qr(t.children) : Pt(t) ? t.data : "";
}
function bi(t) {
  return Me(t) ? t.children : [];
}
function Jl(t) {
  return t.parent || null;
}
function ed(t) {
  const e = Jl(t);
  if (e != null)
    return bi(e);
  const n = [t];
  let { prev: s, next: r } = t;
  for (; s != null; )
    n.unshift(s), { prev: s } = s;
  for (; r != null; )
    n.push(r), { next: r } = r;
  return n;
}
function X1(t, e) {
  var n;
  return (n = t.attribs) === null || n === void 0 ? void 0 : n[e];
}
function Q1(t, e) {
  return t.attribs != null && Object.prototype.hasOwnProperty.call(t.attribs, e) && t.attribs[e] != null;
}
function K1(t) {
  return t.name;
}
function Ra(t) {
  let { next: e } = t;
  for (; e !== null && !ee(e); )
    ({ next: e } = e);
  return e;
}
function Pa(t) {
  let { prev: e } = t;
  for (; e !== null && !ee(e); )
    ({ prev: e } = e);
  return e;
}
function Bn(t) {
  if (t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t.parent) {
    const e = t.parent.children, n = e.lastIndexOf(t);
    n >= 0 && e.splice(n, 1);
  }
  t.next = null, t.prev = null, t.parent = null;
}
function Z1(t, e) {
  const n = e.prev = t.prev;
  n && (n.next = e);
  const s = e.next = t.next;
  s && (s.prev = e);
  const r = e.parent = t.parent;
  if (r) {
    const i = r.children;
    i[i.lastIndexOf(t)] = e, t.parent = null;
  }
}
function J1(t, e) {
  if (Bn(e), e.next = null, e.parent = t, t.children.push(e) > 1) {
    const n = t.children[t.children.length - 2];
    n.next = e, e.prev = n;
  } else
    e.prev = null;
}
function e2(t, e) {
  Bn(e);
  const { parent: n } = t, s = t.next;
  if (e.next = s, e.prev = t, t.next = e, e.parent = n, s) {
    if (s.prev = e, n) {
      const r = n.children;
      r.splice(r.lastIndexOf(s), 0, e);
    }
  } else n && n.children.push(e);
}
function t2(t, e) {
  if (Bn(e), e.parent = t, e.prev = null, t.children.unshift(e) !== 1) {
    const n = t.children[1];
    n.prev = e, e.next = n;
  } else
    e.next = null;
}
function n2(t, e) {
  Bn(e);
  const { parent: n } = t;
  if (n) {
    const s = n.children;
    s.splice(s.indexOf(t), 0, e);
  }
  t.prev && (t.prev.next = e), e.parent = n, e.prev = t.prev, e.next = t, t.prev = e;
}
function nr(t, e, n = !0, s = 1 / 0) {
  return Fa(t, Array.isArray(e) ? e : [e], n, s);
}
function Fa(t, e, n, s) {
  const r = [], i = [Array.isArray(e) ? e : [e]], u = [0];
  for (; ; ) {
    if (u[0] >= i[0].length) {
      if (u.length === 1)
        return r;
      i.shift(), u.shift();
      continue;
    }
    const a = i[0][u[0]++];
    if (t(a) && (r.push(a), --s <= 0))
      return r;
    n && Me(a) && a.children.length > 0 && (u.unshift(0), i.unshift(a.children));
  }
}
function s2(t, e) {
  return e.find(t);
}
function Ha(t, e, n = !0) {
  const s = Array.isArray(e) ? e : [e];
  for (let r = 0; r < s.length; r++) {
    const i = s[r];
    if (ee(i) && t(i))
      return i;
    if (n && Me(i) && i.children.length > 0) {
      const u = Ha(t, i.children, !0);
      if (u)
        return u;
    }
  }
  return null;
}
function td(t, e) {
  return (Array.isArray(e) ? e : [e]).some((n) => ee(n) && t(n) || Me(n) && td(t, n.children));
}
function r2(t, e) {
  const n = [], s = [Array.isArray(e) ? e : [e]], r = [0];
  for (; ; ) {
    if (r[0] >= s[0].length) {
      if (s.length === 1)
        return n;
      s.shift(), r.shift();
      continue;
    }
    const i = s[0][r[0]++];
    ee(i) && t(i) && n.push(i), Me(i) && i.children.length > 0 && (r.unshift(0), s.unshift(i.children));
  }
}
const $r = {
  tag_name(t) {
    return typeof t == "function" ? (e) => ee(e) && t(e.name) : t === "*" ? ee : (e) => ee(e) && e.name === t;
  },
  tag_type(t) {
    return typeof t == "function" ? (e) => t(e.type) : (e) => e.type === t;
  },
  tag_contains(t) {
    return typeof t == "function" ? (e) => Pt(e) && t(e.data) : (e) => Pt(e) && e.data === t;
  }
};
function Ua(t, e) {
  return typeof e == "function" ? (n) => ee(n) && e(n.attribs[t]) : (n) => ee(n) && n.attribs[t] === e;
}
function i2(t, e) {
  return (n) => t(n) || e(n);
}
function nd(t) {
  const e = Object.keys(t).map((n) => {
    const s = t[n];
    return Object.prototype.hasOwnProperty.call($r, n) ? $r[n](s) : Ua(n, s);
  });
  return e.length === 0 ? null : e.reduce(i2);
}
function u2(t, e) {
  const n = nd(t);
  return n ? n(e) : !0;
}
function a2(t, e, n, s = 1 / 0) {
  const r = nd(t);
  return r ? nr(r, e, n, s) : [];
}
function o2(t, e, n = !0) {
  return Array.isArray(e) || (e = [e]), Ha(Ua("id", t), e, n);
}
function is(t, e, n = !0, s = 1 / 0) {
  return nr($r.tag_name(t), e, n, s);
}
function c2(t, e, n = !0, s = 1 / 0) {
  return nr(Ua("class", t), e, n, s);
}
function l2(t, e, n = !0, s = 1 / 0) {
  return nr($r.tag_type(t), e, n, s);
}
function d2(t) {
  let e = t.length;
  for (; --e >= 0; ) {
    const n = t[e];
    if (e > 0 && t.lastIndexOf(n, e - 1) >= 0) {
      t.splice(e, 1);
      continue;
    }
    for (let s = n.parent; s; s = s.parent)
      if (t.includes(s)) {
        t.splice(e, 1);
        break;
      }
  }
  return t;
}
var mt;
(function(t) {
  t[t.DISCONNECTED = 1] = "DISCONNECTED", t[t.PRECEDING = 2] = "PRECEDING", t[t.FOLLOWING = 4] = "FOLLOWING", t[t.CONTAINS = 8] = "CONTAINS", t[t.CONTAINED_BY = 16] = "CONTAINED_BY";
})(mt || (mt = {}));
function sd(t, e) {
  const n = [], s = [];
  if (t === e)
    return 0;
  let r = Me(t) ? t : t.parent;
  for (; r; )
    n.unshift(r), r = r.parent;
  for (r = Me(e) ? e : e.parent; r; )
    s.unshift(r), r = r.parent;
  const i = Math.min(n.length, s.length);
  let u = 0;
  for (; u < i && n[u] === s[u]; )
    u++;
  if (u === 0)
    return mt.DISCONNECTED;
  const a = n[u - 1], o = a.children, c = n[u], l = s[u];
  return o.indexOf(c) > o.indexOf(l) ? a === e ? mt.FOLLOWING | mt.CONTAINED_BY : mt.FOLLOWING : a === t ? mt.PRECEDING | mt.CONTAINS : mt.PRECEDING;
}
function us(t) {
  return t = t.filter((e, n, s) => !s.includes(e, n + 1)), t.sort((e, n) => {
    const s = sd(e, n);
    return s & mt.PRECEDING ? -1 : s & mt.FOLLOWING ? 1 : 0;
  }), t;
}
function f2(t) {
  const e = Wr(p2, t);
  return e ? e.name === "feed" ? h2(e) : b2(e) : null;
}
function h2(t) {
  var e;
  const n = t.children, s = {
    type: "atom",
    items: is("entry", n).map((u) => {
      var a;
      const { children: o } = u, c = { media: rd(o) };
      rt(c, "id", "id", o), rt(c, "title", "title", o);
      const l = (a = Wr("link", o)) === null || a === void 0 ? void 0 : a.attribs.href;
      l && (c.link = l);
      const f = nn("summary", o) || nn("content", o);
      f && (c.description = f);
      const h = nn("updated", o);
      return h && (c.pubDate = new Date(h)), c;
    })
  };
  rt(s, "id", "id", n), rt(s, "title", "title", n);
  const r = (e = Wr("link", n)) === null || e === void 0 ? void 0 : e.attribs.href;
  r && (s.link = r), rt(s, "description", "subtitle", n);
  const i = nn("updated", n);
  return i && (s.updated = new Date(i)), rt(s, "author", "email", n, !0), s;
}
function b2(t) {
  var e, n;
  const s = (n = (e = Wr("channel", t.children)) === null || e === void 0 ? void 0 : e.children) !== null && n !== void 0 ? n : [], r = {
    type: t.name.substr(0, 3),
    id: "",
    items: is("item", t.children).map((u) => {
      const { children: a } = u, o = { media: rd(a) };
      rt(o, "id", "guid", a), rt(o, "title", "title", a), rt(o, "link", "link", a), rt(o, "description", "description", a);
      const c = nn("pubDate", a) || nn("dc:date", a);
      return c && (o.pubDate = new Date(c)), o;
    })
  };
  rt(r, "title", "title", s), rt(r, "link", "link", s), rt(r, "description", "description", s);
  const i = nn("lastBuildDate", s);
  return i && (r.updated = new Date(i)), rt(r, "author", "managingEditor", s, !0), r;
}
const x2 = ["url", "type", "lang"], m2 = [
  "fileSize",
  "bitrate",
  "framerate",
  "samplingrate",
  "channels",
  "duration",
  "height",
  "width"
];
function rd(t) {
  return is("media:content", t).map((e) => {
    const { attribs: n } = e, s = {
      medium: n.medium,
      isDefault: !!n.isDefault
    };
    for (const r of x2)
      n[r] && (s[r] = n[r]);
    for (const r of m2)
      n[r] && (s[r] = parseInt(n[r], 10));
    return n.expression && (s.expression = n.expression), s;
  });
}
function Wr(t, e) {
  return is(t, e, !0, 1)[0];
}
function nn(t, e, n = !1) {
  return Zn(is(t, e, n, 1)).trim();
}
function rt(t, e, n, s, r = !1) {
  const i = nn(n, s, r);
  i && (t[e] = i);
}
function p2(t) {
  return t === "rss" || t === "feed" || t === "rdf:RDF";
}
const xi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DocumentPosition() {
    return mt;
  },
  append: e2,
  appendChild: J1,
  compareDocumentPosition: sd,
  existsOne: td,
  filter: nr,
  find: Fa,
  findAll: r2,
  findOne: Ha,
  findOneChild: s2,
  getAttributeValue: X1,
  getChildren: bi,
  getElementById: o2,
  getElements: a2,
  getElementsByClassName: c2,
  getElementsByTagName: is,
  getElementsByTagType: l2,
  getFeed: f2,
  getInnerHTML: G1,
  getName: K1,
  getOuterHTML: Zl,
  getParent: Jl,
  getSiblings: ed,
  getText: Lr,
  hasAttrib: Q1,
  hasChildren: Me,
  innerText: qr,
  isCDATA: di,
  isComment: fi,
  isDocument: cn,
  isTag: ee,
  isText: Pt,
  nextElementSibling: Ra,
  prepend: n2,
  prependChild: t2,
  prevElementSibling: Pa,
  removeElement: Bn,
  removeSubsets: d2,
  replaceElement: Z1,
  testElement: u2,
  textContent: Zn,
  uniqueSort: us
}, Symbol.toStringTag, { value: "Module" })), g2 = {
  _useHtmlParser2: !1
};
function Ku(t, e) {
  if (!t)
    return e ?? g2;
  const n = {
    _useHtmlParser2: !!t.xmlMode,
    ...e,
    ...t
  };
  return t.xml ? (n._useHtmlParser2 = !0, n.xmlMode = !0, t.xml !== !0 && Object.assign(n, t.xml)) : t.xmlMode && (n._useHtmlParser2 = !0), n;
}
function id(t, e, n) {
  return t ? t(e ?? t._root.children, null, void 0, n).toString() : "";
}
function E2(t, e) {
  return typeof t == "object" && t != null && !("length" in t) && !("type" in t);
}
function _2(t, e) {
  const n = E2(t) ? (e = t, void 0) : t, s = {
    ...this === null || this === void 0 ? void 0 : this._options,
    ...Ku(e)
  };
  return id(this, n, s);
}
function T2(t) {
  const e = { ...this._options, xmlMode: !0 };
  return id(this, t, e);
}
function zs(t) {
  const e = t ?? (this ? this.root() : []);
  let n = "";
  for (let s = 0; s < e.length; s++)
    n += Zn(e[s]);
  return n;
}
function A2(t, e, n = typeof e == "boolean" ? e : !1) {
  if (!t || typeof t != "string")
    return null;
  typeof e == "boolean" && (n = e);
  const s = this.load(t, this._options, !1);
  return n || s("script").remove(), [...s.root()[0].children];
}
function y2() {
  return this(this._root);
}
function ud(t, e) {
  if (e === t)
    return !1;
  let n = e;
  for (; n && n !== n.parent; )
    if (n = n.parent, n === t)
      return !0;
  return !1;
}
function C2(t) {
  return this.root().extract(t);
}
function D2(t, e) {
  if (!F0(t) || !F0(e))
    return;
  let n = t.length;
  const s = +e.length;
  for (let r = 0; r < s; r++)
    t[n++] = e[r];
  return t.length = n, t;
}
function F0(t) {
  if (Array.isArray(t))
    return !0;
  if (typeof t != "object" || t === null || !("length" in t) || typeof t.length != "number" || t.length < 0)
    return !1;
  for (let e = 0; e < t.length; e++)
    if (!(e in t))
      return !1;
  return !0;
}
const v2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contains: ud,
  extract: C2,
  html: _2,
  merge: D2,
  parseHTML: A2,
  root: y2,
  text: zs,
  xml: T2
}, Symbol.toStringTag, { value: "Module" }));
function Xt(t) {
  return t.cheerio != null;
}
function S2(t) {
  return t.replace(/[._-](\w|$)/g, (e, n) => n.toUpperCase());
}
function w2(t) {
  return t.replace(/[A-Z]/g, "-$&").toLowerCase();
}
function Ne(t, e) {
  const n = t.length;
  for (let s = 0; s < n; s++)
    e(t[s], s);
  return t;
}
var _n;
(function(t) {
  t[t.LowerA = 97] = "LowerA", t[t.LowerZ = 122] = "LowerZ", t[t.UpperA = 65] = "UpperA", t[t.UpperZ = 90] = "UpperZ", t[t.Exclamation = 33] = "Exclamation";
})(_n || (_n = {}));
function Zu(t) {
  const e = t.indexOf("<");
  if (e === -1 || e > t.length - 3)
    return !1;
  const n = t.charCodeAt(e + 1);
  return (n >= _n.LowerA && n <= _n.LowerZ || n >= _n.UpperA && n <= _n.UpperZ || n === _n.Exclamation) && t.includes(">", e + 2);
}
const N2 = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), I2 = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var Ui;
const O2 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), H0 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, n/no-unsupported-features/es-builtins
  (Ui = String.fromCodePoint) !== null && Ui !== void 0 ? Ui : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function B2(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = O2.get(t)) !== null && e !== void 0 ? e : t;
}
var We;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(We || (We = {}));
const k2 = 32;
var sn;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(sn || (sn = {}));
function Ju(t) {
  return t >= We.ZERO && t <= We.NINE;
}
function L2(t) {
  return t >= We.UPPER_A && t <= We.UPPER_F || t >= We.LOWER_A && t <= We.LOWER_F;
}
function M2(t) {
  return t >= We.UPPER_A && t <= We.UPPER_Z || t >= We.LOWER_A && t <= We.LOWER_Z || Ju(t);
}
function R2(t) {
  return t === We.EQUALS || M2(t);
}
var qe;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(qe || (qe = {}));
var kt;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(kt || (kt = {}));
let P2 = class {
  constructor(e, n, s) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = s, this.state = qe.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = kt.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = qe.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case qe.EntityStart:
        return e.charCodeAt(n) === We.NUM ? (this.state = qe.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = qe.NamedEntity, this.stateNamedEntity(e, n));
      case qe.NumericStart:
        return this.stateNumericStart(e, n);
      case qe.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case qe.NumericHex:
        return this.stateNumericHex(e, n);
      case qe.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | k2) === We.LOWER_X ? (this.state = qe.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = qe.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, s, r) {
    if (n !== s) {
      const i = s - n;
      this.result = this.result * Math.pow(r, i) + Number.parseInt(e.substr(n, i), r), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const s = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (Ju(r) || L2(r))
        n += 1;
      else
        return this.addToNumericResult(e, s, n, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(e, s, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const s = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (Ju(r))
        n += 1;
      else
        return this.addToNumericResult(e, s, n, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(e, s, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var s;
    if (this.consumed <= n)
      return (s = this.errors) === null || s === void 0 || s.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === We.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === kt.Strict)
      return 0;
    return this.emitCodePoint(B2(this.result), this.consumed), this.errors && (e !== We.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: s } = this;
    let r = s[this.treeIndex], i = (r & sn.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const u = e.charCodeAt(n);
      if (this.treeIndex = F2(s, r, this.treeIndex + Math.max(1, i), u), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === kt.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        R2(u)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = s[this.treeIndex], i = (r & sn.VALUE_LENGTH) >> 14, i !== 0) {
        if (u === We.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== kt.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: s } = this, r = (s[n] & sn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, r, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, s) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(n === 1 ? r[e] & ~sn.VALUE_LENGTH : r[e + 1], s), n === 3 && this.emitCodePoint(r[e + 2], s), s;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case qe.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== kt.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case qe.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case qe.NumericHex:
        return this.emitNumericEntity(0, 3);
      case qe.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case qe.EntityStart:
        return 0;
    }
  }
};
function F2(t, e, n, s) {
  const r = (e & sn.BRANCH_LENGTH) >> 7, i = e & sn.JUMP_TABLE;
  if (r === 0)
    return i !== 0 && s === i ? n : -1;
  if (i) {
    const o = s - i;
    return o < 0 || o >= r ? -1 : t[n + o] - 1;
  }
  let u = n, a = u + r - 1;
  for (; u <= a; ) {
    const o = u + a >>> 1, c = t[o];
    if (c < s)
      u = o + 1;
    else if (c > s)
      a = o - 1;
    else
      return t[o + r];
  }
  return -1;
}
var J;
(function(t) {
  t[t.Tab = 9] = "Tab", t[t.NewLine = 10] = "NewLine", t[t.FormFeed = 12] = "FormFeed", t[t.CarriageReturn = 13] = "CarriageReturn", t[t.Space = 32] = "Space", t[t.ExclamationMark = 33] = "ExclamationMark", t[t.Number = 35] = "Number", t[t.Amp = 38] = "Amp", t[t.SingleQuote = 39] = "SingleQuote", t[t.DoubleQuote = 34] = "DoubleQuote", t[t.Dash = 45] = "Dash", t[t.Slash = 47] = "Slash", t[t.Zero = 48] = "Zero", t[t.Nine = 57] = "Nine", t[t.Semi = 59] = "Semi", t[t.Lt = 60] = "Lt", t[t.Eq = 61] = "Eq", t[t.Gt = 62] = "Gt", t[t.Questionmark = 63] = "Questionmark", t[t.UpperA = 65] = "UpperA", t[t.LowerA = 97] = "LowerA", t[t.UpperF = 70] = "UpperF", t[t.LowerF = 102] = "LowerF", t[t.UpperZ = 90] = "UpperZ", t[t.LowerZ = 122] = "LowerZ", t[t.LowerX = 120] = "LowerX", t[t.OpeningSquareBracket = 91] = "OpeningSquareBracket";
})(J || (J = {}));
var G;
(function(t) {
  t[t.Text = 1] = "Text", t[t.BeforeTagName = 2] = "BeforeTagName", t[t.InTagName = 3] = "InTagName", t[t.InSelfClosingTag = 4] = "InSelfClosingTag", t[t.BeforeClosingTagName = 5] = "BeforeClosingTagName", t[t.InClosingTagName = 6] = "InClosingTagName", t[t.AfterClosingTagName = 7] = "AfterClosingTagName", t[t.BeforeAttributeName = 8] = "BeforeAttributeName", t[t.InAttributeName = 9] = "InAttributeName", t[t.AfterAttributeName = 10] = "AfterAttributeName", t[t.BeforeAttributeValue = 11] = "BeforeAttributeValue", t[t.InAttributeValueDq = 12] = "InAttributeValueDq", t[t.InAttributeValueSq = 13] = "InAttributeValueSq", t[t.InAttributeValueNq = 14] = "InAttributeValueNq", t[t.BeforeDeclaration = 15] = "BeforeDeclaration", t[t.InDeclaration = 16] = "InDeclaration", t[t.InProcessingInstruction = 17] = "InProcessingInstruction", t[t.BeforeComment = 18] = "BeforeComment", t[t.CDATASequence = 19] = "CDATASequence", t[t.InSpecialComment = 20] = "InSpecialComment", t[t.InCommentLike = 21] = "InCommentLike", t[t.BeforeSpecialS = 22] = "BeforeSpecialS", t[t.BeforeSpecialT = 23] = "BeforeSpecialT", t[t.SpecialStartSequence = 24] = "SpecialStartSequence", t[t.InSpecialTag = 25] = "InSpecialTag", t[t.InEntity = 26] = "InEntity";
})(G || (G = {}));
function $t(t) {
  return t === J.Space || t === J.NewLine || t === J.Tab || t === J.FormFeed || t === J.CarriageReturn;
}
function br(t) {
  return t === J.Slash || t === J.Gt || $t(t);
}
function H2(t) {
  return t >= J.LowerA && t <= J.LowerZ || t >= J.UpperA && t <= J.UpperZ;
}
var Lt;
(function(t) {
  t[t.NoValue = 0] = "NoValue", t[t.Unquoted = 1] = "Unquoted", t[t.Single = 2] = "Single", t[t.Double = 3] = "Double";
})(Lt || (Lt = {}));
const Pe = {
  Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
  // CDATA[
  CdataEnd: new Uint8Array([93, 93, 62]),
  // ]]>
  CommentEnd: new Uint8Array([45, 45, 62]),
  // `-->`
  ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
  // `<\/script`
  StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
  // `</style`
  TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101]),
  // `</title`
  TextareaEnd: new Uint8Array([
    60,
    47,
    116,
    101,
    120,
    116,
    97,
    114,
    101,
    97
  ]),
  // `</textarea`
  XmpEnd: new Uint8Array([60, 47, 120, 109, 112])
  // `</xmp`
};
let U2 = class {
  constructor({ xmlMode: e = !1, decodeEntities: n = !0 }, s) {
    this.cbs = s, this.state = G.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.entityStart = 0, this.baseState = G.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.xmlMode = e, this.decodeEntities = n, this.entityDecoder = new P2(e ? I2 : N2, (r, i) => this.emitCodePoint(r, i));
  }
  reset() {
    this.state = G.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = G.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
  }
  write(e) {
    this.offset += this.buffer.length, this.buffer = e, this.parse();
  }
  end() {
    this.running && this.finish();
  }
  pause() {
    this.running = !1;
  }
  resume() {
    this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
  }
  stateText(e) {
    e === J.Lt || !this.decodeEntities && this.fastForwardTo(J.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = G.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && e === J.Amp && this.startEntity();
  }
  stateSpecialStartSequence(e) {
    const n = this.sequenceIndex === this.currentSequence.length;
    if (!(n ? (
      // If we are at the end of the sequence, make sure the tag name has ended
      br(e)
    ) : (
      // Otherwise, do a case-insensitive comparison
      (e | 32) === this.currentSequence[this.sequenceIndex]
    )))
      this.isSpecial = !1;
    else if (!n) {
      this.sequenceIndex++;
      return;
    }
    this.sequenceIndex = 0, this.state = G.InTagName, this.stateInTagName(e);
  }
  /** Look for an end tag. For <title> tags, also decode entities. */
  stateInSpecialTag(e) {
    if (this.sequenceIndex === this.currentSequence.length) {
      if (e === J.Gt || $t(e)) {
        const n = this.index - this.currentSequence.length;
        if (this.sectionStart < n) {
          const s = this.index;
          this.index = n, this.cbs.ontext(this.sectionStart, n), this.index = s;
        }
        this.isSpecial = !1, this.sectionStart = n + 2, this.stateInClosingTagName(e);
        return;
      }
      this.sequenceIndex = 0;
    }
    (e | 32) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : this.sequenceIndex === 0 ? this.currentSequence === Pe.TitleEnd ? this.decodeEntities && e === J.Amp && this.startEntity() : this.fastForwardTo(J.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = +(e === J.Lt);
  }
  stateCDATASequence(e) {
    e === Pe.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === Pe.Cdata.length && (this.state = G.InCommentLike, this.currentSequence = Pe.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = G.InDeclaration, this.stateInDeclaration(e));
  }
  /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */
  fastForwardTo(e) {
    for (; ++this.index < this.buffer.length + this.offset; )
      if (this.buffer.charCodeAt(this.index - this.offset) === e)
        return !0;
    return this.index = this.buffer.length + this.offset - 1, !1;
  }
  /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */
  stateInCommentLike(e) {
    e === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === Pe.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = G.Text) : this.sequenceIndex === 0 ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
  }
  /**
   * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
   *
   * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
   * We allow anything that wouldn't end the tag.
   */
  isTagStartChar(e) {
    return this.xmlMode ? !br(e) : H2(e);
  }
  startSpecial(e, n) {
    this.isSpecial = !0, this.currentSequence = e, this.sequenceIndex = n, this.state = G.SpecialStartSequence;
  }
  stateBeforeTagName(e) {
    if (e === J.ExclamationMark)
      this.state = G.BeforeDeclaration, this.sectionStart = this.index + 1;
    else if (e === J.Questionmark)
      this.state = G.InProcessingInstruction, this.sectionStart = this.index + 1;
    else if (this.isTagStartChar(e)) {
      const n = e | 32;
      this.sectionStart = this.index, this.xmlMode ? this.state = G.InTagName : n === Pe.ScriptEnd[2] ? this.state = G.BeforeSpecialS : n === Pe.TitleEnd[2] || n === Pe.XmpEnd[2] ? this.state = G.BeforeSpecialT : this.state = G.InTagName;
    } else e === J.Slash ? this.state = G.BeforeClosingTagName : (this.state = G.Text, this.stateText(e));
  }
  stateInTagName(e) {
    br(e) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateBeforeClosingTagName(e) {
    $t(e) || (e === J.Gt ? this.state = G.Text : (this.state = this.isTagStartChar(e) ? G.InClosingTagName : G.InSpecialComment, this.sectionStart = this.index));
  }
  stateInClosingTagName(e) {
    (e === J.Gt || $t(e)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = G.AfterClosingTagName, this.stateAfterClosingTagName(e));
  }
  stateAfterClosingTagName(e) {
    (e === J.Gt || this.fastForwardTo(J.Gt)) && (this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeAttributeName(e) {
    e === J.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = G.InSpecialTag, this.sequenceIndex = 0) : this.state = G.Text, this.sectionStart = this.index + 1) : e === J.Slash ? this.state = G.InSelfClosingTag : $t(e) || (this.state = G.InAttributeName, this.sectionStart = this.index);
  }
  stateInSelfClosingTag(e) {
    e === J.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = G.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : $t(e) || (this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(e));
  }
  stateInAttributeName(e) {
    (e === J.Eq || br(e)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = this.index, this.state = G.AfterAttributeName, this.stateAfterAttributeName(e));
  }
  stateAfterAttributeName(e) {
    e === J.Eq ? this.state = G.BeforeAttributeValue : e === J.Slash || e === J.Gt ? (this.cbs.onattribend(Lt.NoValue, this.sectionStart), this.sectionStart = -1, this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(e)) : $t(e) || (this.cbs.onattribend(Lt.NoValue, this.sectionStart), this.state = G.InAttributeName, this.sectionStart = this.index);
  }
  stateBeforeAttributeValue(e) {
    e === J.DoubleQuote ? (this.state = G.InAttributeValueDq, this.sectionStart = this.index + 1) : e === J.SingleQuote ? (this.state = G.InAttributeValueSq, this.sectionStart = this.index + 1) : $t(e) || (this.sectionStart = this.index, this.state = G.InAttributeValueNq, this.stateInAttributeValueNoQuotes(e));
  }
  handleInAttributeValue(e, n) {
    e === n || !this.decodeEntities && this.fastForwardTo(n) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(n === J.DoubleQuote ? Lt.Double : Lt.Single, this.index + 1), this.state = G.BeforeAttributeName) : this.decodeEntities && e === J.Amp && this.startEntity();
  }
  stateInAttributeValueDoubleQuotes(e) {
    this.handleInAttributeValue(e, J.DoubleQuote);
  }
  stateInAttributeValueSingleQuotes(e) {
    this.handleInAttributeValue(e, J.SingleQuote);
  }
  stateInAttributeValueNoQuotes(e) {
    $t(e) || e === J.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(Lt.Unquoted, this.index), this.state = G.BeforeAttributeName, this.stateBeforeAttributeName(e)) : this.decodeEntities && e === J.Amp && this.startEntity();
  }
  stateBeforeDeclaration(e) {
    e === J.OpeningSquareBracket ? (this.state = G.CDATASequence, this.sequenceIndex = 0) : this.state = e === J.Dash ? G.BeforeComment : G.InDeclaration;
  }
  stateInDeclaration(e) {
    (e === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateInProcessingInstruction(e) {
    (e === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeComment(e) {
    e === J.Dash ? (this.state = G.InCommentLike, this.currentSequence = Pe.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = G.InDeclaration;
  }
  stateInSpecialComment(e) {
    (e === J.Gt || this.fastForwardTo(J.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = G.Text, this.sectionStart = this.index + 1);
  }
  stateBeforeSpecialS(e) {
    const n = e | 32;
    n === Pe.ScriptEnd[3] ? this.startSpecial(Pe.ScriptEnd, 4) : n === Pe.StyleEnd[3] ? this.startSpecial(Pe.StyleEnd, 4) : (this.state = G.InTagName, this.stateInTagName(e));
  }
  stateBeforeSpecialT(e) {
    switch (e | 32) {
      case Pe.TitleEnd[3]: {
        this.startSpecial(Pe.TitleEnd, 4);
        break;
      }
      case Pe.TextareaEnd[3]: {
        this.startSpecial(Pe.TextareaEnd, 4);
        break;
      }
      case Pe.XmpEnd[3]: {
        this.startSpecial(Pe.XmpEnd, 4);
        break;
      }
      default:
        this.state = G.InTagName, this.stateInTagName(e);
    }
  }
  startEntity() {
    this.baseState = this.state, this.state = G.InEntity, this.entityStart = this.index, this.entityDecoder.startEntity(this.xmlMode ? kt.Strict : this.baseState === G.Text || this.baseState === G.InSpecialTag ? kt.Legacy : kt.Attribute);
  }
  stateInEntity() {
    const e = this.entityDecoder.write(this.buffer, this.index - this.offset);
    e >= 0 ? (this.state = this.baseState, e === 0 && (this.index = this.entityStart)) : this.index = this.offset + this.buffer.length - 1;
  }
  /**
   * Remove data that has already been consumed from the buffer.
   */
  cleanup() {
    this.running && this.sectionStart !== this.index && (this.state === G.Text || this.state === G.InSpecialTag && this.sequenceIndex === 0 ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : (this.state === G.InAttributeValueDq || this.state === G.InAttributeValueSq || this.state === G.InAttributeValueNq) && (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
  }
  shouldContinue() {
    return this.index < this.buffer.length + this.offset && this.running;
  }
  /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */
  parse() {
    for (; this.shouldContinue(); ) {
      const e = this.buffer.charCodeAt(this.index - this.offset);
      switch (this.state) {
        case G.Text: {
          this.stateText(e);
          break;
        }
        case G.SpecialStartSequence: {
          this.stateSpecialStartSequence(e);
          break;
        }
        case G.InSpecialTag: {
          this.stateInSpecialTag(e);
          break;
        }
        case G.CDATASequence: {
          this.stateCDATASequence(e);
          break;
        }
        case G.InAttributeValueDq: {
          this.stateInAttributeValueDoubleQuotes(e);
          break;
        }
        case G.InAttributeName: {
          this.stateInAttributeName(e);
          break;
        }
        case G.InCommentLike: {
          this.stateInCommentLike(e);
          break;
        }
        case G.InSpecialComment: {
          this.stateInSpecialComment(e);
          break;
        }
        case G.BeforeAttributeName: {
          this.stateBeforeAttributeName(e);
          break;
        }
        case G.InTagName: {
          this.stateInTagName(e);
          break;
        }
        case G.InClosingTagName: {
          this.stateInClosingTagName(e);
          break;
        }
        case G.BeforeTagName: {
          this.stateBeforeTagName(e);
          break;
        }
        case G.AfterAttributeName: {
          this.stateAfterAttributeName(e);
          break;
        }
        case G.InAttributeValueSq: {
          this.stateInAttributeValueSingleQuotes(e);
          break;
        }
        case G.BeforeAttributeValue: {
          this.stateBeforeAttributeValue(e);
          break;
        }
        case G.BeforeClosingTagName: {
          this.stateBeforeClosingTagName(e);
          break;
        }
        case G.AfterClosingTagName: {
          this.stateAfterClosingTagName(e);
          break;
        }
        case G.BeforeSpecialS: {
          this.stateBeforeSpecialS(e);
          break;
        }
        case G.BeforeSpecialT: {
          this.stateBeforeSpecialT(e);
          break;
        }
        case G.InAttributeValueNq: {
          this.stateInAttributeValueNoQuotes(e);
          break;
        }
        case G.InSelfClosingTag: {
          this.stateInSelfClosingTag(e);
          break;
        }
        case G.InDeclaration: {
          this.stateInDeclaration(e);
          break;
        }
        case G.BeforeDeclaration: {
          this.stateBeforeDeclaration(e);
          break;
        }
        case G.BeforeComment: {
          this.stateBeforeComment(e);
          break;
        }
        case G.InProcessingInstruction: {
          this.stateInProcessingInstruction(e);
          break;
        }
        case G.InEntity: {
          this.stateInEntity();
          break;
        }
      }
      this.index++;
    }
    this.cleanup();
  }
  finish() {
    this.state === G.InEntity && (this.entityDecoder.end(), this.state = this.baseState), this.handleTrailingData(), this.cbs.onend();
  }
  /** Handle any trailing data. */
  handleTrailingData() {
    const e = this.buffer.length + this.offset;
    this.sectionStart >= e || (this.state === G.InCommentLike ? this.currentSequence === Pe.CdataEnd ? this.cbs.oncdata(this.sectionStart, e, 0) : this.cbs.oncomment(this.sectionStart, e, 0) : this.state === G.InTagName || this.state === G.BeforeAttributeName || this.state === G.BeforeAttributeValue || this.state === G.AfterAttributeName || this.state === G.InAttributeName || this.state === G.InAttributeValueSq || this.state === G.InAttributeValueDq || this.state === G.InAttributeValueNq || this.state === G.InClosingTagName || this.cbs.ontext(this.sectionStart, e));
  }
  emitCodePoint(e, n) {
    this.baseState !== G.Text && this.baseState !== G.InSpecialTag ? (this.sectionStart < this.entityStart && this.cbs.onattribdata(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.onattribentity(e)) : (this.sectionStart < this.entityStart && this.cbs.ontext(this.sectionStart, this.entityStart), this.sectionStart = this.entityStart + n, this.index = this.sectionStart - 1, this.cbs.ontextentity(e, this.sectionStart));
  }
};
const $n = /* @__PURE__ */ new Set([
  "input",
  "option",
  "optgroup",
  "select",
  "button",
  "datalist",
  "textarea"
]), _e = /* @__PURE__ */ new Set(["p"]), U0 = /* @__PURE__ */ new Set(["thead", "tbody"]), Y0 = /* @__PURE__ */ new Set(["dd", "dt"]), q0 = /* @__PURE__ */ new Set(["rt", "rp"]), Y2 = /* @__PURE__ */ new Map([
  ["tr", /* @__PURE__ */ new Set(["tr", "th", "td"])],
  ["th", /* @__PURE__ */ new Set(["th"])],
  ["td", /* @__PURE__ */ new Set(["thead", "th", "td"])],
  ["body", /* @__PURE__ */ new Set(["head", "link", "script"])],
  ["li", /* @__PURE__ */ new Set(["li"])],
  ["p", _e],
  ["h1", _e],
  ["h2", _e],
  ["h3", _e],
  ["h4", _e],
  ["h5", _e],
  ["h6", _e],
  ["select", $n],
  ["input", $n],
  ["output", $n],
  ["button", $n],
  ["datalist", $n],
  ["textarea", $n],
  ["option", /* @__PURE__ */ new Set(["option"])],
  ["optgroup", /* @__PURE__ */ new Set(["optgroup", "option"])],
  ["dd", Y0],
  ["dt", Y0],
  ["address", _e],
  ["article", _e],
  ["aside", _e],
  ["blockquote", _e],
  ["details", _e],
  ["div", _e],
  ["dl", _e],
  ["fieldset", _e],
  ["figcaption", _e],
  ["figure", _e],
  ["footer", _e],
  ["form", _e],
  ["header", _e],
  ["hr", _e],
  ["main", _e],
  ["nav", _e],
  ["ol", _e],
  ["pre", _e],
  ["section", _e],
  ["table", _e],
  ["ul", _e],
  ["rt", q0],
  ["rp", q0],
  ["tbody", U0],
  ["tfoot", U0]
]), q2 = /* @__PURE__ */ new Set([
  "area",
  "base",
  "basefont",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
]), $0 = /* @__PURE__ */ new Set(["math", "svg"]), W0 = /* @__PURE__ */ new Set([
  "mi",
  "mo",
  "mn",
  "ms",
  "mtext",
  "annotation-xml",
  "foreignobject",
  "desc",
  "title"
]), $2 = /\s|\//;
let W2 = class {
  constructor(e, n = {}) {
    var s, r, i, u, a, o;
    this.options = n, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = e ?? {}, this.htmlMode = !this.options.xmlMode, this.lowerCaseTagNames = (s = n.lowerCaseTags) !== null && s !== void 0 ? s : this.htmlMode, this.lowerCaseAttributeNames = (r = n.lowerCaseAttributeNames) !== null && r !== void 0 ? r : this.htmlMode, this.recognizeSelfClosing = (i = n.recognizeSelfClosing) !== null && i !== void 0 ? i : !this.htmlMode, this.tokenizer = new ((u = n.Tokenizer) !== null && u !== void 0 ? u : U2)(this.options, this), this.foreignContext = [!this.htmlMode], (o = (a = this.cbs).onparserinit) === null || o === void 0 || o.call(a, this);
  }
  // Tokenizer event handlers
  /** @internal */
  ontext(e, n) {
    var s, r;
    const i = this.getSlice(e, n);
    this.endIndex = n - 1, (r = (s = this.cbs).ontext) === null || r === void 0 || r.call(s, i), this.startIndex = n;
  }
  /** @internal */
  ontextentity(e, n) {
    var s, r;
    this.endIndex = n - 1, (r = (s = this.cbs).ontext) === null || r === void 0 || r.call(s, H0(e)), this.startIndex = n;
  }
  /**
   * Checks if the current tag is a void element. Override this if you want
   * to specify your own additional void elements.
   */
  isVoidElement(e) {
    return this.htmlMode && q2.has(e);
  }
  /** @internal */
  onopentagname(e, n) {
    this.endIndex = n;
    let s = this.getSlice(e, n);
    this.lowerCaseTagNames && (s = s.toLowerCase()), this.emitOpenTag(s);
  }
  emitOpenTag(e) {
    var n, s, r, i;
    this.openTagStart = this.startIndex, this.tagname = e;
    const u = this.htmlMode && Y2.get(e);
    if (u)
      for (; this.stack.length > 0 && u.has(this.stack[0]); ) {
        const a = this.stack.shift();
        (s = (n = this.cbs).onclosetag) === null || s === void 0 || s.call(n, a, !0);
      }
    this.isVoidElement(e) || (this.stack.unshift(e), this.htmlMode && ($0.has(e) ? this.foreignContext.unshift(!0) : W0.has(e) && this.foreignContext.unshift(!1))), (i = (r = this.cbs).onopentagname) === null || i === void 0 || i.call(r, e), this.cbs.onopentag && (this.attribs = {});
  }
  endOpenTag(e) {
    var n, s;
    this.startIndex = this.openTagStart, this.attribs && ((s = (n = this.cbs).onopentag) === null || s === void 0 || s.call(n, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
  }
  /** @internal */
  onopentagend(e) {
    this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
  }
  /** @internal */
  onclosetag(e, n) {
    var s, r, i, u, a, o, c, l;
    this.endIndex = n;
    let f = this.getSlice(e, n);
    if (this.lowerCaseTagNames && (f = f.toLowerCase()), this.htmlMode && ($0.has(f) || W0.has(f)) && this.foreignContext.shift(), this.isVoidElement(f))
      this.htmlMode && f === "br" && ((u = (i = this.cbs).onopentagname) === null || u === void 0 || u.call(i, "br"), (o = (a = this.cbs).onopentag) === null || o === void 0 || o.call(a, "br", {}, !0), (l = (c = this.cbs).onclosetag) === null || l === void 0 || l.call(c, "br", !1));
    else {
      const h = this.stack.indexOf(f);
      if (h !== -1)
        for (let x = 0; x <= h; x++) {
          const m = this.stack.shift();
          (r = (s = this.cbs).onclosetag) === null || r === void 0 || r.call(s, m, x !== h);
        }
      else this.htmlMode && f === "p" && (this.emitOpenTag("p"), this.closeCurrentTag(!0));
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  onselfclosingtag(e) {
    this.endIndex = e, this.recognizeSelfClosing || this.foreignContext[0] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
  }
  closeCurrentTag(e) {
    var n, s;
    const r = this.tagname;
    this.endOpenTag(e), this.stack[0] === r && ((s = (n = this.cbs).onclosetag) === null || s === void 0 || s.call(n, r, !e), this.stack.shift());
  }
  /** @internal */
  onattribname(e, n) {
    this.startIndex = e;
    const s = this.getSlice(e, n);
    this.attribname = this.lowerCaseAttributeNames ? s.toLowerCase() : s;
  }
  /** @internal */
  onattribdata(e, n) {
    this.attribvalue += this.getSlice(e, n);
  }
  /** @internal */
  onattribentity(e) {
    this.attribvalue += H0(e);
  }
  /** @internal */
  onattribend(e, n) {
    var s, r;
    this.endIndex = n, (r = (s = this.cbs).onattribute) === null || r === void 0 || r.call(s, this.attribname, this.attribvalue, e === Lt.Double ? '"' : e === Lt.Single ? "'" : e === Lt.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
  }
  getInstructionName(e) {
    const n = e.search($2);
    let s = n < 0 ? e : e.substr(0, n);
    return this.lowerCaseTagNames && (s = s.toLowerCase()), s;
  }
  /** @internal */
  ondeclaration(e, n) {
    this.endIndex = n;
    const s = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      const r = this.getInstructionName(s);
      this.cbs.onprocessinginstruction(`!${r}`, `!${s}`);
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  onprocessinginstruction(e, n) {
    this.endIndex = n;
    const s = this.getSlice(e, n);
    if (this.cbs.onprocessinginstruction) {
      const r = this.getInstructionName(s);
      this.cbs.onprocessinginstruction(`?${r}`, `?${s}`);
    }
    this.startIndex = n + 1;
  }
  /** @internal */
  oncomment(e, n, s) {
    var r, i, u, a;
    this.endIndex = n, (i = (r = this.cbs).oncomment) === null || i === void 0 || i.call(r, this.getSlice(e, n - s)), (a = (u = this.cbs).oncommentend) === null || a === void 0 || a.call(u), this.startIndex = n + 1;
  }
  /** @internal */
  oncdata(e, n, s) {
    var r, i, u, a, o, c, l, f, h, x;
    this.endIndex = n;
    const m = this.getSlice(e, n - s);
    !this.htmlMode || this.options.recognizeCDATA ? ((i = (r = this.cbs).oncdatastart) === null || i === void 0 || i.call(r), (a = (u = this.cbs).ontext) === null || a === void 0 || a.call(u, m), (c = (o = this.cbs).oncdataend) === null || c === void 0 || c.call(o)) : ((f = (l = this.cbs).oncomment) === null || f === void 0 || f.call(l, `[CDATA[${m}]]`), (x = (h = this.cbs).oncommentend) === null || x === void 0 || x.call(h)), this.startIndex = n + 1;
  }
  /** @internal */
  onend() {
    var e, n;
    if (this.cbs.onclosetag) {
      this.endIndex = this.startIndex;
      for (let s = 0; s < this.stack.length; s++)
        this.cbs.onclosetag(this.stack[s], !0);
    }
    (n = (e = this.cbs).onend) === null || n === void 0 || n.call(e);
  }
  /**
   * Resets the parser to a blank state, ready to parse a new HTML document
   */
  reset() {
    var e, n, s, r;
    (n = (e = this.cbs).onreset) === null || n === void 0 || n.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, (r = (s = this.cbs).onparserinit) === null || r === void 0 || r.call(s, this), this.buffers.length = 0, this.foreignContext.length = 0, this.foreignContext.unshift(!this.htmlMode), this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
  }
  /**
   * Resets the parser, then parses a complete document and
   * pushes it to the handler.
   *
   * @param data Document to parse.
   */
  parseComplete(e) {
    this.reset(), this.end(e);
  }
  getSlice(e, n) {
    for (; e - this.bufferOffset >= this.buffers[0].length; )
      this.shiftBuffer();
    let s = this.buffers[0].slice(e - this.bufferOffset, n - this.bufferOffset);
    for (; n - this.bufferOffset > this.buffers[0].length; )
      this.shiftBuffer(), s += this.buffers[0].slice(0, n - this.bufferOffset);
    return s;
  }
  shiftBuffer() {
    this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
  }
  /**
   * Parses a chunk of data and calls the corresponding callbacks.
   *
   * @param chunk Chunk to parse.
   */
  write(e) {
    var n, s;
    if (this.ended) {
      (s = (n = this.cbs).onerror) === null || s === void 0 || s.call(n, new Error(".write() after done!"));
      return;
    }
    this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++);
  }
  /**
   * Parses the end of the buffer and clears the stack, calls onend.
   *
   * @param chunk Optional final chunk to parse.
   */
  end(e) {
    var n, s;
    if (this.ended) {
      (s = (n = this.cbs).onerror) === null || s === void 0 || s.call(n, new Error(".end() after done!"));
      return;
    }
    e && this.write(e), this.ended = !0, this.tokenizer.end();
  }
  /**
   * Pauses parsing. The parser won't emit events until `resume` is called.
   */
  pause() {
    this.tokenizer.pause();
  }
  /**
   * Resumes parsing after `pause` was called.
   */
  resume() {
    for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length; )
      this.tokenizer.write(this.buffers[this.writeIndex++]);
    this.ended && this.tokenizer.end();
  }
  /**
   * Alias of `write`, for backwards compatibility.
   *
   * @param chunk Chunk to parse.
   * @deprecated
   */
  parseChunk(e) {
    this.write(e);
  }
  /**
   * Alias of `end`, for backwards compatibility.
   *
   * @param chunk Optional final chunk to parse.
   * @deprecated
   */
  done(e) {
    this.end(e);
  }
};
function z2(t, e) {
  const n = new I1(void 0, e);
  return new W2(n, e).end(t), n.root;
}
var Yi;
const Vs = (
  // @ts-expect-error `hasOwn` is a standard object method
  (Yi = Object.hasOwn) !== null && Yi !== void 0 ? Yi : (t, e) => Object.prototype.hasOwnProperty.call(t, e)
), js = /\s+/, ea = "data-", Ya = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, V2 = /^{[^]*}$|^\[[^]*]$/;
function zr(t, e, n) {
  var s;
  if (!(!t || !ee(t))) {
    if ((s = t.attribs) !== null && s !== void 0 || (t.attribs = {}), !e)
      return t.attribs;
    if (Vs(t.attribs, e))
      return !n && Ya.test(e) ? e : t.attribs[e];
    if (t.name === "option" && e === "value")
      return zs(t.children);
    if (t.name === "input" && (t.attribs.type === "radio" || t.attribs.type === "checkbox") && e === "value")
      return "on";
  }
}
function Gn(t, e, n) {
  n === null ? od(t, e) : t.attribs[e] = `${n}`;
}
function j2(t, e) {
  if (typeof t == "object" || e !== void 0) {
    if (typeof e == "function") {
      if (typeof t != "string")
        throw new Error("Bad combination of arguments.");
      return Ne(this, (n, s) => {
        ee(n) && Gn(n, t, e.call(n, s, n.attribs[t]));
      });
    }
    return Ne(this, (n) => {
      if (ee(n))
        if (typeof t == "object")
          for (const s of Object.keys(t)) {
            const r = t[s];
            Gn(n, s, r);
          }
        else
          Gn(n, t, e);
    });
  }
  return arguments.length > 1 ? this : zr(this[0], t, this.options.xmlMode);
}
function z0(t, e, n) {
  return e in t ? (
    // @ts-expect-error TS doesn't like us accessing the value directly here.
    t[e]
  ) : !n && Ya.test(e) ? zr(t, e, !1) !== void 0 : zr(t, e, n);
}
function qi(t, e, n, s) {
  e in t ? t[e] = n : Gn(t, e, !s && Ya.test(e) ? n ? "" : null : `${n}`);
}
function G2(t, e) {
  var n;
  if (typeof t == "string" && e === void 0) {
    const s = this[0];
    if (!s)
      return;
    switch (t) {
      case "style": {
        const r = this.css(), i = Object.keys(r);
        for (let u = 0; u < i.length; u++)
          r[u] = i[u];
        return r.length = i.length, r;
      }
      case "tagName":
      case "nodeName":
        return ee(s) ? s.name.toUpperCase() : void 0;
      case "href":
      case "src": {
        if (!ee(s))
          return;
        const r = (n = s.attribs) === null || n === void 0 ? void 0 : n[t];
        return typeof URL < "u" && (t === "href" && (s.tagName === "a" || s.tagName === "link") || t === "src" && (s.tagName === "img" || s.tagName === "iframe" || s.tagName === "audio" || s.tagName === "video" || s.tagName === "source")) && r !== void 0 && this.options.baseURI ? new URL(r, this.options.baseURI).href : r;
      }
      case "innerText":
        return qr(s);
      case "textContent":
        return Zn(s);
      case "outerHTML":
        return s.type === Ia ? this.html() : this.clone().wrap("<container />").parent().html();
      case "innerHTML":
        return this.html();
      default:
        return ee(s) ? z0(s, t, this.options.xmlMode) : void 0;
    }
  }
  if (typeof t == "object" || e !== void 0) {
    if (typeof e == "function") {
      if (typeof t == "object")
        throw new TypeError("Bad combination of arguments.");
      return Ne(this, (s, r) => {
        ee(s) && qi(s, t, e.call(s, r, z0(s, t, this.options.xmlMode)), this.options.xmlMode);
      });
    }
    return Ne(this, (s) => {
      if (ee(s))
        if (typeof t == "object")
          for (const r of Object.keys(t)) {
            const i = t[r];
            qi(s, r, i, this.options.xmlMode);
          }
        else
          qi(s, t, e, this.options.xmlMode);
    });
  }
}
function V0(t, e, n) {
  var s;
  (s = t.data) !== null && s !== void 0 || (t.data = {}), typeof e == "object" ? Object.assign(t.data, e) : typeof e == "string" && n !== void 0 && (t.data[e] = n);
}
function X2(t) {
  for (const e of Object.keys(t.attribs)) {
    if (!e.startsWith(ea))
      continue;
    const n = S2(e.slice(ea.length));
    Vs(t.data, n) || (t.data[n] = ad(t.attribs[e]));
  }
  return t.data;
}
function Q2(t, e) {
  const n = ea + w2(e), s = t.data;
  if (Vs(s, e))
    return s[e];
  if (Vs(t.attribs, n))
    return s[e] = ad(t.attribs[n]);
}
function ad(t) {
  if (t === "null")
    return null;
  if (t === "true")
    return !0;
  if (t === "false")
    return !1;
  const e = Number(t);
  if (t === String(e))
    return e;
  if (V2.test(t))
    try {
      return JSON.parse(t);
    } catch {
    }
  return t;
}
function K2(t, e) {
  var n;
  const s = this[0];
  if (!s || !ee(s))
    return;
  const r = s;
  return (n = r.data) !== null && n !== void 0 || (r.data = {}), t == null ? X2(r) : typeof t == "object" || e !== void 0 ? (Ne(this, (i) => {
    ee(i) && (typeof t == "object" ? V0(i, t) : V0(i, t, e));
  }), this) : Q2(r, t);
}
function Z2(t) {
  const e = arguments.length === 0, n = this[0];
  if (!n || !ee(n))
    return e ? void 0 : this;
  switch (n.name) {
    case "textarea":
      return this.text(t);
    case "select": {
      const s = this.find("option:selected");
      if (!e) {
        if (this.attr("multiple") == null && typeof t == "object")
          return this;
        this.find("option").removeAttr("selected");
        const r = typeof t == "object" ? t : [t];
        for (const i of r)
          this.find(`option[value="${i}"]`).attr("selected", "");
        return this;
      }
      return this.attr("multiple") ? s.toArray().map((r) => zs(r.children)) : s.attr("value");
    }
    case "input":
    case "option":
      return e ? this.attr("value") : this.attr("value", t);
  }
}
function od(t, e) {
  !t.attribs || !Vs(t.attribs, e) || delete t.attribs[e];
}
function Vr(t) {
  return t ? t.trim().split(js) : [];
}
function J2(t) {
  const e = Vr(t);
  for (const n of e)
    Ne(this, (s) => {
      ee(s) && od(s, n);
    });
  return this;
}
function eb(t) {
  return this.toArray().some((e) => {
    const n = ee(e) && e.attribs.class;
    let s = -1;
    if (n && t.length > 0)
      for (; (s = n.indexOf(t, s + 1)) > -1; ) {
        const r = s + t.length;
        if ((s === 0 || js.test(n[s - 1])) && (r === n.length || js.test(n[r])))
          return !0;
      }
    return !1;
  });
}
function cd(t) {
  if (typeof t == "function")
    return Ne(this, (s, r) => {
      if (ee(s)) {
        const i = s.attribs.class || "";
        cd.call([s], t.call(s, r, i));
      }
    });
  if (!t || typeof t != "string")
    return this;
  const e = t.split(js), n = this.length;
  for (let s = 0; s < n; s++) {
    const r = this[s];
    if (!ee(r))
      continue;
    const i = zr(r, "class", !1);
    if (i) {
      let u = ` ${i} `;
      for (const a of e) {
        const o = `${a} `;
        u.includes(` ${o}`) || (u += o);
      }
      Gn(r, "class", u.trim());
    } else
      Gn(r, "class", e.join(" ").trim());
  }
  return this;
}
function ld(t) {
  if (typeof t == "function")
    return Ne(this, (r, i) => {
      ee(r) && ld.call([r], t.call(r, i, r.attribs.class || ""));
    });
  const e = Vr(t), n = e.length, s = arguments.length === 0;
  return Ne(this, (r) => {
    if (ee(r))
      if (s)
        r.attribs.class = "";
      else {
        const i = Vr(r.attribs.class);
        let u = !1;
        for (let a = 0; a < n; a++) {
          const o = i.indexOf(e[a]);
          o !== -1 && (i.splice(o, 1), u = !0, a--);
        }
        u && (r.attribs.class = i.join(" "));
      }
  });
}
function dd(t, e) {
  if (typeof t == "function")
    return Ne(this, (u, a) => {
      ee(u) && dd.call([u], t.call(u, a, u.attribs.class || "", e), e);
    });
  if (!t || typeof t != "string")
    return this;
  const n = t.split(js), s = n.length, r = typeof e == "boolean" ? e ? 1 : -1 : 0, i = this.length;
  for (let u = 0; u < i; u++) {
    const a = this[u];
    if (!ee(a))
      continue;
    const o = Vr(a.attribs.class);
    for (let c = 0; c < s; c++) {
      const l = o.indexOf(n[c]);
      r >= 0 && l === -1 ? o.push(n[c]) : r <= 0 && l !== -1 && o.splice(l, 1);
    }
    a.attribs.class = o.join(" ");
  }
  return this;
}
const tb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addClass: cd,
  attr: j2,
  data: K2,
  hasClass: eb,
  prop: G2,
  removeAttr: J2,
  removeClass: ld,
  toggleClass: dd,
  val: Z2
}, Symbol.toStringTag, { value: "Module" }));
var Z;
(function(t) {
  t.Attribute = "attribute", t.Pseudo = "pseudo", t.PseudoElement = "pseudo-element", t.Tag = "tag", t.Universal = "universal", t.Adjacent = "adjacent", t.Child = "child", t.Descendant = "descendant", t.Parent = "parent", t.Sibling = "sibling", t.ColumnCombinator = "column-combinator";
})(Z || (Z = {}));
var He;
(function(t) {
  t.Any = "any", t.Element = "element", t.End = "end", t.Equals = "equals", t.Exists = "exists", t.Hyphen = "hyphen", t.Not = "not", t.Start = "start";
})(He || (He = {}));
const j0 = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/, nb = /\\([\da-f]{1,6}\s?|(\s)|.)/gi, sb = /* @__PURE__ */ new Map([
  [126, He.Element],
  [94, He.Start],
  [36, He.End],
  [42, He.Any],
  [33, He.Not],
  [124, He.Hyphen]
]), rb = /* @__PURE__ */ new Set([
  "has",
  "not",
  "matches",
  "is",
  "where",
  "host",
  "host-context"
]);
function Os(t) {
  switch (t.type) {
    case Z.Adjacent:
    case Z.Child:
    case Z.Descendant:
    case Z.Parent:
    case Z.Sibling:
    case Z.ColumnCombinator:
      return !0;
    default:
      return !1;
  }
}
const ib = /* @__PURE__ */ new Set(["contains", "icontains"]);
function ub(t, e, n) {
  const s = parseInt(e, 16) - 65536;
  return s !== s || n ? e : s < 0 ? (
    // BMP codepoint
    String.fromCharCode(s + 65536)
  ) : (
    // Supplemental Plane codepoint (surrogate pair)
    String.fromCharCode(s >> 10 | 55296, s & 1023 | 56320)
  );
}
function hs(t) {
  return t.replace(nb, ub);
}
function $i(t) {
  return t === 39 || t === 34;
}
function G0(t) {
  return t === 32 || t === 9 || t === 10 || t === 12 || t === 13;
}
function mi(t) {
  const e = [], n = fd(e, `${t}`, 0);
  if (n < t.length)
    throw new Error(`Unmatched selector: ${t.slice(n)}`);
  return e;
}
function fd(t, e, n) {
  let s = [];
  function r(h) {
    const x = e.slice(n + h).match(j0);
    if (!x)
      throw new Error(`Expected name, found ${e.slice(n)}`);
    const [m] = x;
    return n += h + m.length, hs(m);
  }
  function i(h) {
    for (n += h; n < e.length && G0(e.charCodeAt(n)); )
      n++;
  }
  function u() {
    n += 1;
    const h = n;
    let x = 1;
    for (; x > 0 && n < e.length; n++)
      e.charCodeAt(n) === 40 && !a(n) ? x++ : e.charCodeAt(n) === 41 && !a(n) && x--;
    if (x)
      throw new Error("Parenthesis not matched");
    return hs(e.slice(h, n - 1));
  }
  function a(h) {
    let x = 0;
    for (; e.charCodeAt(--h) === 92; )
      x++;
    return (x & 1) === 1;
  }
  function o() {
    if (s.length > 0 && Os(s[s.length - 1]))
      throw new Error("Did not expect successive traversals.");
  }
  function c(h) {
    if (s.length > 0 && s[s.length - 1].type === Z.Descendant) {
      s[s.length - 1].type = h;
      return;
    }
    o(), s.push({ type: h });
  }
  function l(h, x) {
    s.push({
      type: Z.Attribute,
      name: h,
      action: x,
      value: r(1),
      namespace: null,
      ignoreCase: "quirks"
    });
  }
  function f() {
    if (s.length && s[s.length - 1].type === Z.Descendant && s.pop(), s.length === 0)
      throw new Error("Empty sub-selector");
    t.push(s);
  }
  if (i(0), e.length === n)
    return n;
  e: for (; n < e.length; ) {
    const h = e.charCodeAt(n);
    switch (h) {
      case 32:
      case 9:
      case 10:
      case 12:
      case 13: {
        (s.length === 0 || s[0].type !== Z.Descendant) && (o(), s.push({ type: Z.Descendant })), i(1);
        break;
      }
      case 62: {
        c(Z.Child), i(1);
        break;
      }
      case 60: {
        c(Z.Parent), i(1);
        break;
      }
      case 126: {
        c(Z.Sibling), i(1);
        break;
      }
      case 43: {
        c(Z.Adjacent), i(1);
        break;
      }
      case 46: {
        l("class", He.Element);
        break;
      }
      case 35: {
        l("id", He.Equals);
        break;
      }
      case 91: {
        i(1);
        let x, m = null;
        e.charCodeAt(n) === 124 ? x = r(1) : e.startsWith("*|", n) ? (m = "*", x = r(2)) : (x = r(0), e.charCodeAt(n) === 124 && e.charCodeAt(n + 1) !== 61 && (m = x, x = r(1))), i(0);
        let p = He.Exists;
        const b = sb.get(e.charCodeAt(n));
        if (b) {
          if (p = b, e.charCodeAt(n + 1) !== 61)
            throw new Error("Expected `=`");
          i(2);
        } else e.charCodeAt(n) === 61 && (p = He.Equals, i(1));
        let E = "", g = null;
        if (p !== "exists") {
          if ($i(e.charCodeAt(n))) {
            const C = e.charCodeAt(n);
            let y = n + 1;
            for (; y < e.length && (e.charCodeAt(y) !== C || a(y)); )
              y += 1;
            if (e.charCodeAt(y) !== C)
              throw new Error("Attribute value didn't end");
            E = hs(e.slice(n + 1, y)), n = y + 1;
          } else {
            const C = n;
            for (; n < e.length && (!G0(e.charCodeAt(n)) && e.charCodeAt(n) !== 93 || a(n)); )
              n += 1;
            E = hs(e.slice(C, n));
          }
          i(0);
          const T = e.charCodeAt(n) | 32;
          T === 115 ? (g = !1, i(1)) : T === 105 && (g = !0, i(1));
        }
        if (e.charCodeAt(n) !== 93)
          throw new Error("Attribute selector didn't terminate");
        n += 1;
        const _ = {
          type: Z.Attribute,
          name: x,
          action: p,
          value: E,
          namespace: m,
          ignoreCase: g
        };
        s.push(_);
        break;
      }
      case 58: {
        if (e.charCodeAt(n + 1) === 58) {
          s.push({
            type: Z.PseudoElement,
            name: r(2).toLowerCase(),
            data: e.charCodeAt(n) === 40 ? u() : null
          });
          continue;
        }
        const x = r(1).toLowerCase();
        let m = null;
        if (e.charCodeAt(n) === 40)
          if (rb.has(x)) {
            if ($i(e.charCodeAt(n + 1)))
              throw new Error(`Pseudo-selector ${x} cannot be quoted`);
            if (m = [], n = fd(m, e, n + 1), e.charCodeAt(n) !== 41)
              throw new Error(`Missing closing parenthesis in :${x} (${e})`);
            n += 1;
          } else {
            if (m = u(), ib.has(x)) {
              const p = m.charCodeAt(0);
              p === m.charCodeAt(m.length - 1) && $i(p) && (m = m.slice(1, -1));
            }
            m = hs(m);
          }
        s.push({ type: Z.Pseudo, name: x, data: m });
        break;
      }
      case 44: {
        f(), s = [], i(1);
        break;
      }
      default: {
        if (e.startsWith("/*", n)) {
          const p = e.indexOf("*/", n + 2);
          if (p < 0)
            throw new Error("Comment was not terminated");
          n = p + 2, s.length === 0 && i(0);
          break;
        }
        let x = null, m;
        if (h === 42)
          n += 1, m = "*";
        else if (h === 124) {
          if (m = "", e.charCodeAt(n + 1) === 124) {
            c(Z.ColumnCombinator), i(2);
            break;
          }
        } else if (j0.test(e.slice(n)))
          m = r(0);
        else
          break e;
        e.charCodeAt(n) === 124 && e.charCodeAt(n + 1) !== 124 && (x = m, e.charCodeAt(n + 1) === 42 ? (m = "*", n += 2) : m = r(1)), s.push(m === "*" ? { type: Z.Universal, namespace: x } : { type: Z.Tag, name: m, namespace: x });
      }
    }
  }
  return f(), n;
}
var jr = {
  trueFunc: function() {
    return !0;
  },
  falseFunc: function() {
    return !1;
  }
};
const le = /* @__PURE__ */ rs(jr), hd = /* @__PURE__ */ new Map([
  [Z.Universal, 50],
  [Z.Tag, 30],
  [Z.Attribute, 1],
  [Z.Pseudo, 0]
]);
function qa(t) {
  return !hd.has(t.type);
}
const ab = /* @__PURE__ */ new Map([
  [He.Exists, 10],
  [He.Equals, 8],
  [He.Not, 7],
  [He.Start, 6],
  [He.End, 6],
  [He.Any, 5]
]);
function ob(t) {
  const e = t.map(bd);
  for (let n = 1; n < t.length; n++) {
    const s = e[n];
    if (!(s < 0))
      for (let r = n - 1; r >= 0 && s < e[r]; r--) {
        const i = t[r + 1];
        t[r + 1] = t[r], t[r] = i, e[r + 1] = e[r], e[r] = s;
      }
  }
}
function bd(t) {
  var e, n;
  let s = (e = hd.get(t.type)) !== null && e !== void 0 ? e : -1;
  return t.type === Z.Attribute ? (s = (n = ab.get(t.action)) !== null && n !== void 0 ? n : 4, t.action === He.Equals && t.name === "id" && (s = 9), t.ignoreCase && (s >>= 1)) : t.type === Z.Pseudo && (t.data ? t.name === "has" || t.name === "contains" ? s = 0 : Array.isArray(t.data) ? (s = Math.min(...t.data.map((r) => Math.min(...r.map(bd)))), s < 0 && (s = 0)) : s = 2 : s = 3), s;
}
const cb = /[-[\]{}()*+?.,\\^$|#\s]/g;
function X0(t) {
  return t.replace(cb, "\\$&");
}
const lb = /* @__PURE__ */ new Set([
  "accept",
  "accept-charset",
  "align",
  "alink",
  "axis",
  "bgcolor",
  "charset",
  "checked",
  "clear",
  "codetype",
  "color",
  "compact",
  "declare",
  "defer",
  "dir",
  "direction",
  "disabled",
  "enctype",
  "face",
  "frame",
  "hreflang",
  "http-equiv",
  "lang",
  "language",
  "link",
  "media",
  "method",
  "multiple",
  "nohref",
  "noresize",
  "noshade",
  "nowrap",
  "readonly",
  "rel",
  "rev",
  "rules",
  "scope",
  "scrolling",
  "selected",
  "shape",
  "target",
  "text",
  "type",
  "valign",
  "valuetype",
  "vlink"
]);
function hn(t, e) {
  return typeof t.ignoreCase == "boolean" ? t.ignoreCase : t.ignoreCase === "quirks" ? !!e.quirksMode : !e.xmlMode && lb.has(t.name);
}
const db = {
  equals(t, e, n) {
    const { adapter: s } = n, { name: r } = e;
    let { value: i } = e;
    return hn(e, n) ? (i = i.toLowerCase(), (u) => {
      const a = s.getAttributeValue(u, r);
      return a != null && a.length === i.length && a.toLowerCase() === i && t(u);
    }) : (u) => s.getAttributeValue(u, r) === i && t(u);
  },
  hyphen(t, e, n) {
    const { adapter: s } = n, { name: r } = e;
    let { value: i } = e;
    const u = i.length;
    return hn(e, n) ? (i = i.toLowerCase(), function(o) {
      const c = s.getAttributeValue(o, r);
      return c != null && (c.length === u || c.charAt(u) === "-") && c.substr(0, u).toLowerCase() === i && t(o);
    }) : function(o) {
      const c = s.getAttributeValue(o, r);
      return c != null && (c.length === u || c.charAt(u) === "-") && c.substr(0, u) === i && t(o);
    };
  },
  element(t, e, n) {
    const { adapter: s } = n, { name: r, value: i } = e;
    if (/\s/.test(i))
      return le.falseFunc;
    const u = new RegExp(`(?:^|\\s)${X0(i)}(?:$|\\s)`, hn(e, n) ? "i" : "");
    return function(o) {
      const c = s.getAttributeValue(o, r);
      return c != null && c.length >= i.length && u.test(c) && t(o);
    };
  },
  exists(t, { name: e }, { adapter: n }) {
    return (s) => n.hasAttrib(s, e) && t(s);
  },
  start(t, e, n) {
    const { adapter: s } = n, { name: r } = e;
    let { value: i } = e;
    const u = i.length;
    return u === 0 ? le.falseFunc : hn(e, n) ? (i = i.toLowerCase(), (a) => {
      const o = s.getAttributeValue(a, r);
      return o != null && o.length >= u && o.substr(0, u).toLowerCase() === i && t(a);
    }) : (a) => {
      var o;
      return !!(!((o = s.getAttributeValue(a, r)) === null || o === void 0) && o.startsWith(i)) && t(a);
    };
  },
  end(t, e, n) {
    const { adapter: s } = n, { name: r } = e;
    let { value: i } = e;
    const u = -i.length;
    return u === 0 ? le.falseFunc : hn(e, n) ? (i = i.toLowerCase(), (a) => {
      var o;
      return ((o = s.getAttributeValue(a, r)) === null || o === void 0 ? void 0 : o.substr(u).toLowerCase()) === i && t(a);
    }) : (a) => {
      var o;
      return !!(!((o = s.getAttributeValue(a, r)) === null || o === void 0) && o.endsWith(i)) && t(a);
    };
  },
  any(t, e, n) {
    const { adapter: s } = n, { name: r, value: i } = e;
    if (i === "")
      return le.falseFunc;
    if (hn(e, n)) {
      const u = new RegExp(X0(i), "i");
      return function(o) {
        const c = s.getAttributeValue(o, r);
        return c != null && c.length >= i.length && u.test(c) && t(o);
      };
    }
    return (u) => {
      var a;
      return !!(!((a = s.getAttributeValue(u, r)) === null || a === void 0) && a.includes(i)) && t(u);
    };
  },
  not(t, e, n) {
    const { adapter: s } = n, { name: r } = e;
    let { value: i } = e;
    return i === "" ? (u) => !!s.getAttributeValue(u, r) && t(u) : hn(e, n) ? (i = i.toLowerCase(), (u) => {
      const a = s.getAttributeValue(u, r);
      return (a == null || a.length !== i.length || a.toLowerCase() !== i) && t(u);
    }) : (u) => s.getAttributeValue(u, r) !== i && t(u);
  }
}, fb = /* @__PURE__ */ new Set([9, 10, 12, 13, 32]), Q0 = 48, hb = 57;
function bb(t) {
  if (t = t.trim().toLowerCase(), t === "even")
    return [2, 0];
  if (t === "odd")
    return [2, 1];
  let e = 0, n = 0, s = i(), r = u();
  if (e < t.length && t.charAt(e) === "n" && (e++, n = s * (r ?? 1), a(), e < t.length ? (s = i(), a(), r = u()) : s = r = 0), r === null || e < t.length)
    throw new Error(`n-th rule couldn't be parsed ('${t}')`);
  return [n, s * r];
  function i() {
    return t.charAt(e) === "-" ? (e++, -1) : (t.charAt(e) === "+" && e++, 1);
  }
  function u() {
    const o = e;
    let c = 0;
    for (; e < t.length && t.charCodeAt(e) >= Q0 && t.charCodeAt(e) <= hb; )
      c = c * 10 + (t.charCodeAt(e) - Q0), e++;
    return e === o ? null : c;
  }
  function a() {
    for (; e < t.length && fb.has(t.charCodeAt(e)); )
      e++;
  }
}
function xb(t) {
  const e = t[0], n = t[1] - 1;
  if (n < 0 && e <= 0)
    return le.falseFunc;
  if (e === -1)
    return (i) => i <= n;
  if (e === 0)
    return (i) => i === n;
  if (e === 1)
    return n < 0 ? le.trueFunc : (i) => i >= n;
  const s = Math.abs(e), r = (n % s + s) % s;
  return e > 1 ? (i) => i >= n && i % s === r : (i) => i <= n && i % s === r;
}
function xr(t) {
  return xb(bb(t));
}
function mr(t, e) {
  return (n) => {
    const s = e.getParent(n);
    return s != null && e.isTag(s) && t(n);
  };
}
const ta = {
  contains(t, e, { adapter: n }) {
    return function(r) {
      return t(r) && n.getText(r).includes(e);
    };
  },
  icontains(t, e, { adapter: n }) {
    const s = e.toLowerCase();
    return function(i) {
      return t(i) && n.getText(i).toLowerCase().includes(s);
    };
  },
  // Location specific methods
  "nth-child"(t, e, { adapter: n, equals: s }) {
    const r = xr(e);
    return r === le.falseFunc ? le.falseFunc : r === le.trueFunc ? mr(t, n) : function(u) {
      const a = n.getSiblings(u);
      let o = 0;
      for (let c = 0; c < a.length && !s(u, a[c]); c++)
        n.isTag(a[c]) && o++;
      return r(o) && t(u);
    };
  },
  "nth-last-child"(t, e, { adapter: n, equals: s }) {
    const r = xr(e);
    return r === le.falseFunc ? le.falseFunc : r === le.trueFunc ? mr(t, n) : function(u) {
      const a = n.getSiblings(u);
      let o = 0;
      for (let c = a.length - 1; c >= 0 && !s(u, a[c]); c--)
        n.isTag(a[c]) && o++;
      return r(o) && t(u);
    };
  },
  "nth-of-type"(t, e, { adapter: n, equals: s }) {
    const r = xr(e);
    return r === le.falseFunc ? le.falseFunc : r === le.trueFunc ? mr(t, n) : function(u) {
      const a = n.getSiblings(u);
      let o = 0;
      for (let c = 0; c < a.length; c++) {
        const l = a[c];
        if (s(u, l))
          break;
        n.isTag(l) && n.getName(l) === n.getName(u) && o++;
      }
      return r(o) && t(u);
    };
  },
  "nth-last-of-type"(t, e, { adapter: n, equals: s }) {
    const r = xr(e);
    return r === le.falseFunc ? le.falseFunc : r === le.trueFunc ? mr(t, n) : function(u) {
      const a = n.getSiblings(u);
      let o = 0;
      for (let c = a.length - 1; c >= 0; c--) {
        const l = a[c];
        if (s(u, l))
          break;
        n.isTag(l) && n.getName(l) === n.getName(u) && o++;
      }
      return r(o) && t(u);
    };
  },
  // TODO determine the actual root element
  root(t, e, { adapter: n }) {
    return (s) => {
      const r = n.getParent(s);
      return (r == null || !n.isTag(r)) && t(s);
    };
  },
  scope(t, e, n, s) {
    const { equals: r } = n;
    return !s || s.length === 0 ? ta.root(t, e, n) : s.length === 1 ? (i) => r(s[0], i) && t(i) : (i) => s.includes(i) && t(i);
  },
  hover: Wi("isHovered"),
  visited: Wi("isVisited"),
  active: Wi("isActive")
};
function Wi(t) {
  return function(n, s, { adapter: r }) {
    const i = r[t];
    return typeof i != "function" ? le.falseFunc : function(a) {
      return i(a) && n(a);
    };
  };
}
const K0 = {
  empty(t, { adapter: e }) {
    return !e.getChildren(t).some((n) => (
      // FIXME: `getText` call is potentially expensive.
      e.isTag(n) || e.getText(n) !== ""
    ));
  },
  "first-child"(t, { adapter: e, equals: n }) {
    if (e.prevElementSibling)
      return e.prevElementSibling(t) == null;
    const s = e.getSiblings(t).find((r) => e.isTag(r));
    return s != null && n(t, s);
  },
  "last-child"(t, { adapter: e, equals: n }) {
    const s = e.getSiblings(t);
    for (let r = s.length - 1; r >= 0; r--) {
      if (n(t, s[r]))
        return !0;
      if (e.isTag(s[r]))
        break;
    }
    return !1;
  },
  "first-of-type"(t, { adapter: e, equals: n }) {
    const s = e.getSiblings(t), r = e.getName(t);
    for (let i = 0; i < s.length; i++) {
      const u = s[i];
      if (n(t, u))
        return !0;
      if (e.isTag(u) && e.getName(u) === r)
        break;
    }
    return !1;
  },
  "last-of-type"(t, { adapter: e, equals: n }) {
    const s = e.getSiblings(t), r = e.getName(t);
    for (let i = s.length - 1; i >= 0; i--) {
      const u = s[i];
      if (n(t, u))
        return !0;
      if (e.isTag(u) && e.getName(u) === r)
        break;
    }
    return !1;
  },
  "only-of-type"(t, { adapter: e, equals: n }) {
    const s = e.getName(t);
    return e.getSiblings(t).every((r) => n(t, r) || !e.isTag(r) || e.getName(r) !== s);
  },
  "only-child"(t, { adapter: e, equals: n }) {
    return e.getSiblings(t).every((s) => n(t, s) || !e.isTag(s));
  }
};
function Z0(t, e, n, s) {
  if (n === null) {
    if (t.length > s)
      throw new Error(`Pseudo-class :${e} requires an argument`);
  } else if (t.length === s)
    throw new Error(`Pseudo-class :${e} doesn't have any arguments`);
}
const mb = {
  // Links
  "any-link": ":is(a, area, link)[href]",
  link: ":any-link:not(:visited)",
  // Forms
  // https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
  disabled: `:is(
        :is(button, input, select, textarea, optgroup, option)[disabled],
        optgroup[disabled] > option,
        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)
    )`,
  enabled: ":not(:disabled)",
  checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
  required: ":is(input, select, textarea)[required]",
  optional: ":is(input, select, textarea):not([required])",
  // JQuery extensions
  // https://html.spec.whatwg.org/multipage/form-elements.html#concept-option-selectedness
  selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
  checkbox: "[type=checkbox]",
  file: "[type=file]",
  password: "[type=password]",
  radio: "[type=radio]",
  reset: "[type=reset]",
  image: "[type=image]",
  submit: "[type=submit]",
  parent: ":not(:empty)",
  header: ":is(h1, h2, h3, h4, h5, h6)",
  button: ":is(button, input[type=button])",
  input: ":is(input, textarea, select, button)",
  text: "input:is(:not([type!='']), [type=text])"
}, xd = {};
function pb(t, e) {
  return t === le.falseFunc ? le.falseFunc : (n) => e.isTag(n) && t(n);
}
function md(t, e) {
  const n = e.getSiblings(t);
  if (n.length <= 1)
    return [];
  const s = n.indexOf(t);
  return s < 0 || s === n.length - 1 ? [] : n.slice(s + 1).filter(e.isTag);
}
function na(t) {
  return {
    xmlMode: !!t.xmlMode,
    lowerCaseAttributeNames: !!t.lowerCaseAttributeNames,
    lowerCaseTags: !!t.lowerCaseTags,
    quirksMode: !!t.quirksMode,
    cacheResults: !!t.cacheResults,
    pseudos: t.pseudos,
    adapter: t.adapter,
    equals: t.equals
  };
}
const zi = (t, e, n, s, r) => {
  const i = r(e, na(n), s);
  return i === le.trueFunc ? t : i === le.falseFunc ? le.falseFunc : (u) => i(u) && t(u);
}, Vi = {
  is: zi,
  /**
   * `:matches` and `:where` are aliases for `:is`.
   */
  matches: zi,
  where: zi,
  not(t, e, n, s, r) {
    const i = r(e, na(n), s);
    return i === le.falseFunc ? t : i === le.trueFunc ? le.falseFunc : (u) => !i(u) && t(u);
  },
  has(t, e, n, s, r) {
    const { adapter: i } = n, u = na(n);
    u.relativeSelector = !0;
    const a = e.some((l) => l.some(qa)) ? (
      // Used as a placeholder. Will be replaced with the actual element.
      [xd]
    ) : void 0, o = r(e, u, a);
    if (o === le.falseFunc)
      return le.falseFunc;
    const c = pb(o, i);
    if (a && o !== le.trueFunc) {
      const { shouldTestNextSiblings: l = !1 } = o;
      return (f) => {
        if (!t(f))
          return !1;
        a[0] = f;
        const h = i.getChildren(f), x = l ? [...h, ...md(f, i)] : h;
        return i.existsOne(c, x);
      };
    }
    return (l) => t(l) && i.existsOne(c, i.getChildren(l));
  }
};
function gb(t, e, n, s, r) {
  var i;
  const { name: u, data: a } = e;
  if (Array.isArray(a)) {
    if (!(u in Vi))
      throw new Error(`Unknown pseudo-class :${u}(${a})`);
    return Vi[u](t, a, n, s, r);
  }
  const o = (i = n.pseudos) === null || i === void 0 ? void 0 : i[u], c = typeof o == "string" ? o : mb[u];
  if (typeof c == "string") {
    if (a != null)
      throw new Error(`Pseudo ${u} doesn't have any arguments`);
    const l = mi(c);
    return Vi.is(t, l, n, s, r);
  }
  if (typeof o == "function")
    return Z0(o, u, a, 1), (l) => o(l, a) && t(l);
  if (u in ta)
    return ta[u](t, a, n, s);
  if (u in K0) {
    const l = K0[u];
    return Z0(l, u, a, 2), (f) => l(f, n, a) && t(f);
  }
  throw new Error(`Unknown pseudo-class :${u}`);
}
function ji(t, e) {
  const n = e.getParent(t);
  return n && e.isTag(n) ? n : null;
}
function Eb(t, e, n, s, r) {
  const { adapter: i, equals: u } = n;
  switch (e.type) {
    case Z.PseudoElement:
      throw new Error("Pseudo-elements are not supported by css-select");
    case Z.ColumnCombinator:
      throw new Error("Column combinators are not yet supported by css-select");
    case Z.Attribute: {
      if (e.namespace != null)
        throw new Error("Namespaced attributes are not yet supported by css-select");
      return (!n.xmlMode || n.lowerCaseAttributeNames) && (e.name = e.name.toLowerCase()), db[e.action](t, e, n);
    }
    case Z.Pseudo:
      return gb(t, e, n, s, r);
    case Z.Tag: {
      if (e.namespace != null)
        throw new Error("Namespaced tag names are not yet supported by css-select");
      let { name: a } = e;
      return (!n.xmlMode || n.lowerCaseTags) && (a = a.toLowerCase()), function(c) {
        return i.getName(c) === a && t(c);
      };
    }
    case Z.Descendant: {
      if (n.cacheResults === !1 || typeof WeakSet > "u")
        return function(c) {
          let l = c;
          for (; l = ji(l, i); )
            if (t(l))
              return !0;
          return !1;
        };
      const a = /* @__PURE__ */ new WeakSet();
      return function(c) {
        let l = c;
        for (; l = ji(l, i); )
          if (!a.has(l)) {
            if (i.isTag(l) && t(l))
              return !0;
            a.add(l);
          }
        return !1;
      };
    }
    case "_flexibleDescendant":
      return function(o) {
        let c = o;
        do
          if (t(c))
            return !0;
        while (c = ji(c, i));
        return !1;
      };
    case Z.Parent:
      return function(o) {
        return i.getChildren(o).some((c) => i.isTag(c) && t(c));
      };
    case Z.Child:
      return function(o) {
        const c = i.getParent(o);
        return c != null && i.isTag(c) && t(c);
      };
    case Z.Sibling:
      return function(o) {
        const c = i.getSiblings(o);
        for (let l = 0; l < c.length; l++) {
          const f = c[l];
          if (u(o, f))
            break;
          if (i.isTag(f) && t(f))
            return !0;
        }
        return !1;
      };
    case Z.Adjacent:
      return i.prevElementSibling ? function(o) {
        const c = i.prevElementSibling(o);
        return c != null && t(c);
      } : function(o) {
        const c = i.getSiblings(o);
        let l;
        for (let f = 0; f < c.length; f++) {
          const h = c[f];
          if (u(o, h))
            break;
          i.isTag(h) && (l = h);
        }
        return !!l && t(l);
      };
    case Z.Universal: {
      if (e.namespace != null && e.namespace !== "*")
        throw new Error("Namespaced universal selectors are not yet supported by css-select");
      return t;
    }
  }
}
function pd(t) {
  return t.type === Z.Pseudo && (t.name === "scope" || Array.isArray(t.data) && t.data.some((e) => e.some(pd)));
}
const _b = { type: Z.Descendant }, Tb = {
  type: "_flexibleDescendant"
}, Ab = {
  type: Z.Pseudo,
  name: "scope",
  data: null
};
function yb(t, { adapter: e }, n) {
  const s = !!n?.every((r) => {
    const i = e.isTag(r) && e.getParent(r);
    return r === xd || i && e.isTag(i);
  });
  for (const r of t) {
    if (!(r.length > 0 && qa(r[0]) && r[0].type !== Z.Descendant)) if (s && !r.some(pd))
      r.unshift(_b);
    else
      continue;
    r.unshift(Ab);
  }
}
function gd(t, e, n) {
  var s;
  t.forEach(ob), n = (s = e.context) !== null && s !== void 0 ? s : n;
  const r = Array.isArray(n), i = n && (Array.isArray(n) ? n : [n]);
  if (e.relativeSelector !== !1)
    yb(t, e, i);
  else if (t.some((o) => o.length > 0 && qa(o[0])))
    throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
  let u = !1;
  const a = t.map((o) => {
    if (o.length >= 2) {
      const [c, l] = o;
      c.type !== Z.Pseudo || c.name !== "scope" || (r && l.type === Z.Descendant ? o[1] = Tb : (l.type === Z.Adjacent || l.type === Z.Sibling) && (u = !0));
    }
    return Cb(o, e, i);
  }).reduce(Db, le.falseFunc);
  return a.shouldTestNextSiblings = u, a;
}
function Cb(t, e, n) {
  var s;
  return t.reduce((r, i) => r === le.falseFunc ? le.falseFunc : Eb(r, i, e, n, gd), (s = e.rootFunc) !== null && s !== void 0 ? s : le.trueFunc);
}
function Db(t, e) {
  return e === le.falseFunc || t === le.trueFunc ? t : t === le.falseFunc || e === le.trueFunc ? e : function(s) {
    return t(s) || e(s);
  };
}
const Ed = (t, e) => t === e, vb = {
  adapter: xi,
  equals: Ed
};
function Sb(t) {
  var e, n, s, r;
  const i = t ?? vb;
  return (e = i.adapter) !== null && e !== void 0 || (i.adapter = xi), (n = i.equals) !== null && n !== void 0 || (i.equals = (r = (s = i.adapter) === null || s === void 0 ? void 0 : s.equals) !== null && r !== void 0 ? r : Ed), i;
}
function wb(t) {
  return function(n, s, r) {
    const i = Sb(s);
    return t(n, i, r);
  };
}
const $a = wb(gd);
function _d(t, e, n = !1) {
  return n && (t = Nb(t, e)), Array.isArray(t) ? e.removeSubsets(t) : e.getChildren(t);
}
function Nb(t, e) {
  const n = Array.isArray(t) ? t.slice(0) : [t], s = n.length;
  for (let r = 0; r < s; r++) {
    const i = md(n[r], e);
    n.push(...i);
  }
  return n;
}
const Ib = /* @__PURE__ */ new Set([
  "first",
  "last",
  "eq",
  "gt",
  "nth",
  "lt",
  "even",
  "odd"
]);
function Gr(t) {
  return t.type !== "pseudo" ? !1 : Ib.has(t.name) ? !0 : t.name === "not" && Array.isArray(t.data) ? t.data.some((e) => e.some(Gr)) : !1;
}
function Ob(t, e, n) {
  const s = e != null ? parseInt(e, 10) : NaN;
  switch (t) {
    case "first":
      return 1;
    case "nth":
    case "eq":
      return isFinite(s) ? s >= 0 ? s + 1 : 1 / 0 : 0;
    case "lt":
      return isFinite(s) ? s >= 0 ? Math.min(s, n) : 1 / 0 : 0;
    case "gt":
      return isFinite(s) ? 1 / 0 : 0;
    case "odd":
      return 2 * n;
    case "even":
      return 2 * n - 1;
    case "last":
    case "not":
      return 1 / 0;
  }
}
function Bb(t) {
  for (; t.parent; )
    t = t.parent;
  return t;
}
function Wa(t) {
  const e = [], n = [];
  for (const s of t)
    s.some(Gr) ? e.push(s) : n.push(s);
  return [n, e];
}
const kb = {
  type: Z.Universal,
  namespace: null
}, Lb = {
  type: Z.Pseudo,
  name: "scope",
  data: null
};
function Td(t, e, n = {}) {
  return Ad([t], e, n);
}
function Ad(t, e, n = {}) {
  if (typeof e == "function")
    return t.some(e);
  const [s, r] = Wa(mi(e));
  return s.length > 0 && t.some($a(s, n)) || r.some((i) => Dd(i, t, n).length > 0);
}
function Mb(t, e, n, s) {
  const r = typeof n == "string" ? parseInt(n, 10) : NaN;
  switch (t) {
    case "first":
    case "lt":
      return e;
    case "last":
      return e.length > 0 ? [e[e.length - 1]] : e;
    case "nth":
    case "eq":
      return isFinite(r) && Math.abs(r) < e.length ? [r < 0 ? e[e.length + r] : e[r]] : [];
    case "gt":
      return isFinite(r) ? e.slice(r + 1) : [];
    case "even":
      return e.filter((i, u) => u % 2 === 0);
    case "odd":
      return e.filter((i, u) => u % 2 === 1);
    case "not": {
      const i = new Set(Cd(n, e, s));
      return e.filter((u) => !i.has(u));
    }
  }
}
function yd(t, e, n = {}) {
  return Cd(mi(t), e, n);
}
function Cd(t, e, n) {
  if (e.length === 0)
    return [];
  const [s, r] = Wa(t);
  let i;
  if (s.length) {
    const u = ra(e, s, n);
    if (r.length === 0)
      return u;
    u.length && (i = new Set(u));
  }
  for (let u = 0; u < r.length && i?.size !== e.length; u++) {
    const a = r[u];
    if ((i ? e.filter((l) => ee(l) && !i.has(l)) : e).length === 0)
      break;
    const c = Dd(a, e, n);
    if (c.length)
      if (i)
        c.forEach((l) => i.add(l));
      else {
        if (u === r.length - 1)
          return c;
        i = new Set(c);
      }
  }
  return typeof i < "u" ? i.size === e.length ? e : (
    // Filter elements to preserve order
    e.filter((u) => i.has(u))
  ) : [];
}
function Dd(t, e, n) {
  var s;
  if (t.some(Os)) {
    const r = (s = n.root) !== null && s !== void 0 ? s : Bb(e[0]), i = { ...n, context: e, relativeSelector: !1 };
    return t.push(Lb), Xr(r, t, i, !0, e.length);
  }
  return Xr(e, t, n, !1, e.length);
}
function Rb(t, e, n = {}, s = 1 / 0) {
  if (typeof t == "function")
    return vd(e, t);
  const [r, i] = Wa(mi(t)), u = i.map((a) => Xr(e, a, n, !0, s));
  return r.length && u.push(sa(e, r, n, s)), u.length === 0 ? [] : u.length === 1 ? u[0] : us(u.reduce((a, o) => [...a, ...o]));
}
function Xr(t, e, n, s, r) {
  const i = e.findIndex(Gr), u = e.slice(0, i), a = e[i], o = e.length - 1 === i ? r : 1 / 0, c = Ob(a.name, a.data, o);
  if (c === 0)
    return [];
  const f = (u.length === 0 && !Array.isArray(t) ? bi(t).filter(ee) : u.length === 0 ? (Array.isArray(t) ? t : [t]).filter(ee) : s || u.some(Os) ? sa(t, [u], n, c) : ra(t, [u], n)).slice(0, c);
  let h = Mb(a.name, f, a.data, n);
  if (h.length === 0 || e.length === i + 1)
    return h;
  const x = e.slice(i + 1), m = x.some(Os);
  if (m) {
    if (Os(x[0])) {
      const { type: p } = x[0];
      (p === Z.Sibling || p === Z.Adjacent) && (h = _d(h, xi, !0)), x.unshift(kb);
    }
    n = {
      ...n,
      // Avoid absolutizing the selector
      relativeSelector: !1,
      /*
       * Add a custom root func, to make sure traversals don't match elements
       * that aren't a part of the considered tree.
       */
      rootFunc: (p) => h.includes(p)
    };
  } else n.rootFunc && n.rootFunc !== jr.trueFunc && (n = { ...n, rootFunc: jr.trueFunc });
  return x.some(Gr) ? Xr(h, x, n, !1, r) : m ? (
    // Query existing elements to resolve traversal.
    sa(h, [x], n, r)
  ) : (
    // If we don't have any more traversals, simply filter elements.
    ra(h, [x], n)
  );
}
function sa(t, e, n, s) {
  const r = $a(e, n, t);
  return vd(t, r, s);
}
function vd(t, e, n = 1 / 0) {
  const s = _d(t, xi, e.shouldTestNextSiblings);
  return Fa((r) => ee(r) && e(r), s, !0, n);
}
function ra(t, e, n) {
  const s = (Array.isArray(t) ? t : [t]).filter(ee);
  if (s.length === 0)
    return s;
  const r = $a(e, n);
  return r === jr.trueFunc ? s : s.filter(r);
}
const Pb = /^\s*[+~]/;
function Fb(t) {
  if (!t)
    return this._make([]);
  if (typeof t != "string") {
    const e = Xt(t) ? t.toArray() : [t], n = this.toArray();
    return this._make(e.filter((s) => n.some((r) => ud(r, s))));
  }
  return this._findBySelector(t, Number.POSITIVE_INFINITY);
}
function Hb(t, e) {
  var n;
  const s = this.toArray(), r = Pb.test(t) ? s : this.children().toArray(), i = {
    context: s,
    root: (n = this._root) === null || n === void 0 ? void 0 : n[0],
    // Pass options that are recognized by `cheerio-select`
    xmlMode: this.options.xmlMode,
    lowerCaseTags: this.options.lowerCaseTags,
    lowerCaseAttributeNames: this.options.lowerCaseAttributeNames,
    pseudos: this.options.pseudos,
    quirksMode: this.options.quirksMode
  };
  return this._make(Rb(t, r, i, e));
}
function za(t) {
  return function(e, ...n) {
    return function(s) {
      var r;
      let i = t(e, this);
      return s && (i = Ga(i, s, this.options.xmlMode, (r = this._root) === null || r === void 0 ? void 0 : r[0])), this._make(
        // Post processing is only necessary if there is more than one element.
        this.length > 1 && i.length > 1 ? n.reduce((u, a) => a(u), i) : i
      );
    };
  };
}
const sr = za((t, e) => {
  let n = [];
  for (let s = 0; s < e.length; s++) {
    const r = t(e[s]);
    r.length > 0 && (n = n.concat(r));
  }
  return n;
}), Va = za((t, e) => {
  const n = [];
  for (let s = 0; s < e.length; s++) {
    const r = t(e[s]);
    r !== null && n.push(r);
  }
  return n;
});
function ja(t, ...e) {
  let n = null;
  const s = za((r, i) => {
    const u = [];
    return Ne(i, (a) => {
      for (let o; (o = r(a)) && !n?.(o, u.length); a = o)
        u.push(o);
    }), u;
  })(t, ...e);
  return function(r, i) {
    n = typeof r == "string" ? (a) => Td(a, r, this.options) : r ? rr(r) : null;
    const u = s.call(this, i);
    return n = null, u;
  };
}
function as(t) {
  return t.length > 1 ? Array.from(new Set(t)) : t;
}
const Ub = Va(({ parent: t }) => t && !cn(t) ? t : null, as), Yb = sr((t) => {
  const e = [];
  for (; t.parent && !cn(t.parent); )
    e.push(t.parent), t = t.parent;
  return e;
}, us, (t) => t.reverse()), qb = ja(({ parent: t }) => t && !cn(t) ? t : null, us, (t) => t.reverse());
function $b(t) {
  var e;
  const n = [];
  if (!t)
    return this._make(n);
  const s = {
    xmlMode: this.options.xmlMode,
    root: (e = this._root) === null || e === void 0 ? void 0 : e[0]
  }, r = typeof t == "string" ? (i) => Td(i, t, s) : rr(t);
  return Ne(this, (i) => {
    for (i && !cn(i) && !ee(i) && (i = i.parent); i && ee(i); ) {
      if (r(i, 0)) {
        n.includes(i) || n.push(i);
        break;
      }
      i = i.parent;
    }
  }), this._make(n);
}
const Wb = Va((t) => Ra(t)), zb = sr((t) => {
  const e = [];
  for (; t.next; )
    t = t.next, ee(t) && e.push(t);
  return e;
}, as), Vb = ja((t) => Ra(t), as), jb = Va((t) => Pa(t)), Gb = sr((t) => {
  const e = [];
  for (; t.prev; )
    t = t.prev, ee(t) && e.push(t);
  return e;
}, as), Xb = ja((t) => Pa(t), as), Qb = sr((t) => ed(t).filter((e) => ee(e) && e !== t), us), Kb = sr((t) => bi(t).filter(ee), as);
function Zb() {
  const t = this.toArray().reduce((e, n) => Me(n) ? e.concat(n.children) : e, []);
  return this._make(t);
}
function Jb(t) {
  let e = 0;
  const n = this.length;
  for (; e < n && t.call(this[e], e, this[e]) !== !1; )
    ++e;
  return this;
}
function ex(t) {
  let e = [];
  for (let n = 0; n < this.length; n++) {
    const s = this[n], r = t.call(s, n, s);
    r != null && (e = e.concat(r));
  }
  return this._make(e);
}
function rr(t) {
  return typeof t == "function" ? (e, n) => t.call(e, n, e) : Xt(t) ? (e) => Array.prototype.includes.call(t, e) : function(e) {
    return t === e;
  };
}
function tx(t) {
  var e;
  return this._make(Ga(this.toArray(), t, this.options.xmlMode, (e = this._root) === null || e === void 0 ? void 0 : e[0]));
}
function Ga(t, e, n, s) {
  return typeof e == "string" ? yd(e, t, { xmlMode: n, root: s }) : t.filter(rr(e));
}
function nx(t) {
  const e = this.toArray();
  return typeof t == "string" ? Ad(e.filter(ee), t, this.options) : t ? e.some(rr(t)) : !1;
}
function sx(t) {
  let e = this.toArray();
  if (typeof t == "string") {
    const n = new Set(yd(t, e, this.options));
    e = e.filter((s) => !n.has(s));
  } else {
    const n = rr(t);
    e = e.filter((s, r) => !n(s, r));
  }
  return this._make(e);
}
function rx(t) {
  return this.filter(typeof t == "string" ? (
    // Using the `:has` selector here short-circuits searches.
    `:has(${t})`
  ) : (e, n) => this._make(n).find(t).length > 0);
}
function ix() {
  return this.length > 1 ? this._make(this[0]) : this;
}
function ux() {
  return this.length > 0 ? this._make(this[this.length - 1]) : this;
}
function ax(t) {
  var e;
  return t = +t, t === 0 && this.length <= 1 ? this : (t < 0 && (t = this.length + t), this._make((e = this[t]) !== null && e !== void 0 ? e : []));
}
function ox(t) {
  return t == null ? this.toArray() : this[t < 0 ? this.length + t : t];
}
function cx() {
  return Array.prototype.slice.call(this);
}
function lx(t) {
  let e, n;
  return t == null ? (e = this.parent().children(), n = this[0]) : typeof t == "string" ? (e = this._make(t), n = this[0]) : (e = this, n = Xt(t) ? t[0] : t), Array.prototype.indexOf.call(e, n);
}
function dx(t, e) {
  return this._make(Array.prototype.slice.call(this, t, e));
}
function fx() {
  var t;
  return (t = this.prevObject) !== null && t !== void 0 ? t : this._make([]);
}
function hx(t, e) {
  const n = this._make(t, e), s = us([...this.get(), ...n.get()]);
  return this._make(s);
}
function bx(t) {
  return this.prevObject ? this.add(t ? this.prevObject.filter(t) : this.prevObject) : this;
}
const xx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _findBySelector: Hb,
  add: hx,
  addBack: bx,
  children: Kb,
  closest: $b,
  contents: Zb,
  each: Jb,
  end: fx,
  eq: ax,
  filter: tx,
  filterArray: Ga,
  find: Fb,
  first: ix,
  get: ox,
  has: rx,
  index: lx,
  is: nx,
  last: ux,
  map: ex,
  next: Wb,
  nextAll: zb,
  nextUntil: Vb,
  not: sx,
  parent: Ub,
  parents: Yb,
  parentsUntil: qb,
  prev: jb,
  prevAll: Gb,
  prevUntil: Xb,
  siblings: Qb,
  slice: dx,
  toArray: cx
}, Symbol.toStringTag, { value: "Module" }));
function mx(t) {
  return function(n, s, r, i) {
    if (typeof Buffer < "u" && Buffer.isBuffer(n) && (n = n.toString()), typeof n == "string")
      return t(n, s, r, i);
    const u = n;
    if (!Array.isArray(u) && cn(u))
      return u;
    const a = new wn([]);
    return Nn(u, a), a;
  };
}
function Nn(t, e) {
  const n = Array.isArray(t) ? t : [t];
  e ? e.children = n : e = null;
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    r.parent && r.parent.children !== n && Bn(r), e ? (r.prev = n[s - 1] || null, r.next = n[s + 1] || null) : r.prev = r.next = null, r.parent = e;
  }
  return e;
}
function px(t, e) {
  if (t == null)
    return [];
  if (typeof t == "string")
    return this._parse(t, this.options, !1, null).children.slice(0);
  if ("length" in t) {
    if (t.length === 1)
      return this._makeDomArray(t[0], e);
    const n = [];
    for (let s = 0; s < t.length; s++) {
      const r = t[s];
      if (typeof r == "object") {
        if (r == null)
          continue;
        if (!("length" in r)) {
          n.push(e ? Ws(r, !0) : r);
          continue;
        }
      }
      n.push(...this._makeDomArray(r, e));
    }
    return n;
  }
  return [e ? Ws(t, !0) : t];
}
function Sd(t) {
  return function(...e) {
    const n = this.length - 1;
    return Ne(this, (s, r) => {
      if (!Me(s))
        return;
      const i = typeof e[0] == "function" ? e[0].call(s, r, this._render(s.children)) : e, u = this._makeDomArray(i, r < n);
      t(u, s.children, s);
    });
  };
}
function ln(t, e, n, s, r) {
  var i, u;
  const a = [
    e,
    n,
    ...s
  ], o = e === 0 ? null : t[e - 1], c = e + n >= t.length ? null : t[e + n];
  for (let l = 0; l < s.length; ++l) {
    const f = s[l], h = f.parent;
    if (h) {
      const m = h.children.indexOf(f);
      m !== -1 && (h.children.splice(m, 1), r === h && e > m && a[0]--);
    }
    f.parent = r, f.prev && (f.prev.next = (i = f.next) !== null && i !== void 0 ? i : null), f.next && (f.next.prev = (u = f.prev) !== null && u !== void 0 ? u : null), f.prev = l === 0 ? o : s[l - 1], f.next = l === s.length - 1 ? c : s[l + 1];
  }
  return o && (o.next = s[0]), c && (c.prev = s[s.length - 1]), t.splice(...a);
}
function gx(t) {
  return (Xt(t) ? t : this._make(t)).append(this), this;
}
function Ex(t) {
  return (Xt(t) ? t : this._make(t)).prepend(this), this;
}
const _x = Sd((t, e, n) => {
  ln(e, e.length, 0, t, n);
}), Tx = Sd((t, e, n) => {
  ln(e, 0, 0, t, n);
});
function wd(t) {
  return function(e) {
    const n = this.length - 1, s = this.parents().last();
    for (let r = 0; r < this.length; r++) {
      const i = this[r], u = typeof e == "function" ? e.call(i, r, i) : typeof e == "string" && !Zu(e) ? s.find(e).clone() : e, [a] = this._makeDomArray(u, r < n);
      if (!a || !Me(a))
        continue;
      let o = a, c = 0;
      for (; c < o.children.length; ) {
        const l = o.children[c];
        ee(l) ? (o = l, c = 0) : c++;
      }
      t(i, o, [a]);
    }
    return this;
  };
}
const Ax = wd((t, e, n) => {
  const { parent: s } = t;
  if (!s)
    return;
  const r = s.children, i = r.indexOf(t);
  Nn([t], e), ln(r, i, 0, n, s);
}), yx = wd((t, e, n) => {
  Me(t) && (Nn(t.children, e), Nn(n, t));
});
function Cx(t) {
  return this.parent(t).not("body").each((e, n) => {
    this._make(n).replaceWith(n.children);
  }), this;
}
function Dx(t) {
  const e = this[0];
  if (e) {
    const n = this._make(typeof t == "function" ? t.call(e, 0, e) : t).insertBefore(e);
    let s;
    for (let i = 0; i < n.length; i++)
      n[i].type === Xu && (s = n[i]);
    let r = 0;
    for (; s && r < s.children.length; ) {
      const i = s.children[r];
      i.type === Xu ? (s = i, r = 0) : r++;
    }
    s && this._make(s).append(this);
  }
  return this;
}
function vx(...t) {
  const e = this.length - 1;
  return Ne(this, (n, s) => {
    if (!Me(n) || !n.parent)
      return;
    const r = n.parent.children, i = r.indexOf(n);
    if (i === -1)
      return;
    const u = typeof t[0] == "function" ? t[0].call(n, s, this._render(n.children)) : t, a = this._makeDomArray(u, s < e);
    ln(r, i + 1, 0, a, n.parent);
  });
}
function Sx(t) {
  typeof t == "string" && (t = this._make(t)), this.remove();
  const e = [];
  for (const n of this._makeDomArray(t)) {
    const s = this.clone().toArray(), { parent: r } = n;
    if (!r)
      continue;
    const i = r.children, u = i.indexOf(n);
    u !== -1 && (ln(i, u + 1, 0, s, r), e.push(...s));
  }
  return this._make(e);
}
function wx(...t) {
  const e = this.length - 1;
  return Ne(this, (n, s) => {
    if (!Me(n) || !n.parent)
      return;
    const r = n.parent.children, i = r.indexOf(n);
    if (i === -1)
      return;
    const u = typeof t[0] == "function" ? t[0].call(n, s, this._render(n.children)) : t, a = this._makeDomArray(u, s < e);
    ln(r, i, 0, a, n.parent);
  });
}
function Nx(t) {
  const e = this._make(t);
  this.remove();
  const n = [];
  return Ne(e, (s) => {
    const r = this.clone().toArray(), { parent: i } = s;
    if (!i)
      return;
    const u = i.children, a = u.indexOf(s);
    a !== -1 && (ln(u, a, 0, r, i), n.push(...r));
  }), this._make(n);
}
function Ix(t) {
  const e = t ? this.filter(t) : this;
  return Ne(e, (n) => {
    Bn(n), n.prev = n.next = n.parent = null;
  }), this;
}
function Ox(t) {
  return Ne(this, (e, n) => {
    const { parent: s } = e;
    if (!s)
      return;
    const r = s.children, i = typeof t == "function" ? t.call(e, n, e) : t, u = this._makeDomArray(i);
    Nn(u, null);
    const a = r.indexOf(e);
    ln(r, a, 1, u, s), u.includes(e) || (e.parent = e.prev = e.next = null);
  });
}
function Bx() {
  return Ne(this, (t) => {
    if (Me(t)) {
      for (const e of t.children)
        e.next = e.prev = e.parent = null;
      t.children.length = 0;
    }
  });
}
function kx(t) {
  if (t === void 0) {
    const e = this[0];
    return !e || !Me(e) ? null : this._render(e.children);
  }
  return Ne(this, (e) => {
    if (!Me(e))
      return;
    for (const s of e.children)
      s.next = s.prev = s.parent = null;
    const n = Xt(t) ? t.toArray() : this._parse(`${t}`, this.options, !1, e).children;
    Nn(n, e);
  });
}
function Lx() {
  return this._render(this);
}
function Mx(t) {
  return t === void 0 ? zs(this) : typeof t == "function" ? Ne(this, (e, n) => this._make(e).text(t.call(e, n, zs([e])))) : Ne(this, (e) => {
    if (!Me(e))
      return;
    for (const s of e.children)
      s.next = s.prev = s.parent = null;
    const n = new $s(`${t}`);
    Nn(n, e);
  });
}
function Rx() {
  const t = Array.prototype.map.call(this.get(), (n) => Ws(n, !0)), e = new wn(t);
  for (const n of t)
    n.parent = e;
  return this._make(t);
}
const Px = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  _makeDomArray: px,
  after: vx,
  append: _x,
  appendTo: gx,
  before: wx,
  clone: Rx,
  empty: Bx,
  html: kx,
  insertAfter: Sx,
  insertBefore: Nx,
  prepend: Tx,
  prependTo: Ex,
  remove: Ix,
  replaceWith: Ox,
  text: Mx,
  toString: Lx,
  unwrap: Cx,
  wrap: Ax,
  wrapAll: Dx,
  wrapInner: yx
}, Symbol.toStringTag, { value: "Module" }));
function Fx(t, e) {
  if (t != null && e != null || // When `prop` is a "plain" object
  typeof t == "object" && !Array.isArray(t))
    return Ne(this, (n, s) => {
      ee(n) && Nd(n, t, e, s);
    });
  if (this.length !== 0)
    return Id(this[0], t);
}
function Nd(t, e, n, s) {
  if (typeof e == "string") {
    const r = Id(t), i = typeof n == "function" ? n.call(t, s, r[e]) : n;
    i === "" ? delete r[e] : i != null && (r[e] = i), t.attribs.style = Hx(r);
  } else if (typeof e == "object") {
    const r = Object.keys(e);
    for (let i = 0; i < r.length; i++) {
      const u = r[i];
      Nd(t, u, e[u], i);
    }
  }
}
function Id(t, e) {
  if (!t || !ee(t))
    return;
  const n = Ux(t.attribs.style);
  if (typeof e == "string")
    return n[e];
  if (Array.isArray(e)) {
    const s = {};
    for (const r of e)
      n[r] != null && (s[r] = n[r]);
    return s;
  }
  return n;
}
function Hx(t) {
  return Object.keys(t).reduce((e, n) => `${e}${e ? " " : ""}${n}: ${t[n]};`, "");
}
function Ux(t) {
  if (t = (t || "").trim(), !t)
    return {};
  const e = {};
  let n;
  for (const s of t.split(";")) {
    const r = s.indexOf(":");
    if (r < 1 || r === s.length - 1) {
      const i = s.trimEnd();
      i.length > 0 && n !== void 0 && (e[n] += `;${i}`);
    } else
      n = s.slice(0, r).trim(), e[n] = s.slice(r + 1).trim();
  }
  return e;
}
const Yx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  css: Fx
}, Symbol.toStringTag, { value: "Module" })), J0 = "input,select,textarea,keygen", qx = /%20/g, eo = /\r?\n/g;
function $x() {
  return this.serializeArray().map((n) => `${encodeURIComponent(n.name)}=${encodeURIComponent(n.value)}`).join("&").replace(qx, "+");
}
function Wx() {
  return this.map((t, e) => {
    const n = this._make(e);
    return ee(e) && e.name === "form" ? n.find(J0).toArray() : n.filter(J0).toArray();
  }).filter(
    // Verify elements have a name (`attr.name`) and are not disabled (`:enabled`)
    '[name!=""]:enabled:not(:submit, :button, :image, :reset, :file):matches([checked], :not(:checkbox, :radio))'
  ).map((t, e) => {
    var n;
    const s = this._make(e), r = s.attr("name"), i = (n = s.val()) !== null && n !== void 0 ? n : "";
    return Array.isArray(i) ? i.map((u) => (
      /*
       * We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
       * These can occur inside of `<textarea>'s`
       */
      { name: r, value: u.replace(eo, `\r
`) }
    )) : { name: r, value: i.replace(eo, `\r
`) };
  }).toArray();
}
const zx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  serialize: $x,
  serializeArray: Wx
}, Symbol.toStringTag, { value: "Module" }));
function Vx(t) {
  var e;
  return typeof t == "string" ? { selector: t, value: "textContent" } : {
    selector: t.selector,
    value: (e = t.value) !== null && e !== void 0 ? e : "textContent"
  };
}
function jx(t) {
  const e = {};
  for (const n in t) {
    const s = t[n], r = Array.isArray(s), { selector: i, value: u } = Vx(r ? s[0] : s), a = typeof u == "function" ? u : typeof u == "string" ? (o) => this._make(o).prop(u) : (o) => this._make(o).extract(u);
    if (r)
      e[n] = this._findBySelector(i, Number.POSITIVE_INFINITY).map((o, c) => a(c, n, e)).get();
    else {
      const o = this._findBySelector(i, 1);
      e[n] = o.length > 0 ? a(o[0], n, e) : void 0;
    }
  }
  return e;
}
const Gx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  extract: jx
}, Symbol.toStringTag, { value: "Module" }));
class ir {
  /**
   * Instance of cheerio. Methods are specified in the modules. Usage of this
   * constructor is not recommended. Please use `$.load` instead.
   *
   * @private
   * @param elements - The new selection.
   * @param root - Sets the root node.
   * @param options - Options for the instance.
   */
  constructor(e, n, s) {
    if (this.length = 0, this.options = s, this._root = n, e) {
      for (let r = 0; r < e.length; r++)
        this[r] = e[r];
      this.length = e.length;
    }
  }
}
ir.prototype.cheerio = "[cheerio object]";
ir.prototype.splice = Array.prototype.splice;
ir.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator];
Object.assign(ir.prototype, tb, xx, Px, Yx, zx, Gx);
function Xx(t, e) {
  return function n(s, r, i = !0) {
    if (s == null)
      throw new Error("cheerio.load() expects a string");
    const u = Ku(r), a = t(s, u, i, null);
    class o extends ir {
      _make(f, h) {
        const x = c(f, h);
        return x.prevObject = this, x;
      }
      _parse(f, h, x, m) {
        return t(f, h, x, m);
      }
      _render(f) {
        return e(f, this.options);
      }
    }
    function c(l, f, h = a, x) {
      if (l && Xt(l))
        return l;
      const m = Ku(x, u), p = typeof h == "string" ? [t(h, m, !1, null)] : "length" in h ? h : [h], b = Xt(p) ? p : new o(p, null, m);
      if (b._root = b, !l)
        return new o(void 0, b, m);
      const E = typeof l == "string" && Zu(l) ? (
        // $(<html>)
        t(l, m, !1, null).children
      ) : Qx(l) ? (
        // $(dom)
        [l]
      ) : Array.isArray(l) ? (
        // $([dom])
        l
      ) : void 0, g = new o(E, b, m);
      if (E)
        return g;
      if (typeof l != "string")
        throw new TypeError("Unexpected type of selector");
      let _ = l;
      const T = f ? (
        // If we don't have a context, maybe we have a root, from loading
        typeof f == "string" ? Zu(f) ? (
          // $('li', '<ul>...</ul>')
          new o([t(f, m, !1, null)], b, m)
        ) : (
          // $('li', 'ul')
          (_ = `${f} ${_}`, b)
        ) : Xt(f) ? (
          // $('li', $)
          f
        ) : (
          // $('li', node), $('li', [nodes])
          new o(Array.isArray(f) ? f : [f], b, m)
        )
      ) : b;
      return T ? T.find(_) : g;
    }
    return Object.assign(c, v2, {
      load: n,
      // `_root` and `_options` are used in static methods.
      _root: a,
      _options: u,
      // Add `fn` for plugins
      fn: o.prototype,
      // Add the prototype here to maintain `instanceof` behavior.
      prototype: o.prototype
    }), c;
  };
}
function Qx(t) {
  return (
    // @ts-expect-error: TS doesn't know about the `name` property.
    !!t.name || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === Ia || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === Vl || // @ts-expect-error: TS doesn't know about the `type` property.
    t.type === jl
  );
}
const Kx = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Se = "�";
var A;
(function(t) {
  t[t.EOF = -1] = "EOF", t[t.NULL = 0] = "NULL", t[t.TABULATION = 9] = "TABULATION", t[t.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", t[t.LINE_FEED = 10] = "LINE_FEED", t[t.FORM_FEED = 12] = "FORM_FEED", t[t.SPACE = 32] = "SPACE", t[t.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", t[t.QUOTATION_MARK = 34] = "QUOTATION_MARK", t[t.AMPERSAND = 38] = "AMPERSAND", t[t.APOSTROPHE = 39] = "APOSTROPHE", t[t.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", t[t.SOLIDUS = 47] = "SOLIDUS", t[t.DIGIT_0 = 48] = "DIGIT_0", t[t.DIGIT_9 = 57] = "DIGIT_9", t[t.SEMICOLON = 59] = "SEMICOLON", t[t.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", t[t.EQUALS_SIGN = 61] = "EQUALS_SIGN", t[t.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", t[t.QUESTION_MARK = 63] = "QUESTION_MARK", t[t.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", t[t.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", t[t.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", t[t.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", t[t.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", t[t.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(A || (A = {}));
const nt = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function Od(t) {
  return t >= 55296 && t <= 57343;
}
function Zx(t) {
  return t >= 56320 && t <= 57343;
}
function Jx(t, e) {
  return (t - 55296) * 1024 + 9216 + e;
}
function Bd(t) {
  return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
}
function kd(t) {
  return t >= 64976 && t <= 65007 || Kx.has(t);
}
var U;
(function(t) {
  t.controlCharacterInInputStream = "control-character-in-input-stream", t.noncharacterInInputStream = "noncharacter-in-input-stream", t.surrogateInInputStream = "surrogate-in-input-stream", t.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", t.endTagWithAttributes = "end-tag-with-attributes", t.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", t.unexpectedSolidusInTag = "unexpected-solidus-in-tag", t.unexpectedNullCharacter = "unexpected-null-character", t.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", t.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", t.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", t.missingEndTagName = "missing-end-tag-name", t.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", t.unknownNamedCharacterReference = "unknown-named-character-reference", t.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", t.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", t.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", t.eofBeforeTagName = "eof-before-tag-name", t.eofInTag = "eof-in-tag", t.missingAttributeValue = "missing-attribute-value", t.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", t.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", t.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", t.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", t.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", t.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", t.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", t.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", t.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", t.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", t.cdataInHtmlContent = "cdata-in-html-content", t.incorrectlyOpenedComment = "incorrectly-opened-comment", t.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", t.eofInDoctype = "eof-in-doctype", t.nestedComment = "nested-comment", t.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", t.eofInComment = "eof-in-comment", t.incorrectlyClosedComment = "incorrectly-closed-comment", t.eofInCdata = "eof-in-cdata", t.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", t.nullCharacterReference = "null-character-reference", t.surrogateCharacterReference = "surrogate-character-reference", t.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", t.controlCharacterReference = "control-character-reference", t.noncharacterCharacterReference = "noncharacter-character-reference", t.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", t.missingDoctypeName = "missing-doctype-name", t.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", t.duplicateAttribute = "duplicate-attribute", t.nonConformingDoctype = "non-conforming-doctype", t.missingDoctype = "missing-doctype", t.misplacedDoctype = "misplaced-doctype", t.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", t.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", t.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", t.openElementsLeftAfterEof = "open-elements-left-after-eof", t.abandonedHeadElementChild = "abandoned-head-element-child", t.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", t.nestedNoscriptInHead = "nested-noscript-in-head", t.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(U || (U = {}));
const em = 65536;
class tm {
  constructor(e) {
    this.handler = e, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = em, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(e, n) {
    const { line: s, col: r, offset: i } = this, u = r + n, a = i + n;
    return {
      code: e,
      startLine: s,
      endLine: s,
      startCol: u,
      endCol: u,
      startOffset: a,
      endOffset: a
    };
  }
  _err(e) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(e, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (Zx(n))
        return this.pos++, this._addGap(), Jx(e, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, A.EOF;
    return this._err(U.surrogateInInputStream), e;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(e, n) {
    this.html.length > 0 ? this.html += e : this.html = e, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(e, n) {
    if (this.pos + e.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(e, this.pos);
    for (let s = 0; s < e.length; s++)
      if ((this.html.charCodeAt(this.pos + s) | 32) !== e.charCodeAt(s))
        return !1;
    return !0;
  }
  peek(e) {
    const n = this.pos + e;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, A.EOF;
    const s = this.html.charCodeAt(n);
    return s === A.CARRIAGE_RETURN ? A.LINE_FEED : s;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, A.EOF;
    let e = this.html.charCodeAt(this.pos);
    return e === A.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, A.LINE_FEED) : e === A.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, Od(e) && (e = this._processSurrogate(e)), this.handler.onParseError === null || e > 31 && e < 127 || e === A.LINE_FEED || e === A.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    Bd(e) ? this._err(U.controlCharacterInInputStream) : kd(e) && this._err(U.noncharacterInInputStream);
  }
  retreat(e) {
    for (this.pos -= e; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var xe;
(function(t) {
  t[t.CHARACTER = 0] = "CHARACTER", t[t.NULL_CHARACTER = 1] = "NULL_CHARACTER", t[t.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", t[t.START_TAG = 3] = "START_TAG", t[t.END_TAG = 4] = "END_TAG", t[t.COMMENT = 5] = "COMMENT", t[t.DOCTYPE = 6] = "DOCTYPE", t[t.EOF = 7] = "EOF", t[t.HIBERNATION = 8] = "HIBERNATION";
})(xe || (xe = {}));
function Ld(t, e) {
  for (let n = t.attrs.length - 1; n >= 0; n--)
    if (t.attrs[n].name === e)
      return t.attrs[n].value;
  return null;
}
const nm = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), sm = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function rm(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = sm.get(t)) !== null && e !== void 0 ? e : t;
}
var ze;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(ze || (ze = {}));
const im = 32;
var rn;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(rn || (rn = {}));
function ia(t) {
  return t >= ze.ZERO && t <= ze.NINE;
}
function um(t) {
  return t >= ze.UPPER_A && t <= ze.UPPER_F || t >= ze.LOWER_A && t <= ze.LOWER_F;
}
function am(t) {
  return t >= ze.UPPER_A && t <= ze.UPPER_Z || t >= ze.LOWER_A && t <= ze.LOWER_Z || ia(t);
}
function om(t) {
  return t === ze.EQUALS || am(t);
}
var $e;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})($e || ($e = {}));
var Gt;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(Gt || (Gt = {}));
class cm {
  constructor(e, n, s) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = s, this.state = $e.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Gt.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = $e.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case $e.EntityStart:
        return e.charCodeAt(n) === ze.NUM ? (this.state = $e.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = $e.NamedEntity, this.stateNamedEntity(e, n));
      case $e.NumericStart:
        return this.stateNumericStart(e, n);
      case $e.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case $e.NumericHex:
        return this.stateNumericHex(e, n);
      case $e.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | im) === ze.LOWER_X ? (this.state = $e.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = $e.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, s, r) {
    if (n !== s) {
      const i = s - n;
      this.result = this.result * Math.pow(r, i) + Number.parseInt(e.substr(n, i), r), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const s = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (ia(r) || um(r))
        n += 1;
      else
        return this.addToNumericResult(e, s, n, 16), this.emitNumericEntity(r, 3);
    }
    return this.addToNumericResult(e, s, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const s = n;
    for (; n < e.length; ) {
      const r = e.charCodeAt(n);
      if (ia(r))
        n += 1;
      else
        return this.addToNumericResult(e, s, n, 10), this.emitNumericEntity(r, 2);
    }
    return this.addToNumericResult(e, s, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var s;
    if (this.consumed <= n)
      return (s = this.errors) === null || s === void 0 || s.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === ze.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Gt.Strict)
      return 0;
    return this.emitCodePoint(rm(this.result), this.consumed), this.errors && (e !== ze.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: s } = this;
    let r = s[this.treeIndex], i = (r & rn.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const u = e.charCodeAt(n);
      if (this.treeIndex = lm(s, r, this.treeIndex + Math.max(1, i), u), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Gt.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        om(u)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (r = s[this.treeIndex], i = (r & rn.VALUE_LENGTH) >> 14, i !== 0) {
        if (u === ze.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== Gt.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: s } = this, r = (s[n] & rn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, r, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, s) {
    const { decodeTree: r } = this;
    return this.emitCodePoint(n === 1 ? r[e] & ~rn.VALUE_LENGTH : r[e + 1], s), n === 3 && this.emitCodePoint(r[e + 2], s), s;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case $e.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Gt.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case $e.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case $e.NumericHex:
        return this.emitNumericEntity(0, 3);
      case $e.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case $e.EntityStart:
        return 0;
    }
  }
}
function lm(t, e, n, s) {
  const r = (e & rn.BRANCH_LENGTH) >> 7, i = e & rn.JUMP_TABLE;
  if (r === 0)
    return i !== 0 && s === i ? n : -1;
  if (i) {
    const o = s - i;
    return o < 0 || o >= r ? -1 : t[n + o] - 1;
  }
  let u = n, a = u + r - 1;
  for (; u <= a; ) {
    const o = u + a >>> 1, c = t[o];
    if (c < s)
      u = o + 1;
    else if (c > s)
      a = o - 1;
    else
      return t[o + r];
  }
  return -1;
}
var z;
(function(t) {
  t.HTML = "http://www.w3.org/1999/xhtml", t.MATHML = "http://www.w3.org/1998/Math/MathML", t.SVG = "http://www.w3.org/2000/svg", t.XLINK = "http://www.w3.org/1999/xlink", t.XML = "http://www.w3.org/XML/1998/namespace", t.XMLNS = "http://www.w3.org/2000/xmlns/";
})(z || (z = {}));
var Cn;
(function(t) {
  t.TYPE = "type", t.ACTION = "action", t.ENCODING = "encoding", t.PROMPT = "prompt", t.NAME = "name", t.COLOR = "color", t.FACE = "face", t.SIZE = "size";
})(Cn || (Cn = {}));
var dt;
(function(t) {
  t.NO_QUIRKS = "no-quirks", t.QUIRKS = "quirks", t.LIMITED_QUIRKS = "limited-quirks";
})(dt || (dt = {}));
var k;
(function(t) {
  t.A = "a", t.ADDRESS = "address", t.ANNOTATION_XML = "annotation-xml", t.APPLET = "applet", t.AREA = "area", t.ARTICLE = "article", t.ASIDE = "aside", t.B = "b", t.BASE = "base", t.BASEFONT = "basefont", t.BGSOUND = "bgsound", t.BIG = "big", t.BLOCKQUOTE = "blockquote", t.BODY = "body", t.BR = "br", t.BUTTON = "button", t.CAPTION = "caption", t.CENTER = "center", t.CODE = "code", t.COL = "col", t.COLGROUP = "colgroup", t.DD = "dd", t.DESC = "desc", t.DETAILS = "details", t.DIALOG = "dialog", t.DIR = "dir", t.DIV = "div", t.DL = "dl", t.DT = "dt", t.EM = "em", t.EMBED = "embed", t.FIELDSET = "fieldset", t.FIGCAPTION = "figcaption", t.FIGURE = "figure", t.FONT = "font", t.FOOTER = "footer", t.FOREIGN_OBJECT = "foreignObject", t.FORM = "form", t.FRAME = "frame", t.FRAMESET = "frameset", t.H1 = "h1", t.H2 = "h2", t.H3 = "h3", t.H4 = "h4", t.H5 = "h5", t.H6 = "h6", t.HEAD = "head", t.HEADER = "header", t.HGROUP = "hgroup", t.HR = "hr", t.HTML = "html", t.I = "i", t.IMG = "img", t.IMAGE = "image", t.INPUT = "input", t.IFRAME = "iframe", t.KEYGEN = "keygen", t.LABEL = "label", t.LI = "li", t.LINK = "link", t.LISTING = "listing", t.MAIN = "main", t.MALIGNMARK = "malignmark", t.MARQUEE = "marquee", t.MATH = "math", t.MENU = "menu", t.META = "meta", t.MGLYPH = "mglyph", t.MI = "mi", t.MO = "mo", t.MN = "mn", t.MS = "ms", t.MTEXT = "mtext", t.NAV = "nav", t.NOBR = "nobr", t.NOFRAMES = "noframes", t.NOEMBED = "noembed", t.NOSCRIPT = "noscript", t.OBJECT = "object", t.OL = "ol", t.OPTGROUP = "optgroup", t.OPTION = "option", t.P = "p", t.PARAM = "param", t.PLAINTEXT = "plaintext", t.PRE = "pre", t.RB = "rb", t.RP = "rp", t.RT = "rt", t.RTC = "rtc", t.RUBY = "ruby", t.S = "s", t.SCRIPT = "script", t.SEARCH = "search", t.SECTION = "section", t.SELECT = "select", t.SOURCE = "source", t.SMALL = "small", t.SPAN = "span", t.STRIKE = "strike", t.STRONG = "strong", t.STYLE = "style", t.SUB = "sub", t.SUMMARY = "summary", t.SUP = "sup", t.TABLE = "table", t.TBODY = "tbody", t.TEMPLATE = "template", t.TEXTAREA = "textarea", t.TFOOT = "tfoot", t.TD = "td", t.TH = "th", t.THEAD = "thead", t.TITLE = "title", t.TR = "tr", t.TRACK = "track", t.TT = "tt", t.U = "u", t.UL = "ul", t.SVG = "svg", t.VAR = "var", t.WBR = "wbr", t.XMP = "xmp";
})(k || (k = {}));
var d;
(function(t) {
  t[t.UNKNOWN = 0] = "UNKNOWN", t[t.A = 1] = "A", t[t.ADDRESS = 2] = "ADDRESS", t[t.ANNOTATION_XML = 3] = "ANNOTATION_XML", t[t.APPLET = 4] = "APPLET", t[t.AREA = 5] = "AREA", t[t.ARTICLE = 6] = "ARTICLE", t[t.ASIDE = 7] = "ASIDE", t[t.B = 8] = "B", t[t.BASE = 9] = "BASE", t[t.BASEFONT = 10] = "BASEFONT", t[t.BGSOUND = 11] = "BGSOUND", t[t.BIG = 12] = "BIG", t[t.BLOCKQUOTE = 13] = "BLOCKQUOTE", t[t.BODY = 14] = "BODY", t[t.BR = 15] = "BR", t[t.BUTTON = 16] = "BUTTON", t[t.CAPTION = 17] = "CAPTION", t[t.CENTER = 18] = "CENTER", t[t.CODE = 19] = "CODE", t[t.COL = 20] = "COL", t[t.COLGROUP = 21] = "COLGROUP", t[t.DD = 22] = "DD", t[t.DESC = 23] = "DESC", t[t.DETAILS = 24] = "DETAILS", t[t.DIALOG = 25] = "DIALOG", t[t.DIR = 26] = "DIR", t[t.DIV = 27] = "DIV", t[t.DL = 28] = "DL", t[t.DT = 29] = "DT", t[t.EM = 30] = "EM", t[t.EMBED = 31] = "EMBED", t[t.FIELDSET = 32] = "FIELDSET", t[t.FIGCAPTION = 33] = "FIGCAPTION", t[t.FIGURE = 34] = "FIGURE", t[t.FONT = 35] = "FONT", t[t.FOOTER = 36] = "FOOTER", t[t.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", t[t.FORM = 38] = "FORM", t[t.FRAME = 39] = "FRAME", t[t.FRAMESET = 40] = "FRAMESET", t[t.H1 = 41] = "H1", t[t.H2 = 42] = "H2", t[t.H3 = 43] = "H3", t[t.H4 = 44] = "H4", t[t.H5 = 45] = "H5", t[t.H6 = 46] = "H6", t[t.HEAD = 47] = "HEAD", t[t.HEADER = 48] = "HEADER", t[t.HGROUP = 49] = "HGROUP", t[t.HR = 50] = "HR", t[t.HTML = 51] = "HTML", t[t.I = 52] = "I", t[t.IMG = 53] = "IMG", t[t.IMAGE = 54] = "IMAGE", t[t.INPUT = 55] = "INPUT", t[t.IFRAME = 56] = "IFRAME", t[t.KEYGEN = 57] = "KEYGEN", t[t.LABEL = 58] = "LABEL", t[t.LI = 59] = "LI", t[t.LINK = 60] = "LINK", t[t.LISTING = 61] = "LISTING", t[t.MAIN = 62] = "MAIN", t[t.MALIGNMARK = 63] = "MALIGNMARK", t[t.MARQUEE = 64] = "MARQUEE", t[t.MATH = 65] = "MATH", t[t.MENU = 66] = "MENU", t[t.META = 67] = "META", t[t.MGLYPH = 68] = "MGLYPH", t[t.MI = 69] = "MI", t[t.MO = 70] = "MO", t[t.MN = 71] = "MN", t[t.MS = 72] = "MS", t[t.MTEXT = 73] = "MTEXT", t[t.NAV = 74] = "NAV", t[t.NOBR = 75] = "NOBR", t[t.NOFRAMES = 76] = "NOFRAMES", t[t.NOEMBED = 77] = "NOEMBED", t[t.NOSCRIPT = 78] = "NOSCRIPT", t[t.OBJECT = 79] = "OBJECT", t[t.OL = 80] = "OL", t[t.OPTGROUP = 81] = "OPTGROUP", t[t.OPTION = 82] = "OPTION", t[t.P = 83] = "P", t[t.PARAM = 84] = "PARAM", t[t.PLAINTEXT = 85] = "PLAINTEXT", t[t.PRE = 86] = "PRE", t[t.RB = 87] = "RB", t[t.RP = 88] = "RP", t[t.RT = 89] = "RT", t[t.RTC = 90] = "RTC", t[t.RUBY = 91] = "RUBY", t[t.S = 92] = "S", t[t.SCRIPT = 93] = "SCRIPT", t[t.SEARCH = 94] = "SEARCH", t[t.SECTION = 95] = "SECTION", t[t.SELECT = 96] = "SELECT", t[t.SOURCE = 97] = "SOURCE", t[t.SMALL = 98] = "SMALL", t[t.SPAN = 99] = "SPAN", t[t.STRIKE = 100] = "STRIKE", t[t.STRONG = 101] = "STRONG", t[t.STYLE = 102] = "STYLE", t[t.SUB = 103] = "SUB", t[t.SUMMARY = 104] = "SUMMARY", t[t.SUP = 105] = "SUP", t[t.TABLE = 106] = "TABLE", t[t.TBODY = 107] = "TBODY", t[t.TEMPLATE = 108] = "TEMPLATE", t[t.TEXTAREA = 109] = "TEXTAREA", t[t.TFOOT = 110] = "TFOOT", t[t.TD = 111] = "TD", t[t.TH = 112] = "TH", t[t.THEAD = 113] = "THEAD", t[t.TITLE = 114] = "TITLE", t[t.TR = 115] = "TR", t[t.TRACK = 116] = "TRACK", t[t.TT = 117] = "TT", t[t.U = 118] = "U", t[t.UL = 119] = "UL", t[t.SVG = 120] = "SVG", t[t.VAR = 121] = "VAR", t[t.WBR = 122] = "WBR", t[t.XMP = 123] = "XMP";
})(d || (d = {}));
const dm = /* @__PURE__ */ new Map([
  [k.A, d.A],
  [k.ADDRESS, d.ADDRESS],
  [k.ANNOTATION_XML, d.ANNOTATION_XML],
  [k.APPLET, d.APPLET],
  [k.AREA, d.AREA],
  [k.ARTICLE, d.ARTICLE],
  [k.ASIDE, d.ASIDE],
  [k.B, d.B],
  [k.BASE, d.BASE],
  [k.BASEFONT, d.BASEFONT],
  [k.BGSOUND, d.BGSOUND],
  [k.BIG, d.BIG],
  [k.BLOCKQUOTE, d.BLOCKQUOTE],
  [k.BODY, d.BODY],
  [k.BR, d.BR],
  [k.BUTTON, d.BUTTON],
  [k.CAPTION, d.CAPTION],
  [k.CENTER, d.CENTER],
  [k.CODE, d.CODE],
  [k.COL, d.COL],
  [k.COLGROUP, d.COLGROUP],
  [k.DD, d.DD],
  [k.DESC, d.DESC],
  [k.DETAILS, d.DETAILS],
  [k.DIALOG, d.DIALOG],
  [k.DIR, d.DIR],
  [k.DIV, d.DIV],
  [k.DL, d.DL],
  [k.DT, d.DT],
  [k.EM, d.EM],
  [k.EMBED, d.EMBED],
  [k.FIELDSET, d.FIELDSET],
  [k.FIGCAPTION, d.FIGCAPTION],
  [k.FIGURE, d.FIGURE],
  [k.FONT, d.FONT],
  [k.FOOTER, d.FOOTER],
  [k.FOREIGN_OBJECT, d.FOREIGN_OBJECT],
  [k.FORM, d.FORM],
  [k.FRAME, d.FRAME],
  [k.FRAMESET, d.FRAMESET],
  [k.H1, d.H1],
  [k.H2, d.H2],
  [k.H3, d.H3],
  [k.H4, d.H4],
  [k.H5, d.H5],
  [k.H6, d.H6],
  [k.HEAD, d.HEAD],
  [k.HEADER, d.HEADER],
  [k.HGROUP, d.HGROUP],
  [k.HR, d.HR],
  [k.HTML, d.HTML],
  [k.I, d.I],
  [k.IMG, d.IMG],
  [k.IMAGE, d.IMAGE],
  [k.INPUT, d.INPUT],
  [k.IFRAME, d.IFRAME],
  [k.KEYGEN, d.KEYGEN],
  [k.LABEL, d.LABEL],
  [k.LI, d.LI],
  [k.LINK, d.LINK],
  [k.LISTING, d.LISTING],
  [k.MAIN, d.MAIN],
  [k.MALIGNMARK, d.MALIGNMARK],
  [k.MARQUEE, d.MARQUEE],
  [k.MATH, d.MATH],
  [k.MENU, d.MENU],
  [k.META, d.META],
  [k.MGLYPH, d.MGLYPH],
  [k.MI, d.MI],
  [k.MO, d.MO],
  [k.MN, d.MN],
  [k.MS, d.MS],
  [k.MTEXT, d.MTEXT],
  [k.NAV, d.NAV],
  [k.NOBR, d.NOBR],
  [k.NOFRAMES, d.NOFRAMES],
  [k.NOEMBED, d.NOEMBED],
  [k.NOSCRIPT, d.NOSCRIPT],
  [k.OBJECT, d.OBJECT],
  [k.OL, d.OL],
  [k.OPTGROUP, d.OPTGROUP],
  [k.OPTION, d.OPTION],
  [k.P, d.P],
  [k.PARAM, d.PARAM],
  [k.PLAINTEXT, d.PLAINTEXT],
  [k.PRE, d.PRE],
  [k.RB, d.RB],
  [k.RP, d.RP],
  [k.RT, d.RT],
  [k.RTC, d.RTC],
  [k.RUBY, d.RUBY],
  [k.S, d.S],
  [k.SCRIPT, d.SCRIPT],
  [k.SEARCH, d.SEARCH],
  [k.SECTION, d.SECTION],
  [k.SELECT, d.SELECT],
  [k.SOURCE, d.SOURCE],
  [k.SMALL, d.SMALL],
  [k.SPAN, d.SPAN],
  [k.STRIKE, d.STRIKE],
  [k.STRONG, d.STRONG],
  [k.STYLE, d.STYLE],
  [k.SUB, d.SUB],
  [k.SUMMARY, d.SUMMARY],
  [k.SUP, d.SUP],
  [k.TABLE, d.TABLE],
  [k.TBODY, d.TBODY],
  [k.TEMPLATE, d.TEMPLATE],
  [k.TEXTAREA, d.TEXTAREA],
  [k.TFOOT, d.TFOOT],
  [k.TD, d.TD],
  [k.TH, d.TH],
  [k.THEAD, d.THEAD],
  [k.TITLE, d.TITLE],
  [k.TR, d.TR],
  [k.TRACK, d.TRACK],
  [k.TT, d.TT],
  [k.U, d.U],
  [k.UL, d.UL],
  [k.SVG, d.SVG],
  [k.VAR, d.VAR],
  [k.WBR, d.WBR],
  [k.XMP, d.XMP]
]);
function pi(t) {
  var e;
  return (e = dm.get(t)) !== null && e !== void 0 ? e : d.UNKNOWN;
}
const X = d, fm = {
  [z.HTML]: /* @__PURE__ */ new Set([
    X.ADDRESS,
    X.APPLET,
    X.AREA,
    X.ARTICLE,
    X.ASIDE,
    X.BASE,
    X.BASEFONT,
    X.BGSOUND,
    X.BLOCKQUOTE,
    X.BODY,
    X.BR,
    X.BUTTON,
    X.CAPTION,
    X.CENTER,
    X.COL,
    X.COLGROUP,
    X.DD,
    X.DETAILS,
    X.DIR,
    X.DIV,
    X.DL,
    X.DT,
    X.EMBED,
    X.FIELDSET,
    X.FIGCAPTION,
    X.FIGURE,
    X.FOOTER,
    X.FORM,
    X.FRAME,
    X.FRAMESET,
    X.H1,
    X.H2,
    X.H3,
    X.H4,
    X.H5,
    X.H6,
    X.HEAD,
    X.HEADER,
    X.HGROUP,
    X.HR,
    X.HTML,
    X.IFRAME,
    X.IMG,
    X.INPUT,
    X.LI,
    X.LINK,
    X.LISTING,
    X.MAIN,
    X.MARQUEE,
    X.MENU,
    X.META,
    X.NAV,
    X.NOEMBED,
    X.NOFRAMES,
    X.NOSCRIPT,
    X.OBJECT,
    X.OL,
    X.P,
    X.PARAM,
    X.PLAINTEXT,
    X.PRE,
    X.SCRIPT,
    X.SECTION,
    X.SELECT,
    X.SOURCE,
    X.STYLE,
    X.SUMMARY,
    X.TABLE,
    X.TBODY,
    X.TD,
    X.TEMPLATE,
    X.TEXTAREA,
    X.TFOOT,
    X.TH,
    X.THEAD,
    X.TITLE,
    X.TR,
    X.TRACK,
    X.UL,
    X.WBR,
    X.XMP
  ]),
  [z.MATHML]: /* @__PURE__ */ new Set([X.MI, X.MO, X.MN, X.MS, X.MTEXT, X.ANNOTATION_XML]),
  [z.SVG]: /* @__PURE__ */ new Set([X.TITLE, X.FOREIGN_OBJECT, X.DESC]),
  [z.XLINK]: /* @__PURE__ */ new Set(),
  [z.XML]: /* @__PURE__ */ new Set(),
  [z.XMLNS]: /* @__PURE__ */ new Set()
}, ua = /* @__PURE__ */ new Set([X.H1, X.H2, X.H3, X.H4, X.H5, X.H6]), hm = /* @__PURE__ */ new Set([
  k.STYLE,
  k.SCRIPT,
  k.XMP,
  k.IFRAME,
  k.NOEMBED,
  k.NOFRAMES,
  k.PLAINTEXT
]);
function bm(t, e) {
  return hm.has(t) || e && t === k.NOSCRIPT;
}
var D;
(function(t) {
  t[t.DATA = 0] = "DATA", t[t.RCDATA = 1] = "RCDATA", t[t.RAWTEXT = 2] = "RAWTEXT", t[t.SCRIPT_DATA = 3] = "SCRIPT_DATA", t[t.PLAINTEXT = 4] = "PLAINTEXT", t[t.TAG_OPEN = 5] = "TAG_OPEN", t[t.END_TAG_OPEN = 6] = "END_TAG_OPEN", t[t.TAG_NAME = 7] = "TAG_NAME", t[t.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", t[t.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", t[t.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", t[t.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", t[t.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", t[t.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", t[t.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", t[t.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", t[t.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", t[t.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", t[t.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", t[t.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", t[t.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", t[t.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", t[t.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", t[t.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", t[t.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", t[t.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", t[t.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", t[t.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", t[t.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", t[t.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", t[t.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", t[t.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", t[t.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", t[t.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", t[t.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", t[t.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", t[t.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", t[t.COMMENT_START = 42] = "COMMENT_START", t[t.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", t[t.COMMENT = 44] = "COMMENT", t[t.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", t[t.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", t[t.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", t[t.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", t[t.COMMENT_END = 50] = "COMMENT_END", t[t.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", t[t.DOCTYPE = 52] = "DOCTYPE", t[t.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", t[t.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", t[t.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", t[t.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", t[t.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", t[t.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", t[t.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", t[t.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", t[t.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", t[t.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", t[t.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", t[t.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", t[t.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", t[t.CDATA_SECTION = 68] = "CDATA_SECTION", t[t.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", t[t.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", t[t.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", t[t.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(D || (D = {}));
const ut = {
  DATA: D.DATA,
  RCDATA: D.RCDATA,
  RAWTEXT: D.RAWTEXT,
  SCRIPT_DATA: D.SCRIPT_DATA,
  PLAINTEXT: D.PLAINTEXT,
  CDATA_SECTION: D.CDATA_SECTION
};
function xm(t) {
  return t >= A.DIGIT_0 && t <= A.DIGIT_9;
}
function Ss(t) {
  return t >= A.LATIN_CAPITAL_A && t <= A.LATIN_CAPITAL_Z;
}
function mm(t) {
  return t >= A.LATIN_SMALL_A && t <= A.LATIN_SMALL_Z;
}
function en(t) {
  return mm(t) || Ss(t);
}
function to(t) {
  return en(t) || xm(t);
}
function pr(t) {
  return t + 32;
}
function Md(t) {
  return t === A.SPACE || t === A.LINE_FEED || t === A.TABULATION || t === A.FORM_FEED;
}
function no(t) {
  return Md(t) || t === A.SOLIDUS || t === A.GREATER_THAN_SIGN;
}
function pm(t) {
  return t === A.NULL ? U.nullCharacterReference : t > 1114111 ? U.characterReferenceOutsideUnicodeRange : Od(t) ? U.surrogateCharacterReference : kd(t) ? U.noncharacterCharacterReference : Bd(t) || t === A.CARRIAGE_RETURN ? U.controlCharacterReference : null;
}
class gm {
  constructor(e, n) {
    this.options = e, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = D.DATA, this.returnState = D.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new tm(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new cm(nm, (s, r) => {
      this.preprocessor.pos = this.entityStartPos + r - 1, this._flushCodePointConsumedAsCharacterReference(s);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(U.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (s) => {
        this._err(U.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + s);
      },
      validateNumericCharacterReference: (s) => {
        const r = pm(s);
        r && this._err(r, 1);
      }
    } : void 0);
  }
  //Errors
  _err(e, n = 0) {
    var s, r;
    (r = (s = this.handler).onParseError) === null || r === void 0 || r.call(s, this.preprocessor.getError(e, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(e) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - e,
      startOffset: this.preprocessor.offset - e,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const e = this._consume();
        this._ensureHibernation() || this._callState(e);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(e) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || e?.());
  }
  write(e, n, s) {
    this.active = !0, this.preprocessor.write(e, n), this._runParsingLoop(), this.paused || s?.();
  }
  insertHtmlAtCurrentPos(e) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(e), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(e) {
    this.consumedAfterSnapshot += e;
    for (let n = 0; n < e; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(e, n) {
    return this.preprocessor.startsWith(e, n) ? (this._advanceBy(e.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: xe.START_TAG,
      tagName: "",
      tagID: d.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: xe.END_TAG,
      tagName: "",
      tagID: d.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(e) {
    this.currentToken = {
      type: xe.COMMENT,
      data: "",
      location: this.getCurrentLocation(e)
    };
  }
  _createDoctypeToken(e) {
    this.currentToken = {
      type: xe.DOCTYPE,
      name: e,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(e, n) {
    this.currentCharacterToken = {
      type: e,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(e) {
    this.currentAttr = {
      name: e,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var e, n;
    const s = this.currentToken;
    if (Ld(s, this.currentAttr.name) === null) {
      if (s.attrs.push(this.currentAttr), s.location && this.currentLocation) {
        const r = (e = (n = s.location).attrs) !== null && e !== void 0 ? e : n.attrs = /* @__PURE__ */ Object.create(null);
        r[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(U.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(e) {
    this._emitCurrentCharacterToken(e.location), this.currentToken = null, e.location && (e.location.endLine = this.preprocessor.line, e.location.endCol = this.preprocessor.col + 1, e.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const e = this.currentToken;
    this.prepareToken(e), e.tagID = pi(e.tagName), e.type === xe.START_TAG ? (this.lastStartTagName = e.tagName, this.handler.onStartTag(e)) : (e.attrs.length > 0 && this._err(U.endTagWithAttributes), e.selfClosing && this._err(U.endTagWithTrailingSolidus), this.handler.onEndTag(e)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(e) {
    this.prepareToken(e), this.handler.onComment(e), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(e) {
    this.prepareToken(e), this.handler.onDoctype(e), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(e) {
    if (this.currentCharacterToken) {
      switch (e && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = e.startLine, this.currentCharacterToken.location.endCol = e.startCol, this.currentCharacterToken.location.endOffset = e.startOffset), this.currentCharacterToken.type) {
        case xe.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case xe.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case xe.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const e = this.getCurrentLocation(0);
    e && (e.endLine = e.startLine, e.endCol = e.startCol, e.endOffset = e.startOffset), this._emitCurrentCharacterToken(e), this.handler.onEof({ type: xe.EOF, location: e }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(e, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === e) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(e, n);
  }
  _emitCodePoint(e) {
    const n = Md(e) ? xe.WHITESPACE_CHARACTER : e === A.NULL ? xe.NULL_CHARACTER : xe.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(e));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(e) {
    this._appendCharToCurrentCharacterToken(xe.CHARACTER, e);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = D.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Gt.Attribute : Gt.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === D.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === D.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === D.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(e) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(e) : this._emitCodePoint(e);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(e) {
    switch (this.state) {
      case D.DATA: {
        this._stateData(e);
        break;
      }
      case D.RCDATA: {
        this._stateRcdata(e);
        break;
      }
      case D.RAWTEXT: {
        this._stateRawtext(e);
        break;
      }
      case D.SCRIPT_DATA: {
        this._stateScriptData(e);
        break;
      }
      case D.PLAINTEXT: {
        this._statePlaintext(e);
        break;
      }
      case D.TAG_OPEN: {
        this._stateTagOpen(e);
        break;
      }
      case D.END_TAG_OPEN: {
        this._stateEndTagOpen(e);
        break;
      }
      case D.TAG_NAME: {
        this._stateTagName(e);
        break;
      }
      case D.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(e);
        break;
      }
      case D.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(e);
        break;
      }
      case D.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(e);
        break;
      }
      case D.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(e);
        break;
      }
      case D.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(e);
        break;
      }
      case D.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(e);
        break;
      }
      case D.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(e);
        break;
      }
      case D.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(e);
        break;
      }
      case D.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(e);
        break;
      }
      case D.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(e);
        break;
      }
      case D.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(e);
        break;
      }
      case D.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(e);
        break;
      }
      case D.ATTRIBUTE_NAME: {
        this._stateAttributeName(e);
        break;
      }
      case D.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(e);
        break;
      }
      case D.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(e);
        break;
      }
      case D.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(e);
        break;
      }
      case D.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(e);
        break;
      }
      case D.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(e);
        break;
      }
      case D.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(e);
        break;
      }
      case D.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(e);
        break;
      }
      case D.BOGUS_COMMENT: {
        this._stateBogusComment(e);
        break;
      }
      case D.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(e);
        break;
      }
      case D.COMMENT_START: {
        this._stateCommentStart(e);
        break;
      }
      case D.COMMENT_START_DASH: {
        this._stateCommentStartDash(e);
        break;
      }
      case D.COMMENT: {
        this._stateComment(e);
        break;
      }
      case D.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(e);
        break;
      }
      case D.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(e);
        break;
      }
      case D.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(e);
        break;
      }
      case D.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(e);
        break;
      }
      case D.COMMENT_END_DASH: {
        this._stateCommentEndDash(e);
        break;
      }
      case D.COMMENT_END: {
        this._stateCommentEnd(e);
        break;
      }
      case D.COMMENT_END_BANG: {
        this._stateCommentEndBang(e);
        break;
      }
      case D.DOCTYPE: {
        this._stateDoctype(e);
        break;
      }
      case D.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(e);
        break;
      }
      case D.DOCTYPE_NAME: {
        this._stateDoctypeName(e);
        break;
      }
      case D.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(e);
        break;
      }
      case D.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(e);
        break;
      }
      case D.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(e);
        break;
      }
      case D.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(e);
        break;
      }
      case D.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(e);
        break;
      }
      case D.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(e);
        break;
      }
      case D.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(e);
        break;
      }
      case D.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(e);
        break;
      }
      case D.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(e);
        break;
      }
      case D.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(e);
        break;
      }
      case D.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(e);
        break;
      }
      case D.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(e);
        break;
      }
      case D.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(e);
        break;
      }
      case D.CDATA_SECTION: {
        this._stateCdataSection(e);
        break;
      }
      case D.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(e);
        break;
      }
      case D.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(e);
        break;
      }
      case D.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case D.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(e);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(e) {
    switch (e) {
      case A.LESS_THAN_SIGN: {
        this.state = D.TAG_OPEN;
        break;
      }
      case A.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitCodePoint(e);
        break;
      }
      case A.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(e) {
    switch (e) {
      case A.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(e) {
    switch (e) {
      case A.LESS_THAN_SIGN: {
        this.state = D.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(e) {
    switch (e) {
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(e) {
    switch (e) {
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(e) {
    if (en(e))
      this._createStartTagToken(), this.state = D.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case A.EXCLAMATION_MARK: {
          this.state = D.MARKUP_DECLARATION_OPEN;
          break;
        }
        case A.SOLIDUS: {
          this.state = D.END_TAG_OPEN;
          break;
        }
        case A.QUESTION_MARK: {
          this._err(U.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = D.BOGUS_COMMENT, this._stateBogusComment(e);
          break;
        }
        case A.EOF: {
          this._err(U.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(U.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = D.DATA, this._stateData(e);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(e) {
    if (en(e))
      this._createEndTagToken(), this.state = D.TAG_NAME, this._stateTagName(e);
    else
      switch (e) {
        case A.GREATER_THAN_SIGN: {
          this._err(U.missingEndTagName), this.state = D.DATA;
          break;
        }
        case A.EOF: {
          this._err(U.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(U.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = D.BOGUS_COMMENT, this._stateBogusComment(e);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case A.SOLIDUS: {
        this.state = D.SELF_CLOSING_START_TAG;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.tagName += Se;
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Ss(e) ? pr(e) : e);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(e) {
    e === A.SOLIDUS ? this.state = D.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = D.RCDATA, this._stateRcdata(e));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(e) {
    en(e) ? (this.state = D.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(e)) : (this._emitChars("</"), this.state = D.RCDATA, this._stateRcdata(e));
  }
  handleSpecialEndTag(e) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = D.BEFORE_ATTRIBUTE_NAME, !1;
      case A.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = D.SELF_CLOSING_START_TAG, !1;
      case A.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = D.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = D.RCDATA, this._stateRcdata(e));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(e) {
    e === A.SOLIDUS ? this.state = D.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = D.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(e) {
    en(e) ? (this.state = D.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(e)) : (this._emitChars("</"), this.state = D.RAWTEXT, this._stateRawtext(e));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = D.RAWTEXT, this._stateRawtext(e));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(e) {
    switch (e) {
      case A.SOLIDUS: {
        this.state = D.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case A.EXCLAMATION_MARK: {
        this.state = D.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = D.SCRIPT_DATA, this._stateScriptData(e);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(e) {
    en(e) ? (this.state = D.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(e)) : (this._emitChars("</"), this.state = D.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = D.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(e) {
    e === A.HYPHEN_MINUS ? (this.state = D.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = D.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(e) {
    e === A.HYPHEN_MINUS ? (this.state = D.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = D.SCRIPT_DATA, this._stateScriptData(e));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = D.SCRIPT_DATA_ESCAPED, this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = D.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = D.SCRIPT_DATA_ESCAPED, this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = D.SCRIPT_DATA_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(e) {
    e === A.SOLIDUS ? this.state = D.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : en(e) ? (this._emitChars("<"), this.state = D.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(e)) : (this._emitChars("<"), this.state = D.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(e) {
    en(e) ? (this.state = D.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(e)) : (this._emitChars("</"), this.state = D.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(e) {
    this.handleSpecialEndTag(e) && (this._emitChars("</"), this.state = D.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(e) {
    if (this.preprocessor.startsWith(nt.SCRIPT, !1) && no(this.preprocessor.peek(nt.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < nt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = D.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(e));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case A.LESS_THAN_SIGN: {
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Se);
        break;
      }
      case A.EOF: {
        this._err(U.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(e);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(e) {
    e === A.SOLIDUS ? (this.state = D.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(e) {
    if (this.preprocessor.startsWith(nt.SCRIPT, !1) && no(this.preprocessor.peek(nt.SCRIPT.length))) {
      this._emitCodePoint(e);
      for (let n = 0; n < nt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = D.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = D.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(e));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.SOLIDUS:
      case A.GREATER_THAN_SIGN:
      case A.EOF: {
        this.state = D.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case A.EQUALS_SIGN: {
        this._err(U.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = D.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = D.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
      case A.SOLIDUS:
      case A.GREATER_THAN_SIGN:
      case A.EOF: {
        this._leaveAttrName(), this.state = D.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(e);
        break;
      }
      case A.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = D.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case A.QUOTATION_MARK:
      case A.APOSTROPHE:
      case A.LESS_THAN_SIGN: {
        this._err(U.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(e);
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.name += Se;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Ss(e) ? pr(e) : e);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.SOLIDUS: {
        this.state = D.SELF_CLOSING_START_TAG;
        break;
      }
      case A.EQUALS_SIGN: {
        this.state = D.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = D.ATTRIBUTE_NAME, this._stateAttributeName(e);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.QUOTATION_MARK: {
        this.state = D.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        this.state = D.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.missingAttributeValue), this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = D.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(e);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(e) {
    switch (e) {
      case A.QUOTATION_MARK: {
        this.state = D.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case A.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += Se;
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(e) {
    switch (e) {
      case A.APOSTROPHE: {
        this.state = D.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case A.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += Se;
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this._leaveAttrValue(), this.state = D.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case A.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), this.currentAttr.value += Se;
        break;
      }
      case A.QUOTATION_MARK:
      case A.APOSTROPHE:
      case A.LESS_THAN_SIGN:
      case A.EQUALS_SIGN:
      case A.GRAVE_ACCENT: {
        this._err(U.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(e);
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(e);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this._leaveAttrValue(), this.state = D.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case A.SOLIDUS: {
        this._leaveAttrValue(), this.state = D.SELF_CLOSING_START_TAG;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingWhitespaceBetweenAttributes), this.state = D.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(e) {
    switch (e) {
      case A.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = D.DATA, this.emitCurrentTagToken();
        break;
      }
      case A.EOF: {
        this._err(U.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.unexpectedSolidusInTag), this.state = D.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(e);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(e) {
    const n = this.currentToken;
    switch (e) {
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentComment(n);
        break;
      }
      case A.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.data += Se;
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(e) {
    this._consumeSequenceIfMatch(nt.DASH_DASH, !0) ? (this._createCommentToken(nt.DASH_DASH.length + 1), this.state = D.COMMENT_START) : this._consumeSequenceIfMatch(nt.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(nt.DOCTYPE.length + 1), this.state = D.DOCTYPE) : this._consumeSequenceIfMatch(nt.CDATA_START, !0) ? this.inForeignNode ? this.state = D.CDATA_SECTION : (this._err(U.cdataInHtmlContent), this._createCommentToken(nt.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = D.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(U.incorrectlyOpenedComment), this._createCommentToken(2), this.state = D.BOGUS_COMMENT, this._stateBogusComment(e));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(e) {
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.COMMENT_START_DASH;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptClosingOfEmptyComment), this.state = D.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(e) {
    const n = this.currentToken;
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.COMMENT_END;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptClosingOfEmptyComment), this.state = D.DATA, this.emitCurrentComment(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(e) {
    const n = this.currentToken;
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.COMMENT_END_DASH;
        break;
      }
      case A.LESS_THAN_SIGN: {
        n.data += "<", this.state = D.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.data += Se;
        break;
      }
      case A.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(e);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(e) {
    const n = this.currentToken;
    switch (e) {
      case A.EXCLAMATION_MARK: {
        n.data += "!", this.state = D.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case A.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(e) {
    e === A.HYPHEN_MINUS ? this.state = D.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = D.COMMENT, this._stateComment(e));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(e) {
    e === A.HYPHEN_MINUS ? this.state = D.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = D.COMMENT_END_DASH, this._stateCommentEndDash(e));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(e) {
    e !== A.GREATER_THAN_SIGN && e !== A.EOF && this._err(U.nestedComment), this.state = D.COMMENT_END, this._stateCommentEnd(e);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(e) {
    const n = this.currentToken;
    switch (e) {
      case A.HYPHEN_MINUS: {
        this.state = D.COMMENT_END;
        break;
      }
      case A.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(e) {
    const n = this.currentToken;
    switch (e) {
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentComment(n);
        break;
      }
      case A.EXCLAMATION_MARK: {
        this.state = D.COMMENT_END_BANG;
        break;
      }
      case A.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case A.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(e) {
    const n = this.currentToken;
    switch (e) {
      case A.HYPHEN_MINUS: {
        n.data += "--!", this.state = D.COMMENT_END_DASH;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.incorrectlyClosedComment), this.state = D.DATA, this.emitCurrentComment(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = D.COMMENT, this._stateComment(e);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(e) {
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.BEFORE_DOCTYPE_NAME;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingWhitespaceBeforeDoctypeName), this.state = D.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(e);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(e) {
    if (Ss(e))
      this._createDoctypeToken(String.fromCharCode(pr(e))), this.state = D.DOCTYPE_NAME;
    else
      switch (e) {
        case A.SPACE:
        case A.LINE_FEED:
        case A.TABULATION:
        case A.FORM_FEED:
          break;
        case A.NULL: {
          this._err(U.unexpectedNullCharacter), this._createDoctypeToken(Se), this.state = D.DOCTYPE_NAME;
          break;
        }
        case A.GREATER_THAN_SIGN: {
          this._err(U.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = D.DATA;
          break;
        }
        case A.EOF: {
          this._err(U.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(e)), this.state = D.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.AFTER_DOCTYPE_NAME;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.name += Se;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Ss(e) ? pr(e) : e);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(nt.PUBLIC, !1) ? this.state = D.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(nt.SYSTEM, !1) ? this.state = D.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(U.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case A.QUOTATION_MARK: {
        this._err(U.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = D.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        this._err(U.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = D.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.QUOTATION_MARK: {
        n.publicId = "", this.state = D.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        n.publicId = "", this.state = D.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case A.QUOTATION_MARK: {
        this.state = D.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.publicId += Se;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case A.APOSTROPHE: {
        this.state = D.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.publicId += Se;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.QUOTATION_MARK: {
        this._err(U.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        this._err(U.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.QUOTATION_MARK: {
        n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED: {
        this.state = D.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case A.QUOTATION_MARK: {
        this._err(U.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        this._err(U.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.QUOTATION_MARK: {
        n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case A.APOSTROPHE: {
        n.systemId = "", this.state = D.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case A.QUOTATION_MARK: {
        this.state = D.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.systemId += Se;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(e) {
    const n = this.currentToken;
    switch (e) {
      case A.APOSTROPHE: {
        this.state = D.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter), n.systemId += Se;
        break;
      }
      case A.GREATER_THAN_SIGN: {
        this._err(U.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(e);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(e) {
    const n = this.currentToken;
    switch (e) {
      case A.SPACE:
      case A.LINE_FEED:
      case A.TABULATION:
      case A.FORM_FEED:
        break;
      case A.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.EOF: {
        this._err(U.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(U.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = D.BOGUS_DOCTYPE, this._stateBogusDoctype(e);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(e) {
    const n = this.currentToken;
    switch (e) {
      case A.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = D.DATA;
        break;
      }
      case A.NULL: {
        this._err(U.unexpectedNullCharacter);
        break;
      }
      case A.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(e) {
    switch (e) {
      case A.RIGHT_SQUARE_BRACKET: {
        this.state = D.CDATA_SECTION_BRACKET;
        break;
      }
      case A.EOF: {
        this._err(U.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(e);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(e) {
    e === A.RIGHT_SQUARE_BRACKET ? this.state = D.CDATA_SECTION_END : (this._emitChars("]"), this.state = D.CDATA_SECTION, this._stateCdataSection(e));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(e) {
    switch (e) {
      case A.GREATER_THAN_SIGN: {
        this.state = D.DATA;
        break;
      }
      case A.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = D.CDATA_SECTION, this._stateCdataSection(e);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let e = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (e < 0)
      if (this.preprocessor.lastChunkWritten)
        e = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    e === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(A.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && to(this.preprocessor.peek(1)) ? D.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(e) {
    to(e) ? this._flushCodePointConsumedAsCharacterReference(e) : (e === A.SEMICOLON && this._err(U.unknownNamedCharacterReference), this.state = this.returnState, this._callState(e));
  }
}
const Rd = /* @__PURE__ */ new Set([d.DD, d.DT, d.LI, d.OPTGROUP, d.OPTION, d.P, d.RB, d.RP, d.RT, d.RTC]), so = /* @__PURE__ */ new Set([
  ...Rd,
  d.CAPTION,
  d.COLGROUP,
  d.TBODY,
  d.TD,
  d.TFOOT,
  d.TH,
  d.THEAD,
  d.TR
]), Qr = /* @__PURE__ */ new Set([
  d.APPLET,
  d.CAPTION,
  d.HTML,
  d.MARQUEE,
  d.OBJECT,
  d.TABLE,
  d.TD,
  d.TEMPLATE,
  d.TH
]), Em = /* @__PURE__ */ new Set([...Qr, d.OL, d.UL]), _m = /* @__PURE__ */ new Set([...Qr, d.BUTTON]), ro = /* @__PURE__ */ new Set([d.ANNOTATION_XML, d.MI, d.MN, d.MO, d.MS, d.MTEXT]), io = /* @__PURE__ */ new Set([d.DESC, d.FOREIGN_OBJECT, d.TITLE]), Tm = /* @__PURE__ */ new Set([d.TR, d.TEMPLATE, d.HTML]), Am = /* @__PURE__ */ new Set([d.TBODY, d.TFOOT, d.THEAD, d.TEMPLATE, d.HTML]), ym = /* @__PURE__ */ new Set([d.TABLE, d.TEMPLATE, d.HTML]), Cm = /* @__PURE__ */ new Set([d.TD, d.TH]);
class Dm {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(e, n, s) {
    this.treeAdapter = n, this.handler = s, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = d.UNKNOWN, this.current = e;
  }
  //Index of element
  _indexOf(e) {
    return this.items.lastIndexOf(e, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === d.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === z.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(e, n) {
    this.stackTop++, this.items[this.stackTop] = e, this.current = e, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(e, n, !0);
  }
  pop() {
    const e = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !0);
  }
  replace(e, n) {
    const s = this._indexOf(e);
    this.items[s] = n, s === this.stackTop && (this.current = n);
  }
  insertAfter(e, n, s) {
    const r = this._indexOf(e) + 1;
    this.items.splice(r, 0, n), this.tagIDs.splice(r, 0, s), this.stackTop++, r === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, r === this.stackTop);
  }
  popUntilTagNamePopped(e) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(e, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== z.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(e) {
    for (; this.stackTop >= e; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < e);
    }
  }
  popUntilElementPopped(e) {
    const n = this._indexOf(e);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(e, n) {
    const s = this._indexOfTagNames(e, n);
    this.shortenToLength(Math.max(s, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(ua, z.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(Cm, z.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(e, n) {
    for (let s = this.stackTop; s >= 0; s--)
      if (e.has(this.tagIDs[s]) && this.treeAdapter.getNamespaceURI(this.items[s]) === n)
        return s;
    return -1;
  }
  clearBackTo(e, n) {
    const s = this._indexOfTagNames(e, n);
    this.shortenToLength(s + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(ym, z.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(Am, z.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(Tm, z.HTML);
  }
  remove(e) {
    const n = this._indexOf(e);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(e, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === d.BODY ? this.items[1] : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    const n = this._indexOf(e) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === d.HTML;
  }
  //Element in scope
  hasInDynamicScope(e, n) {
    for (let s = this.stackTop; s >= 0; s--) {
      const r = this.tagIDs[s];
      switch (this.treeAdapter.getNamespaceURI(this.items[s])) {
        case z.HTML: {
          if (r === e)
            return !0;
          if (n.has(r))
            return !1;
          break;
        }
        case z.SVG: {
          if (io.has(r))
            return !1;
          break;
        }
        case z.MATHML: {
          if (ro.has(r))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(e) {
    return this.hasInDynamicScope(e, Qr);
  }
  hasInListItemScope(e) {
    return this.hasInDynamicScope(e, Em);
  }
  hasInButtonScope(e) {
    return this.hasInDynamicScope(e, _m);
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const n = this.tagIDs[e];
      switch (this.treeAdapter.getNamespaceURI(this.items[e])) {
        case z.HTML: {
          if (ua.has(n))
            return !0;
          if (Qr.has(n))
            return !1;
          break;
        }
        case z.SVG: {
          if (io.has(n))
            return !1;
          break;
        }
        case z.MATHML: {
          if (ro.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === z.HTML)
        switch (this.tagIDs[n]) {
          case e:
            return !0;
          case d.TABLE:
          case d.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--)
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === z.HTML)
        switch (this.tagIDs[e]) {
          case d.TBODY:
          case d.THEAD:
          case d.TFOOT:
            return !0;
          case d.TABLE:
          case d.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(e) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === z.HTML)
        switch (this.tagIDs[n]) {
          case e:
            return !0;
          case d.OPTION:
          case d.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && Rd.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && so.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== e && so.has(this.currentTagId); )
      this.pop();
  }
}
const Gi = 3;
var Bt;
(function(t) {
  t[t.Marker = 0] = "Marker", t[t.Element = 1] = "Element";
})(Bt || (Bt = {}));
const uo = { type: Bt.Marker };
class vm {
  constructor(e) {
    this.treeAdapter = e, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(e, n) {
    const s = [], r = n.length, i = this.treeAdapter.getTagName(e), u = this.treeAdapter.getNamespaceURI(e);
    for (let a = 0; a < this.entries.length; a++) {
      const o = this.entries[a];
      if (o.type === Bt.Marker)
        break;
      const { element: c } = o;
      if (this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === u) {
        const l = this.treeAdapter.getAttrList(c);
        l.length === r && s.push({ idx: a, attrs: l });
      }
    }
    return s;
  }
  _ensureNoahArkCondition(e) {
    if (this.entries.length < Gi)
      return;
    const n = this.treeAdapter.getAttrList(e), s = this._getNoahArkConditionCandidates(e, n);
    if (s.length < Gi)
      return;
    const r = new Map(n.map((u) => [u.name, u.value]));
    let i = 0;
    for (let u = 0; u < s.length; u++) {
      const a = s[u];
      a.attrs.every((o) => r.get(o.name) === o.value) && (i += 1, i >= Gi && this.entries.splice(a.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(uo);
  }
  pushElement(e, n) {
    this._ensureNoahArkCondition(e), this.entries.unshift({
      type: Bt.Element,
      element: e,
      token: n
    });
  }
  insertElementAfterBookmark(e, n) {
    const s = this.entries.indexOf(this.bookmark);
    this.entries.splice(s, 0, {
      type: Bt.Element,
      element: e,
      token: n
    });
  }
  removeEntry(e) {
    const n = this.entries.indexOf(e);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const e = this.entries.indexOf(uo);
    e === -1 ? this.entries.length = 0 : this.entries.splice(0, e + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(e) {
    const n = this.entries.find((s) => s.type === Bt.Marker || this.treeAdapter.getTagName(s.element) === e);
    return n && n.type === Bt.Element ? n : null;
  }
  getElementEntry(e) {
    return this.entries.find((n) => n.type === Bt.Element && n.element === e);
  }
}
const Vt = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: dt.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(t, e, n) {
    return {
      nodeName: t,
      tagName: t,
      attrs: n,
      namespaceURI: e,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(t) {
    return {
      nodeName: "#comment",
      data: t,
      parentNode: null
    };
  },
  createTextNode(t) {
    return {
      nodeName: "#text",
      value: t,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(t, e) {
    t.childNodes.push(e), e.parentNode = t;
  },
  insertBefore(t, e, n) {
    const s = t.childNodes.indexOf(n);
    t.childNodes.splice(s, 0, e), e.parentNode = t;
  },
  setTemplateContent(t, e) {
    t.content = e;
  },
  getTemplateContent(t) {
    return t.content;
  },
  setDocumentType(t, e, n, s) {
    const r = t.childNodes.find((i) => i.nodeName === "#documentType");
    if (r)
      r.name = e, r.publicId = n, r.systemId = s;
    else {
      const i = {
        nodeName: "#documentType",
        name: e,
        publicId: n,
        systemId: s,
        parentNode: null
      };
      Vt.appendChild(t, i);
    }
  },
  setDocumentMode(t, e) {
    t.mode = e;
  },
  getDocumentMode(t) {
    return t.mode;
  },
  detachNode(t) {
    if (t.parentNode) {
      const e = t.parentNode.childNodes.indexOf(t);
      t.parentNode.childNodes.splice(e, 1), t.parentNode = null;
    }
  },
  insertText(t, e) {
    if (t.childNodes.length > 0) {
      const n = t.childNodes[t.childNodes.length - 1];
      if (Vt.isTextNode(n)) {
        n.value += e;
        return;
      }
    }
    Vt.appendChild(t, Vt.createTextNode(e));
  },
  insertTextBefore(t, e, n) {
    const s = t.childNodes[t.childNodes.indexOf(n) - 1];
    s && Vt.isTextNode(s) ? s.value += e : Vt.insertBefore(t, Vt.createTextNode(e), n);
  },
  adoptAttributes(t, e) {
    const n = new Set(t.attrs.map((s) => s.name));
    for (let s = 0; s < e.length; s++)
      n.has(e[s].name) || t.attrs.push(e[s]);
  },
  //Tree traversing
  getFirstChild(t) {
    return t.childNodes[0];
  },
  getChildNodes(t) {
    return t.childNodes;
  },
  getParentNode(t) {
    return t.parentNode;
  },
  getAttrList(t) {
    return t.attrs;
  },
  //Node data
  getTagName(t) {
    return t.tagName;
  },
  getNamespaceURI(t) {
    return t.namespaceURI;
  },
  getTextNodeContent(t) {
    return t.value;
  },
  getCommentNodeContent(t) {
    return t.data;
  },
  getDocumentTypeNodeName(t) {
    return t.name;
  },
  getDocumentTypeNodePublicId(t) {
    return t.publicId;
  },
  getDocumentTypeNodeSystemId(t) {
    return t.systemId;
  },
  //Node types
  isTextNode(t) {
    return t.nodeName === "#text";
  },
  isCommentNode(t) {
    return t.nodeName === "#comment";
  },
  isDocumentTypeNode(t) {
    return t.nodeName === "#documentType";
  },
  isElementNode(t) {
    return Object.prototype.hasOwnProperty.call(t, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = e;
  },
  getNodeSourceCodeLocation(t) {
    return t.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(t, e) {
    t.sourceCodeLocation = { ...t.sourceCodeLocation, ...e };
  }
}, Pd = "html", Sm = "about:legacy-compat", wm = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Fd = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], Nm = [
  ...Fd,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], Im = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), Hd = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], Om = [
  ...Hd,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function ao(t, e) {
  return e.some((n) => t.startsWith(n));
}
function Bm(t) {
  return t.name === Pd && t.publicId === null && (t.systemId === null || t.systemId === Sm);
}
function km(t) {
  if (t.name !== Pd)
    return dt.QUIRKS;
  const { systemId: e } = t;
  if (e && e.toLowerCase() === wm)
    return dt.QUIRKS;
  let { publicId: n } = t;
  if (n !== null) {
    if (n = n.toLowerCase(), Im.has(n))
      return dt.QUIRKS;
    let s = e === null ? Nm : Fd;
    if (ao(n, s))
      return dt.QUIRKS;
    if (s = e === null ? Hd : Om, ao(n, s))
      return dt.LIMITED_QUIRKS;
  }
  return dt.NO_QUIRKS;
}
const oo = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, Lm = "definitionurl", Mm = "definitionURL", Rm = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((t) => [t.toLowerCase(), t])), Pm = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: z.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: z.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: z.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: z.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: z.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: z.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: z.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: z.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: z.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: z.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: z.XMLNS }]
]), Fm = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((t) => [t.toLowerCase(), t])), Hm = /* @__PURE__ */ new Set([
  d.B,
  d.BIG,
  d.BLOCKQUOTE,
  d.BODY,
  d.BR,
  d.CENTER,
  d.CODE,
  d.DD,
  d.DIV,
  d.DL,
  d.DT,
  d.EM,
  d.EMBED,
  d.H1,
  d.H2,
  d.H3,
  d.H4,
  d.H5,
  d.H6,
  d.HEAD,
  d.HR,
  d.I,
  d.IMG,
  d.LI,
  d.LISTING,
  d.MENU,
  d.META,
  d.NOBR,
  d.OL,
  d.P,
  d.PRE,
  d.RUBY,
  d.S,
  d.SMALL,
  d.SPAN,
  d.STRONG,
  d.STRIKE,
  d.SUB,
  d.SUP,
  d.TABLE,
  d.TT,
  d.U,
  d.UL,
  d.VAR
]);
function Um(t) {
  const e = t.tagID;
  return e === d.FONT && t.attrs.some(({ name: s }) => s === Cn.COLOR || s === Cn.SIZE || s === Cn.FACE) || Hm.has(e);
}
function Ud(t) {
  for (let e = 0; e < t.attrs.length; e++)
    if (t.attrs[e].name === Lm) {
      t.attrs[e].name = Mm;
      break;
    }
}
function Yd(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = Rm.get(t.attrs[e].name);
    n != null && (t.attrs[e].name = n);
  }
}
function Xa(t) {
  for (let e = 0; e < t.attrs.length; e++) {
    const n = Pm.get(t.attrs[e].name);
    n && (t.attrs[e].prefix = n.prefix, t.attrs[e].name = n.name, t.attrs[e].namespace = n.namespace);
  }
}
function Ym(t) {
  const e = Fm.get(t.tagName);
  e != null && (t.tagName = e, t.tagID = pi(t.tagName));
}
function qm(t, e) {
  return e === z.MATHML && (t === d.MI || t === d.MO || t === d.MN || t === d.MS || t === d.MTEXT);
}
function $m(t, e, n) {
  if (e === z.MATHML && t === d.ANNOTATION_XML) {
    for (let s = 0; s < n.length; s++)
      if (n[s].name === Cn.ENCODING) {
        const r = n[s].value.toLowerCase();
        return r === oo.TEXT_HTML || r === oo.APPLICATION_XML;
      }
  }
  return e === z.SVG && (t === d.FOREIGN_OBJECT || t === d.DESC || t === d.TITLE);
}
function Wm(t, e, n, s) {
  return (!s || s === z.HTML) && $m(t, e, n) || (!s || s === z.MATHML) && qm(t, e);
}
const zm = "hidden", Vm = 8, jm = 3;
var I;
(function(t) {
  t[t.INITIAL = 0] = "INITIAL", t[t.BEFORE_HTML = 1] = "BEFORE_HTML", t[t.BEFORE_HEAD = 2] = "BEFORE_HEAD", t[t.IN_HEAD = 3] = "IN_HEAD", t[t.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", t[t.AFTER_HEAD = 5] = "AFTER_HEAD", t[t.IN_BODY = 6] = "IN_BODY", t[t.TEXT = 7] = "TEXT", t[t.IN_TABLE = 8] = "IN_TABLE", t[t.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", t[t.IN_CAPTION = 10] = "IN_CAPTION", t[t.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", t[t.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", t[t.IN_ROW = 13] = "IN_ROW", t[t.IN_CELL = 14] = "IN_CELL", t[t.IN_SELECT = 15] = "IN_SELECT", t[t.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", t[t.IN_TEMPLATE = 17] = "IN_TEMPLATE", t[t.AFTER_BODY = 18] = "AFTER_BODY", t[t.IN_FRAMESET = 19] = "IN_FRAMESET", t[t.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", t[t.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", t[t.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(I || (I = {}));
const Gm = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, qd = /* @__PURE__ */ new Set([d.TABLE, d.TBODY, d.TFOOT, d.THEAD, d.TR]), co = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Vt,
  onParseError: null
};
let $d = class {
  constructor(e, n, s = null, r = null) {
    this.fragmentContext = s, this.scriptHandler = r, this.currentToken = null, this.stopped = !1, this.insertionMode = I.INITIAL, this.originalInsertionMode = I.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...co,
      ...e
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new gm(this.options, this), this.activeFormattingElements = new vm(this.treeAdapter), this.fragmentContextID = s ? pi(this.treeAdapter.getTagName(s)) : d.UNKNOWN, this._setContextModes(s ?? this.document, this.fragmentContextID), this.openElements = new Dm(this.document, this.treeAdapter, this);
  }
  // API
  static parse(e, n) {
    const s = new this(n);
    return s.tokenizer.write(e, !0), s.document;
  }
  static getFragmentParser(e, n) {
    const s = {
      ...co,
      ...n
    };
    e ?? (e = s.treeAdapter.createElement(k.TEMPLATE, z.HTML, []));
    const r = s.treeAdapter.createElement("documentmock", z.HTML, []), i = new this(s, r, e);
    return i.fragmentContextID === d.TEMPLATE && i.tmplInsertionModeStack.unshift(I.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const e = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(e, n), n;
  }
  //Errors
  /** @internal */
  _err(e, n, s) {
    var r;
    if (!this.onParseError)
      return;
    const i = (r = e.location) !== null && r !== void 0 ? r : Gm, u = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: s ? i.startLine : i.endLine,
      endCol: s ? i.startCol : i.endCol,
      endOffset: s ? i.startOffset : i.endOffset
    };
    this.onParseError(u);
  }
  //Stack events
  /** @internal */
  onItemPush(e, n, s) {
    var r, i;
    (i = (r = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(r, e), s && this.openElements.stackTop > 0 && this._setContextModes(e, n);
  }
  /** @internal */
  onItemPop(e, n) {
    var s, r;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(e, this.currentToken), (r = (s = this.treeAdapter).onItemPop) === null || r === void 0 || r.call(s, e, this.openElements.current), n) {
      let i, u;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, u = this.fragmentContextID) : { current: i, currentTagId: u } = this.openElements, this._setContextModes(i, u);
    }
  }
  _setContextModes(e, n) {
    const s = e === this.document || e && this.treeAdapter.getNamespaceURI(e) === z.HTML;
    this.currentNotInHTML = !s, this.tokenizer.inForeignNode = !s && e !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, e);
  }
  /** @protected */
  _switchToTextParsing(e, n) {
    this._insertElement(e, z.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = I.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = I.TEXT, this.originalInsertionMode = I.IN_BODY, this.tokenizer.state = ut.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let e = this.fragmentContext;
    for (; e; ) {
      if (this.treeAdapter.getTagName(e) === k.FORM) {
        this.formElement = e;
        break;
      }
      e = this.treeAdapter.getParentNode(e);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== z.HTML))
      switch (this.fragmentContextID) {
        case d.TITLE:
        case d.TEXTAREA: {
          this.tokenizer.state = ut.RCDATA;
          break;
        }
        case d.STYLE:
        case d.XMP:
        case d.IFRAME:
        case d.NOEMBED:
        case d.NOFRAMES:
        case d.NOSCRIPT: {
          this.tokenizer.state = ut.RAWTEXT;
          break;
        }
        case d.SCRIPT: {
          this.tokenizer.state = ut.SCRIPT_DATA;
          break;
        }
        case d.PLAINTEXT: {
          this.tokenizer.state = ut.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(e) {
    const n = e.name || "", s = e.publicId || "", r = e.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, s, r), e.location) {
      const u = this.treeAdapter.getChildNodes(this.document).find((a) => this.treeAdapter.isDocumentTypeNode(a));
      u && this.treeAdapter.setNodeSourceCodeLocation(u, e.location);
    }
  }
  /** @protected */
  _attachElementToTree(e, n) {
    if (this.options.sourceCodeLocationInfo) {
      const s = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(e, s);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(e);
    else {
      const s = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(s ?? this.document, e);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(e, n) {
    const s = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(s, e.location);
  }
  /** @protected */
  _insertElement(e, n) {
    const s = this.treeAdapter.createElement(e.tagName, n, e.attrs);
    this._attachElementToTree(s, e.location), this.openElements.push(s, e.tagID);
  }
  /** @protected */
  _insertFakeElement(e, n) {
    const s = this.treeAdapter.createElement(e, z.HTML, []);
    this._attachElementToTree(s, null), this.openElements.push(s, n);
  }
  /** @protected */
  _insertTemplate(e) {
    const n = this.treeAdapter.createElement(e.tagName, z.HTML, e.attrs), s = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, s), this._attachElementToTree(n, e.location), this.openElements.push(n, e.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(s, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const e = this.treeAdapter.createElement(k.HTML, z.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(e, null), this.treeAdapter.appendChild(this.openElements.current, e), this.openElements.push(e, d.HTML);
  }
  /** @protected */
  _appendCommentNode(e, n) {
    const s = this.treeAdapter.createCommentNode(e.data);
    this.treeAdapter.appendChild(n, s), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(s, e.location);
  }
  /** @protected */
  _insertCharacters(e) {
    let n, s;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: s } = this._findFosterParentingLocation(), s ? this.treeAdapter.insertTextBefore(n, e.chars, s) : this.treeAdapter.insertText(n, e.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, e.chars)), !e.location)
      return;
    const r = this.treeAdapter.getChildNodes(n), i = s ? r.lastIndexOf(s) : r.length, u = r[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(u)) {
      const { endLine: o, endCol: c, endOffset: l } = e.location;
      this.treeAdapter.updateNodeSourceCodeLocation(u, { endLine: o, endCol: c, endOffset: l });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(u, e.location);
  }
  /** @protected */
  _adoptNodes(e, n) {
    for (let s = this.treeAdapter.getFirstChild(e); s; s = this.treeAdapter.getFirstChild(e))
      this.treeAdapter.detachNode(s), this.treeAdapter.appendChild(n, s);
  }
  /** @protected */
  _setEndLocation(e, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && n.location) {
      const s = n.location, r = this.treeAdapter.getTagName(e), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === xe.END_TAG && r === n.tagName ? {
          endTag: { ...s },
          endLine: s.endLine,
          endCol: s.endCol,
          endOffset: s.endOffset
        } : {
          endLine: s.startLine,
          endCol: s.startCol,
          endOffset: s.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(e, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(e) {
    if (!this.currentNotInHTML)
      return !1;
    let n, s;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, s = this.fragmentContextID) : { current: n, currentTagId: s } = this.openElements, e.tagID === d.SVG && this.treeAdapter.getTagName(n) === k.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === z.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (e.tagID === d.MGLYPH || e.tagID === d.MALIGNMARK) && s !== void 0 && !this._isIntegrationPoint(s, n, z.HTML)
    );
  }
  /** @protected */
  _processToken(e) {
    switch (e.type) {
      case xe.CHARACTER: {
        this.onCharacter(e);
        break;
      }
      case xe.NULL_CHARACTER: {
        this.onNullCharacter(e);
        break;
      }
      case xe.COMMENT: {
        this.onComment(e);
        break;
      }
      case xe.DOCTYPE: {
        this.onDoctype(e);
        break;
      }
      case xe.START_TAG: {
        this._processStartTag(e);
        break;
      }
      case xe.END_TAG: {
        this.onEndTag(e);
        break;
      }
      case xe.EOF: {
        this.onEof(e);
        break;
      }
      case xe.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(e);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(e, n, s) {
    const r = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return Wm(e, r, i, s);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const e = this.activeFormattingElements.entries.length;
    if (e) {
      const n = this.activeFormattingElements.entries.findIndex((r) => r.type === Bt.Marker || this.openElements.contains(r.element)), s = n === -1 ? e - 1 : n - 1;
      for (let r = s; r >= 0; r--) {
        const i = this.activeFormattingElements.entries[r];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = I.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(d.P), this.openElements.popUntilTagNamePopped(d.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let e = this.openElements.stackTop; e >= 0; e--)
      switch (e === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[e]) {
        case d.TR: {
          this.insertionMode = I.IN_ROW;
          return;
        }
        case d.TBODY:
        case d.THEAD:
        case d.TFOOT: {
          this.insertionMode = I.IN_TABLE_BODY;
          return;
        }
        case d.CAPTION: {
          this.insertionMode = I.IN_CAPTION;
          return;
        }
        case d.COLGROUP: {
          this.insertionMode = I.IN_COLUMN_GROUP;
          return;
        }
        case d.TABLE: {
          this.insertionMode = I.IN_TABLE;
          return;
        }
        case d.BODY: {
          this.insertionMode = I.IN_BODY;
          return;
        }
        case d.FRAMESET: {
          this.insertionMode = I.IN_FRAMESET;
          return;
        }
        case d.SELECT: {
          this._resetInsertionModeForSelect(e);
          return;
        }
        case d.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case d.HTML: {
          this.insertionMode = this.headElement ? I.AFTER_HEAD : I.BEFORE_HEAD;
          return;
        }
        case d.TD:
        case d.TH: {
          if (e > 0) {
            this.insertionMode = I.IN_CELL;
            return;
          }
          break;
        }
        case d.HEAD: {
          if (e > 0) {
            this.insertionMode = I.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = I.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(e) {
    if (e > 0)
      for (let n = e - 1; n > 0; n--) {
        const s = this.openElements.tagIDs[n];
        if (s === d.TEMPLATE)
          break;
        if (s === d.TABLE) {
          this.insertionMode = I.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = I.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(e) {
    return qd.has(e);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let e = this.openElements.stackTop; e >= 0; e--) {
      const n = this.openElements.items[e];
      switch (this.openElements.tagIDs[e]) {
        case d.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === z.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case d.TABLE: {
          const s = this.treeAdapter.getParentNode(n);
          return s ? { parent: s, beforeElement: n } : { parent: this.openElements.items[e - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(e) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, e, n.beforeElement) : this.treeAdapter.appendChild(n.parent, e);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(e, n) {
    const s = this.treeAdapter.getNamespaceURI(e);
    return fm[s].has(n);
  }
  /** @internal */
  onCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      Cg(this, e);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        bs(this, e);
        break;
      }
      case I.BEFORE_HTML: {
        Bs(this, e);
        break;
      }
      case I.BEFORE_HEAD: {
        ks(this, e);
        break;
      }
      case I.IN_HEAD: {
        Ls(this, e);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        Ms(this, e);
        break;
      }
      case I.AFTER_HEAD: {
        Rs(this, e);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE: {
        zd(this, e);
        break;
      }
      case I.TEXT:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        this._insertCharacters(e);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Xi(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Kd(this, e);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Kr(this, e);
        break;
      }
      case I.AFTER_BODY: {
        Zr(this, e);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Mr(this, e);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(e) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      yg(this, e);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        bs(this, e);
        break;
      }
      case I.BEFORE_HTML: {
        Bs(this, e);
        break;
      }
      case I.BEFORE_HEAD: {
        ks(this, e);
        break;
      }
      case I.IN_HEAD: {
        Ls(this, e);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        Ms(this, e);
        break;
      }
      case I.AFTER_HEAD: {
        Rs(this, e);
        break;
      }
      case I.TEXT: {
        this._insertCharacters(e);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Xi(this, e);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Kr(this, e);
        break;
      }
      case I.AFTER_BODY: {
        Zr(this, e);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Mr(this, e);
        break;
      }
    }
  }
  /** @internal */
  onComment(e) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      aa(this, e);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL:
      case I.BEFORE_HTML:
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_TEMPLATE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        aa(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        xs(this, e);
        break;
      }
      case I.AFTER_BODY: {
        tp(this, e);
        break;
      }
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        np(this, e);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(e) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case I.INITIAL: {
        sp(this, e);
        break;
      }
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD: {
        this._err(e, U.misplacedDoctype);
        break;
      }
      case I.IN_TABLE_TEXT: {
        xs(this, e);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this._processStartTag(e), e.selfClosing && !e.ackSelfClosing && this._err(e, U.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(e) {
    this.shouldProcessStartTagTokenInForeignContent(e) ? Dg(this, e) : this._startTagOutsideForeignContent(e);
  }
  /** @protected */
  _startTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        bs(this, e);
        break;
      }
      case I.BEFORE_HTML: {
        rp(this, e);
        break;
      }
      case I.BEFORE_HEAD: {
        up(this, e);
        break;
      }
      case I.IN_HEAD: {
        Dt(this, e);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        cp(this, e);
        break;
      }
      case I.AFTER_HEAD: {
        dp(this, e);
        break;
      }
      case I.IN_BODY: {
        et(this, e);
        break;
      }
      case I.IN_TABLE: {
        Jn(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        xs(this, e);
        break;
      }
      case I.IN_CAPTION: {
        ag(this, e);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Za(this, e);
        break;
      }
      case I.IN_TABLE_BODY: {
        _i(this, e);
        break;
      }
      case I.IN_ROW: {
        Ti(this, e);
        break;
      }
      case I.IN_CELL: {
        lg(this, e);
        break;
      }
      case I.IN_SELECT: {
        ef(this, e);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        fg(this, e);
        break;
      }
      case I.IN_TEMPLATE: {
        bg(this, e);
        break;
      }
      case I.AFTER_BODY: {
        mg(this, e);
        break;
      }
      case I.IN_FRAMESET: {
        pg(this, e);
        break;
      }
      case I.AFTER_FRAMESET: {
        Eg(this, e);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Tg(this, e);
        break;
      }
      case I.AFTER_AFTER_FRAMESET: {
        Ag(this, e);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(e) {
    this.skipNextNewLine = !1, this.currentToken = e, this.currentNotInHTML ? vg(this, e) : this._endTagOutsideForeignContent(e);
  }
  /** @protected */
  _endTagOutsideForeignContent(e) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        bs(this, e);
        break;
      }
      case I.BEFORE_HTML: {
        ip(this, e);
        break;
      }
      case I.BEFORE_HEAD: {
        ap(this, e);
        break;
      }
      case I.IN_HEAD: {
        op(this, e);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        lp(this, e);
        break;
      }
      case I.AFTER_HEAD: {
        fp(this, e);
        break;
      }
      case I.IN_BODY: {
        Ei(this, e);
        break;
      }
      case I.TEXT: {
        Kp(this, e);
        break;
      }
      case I.IN_TABLE: {
        Gs(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        xs(this, e);
        break;
      }
      case I.IN_CAPTION: {
        og(this, e);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        cg(this, e);
        break;
      }
      case I.IN_TABLE_BODY: {
        oa(this, e);
        break;
      }
      case I.IN_ROW: {
        Jd(this, e);
        break;
      }
      case I.IN_CELL: {
        dg(this, e);
        break;
      }
      case I.IN_SELECT: {
        tf(this, e);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        hg(this, e);
        break;
      }
      case I.IN_TEMPLATE: {
        xg(this, e);
        break;
      }
      case I.AFTER_BODY: {
        sf(this, e);
        break;
      }
      case I.IN_FRAMESET: {
        gg(this, e);
        break;
      }
      case I.AFTER_FRAMESET: {
        _g(this, e);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Mr(this, e);
        break;
      }
    }
  }
  /** @internal */
  onEof(e) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        bs(this, e);
        break;
      }
      case I.BEFORE_HTML: {
        Bs(this, e);
        break;
      }
      case I.BEFORE_HEAD: {
        ks(this, e);
        break;
      }
      case I.IN_HEAD: {
        Ls(this, e);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        Ms(this, e);
        break;
      }
      case I.AFTER_HEAD: {
        Rs(this, e);
        break;
      }
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        Xd(this, e);
        break;
      }
      case I.TEXT: {
        Zp(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        xs(this, e);
        break;
      }
      case I.IN_TEMPLATE: {
        nf(this, e);
        break;
      }
      case I.AFTER_BODY:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        Ka(this, e);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(e) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, e.chars.charCodeAt(0) === A.LINE_FEED)) {
      if (e.chars.length === 1)
        return;
      e.chars = e.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(e);
      return;
    }
    switch (this.insertionMode) {
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.TEXT:
      case I.IN_COLUMN_GROUP:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        this._insertCharacters(e);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE:
      case I.AFTER_BODY:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        Wd(this, e);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Xi(this, e);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Qd(this, e);
        break;
      }
    }
  }
};
function Xm(t, e) {
  let n = t.activeFormattingElements.getElementEntryInScopeWithTagName(e.tagName);
  return n ? t.openElements.contains(n.element) ? t.openElements.hasInScope(e.tagID) || (n = null) : (t.activeFormattingElements.removeEntry(n), n = null) : Gd(t, e), n;
}
function Qm(t, e) {
  let n = null, s = t.openElements.stackTop;
  for (; s >= 0; s--) {
    const r = t.openElements.items[s];
    if (r === e.element)
      break;
    t._isSpecialElement(r, t.openElements.tagIDs[s]) && (n = r);
  }
  return n || (t.openElements.shortenToLength(Math.max(s, 0)), t.activeFormattingElements.removeEntry(e)), n;
}
function Km(t, e, n) {
  let s = e, r = t.openElements.getCommonAncestor(e);
  for (let i = 0, u = r; u !== n; i++, u = r) {
    r = t.openElements.getCommonAncestor(u);
    const a = t.activeFormattingElements.getElementEntry(u), o = a && i >= jm;
    !a || o ? (o && t.activeFormattingElements.removeEntry(a), t.openElements.remove(u)) : (u = Zm(t, a), s === e && (t.activeFormattingElements.bookmark = a), t.treeAdapter.detachNode(s), t.treeAdapter.appendChild(u, s), s = u);
  }
  return s;
}
function Zm(t, e) {
  const n = t.treeAdapter.getNamespaceURI(e.element), s = t.treeAdapter.createElement(e.token.tagName, n, e.token.attrs);
  return t.openElements.replace(e.element, s), e.element = s, s;
}
function Jm(t, e, n) {
  const s = t.treeAdapter.getTagName(e), r = pi(s);
  if (t._isElementCausesFosterParenting(r))
    t._fosterParentElement(n);
  else {
    const i = t.treeAdapter.getNamespaceURI(e);
    r === d.TEMPLATE && i === z.HTML && (e = t.treeAdapter.getTemplateContent(e)), t.treeAdapter.appendChild(e, n);
  }
}
function ep(t, e, n) {
  const s = t.treeAdapter.getNamespaceURI(n.element), { token: r } = n, i = t.treeAdapter.createElement(r.tagName, s, r.attrs);
  t._adoptNodes(e, i), t.treeAdapter.appendChild(e, i), t.activeFormattingElements.insertElementAfterBookmark(i, r), t.activeFormattingElements.removeEntry(n), t.openElements.remove(n.element), t.openElements.insertAfter(e, i, r.tagID);
}
function Qa(t, e) {
  for (let n = 0; n < Vm; n++) {
    const s = Xm(t, e);
    if (!s)
      break;
    const r = Qm(t, s);
    if (!r)
      break;
    t.activeFormattingElements.bookmark = s;
    const i = Km(t, r, s.element), u = t.openElements.getCommonAncestor(s.element);
    t.treeAdapter.detachNode(i), u && Jm(t, u, i), ep(t, r, s);
  }
}
function aa(t, e) {
  t._appendCommentNode(e, t.openElements.currentTmplContentOrNode);
}
function tp(t, e) {
  t._appendCommentNode(e, t.openElements.items[0]);
}
function np(t, e) {
  t._appendCommentNode(e, t.document);
}
function Ka(t, e) {
  if (t.stopped = !0, e.location) {
    const n = t.fragmentContext ? 0 : 2;
    for (let s = t.openElements.stackTop; s >= n; s--)
      t._setEndLocation(t.openElements.items[s], e);
    if (!t.fragmentContext && t.openElements.stackTop >= 0) {
      const s = t.openElements.items[0], r = t.treeAdapter.getNodeSourceCodeLocation(s);
      if (r && !r.endTag && (t._setEndLocation(s, e), t.openElements.stackTop >= 1)) {
        const i = t.openElements.items[1], u = t.treeAdapter.getNodeSourceCodeLocation(i);
        u && !u.endTag && t._setEndLocation(i, e);
      }
    }
  }
}
function sp(t, e) {
  t._setDocumentType(e);
  const n = e.forceQuirks ? dt.QUIRKS : km(e);
  Bm(e) || t._err(e, U.nonConformingDoctype), t.treeAdapter.setDocumentMode(t.document, n), t.insertionMode = I.BEFORE_HTML;
}
function bs(t, e) {
  t._err(e, U.missingDoctype, !0), t.treeAdapter.setDocumentMode(t.document, dt.QUIRKS), t.insertionMode = I.BEFORE_HTML, t._processToken(e);
}
function rp(t, e) {
  e.tagID === d.HTML ? (t._insertElement(e, z.HTML), t.insertionMode = I.BEFORE_HEAD) : Bs(t, e);
}
function ip(t, e) {
  const n = e.tagID;
  (n === d.HTML || n === d.HEAD || n === d.BODY || n === d.BR) && Bs(t, e);
}
function Bs(t, e) {
  t._insertFakeRootElement(), t.insertionMode = I.BEFORE_HEAD, t._processToken(e);
}
function up(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.HEAD: {
      t._insertElement(e, z.HTML), t.headElement = t.openElements.current, t.insertionMode = I.IN_HEAD;
      break;
    }
    default:
      ks(t, e);
  }
}
function ap(t, e) {
  const n = e.tagID;
  n === d.HEAD || n === d.BODY || n === d.HTML || n === d.BR ? ks(t, e) : t._err(e, U.endTagWithoutMatchingOpenElement);
}
function ks(t, e) {
  t._insertFakeElement(k.HEAD, d.HEAD), t.headElement = t.openElements.current, t.insertionMode = I.IN_HEAD, t._processToken(e);
}
function Dt(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META: {
      t._appendElement(e, z.HTML), e.ackSelfClosing = !0;
      break;
    }
    case d.TITLE: {
      t._switchToTextParsing(e, ut.RCDATA);
      break;
    }
    case d.NOSCRIPT: {
      t.options.scriptingEnabled ? t._switchToTextParsing(e, ut.RAWTEXT) : (t._insertElement(e, z.HTML), t.insertionMode = I.IN_HEAD_NO_SCRIPT);
      break;
    }
    case d.NOFRAMES:
    case d.STYLE: {
      t._switchToTextParsing(e, ut.RAWTEXT);
      break;
    }
    case d.SCRIPT: {
      t._switchToTextParsing(e, ut.SCRIPT_DATA);
      break;
    }
    case d.TEMPLATE: {
      t._insertTemplate(e), t.activeFormattingElements.insertMarker(), t.framesetOk = !1, t.insertionMode = I.IN_TEMPLATE, t.tmplInsertionModeStack.unshift(I.IN_TEMPLATE);
      break;
    }
    case d.HEAD: {
      t._err(e, U.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Ls(t, e);
  }
}
function op(t, e) {
  switch (e.tagID) {
    case d.HEAD: {
      t.openElements.pop(), t.insertionMode = I.AFTER_HEAD;
      break;
    }
    case d.BODY:
    case d.BR:
    case d.HTML: {
      Ls(t, e);
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
    default:
      t._err(e, U.endTagWithoutMatchingOpenElement);
  }
}
function kn(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.generateImpliedEndTagsThoroughly(), t.openElements.currentTagId !== d.TEMPLATE && t._err(e, U.closingOfElementWithOpenChildElements), t.openElements.popUntilTagNamePopped(d.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode()) : t._err(e, U.endTagWithoutMatchingOpenElement);
}
function Ls(t, e) {
  t.openElements.pop(), t.insertionMode = I.AFTER_HEAD, t._processToken(e);
}
function cp(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.BASEFONT:
    case d.BGSOUND:
    case d.HEAD:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.STYLE: {
      Dt(t, e);
      break;
    }
    case d.NOSCRIPT: {
      t._err(e, U.nestedNoscriptInHead);
      break;
    }
    default:
      Ms(t, e);
  }
}
function lp(t, e) {
  switch (e.tagID) {
    case d.NOSCRIPT: {
      t.openElements.pop(), t.insertionMode = I.IN_HEAD;
      break;
    }
    case d.BR: {
      Ms(t, e);
      break;
    }
    default:
      t._err(e, U.endTagWithoutMatchingOpenElement);
  }
}
function Ms(t, e) {
  const n = e.type === xe.EOF ? U.openElementsLeftAfterEof : U.disallowedContentInNoscriptInHead;
  t._err(e, n), t.openElements.pop(), t.insertionMode = I.IN_HEAD, t._processToken(e);
}
function dp(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.BODY: {
      t._insertElement(e, z.HTML), t.framesetOk = !1, t.insertionMode = I.IN_BODY;
      break;
    }
    case d.FRAMESET: {
      t._insertElement(e, z.HTML), t.insertionMode = I.IN_FRAMESET;
      break;
    }
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.SCRIPT:
    case d.STYLE:
    case d.TEMPLATE:
    case d.TITLE: {
      t._err(e, U.abandonedHeadElementChild), t.openElements.push(t.headElement, d.HEAD), Dt(t, e), t.openElements.remove(t.headElement);
      break;
    }
    case d.HEAD: {
      t._err(e, U.misplacedStartTagForHeadElement);
      break;
    }
    default:
      Rs(t, e);
  }
}
function fp(t, e) {
  switch (e.tagID) {
    case d.BODY:
    case d.HTML:
    case d.BR: {
      Rs(t, e);
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
    default:
      t._err(e, U.endTagWithoutMatchingOpenElement);
  }
}
function Rs(t, e) {
  t._insertFakeElement(k.BODY, d.BODY), t.insertionMode = I.IN_BODY, gi(t, e);
}
function gi(t, e) {
  switch (e.type) {
    case xe.CHARACTER: {
      zd(t, e);
      break;
    }
    case xe.WHITESPACE_CHARACTER: {
      Wd(t, e);
      break;
    }
    case xe.COMMENT: {
      aa(t, e);
      break;
    }
    case xe.START_TAG: {
      et(t, e);
      break;
    }
    case xe.END_TAG: {
      Ei(t, e);
      break;
    }
    case xe.EOF: {
      Xd(t, e);
      break;
    }
  }
}
function Wd(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e);
}
function zd(t, e) {
  t._reconstructActiveFormattingElements(), t._insertCharacters(e), t.framesetOk = !1;
}
function hp(t, e) {
  t.openElements.tmplCount === 0 && t.treeAdapter.adoptAttributes(t.openElements.items[0], e.attrs);
}
function bp(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  n && t.openElements.tmplCount === 0 && (t.framesetOk = !1, t.treeAdapter.adoptAttributes(n, e.attrs));
}
function xp(t, e) {
  const n = t.openElements.tryPeekProperlyNestedBodyElement();
  t.framesetOk && n && (t.treeAdapter.detachNode(n), t.openElements.popAllUpToHtmlElement(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_FRAMESET);
}
function mp(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML);
}
function pp(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t.openElements.currentTagId !== void 0 && ua.has(t.openElements.currentTagId) && t.openElements.pop(), t._insertElement(e, z.HTML);
}
function gp(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML), t.skipNextNewLine = !0, t.framesetOk = !1;
}
function Ep(t, e) {
  const n = t.openElements.tmplCount > 0;
  (!t.formElement || n) && (t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML), n || (t.formElement = t.openElements.current));
}
function _p(t, e) {
  t.framesetOk = !1;
  const n = e.tagID;
  for (let s = t.openElements.stackTop; s >= 0; s--) {
    const r = t.openElements.tagIDs[s];
    if (n === d.LI && r === d.LI || (n === d.DD || n === d.DT) && (r === d.DD || r === d.DT)) {
      t.openElements.generateImpliedEndTagsWithExclusion(r), t.openElements.popUntilTagNamePopped(r);
      break;
    }
    if (r !== d.ADDRESS && r !== d.DIV && r !== d.P && t._isSpecialElement(t.openElements.items[s], r))
      break;
  }
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML);
}
function Tp(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML), t.tokenizer.state = ut.PLAINTEXT;
}
function Ap(t, e) {
  t.openElements.hasInScope(d.BUTTON) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(d.BUTTON)), t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML), t.framesetOk = !1;
}
function yp(t, e) {
  const n = t.activeFormattingElements.getElementEntryInScopeWithTagName(k.A);
  n && (Qa(t, e), t.openElements.remove(n.element), t.activeFormattingElements.removeEntry(n)), t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Cp(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function Dp(t, e) {
  t._reconstructActiveFormattingElements(), t.openElements.hasInScope(d.NOBR) && (Qa(t, e), t._reconstructActiveFormattingElements()), t._insertElement(e, z.HTML), t.activeFormattingElements.pushElement(t.openElements.current, e);
}
function vp(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML), t.activeFormattingElements.insertMarker(), t.framesetOk = !1;
}
function Sp(t, e) {
  t.treeAdapter.getDocumentMode(t.document) !== dt.QUIRKS && t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._insertElement(e, z.HTML), t.framesetOk = !1, t.insertionMode = I.IN_TABLE;
}
function Vd(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, z.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function jd(t) {
  const e = Ld(t, Cn.TYPE);
  return e != null && e.toLowerCase() === zm;
}
function wp(t, e) {
  t._reconstructActiveFormattingElements(), t._appendElement(e, z.HTML), jd(e) || (t.framesetOk = !1), e.ackSelfClosing = !0;
}
function Np(t, e) {
  t._appendElement(e, z.HTML), e.ackSelfClosing = !0;
}
function Ip(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._appendElement(e, z.HTML), t.framesetOk = !1, e.ackSelfClosing = !0;
}
function Op(t, e) {
  e.tagName = k.IMG, e.tagID = d.IMG, Vd(t, e);
}
function Bp(t, e) {
  t._insertElement(e, z.HTML), t.skipNextNewLine = !0, t.tokenizer.state = ut.RCDATA, t.originalInsertionMode = t.insertionMode, t.framesetOk = !1, t.insertionMode = I.TEXT;
}
function kp(t, e) {
  t.openElements.hasInButtonScope(d.P) && t._closePElement(), t._reconstructActiveFormattingElements(), t.framesetOk = !1, t._switchToTextParsing(e, ut.RAWTEXT);
}
function Lp(t, e) {
  t.framesetOk = !1, t._switchToTextParsing(e, ut.RAWTEXT);
}
function lo(t, e) {
  t._switchToTextParsing(e, ut.RAWTEXT);
}
function Mp(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML), t.framesetOk = !1, t.insertionMode = t.insertionMode === I.IN_TABLE || t.insertionMode === I.IN_CAPTION || t.insertionMode === I.IN_TABLE_BODY || t.insertionMode === I.IN_ROW || t.insertionMode === I.IN_CELL ? I.IN_SELECT_IN_TABLE : I.IN_SELECT;
}
function Rp(t, e) {
  t.openElements.currentTagId === d.OPTION && t.openElements.pop(), t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML);
}
function Pp(t, e) {
  t.openElements.hasInScope(d.RUBY) && t.openElements.generateImpliedEndTags(), t._insertElement(e, z.HTML);
}
function Fp(t, e) {
  t.openElements.hasInScope(d.RUBY) && t.openElements.generateImpliedEndTagsWithExclusion(d.RTC), t._insertElement(e, z.HTML);
}
function Hp(t, e) {
  t._reconstructActiveFormattingElements(), Ud(e), Xa(e), e.selfClosing ? t._appendElement(e, z.MATHML) : t._insertElement(e, z.MATHML), e.ackSelfClosing = !0;
}
function Up(t, e) {
  t._reconstructActiveFormattingElements(), Yd(e), Xa(e), e.selfClosing ? t._appendElement(e, z.SVG) : t._insertElement(e, z.SVG), e.ackSelfClosing = !0;
}
function fo(t, e) {
  t._reconstructActiveFormattingElements(), t._insertElement(e, z.HTML);
}
function et(t, e) {
  switch (e.tagID) {
    case d.I:
    case d.S:
    case d.B:
    case d.U:
    case d.EM:
    case d.TT:
    case d.BIG:
    case d.CODE:
    case d.FONT:
    case d.SMALL:
    case d.STRIKE:
    case d.STRONG: {
      Cp(t, e);
      break;
    }
    case d.A: {
      yp(t, e);
      break;
    }
    case d.H1:
    case d.H2:
    case d.H3:
    case d.H4:
    case d.H5:
    case d.H6: {
      pp(t, e);
      break;
    }
    case d.P:
    case d.DL:
    case d.OL:
    case d.UL:
    case d.DIV:
    case d.DIR:
    case d.NAV:
    case d.MAIN:
    case d.MENU:
    case d.ASIDE:
    case d.CENTER:
    case d.FIGURE:
    case d.FOOTER:
    case d.HEADER:
    case d.HGROUP:
    case d.DIALOG:
    case d.DETAILS:
    case d.ADDRESS:
    case d.ARTICLE:
    case d.SEARCH:
    case d.SECTION:
    case d.SUMMARY:
    case d.FIELDSET:
    case d.BLOCKQUOTE:
    case d.FIGCAPTION: {
      mp(t, e);
      break;
    }
    case d.LI:
    case d.DD:
    case d.DT: {
      _p(t, e);
      break;
    }
    case d.BR:
    case d.IMG:
    case d.WBR:
    case d.AREA:
    case d.EMBED:
    case d.KEYGEN: {
      Vd(t, e);
      break;
    }
    case d.HR: {
      Ip(t, e);
      break;
    }
    case d.RB:
    case d.RTC: {
      Pp(t, e);
      break;
    }
    case d.RT:
    case d.RP: {
      Fp(t, e);
      break;
    }
    case d.PRE:
    case d.LISTING: {
      gp(t, e);
      break;
    }
    case d.XMP: {
      kp(t, e);
      break;
    }
    case d.SVG: {
      Up(t, e);
      break;
    }
    case d.HTML: {
      hp(t, e);
      break;
    }
    case d.BASE:
    case d.LINK:
    case d.META:
    case d.STYLE:
    case d.TITLE:
    case d.SCRIPT:
    case d.BGSOUND:
    case d.BASEFONT:
    case d.TEMPLATE: {
      Dt(t, e);
      break;
    }
    case d.BODY: {
      bp(t, e);
      break;
    }
    case d.FORM: {
      Ep(t, e);
      break;
    }
    case d.NOBR: {
      Dp(t, e);
      break;
    }
    case d.MATH: {
      Hp(t, e);
      break;
    }
    case d.TABLE: {
      Sp(t, e);
      break;
    }
    case d.INPUT: {
      wp(t, e);
      break;
    }
    case d.PARAM:
    case d.TRACK:
    case d.SOURCE: {
      Np(t, e);
      break;
    }
    case d.IMAGE: {
      Op(t, e);
      break;
    }
    case d.BUTTON: {
      Ap(t, e);
      break;
    }
    case d.APPLET:
    case d.OBJECT:
    case d.MARQUEE: {
      vp(t, e);
      break;
    }
    case d.IFRAME: {
      Lp(t, e);
      break;
    }
    case d.SELECT: {
      Mp(t, e);
      break;
    }
    case d.OPTION:
    case d.OPTGROUP: {
      Rp(t, e);
      break;
    }
    case d.NOEMBED:
    case d.NOFRAMES: {
      lo(t, e);
      break;
    }
    case d.FRAMESET: {
      xp(t, e);
      break;
    }
    case d.TEXTAREA: {
      Bp(t, e);
      break;
    }
    case d.NOSCRIPT: {
      t.options.scriptingEnabled ? lo(t, e) : fo(t, e);
      break;
    }
    case d.PLAINTEXT: {
      Tp(t, e);
      break;
    }
    case d.COL:
    case d.TH:
    case d.TD:
    case d.TR:
    case d.HEAD:
    case d.FRAME:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.CAPTION:
    case d.COLGROUP:
      break;
    default:
      fo(t, e);
  }
}
function Yp(t, e) {
  if (t.openElements.hasInScope(d.BODY) && (t.insertionMode = I.AFTER_BODY, t.options.sourceCodeLocationInfo)) {
    const n = t.openElements.tryPeekProperlyNestedBodyElement();
    n && t._setEndLocation(n, e);
  }
}
function qp(t, e) {
  t.openElements.hasInScope(d.BODY) && (t.insertionMode = I.AFTER_BODY, sf(t, e));
}
function $p(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n));
}
function Wp(t) {
  const e = t.openElements.tmplCount > 0, { formElement: n } = t;
  e || (t.formElement = null), (n || e) && t.openElements.hasInScope(d.FORM) && (t.openElements.generateImpliedEndTags(), e ? t.openElements.popUntilTagNamePopped(d.FORM) : n && t.openElements.remove(n));
}
function zp(t) {
  t.openElements.hasInButtonScope(d.P) || t._insertFakeElement(k.P, d.P), t._closePElement();
}
function Vp(t) {
  t.openElements.hasInListItemScope(d.LI) && (t.openElements.generateImpliedEndTagsWithExclusion(d.LI), t.openElements.popUntilTagNamePopped(d.LI));
}
function jp(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTagsWithExclusion(n), t.openElements.popUntilTagNamePopped(n));
}
function Gp(t) {
  t.openElements.hasNumberedHeaderInScope() && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilNumberedHeaderPopped());
}
function Xp(t, e) {
  const n = e.tagID;
  t.openElements.hasInScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker());
}
function Qp(t) {
  t._reconstructActiveFormattingElements(), t._insertFakeElement(k.BR, d.BR), t.openElements.pop(), t.framesetOk = !1;
}
function Gd(t, e) {
  const n = e.tagName, s = e.tagID;
  for (let r = t.openElements.stackTop; r > 0; r--) {
    const i = t.openElements.items[r], u = t.openElements.tagIDs[r];
    if (s === u && (s !== d.UNKNOWN || t.treeAdapter.getTagName(i) === n)) {
      t.openElements.generateImpliedEndTagsWithExclusion(s), t.openElements.stackTop >= r && t.openElements.shortenToLength(r);
      break;
    }
    if (t._isSpecialElement(i, u))
      break;
  }
}
function Ei(t, e) {
  switch (e.tagID) {
    case d.A:
    case d.B:
    case d.I:
    case d.S:
    case d.U:
    case d.EM:
    case d.TT:
    case d.BIG:
    case d.CODE:
    case d.FONT:
    case d.NOBR:
    case d.SMALL:
    case d.STRIKE:
    case d.STRONG: {
      Qa(t, e);
      break;
    }
    case d.P: {
      zp(t);
      break;
    }
    case d.DL:
    case d.UL:
    case d.OL:
    case d.DIR:
    case d.DIV:
    case d.NAV:
    case d.PRE:
    case d.MAIN:
    case d.MENU:
    case d.ASIDE:
    case d.BUTTON:
    case d.CENTER:
    case d.FIGURE:
    case d.FOOTER:
    case d.HEADER:
    case d.HGROUP:
    case d.DIALOG:
    case d.ADDRESS:
    case d.ARTICLE:
    case d.DETAILS:
    case d.SEARCH:
    case d.SECTION:
    case d.SUMMARY:
    case d.LISTING:
    case d.FIELDSET:
    case d.BLOCKQUOTE:
    case d.FIGCAPTION: {
      $p(t, e);
      break;
    }
    case d.LI: {
      Vp(t);
      break;
    }
    case d.DD:
    case d.DT: {
      jp(t, e);
      break;
    }
    case d.H1:
    case d.H2:
    case d.H3:
    case d.H4:
    case d.H5:
    case d.H6: {
      Gp(t);
      break;
    }
    case d.BR: {
      Qp(t);
      break;
    }
    case d.BODY: {
      Yp(t, e);
      break;
    }
    case d.HTML: {
      qp(t, e);
      break;
    }
    case d.FORM: {
      Wp(t);
      break;
    }
    case d.APPLET:
    case d.OBJECT:
    case d.MARQUEE: {
      Xp(t, e);
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
    default:
      Gd(t, e);
  }
}
function Xd(t, e) {
  t.tmplInsertionModeStack.length > 0 ? nf(t, e) : Ka(t, e);
}
function Kp(t, e) {
  var n;
  e.tagID === d.SCRIPT && ((n = t.scriptHandler) === null || n === void 0 || n.call(t, t.openElements.current)), t.openElements.pop(), t.insertionMode = t.originalInsertionMode;
}
function Zp(t, e) {
  t._err(e, U.eofInElementThatCanContainOnlyText), t.openElements.pop(), t.insertionMode = t.originalInsertionMode, t.onEof(e);
}
function Xi(t, e) {
  if (t.openElements.currentTagId !== void 0 && qd.has(t.openElements.currentTagId))
    switch (t.pendingCharacterTokens.length = 0, t.hasNonWhitespacePendingCharacterToken = !1, t.originalInsertionMode = t.insertionMode, t.insertionMode = I.IN_TABLE_TEXT, e.type) {
      case xe.CHARACTER: {
        Kd(t, e);
        break;
      }
      case xe.WHITESPACE_CHARACTER: {
        Qd(t, e);
        break;
      }
    }
  else
    ur(t, e);
}
function Jp(t, e) {
  t.openElements.clearBackToTableContext(), t.activeFormattingElements.insertMarker(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_CAPTION;
}
function eg(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_COLUMN_GROUP;
}
function tg(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(k.COLGROUP, d.COLGROUP), t.insertionMode = I.IN_COLUMN_GROUP, Za(t, e);
}
function ng(t, e) {
  t.openElements.clearBackToTableContext(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_TABLE_BODY;
}
function sg(t, e) {
  t.openElements.clearBackToTableContext(), t._insertFakeElement(k.TBODY, d.TBODY), t.insertionMode = I.IN_TABLE_BODY, _i(t, e);
}
function rg(t, e) {
  t.openElements.hasInTableScope(d.TABLE) && (t.openElements.popUntilTagNamePopped(d.TABLE), t._resetInsertionMode(), t._processStartTag(e));
}
function ig(t, e) {
  jd(e) ? t._appendElement(e, z.HTML) : ur(t, e), e.ackSelfClosing = !0;
}
function ug(t, e) {
  !t.formElement && t.openElements.tmplCount === 0 && (t._insertElement(e, z.HTML), t.formElement = t.openElements.current, t.openElements.pop());
}
function Jn(t, e) {
  switch (e.tagID) {
    case d.TD:
    case d.TH:
    case d.TR: {
      sg(t, e);
      break;
    }
    case d.STYLE:
    case d.SCRIPT:
    case d.TEMPLATE: {
      Dt(t, e);
      break;
    }
    case d.COL: {
      tg(t, e);
      break;
    }
    case d.FORM: {
      ug(t, e);
      break;
    }
    case d.TABLE: {
      rg(t, e);
      break;
    }
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      ng(t, e);
      break;
    }
    case d.INPUT: {
      ig(t, e);
      break;
    }
    case d.CAPTION: {
      Jp(t, e);
      break;
    }
    case d.COLGROUP: {
      eg(t, e);
      break;
    }
    default:
      ur(t, e);
  }
}
function Gs(t, e) {
  switch (e.tagID) {
    case d.TABLE: {
      t.openElements.hasInTableScope(d.TABLE) && (t.openElements.popUntilTagNamePopped(d.TABLE), t._resetInsertionMode());
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TBODY:
    case d.TD:
    case d.TFOOT:
    case d.TH:
    case d.THEAD:
    case d.TR:
      break;
    default:
      ur(t, e);
  }
}
function ur(t, e) {
  const n = t.fosterParentingEnabled;
  t.fosterParentingEnabled = !0, gi(t, e), t.fosterParentingEnabled = n;
}
function Qd(t, e) {
  t.pendingCharacterTokens.push(e);
}
function Kd(t, e) {
  t.pendingCharacterTokens.push(e), t.hasNonWhitespacePendingCharacterToken = !0;
}
function xs(t, e) {
  let n = 0;
  if (t.hasNonWhitespacePendingCharacterToken)
    for (; n < t.pendingCharacterTokens.length; n++)
      ur(t, t.pendingCharacterTokens[n]);
  else
    for (; n < t.pendingCharacterTokens.length; n++)
      t._insertCharacters(t.pendingCharacterTokens[n]);
  t.insertionMode = t.originalInsertionMode, t._processToken(e);
}
const Zd = /* @__PURE__ */ new Set([d.CAPTION, d.COL, d.COLGROUP, d.TBODY, d.TD, d.TFOOT, d.TH, d.THEAD, d.TR]);
function ag(t, e) {
  const n = e.tagID;
  Zd.has(n) ? t.openElements.hasInTableScope(d.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(d.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = I.IN_TABLE, Jn(t, e)) : et(t, e);
}
function og(t, e) {
  const n = e.tagID;
  switch (n) {
    case d.CAPTION:
    case d.TABLE: {
      t.openElements.hasInTableScope(d.CAPTION) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(d.CAPTION), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = I.IN_TABLE, n === d.TABLE && Gs(t, e));
      break;
    }
    case d.BODY:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TBODY:
    case d.TD:
    case d.TFOOT:
    case d.TH:
    case d.THEAD:
    case d.TR:
      break;
    default:
      Ei(t, e);
  }
}
function Za(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.COL: {
      t._appendElement(e, z.HTML), e.ackSelfClosing = !0;
      break;
    }
    case d.TEMPLATE: {
      Dt(t, e);
      break;
    }
    default:
      Kr(t, e);
  }
}
function cg(t, e) {
  switch (e.tagID) {
    case d.COLGROUP: {
      t.openElements.currentTagId === d.COLGROUP && (t.openElements.pop(), t.insertionMode = I.IN_TABLE);
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
    case d.COL:
      break;
    default:
      Kr(t, e);
  }
}
function Kr(t, e) {
  t.openElements.currentTagId === d.COLGROUP && (t.openElements.pop(), t.insertionMode = I.IN_TABLE, t._processToken(e));
}
function _i(t, e) {
  switch (e.tagID) {
    case d.TR: {
      t.openElements.clearBackToTableBodyContext(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_ROW;
      break;
    }
    case d.TH:
    case d.TD: {
      t.openElements.clearBackToTableBodyContext(), t._insertFakeElement(k.TR, d.TR), t.insertionMode = I.IN_ROW, Ti(t, e);
      break;
    }
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE, Jn(t, e));
      break;
    }
    default:
      Jn(t, e);
  }
}
function oa(t, e) {
  const n = e.tagID;
  switch (e.tagID) {
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      t.openElements.hasInTableScope(n) && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE);
      break;
    }
    case d.TABLE: {
      t.openElements.hasTableBodyContextInTableScope() && (t.openElements.clearBackToTableBodyContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE, Gs(t, e));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TD:
    case d.TH:
    case d.TR:
      break;
    default:
      Gs(t, e);
  }
}
function Ti(t, e) {
  switch (e.tagID) {
    case d.TH:
    case d.TD: {
      t.openElements.clearBackToTableRowContext(), t._insertElement(e, z.HTML), t.insertionMode = I.IN_CELL, t.activeFormattingElements.insertMarker();
      break;
    }
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.TR: {
      t.openElements.hasInTableScope(d.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE_BODY, _i(t, e));
      break;
    }
    default:
      Jn(t, e);
  }
}
function Jd(t, e) {
  switch (e.tagID) {
    case d.TR: {
      t.openElements.hasInTableScope(d.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE_BODY);
      break;
    }
    case d.TABLE: {
      t.openElements.hasInTableScope(d.TR) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE_BODY, oa(t, e));
      break;
    }
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      (t.openElements.hasInTableScope(e.tagID) || t.openElements.hasInTableScope(d.TR)) && (t.openElements.clearBackToTableRowContext(), t.openElements.pop(), t.insertionMode = I.IN_TABLE_BODY, oa(t, e));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
    case d.TD:
    case d.TH:
      break;
    default:
      Gs(t, e);
  }
}
function lg(t, e) {
  const n = e.tagID;
  Zd.has(n) ? (t.openElements.hasInTableScope(d.TD) || t.openElements.hasInTableScope(d.TH)) && (t._closeTableCell(), Ti(t, e)) : et(t, e);
}
function dg(t, e) {
  const n = e.tagID;
  switch (n) {
    case d.TD:
    case d.TH: {
      t.openElements.hasInTableScope(n) && (t.openElements.generateImpliedEndTags(), t.openElements.popUntilTagNamePopped(n), t.activeFormattingElements.clearToLastMarker(), t.insertionMode = I.IN_ROW);
      break;
    }
    case d.TABLE:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD:
    case d.TR: {
      t.openElements.hasInTableScope(n) && (t._closeTableCell(), Jd(t, e));
      break;
    }
    case d.BODY:
    case d.CAPTION:
    case d.COL:
    case d.COLGROUP:
    case d.HTML:
      break;
    default:
      Ei(t, e);
  }
}
function ef(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.OPTION: {
      t.openElements.currentTagId === d.OPTION && t.openElements.pop(), t._insertElement(e, z.HTML);
      break;
    }
    case d.OPTGROUP: {
      t.openElements.currentTagId === d.OPTION && t.openElements.pop(), t.openElements.currentTagId === d.OPTGROUP && t.openElements.pop(), t._insertElement(e, z.HTML);
      break;
    }
    case d.HR: {
      t.openElements.currentTagId === d.OPTION && t.openElements.pop(), t.openElements.currentTagId === d.OPTGROUP && t.openElements.pop(), t._appendElement(e, z.HTML), e.ackSelfClosing = !0;
      break;
    }
    case d.INPUT:
    case d.KEYGEN:
    case d.TEXTAREA:
    case d.SELECT: {
      t.openElements.hasInSelectScope(d.SELECT) && (t.openElements.popUntilTagNamePopped(d.SELECT), t._resetInsertionMode(), e.tagID !== d.SELECT && t._processStartTag(e));
      break;
    }
    case d.SCRIPT:
    case d.TEMPLATE: {
      Dt(t, e);
      break;
    }
  }
}
function tf(t, e) {
  switch (e.tagID) {
    case d.OPTGROUP: {
      t.openElements.stackTop > 0 && t.openElements.currentTagId === d.OPTION && t.openElements.tagIDs[t.openElements.stackTop - 1] === d.OPTGROUP && t.openElements.pop(), t.openElements.currentTagId === d.OPTGROUP && t.openElements.pop();
      break;
    }
    case d.OPTION: {
      t.openElements.currentTagId === d.OPTION && t.openElements.pop();
      break;
    }
    case d.SELECT: {
      t.openElements.hasInSelectScope(d.SELECT) && (t.openElements.popUntilTagNamePopped(d.SELECT), t._resetInsertionMode());
      break;
    }
    case d.TEMPLATE: {
      kn(t, e);
      break;
    }
  }
}
function fg(t, e) {
  const n = e.tagID;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? (t.openElements.popUntilTagNamePopped(d.SELECT), t._resetInsertionMode(), t._processStartTag(e)) : ef(t, e);
}
function hg(t, e) {
  const n = e.tagID;
  n === d.CAPTION || n === d.TABLE || n === d.TBODY || n === d.TFOOT || n === d.THEAD || n === d.TR || n === d.TD || n === d.TH ? t.openElements.hasInTableScope(n) && (t.openElements.popUntilTagNamePopped(d.SELECT), t._resetInsertionMode(), t.onEndTag(e)) : tf(t, e);
}
function bg(t, e) {
  switch (e.tagID) {
    case d.BASE:
    case d.BASEFONT:
    case d.BGSOUND:
    case d.LINK:
    case d.META:
    case d.NOFRAMES:
    case d.SCRIPT:
    case d.STYLE:
    case d.TEMPLATE:
    case d.TITLE: {
      Dt(t, e);
      break;
    }
    case d.CAPTION:
    case d.COLGROUP:
    case d.TBODY:
    case d.TFOOT:
    case d.THEAD: {
      t.tmplInsertionModeStack[0] = I.IN_TABLE, t.insertionMode = I.IN_TABLE, Jn(t, e);
      break;
    }
    case d.COL: {
      t.tmplInsertionModeStack[0] = I.IN_COLUMN_GROUP, t.insertionMode = I.IN_COLUMN_GROUP, Za(t, e);
      break;
    }
    case d.TR: {
      t.tmplInsertionModeStack[0] = I.IN_TABLE_BODY, t.insertionMode = I.IN_TABLE_BODY, _i(t, e);
      break;
    }
    case d.TD:
    case d.TH: {
      t.tmplInsertionModeStack[0] = I.IN_ROW, t.insertionMode = I.IN_ROW, Ti(t, e);
      break;
    }
    default:
      t.tmplInsertionModeStack[0] = I.IN_BODY, t.insertionMode = I.IN_BODY, et(t, e);
  }
}
function xg(t, e) {
  e.tagID === d.TEMPLATE && kn(t, e);
}
function nf(t, e) {
  t.openElements.tmplCount > 0 ? (t.openElements.popUntilTagNamePopped(d.TEMPLATE), t.activeFormattingElements.clearToLastMarker(), t.tmplInsertionModeStack.shift(), t._resetInsertionMode(), t.onEof(e)) : Ka(t, e);
}
function mg(t, e) {
  e.tagID === d.HTML ? et(t, e) : Zr(t, e);
}
function sf(t, e) {
  var n;
  if (e.tagID === d.HTML) {
    if (t.fragmentContext || (t.insertionMode = I.AFTER_AFTER_BODY), t.options.sourceCodeLocationInfo && t.openElements.tagIDs[0] === d.HTML) {
      t._setEndLocation(t.openElements.items[0], e);
      const s = t.openElements.items[1];
      s && !(!((n = t.treeAdapter.getNodeSourceCodeLocation(s)) === null || n === void 0) && n.endTag) && t._setEndLocation(s, e);
    }
  } else
    Zr(t, e);
}
function Zr(t, e) {
  t.insertionMode = I.IN_BODY, gi(t, e);
}
function pg(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.FRAMESET: {
      t._insertElement(e, z.HTML);
      break;
    }
    case d.FRAME: {
      t._appendElement(e, z.HTML), e.ackSelfClosing = !0;
      break;
    }
    case d.NOFRAMES: {
      Dt(t, e);
      break;
    }
  }
}
function gg(t, e) {
  e.tagID === d.FRAMESET && !t.openElements.isRootHtmlElementCurrent() && (t.openElements.pop(), !t.fragmentContext && t.openElements.currentTagId !== d.FRAMESET && (t.insertionMode = I.AFTER_FRAMESET));
}
function Eg(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.NOFRAMES: {
      Dt(t, e);
      break;
    }
  }
}
function _g(t, e) {
  e.tagID === d.HTML && (t.insertionMode = I.AFTER_AFTER_FRAMESET);
}
function Tg(t, e) {
  e.tagID === d.HTML ? et(t, e) : Mr(t, e);
}
function Mr(t, e) {
  t.insertionMode = I.IN_BODY, gi(t, e);
}
function Ag(t, e) {
  switch (e.tagID) {
    case d.HTML: {
      et(t, e);
      break;
    }
    case d.NOFRAMES: {
      Dt(t, e);
      break;
    }
  }
}
function yg(t, e) {
  e.chars = Se, t._insertCharacters(e);
}
function Cg(t, e) {
  t._insertCharacters(e), t.framesetOk = !1;
}
function rf(t) {
  for (; t.treeAdapter.getNamespaceURI(t.openElements.current) !== z.HTML && t.openElements.currentTagId !== void 0 && !t._isIntegrationPoint(t.openElements.currentTagId, t.openElements.current); )
    t.openElements.pop();
}
function Dg(t, e) {
  if (Um(e))
    rf(t), t._startTagOutsideForeignContent(e);
  else {
    const n = t._getAdjustedCurrentElement(), s = t.treeAdapter.getNamespaceURI(n);
    s === z.MATHML ? Ud(e) : s === z.SVG && (Ym(e), Yd(e)), Xa(e), e.selfClosing ? t._appendElement(e, s) : t._insertElement(e, s), e.ackSelfClosing = !0;
  }
}
function vg(t, e) {
  if (e.tagID === d.P || e.tagID === d.BR) {
    rf(t), t._endTagOutsideForeignContent(e);
    return;
  }
  for (let n = t.openElements.stackTop; n > 0; n--) {
    const s = t.openElements.items[n];
    if (t.treeAdapter.getNamespaceURI(s) === z.HTML) {
      t._endTagOutsideForeignContent(e);
      break;
    }
    const r = t.treeAdapter.getTagName(s);
    if (r.toLowerCase() === e.tagName) {
      e.tagName = r, t.openElements.shortenToLength(n);
      break;
    }
  }
}
function uf(t, e) {
  return function(s) {
    let r, i = 0, u = "";
    for (; r = t.exec(s); )
      i !== r.index && (u += s.substring(i, r.index)), u += e.get(r[0].charCodeAt(0)), i = r.index + 1;
    return u + s.substring(i);
  };
}
const Sg = /* @__PURE__ */ uf(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), wg = /* @__PURE__ */ uf(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), Ng = /* @__PURE__ */ new Set([
  k.AREA,
  k.BASE,
  k.BASEFONT,
  k.BGSOUND,
  k.BR,
  k.COL,
  k.EMBED,
  k.FRAME,
  k.HR,
  k.IMG,
  k.INPUT,
  k.KEYGEN,
  k.LINK,
  k.META,
  k.PARAM,
  k.SOURCE,
  k.TRACK,
  k.WBR
]);
function Ig(t, e) {
  return e.treeAdapter.isElementNode(t) && e.treeAdapter.getNamespaceURI(t) === z.HTML && Ng.has(e.treeAdapter.getTagName(t));
}
const Og = { treeAdapter: Vt, scriptingEnabled: !0 };
function Bg(t, e) {
  const n = { ...Og, ...e };
  return af(t, n);
}
function kg(t, e) {
  let n = "";
  const s = e.treeAdapter.isElementNode(t) && e.treeAdapter.getTagName(t) === k.TEMPLATE && e.treeAdapter.getNamespaceURI(t) === z.HTML ? e.treeAdapter.getTemplateContent(t) : t, r = e.treeAdapter.getChildNodes(s);
  if (r)
    for (const i of r)
      n += af(i, e);
  return n;
}
function af(t, e) {
  return e.treeAdapter.isElementNode(t) ? Lg(t, e) : e.treeAdapter.isTextNode(t) ? Rg(t, e) : e.treeAdapter.isCommentNode(t) ? Pg(t, e) : e.treeAdapter.isDocumentTypeNode(t) ? Fg(t, e) : "";
}
function Lg(t, e) {
  const n = e.treeAdapter.getTagName(t);
  return `<${n}${Mg(t, e)}>${Ig(t, e) ? "" : `${kg(t, e)}</${n}>`}`;
}
function Mg(t, { treeAdapter: e }) {
  let n = "";
  for (const s of e.getAttrList(t)) {
    if (n += " ", s.namespace)
      switch (s.namespace) {
        case z.XML: {
          n += `xml:${s.name}`;
          break;
        }
        case z.XMLNS: {
          s.name !== "xmlns" && (n += "xmlns:"), n += s.name;
          break;
        }
        case z.XLINK: {
          n += `xlink:${s.name}`;
          break;
        }
        default:
          n += `${s.prefix}:${s.name}`;
      }
    else
      n += s.name;
    n += `="${Sg(s.value)}"`;
  }
  return n;
}
function Rg(t, e) {
  const { treeAdapter: n } = e, s = n.getTextNodeContent(t), r = n.getParentNode(t), i = r && n.isElementNode(r) && n.getTagName(r);
  return i && n.getNamespaceURI(r) === z.HTML && bm(i, e.scriptingEnabled) ? s : wg(s);
}
function Pg(t, { treeAdapter: e }) {
  return `<!--${e.getCommentNodeContent(t)}-->`;
}
function Fg(t, { treeAdapter: e }) {
  return `<!DOCTYPE ${e.getDocumentTypeNodeName(t)}>`;
}
function Hg(t, e) {
  return $d.parse(t, e);
}
function Ug(t, e, n) {
  typeof t == "string" && (n = e, e = t, t = null);
  const s = $d.getFragmentParser(t, n);
  return s.tokenizer.write(e, !0), s.getFragment();
}
function ho(t) {
  const e = t.includes('"') ? "'" : '"';
  return e + t + e;
}
function Yg(t, e, n) {
  let s = "!DOCTYPE ";
  return t && (s += t), e ? s += ` PUBLIC ${ho(e)}` : n && (s += " SYSTEM"), n && (s += ` ${ho(n)}`), s;
}
const tn = {
  // Re-exports from domhandler
  isCommentNode: fi,
  isElementNode: ee,
  isTextNode: Pt,
  //Node construction
  createDocument() {
    const t = new wn([]);
    return t["x-mode"] = dt.NO_QUIRKS, t;
  },
  createDocumentFragment() {
    return new wn([]);
  },
  createElement(t, e, n) {
    const s = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
    for (let a = 0; a < n.length; a++) {
      const o = n[a].name;
      s[o] = n[a].value, r[o] = n[a].namespace, i[o] = n[a].prefix;
    }
    const u = new Ma(t, s, []);
    return u.namespace = e, u["x-attribsNamespace"] = r, u["x-attribsPrefix"] = i, u;
  },
  createCommentNode(t) {
    return new Ba(t);
  },
  createTextNode(t) {
    return new $s(t);
  },
  //Tree mutation
  appendChild(t, e) {
    const n = t.children[t.children.length - 1];
    n && (n.next = e, e.prev = n), t.children.push(e), e.parent = t;
  },
  insertBefore(t, e, n) {
    const s = t.children.indexOf(n), { prev: r } = n;
    r && (r.next = e, e.prev = r), n.prev = e, e.next = n, t.children.splice(s, 0, e), e.parent = t;
  },
  setTemplateContent(t, e) {
    tn.appendChild(t, e);
  },
  getTemplateContent(t) {
    return t.children[0];
  },
  setDocumentType(t, e, n, s) {
    const r = Yg(e, n, s);
    let i = t.children.find((u) => Qu(u) && u.name === "!doctype");
    i ? i.data = r ?? null : (i = new ka("!doctype", r), tn.appendChild(t, i)), i["x-name"] = e, i["x-publicId"] = n, i["x-systemId"] = s;
  },
  setDocumentMode(t, e) {
    t["x-mode"] = e;
  },
  getDocumentMode(t) {
    return t["x-mode"];
  },
  detachNode(t) {
    if (t.parent) {
      const e = t.parent.children.indexOf(t), { prev: n, next: s } = t;
      t.prev = null, t.next = null, n && (n.next = s), s && (s.prev = n), t.parent.children.splice(e, 1), t.parent = null;
    }
  },
  insertText(t, e) {
    const n = t.children[t.children.length - 1];
    n && Pt(n) ? n.data += e : tn.appendChild(t, tn.createTextNode(e));
  },
  insertTextBefore(t, e, n) {
    const s = t.children[t.children.indexOf(n) - 1];
    s && Pt(s) ? s.data += e : tn.insertBefore(t, tn.createTextNode(e), n);
  },
  adoptAttributes(t, e) {
    for (let n = 0; n < e.length; n++) {
      const s = e[n].name;
      t.attribs[s] === void 0 && (t.attribs[s] = e[n].value, t["x-attribsNamespace"][s] = e[n].namespace, t["x-attribsPrefix"][s] = e[n].prefix);
    }
  },
  //Tree traversing
  getFirstChild(t) {
    return t.children[0];
  },
  getChildNodes(t) {
    return t.children;
  },
  getParentNode(t) {
    return t.parent;
  },
  getAttrList(t) {
    return t.attributes;
  },
  //Node data
  getTagName(t) {
    return t.name;
  },
  getNamespaceURI(t) {
    return t.namespace;
  },
  getTextNodeContent(t) {
    return t.data;
  },
  getCommentNodeContent(t) {
    return t.data;
  },
  getDocumentTypeNodeName(t) {
    var e;
    return (e = t["x-name"]) !== null && e !== void 0 ? e : "";
  },
  getDocumentTypeNodePublicId(t) {
    var e;
    return (e = t["x-publicId"]) !== null && e !== void 0 ? e : "";
  },
  getDocumentTypeNodeSystemId(t) {
    var e;
    return (e = t["x-systemId"]) !== null && e !== void 0 ? e : "";
  },
  //Node types
  isDocumentTypeNode(t) {
    return Qu(t) && t.name === "!doctype";
  },
  // Source code location
  setNodeSourceCodeLocation(t, e) {
    e && (t.startIndex = e.startOffset, t.endIndex = e.endOffset), t.sourceCodeLocation = e;
  },
  getNodeSourceCodeLocation(t) {
    return t.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(t, e) {
    e.endOffset != null && (t.endIndex = e.endOffset), t.sourceCodeLocation = {
      ...t.sourceCodeLocation,
      ...e
    };
  }
};
function qg(t, e, n, s) {
  var r;
  return (r = e.treeAdapter) !== null && r !== void 0 || (e.treeAdapter = tn), e.scriptingEnabled !== !1 && (e.scriptingEnabled = !0), n ? Hg(t, e) : Ug(s, t, e);
}
const $g = { treeAdapter: tn };
function Wg(t) {
  const e = "length" in t ? t : [t];
  for (let s = 0; s < e.length; s += 1) {
    const r = e[s];
    cn(r) && Array.prototype.splice.call(e, s, 1, ...r.children);
  }
  let n = "";
  for (let s = 0; s < e.length; s += 1) {
    const r = e[s];
    n += Bg(r, $g);
  }
  return n;
}
const zg = mx((t, e, n, s) => e._useHtmlParser2 ? z2(t, e) : qg(t, e, n, s)), Vg = Xx(zg, (t, e) => e._useHtmlParser2 ? hi(t, e) : Wg(t));
ue.extend(T1);
ue.extend($l);
ue.extend(zl);
function _C() {
  const t = {
    mondayToThursday: [
      ["08:00 AM", "08:30 AM"],
      ["10:15 AM", "10:45 AM"],
      ["12:45 PM", "01:15 PM"],
      ["03:15 PM", "03:45 PM"],
      ["05:45 PM", "06:15 PM"],
      ["08:45 PM", "09:15 PM"]
    ],
    friday: [
      ["08:00 AM", "08:30 AM"],
      ["10:15 AM", "10:45 AM"],
      ["12:45 PM", "01:15 PM"],
      ["03:15 PM", "03:45 PM"],
      ["07:45 PM", "08:15 PM"]
    ]
  }, e = ue().tz("America/New_York"), n = e.day();
  let s = [];
  if (n >= 1 && n <= 4)
    s = t.mondayToThursday;
  else if (n === 5)
    s = t.friday;
  else
    return !1;
  for (const [r, i] of s)
    if (e.isAfter(ue.tz(r, "hh:mm A", "America/New_York")) && e.isBefore(ue.tz(i, "hh:mm A", "America/New_York")))
      return !0;
  return !1;
}
function TC(t) {
  return ue.tz(t, "YYYY-MM-DD HH:mm:ss", "America/Los_Angeles").format("MMM. DD, YYYY [at] h:mm a");
}
const AC = (t) => ue(t).format("MMM. D, YYYY"), yC = (t) => t == "sm" && window.innerWidth < 768, CC = (t, e) => t.length <= e ? t : t.substring(0, e) + "...", DC = (t) => {
  if (!t) return 0;
  const s = t.split(/\s+/).length / 200;
  return Math.ceil(s);
}, vC = (t) => {
  const e = [...t];
  for (let n = e.length - 1; n > 0; n--) {
    const s = Math.floor(Math.random() * (n + 1));
    [e[n], e[s]] = [e[s], e[n]];
  }
  return e;
}, SC = (t) => "/" + decodeURI(t).toLowerCase() + "/", wC = (t, e) => e.filter((s) => s.id === t)[0];
function NC(t) {
  return t >= 1e9 ? (t / 1e9).toFixed(2) + "B" : t >= 1e6 ? (t / 1e6).toFixed(2) + "M" : t.toString();
}
const IC = (t) => {
  const e = [], n = Vg(t, {
    xmlMode: !1
    // Do not treat input as XML
  }), s = /\[?(?:NASDAQ|NYSE):\s*([A-Z]+)]?/i;
  return n("h3").each((r, i) => {
    const a = n(i).text().match(s);
    if (a && a[1]) {
      const o = a[1];
      e.includes(o) || e.push(o);
    }
  }), n("p").each((r, i) => {
    const a = n(i).text().match(s);
    if (a && a[1]) {
      const o = a[1];
      e.includes(o) || e.push(o);
    }
  }), e;
}, OC = /\[?(?:NASDAQ|NYSE):\s*([A-Z]+)]?/i;
function jg(t) {
  const e = document.cookie.split(";");
  for (const n of e) {
    const [s, r] = n.split("=");
    if (s.trim() === t)
      return decodeURIComponent(r);
  }
  return null;
}
const Gg = () => !!jg("cookieConsent"), Xg = {
  key: 0,
  class: "cookie-consent"
}, Qg = { class: "container xl:container w-full mx-auto cookie-consent-body gap-[16px] relative !px-0" }, BC = /* @__PURE__ */ ht({
  __name: "CookieConsent",
  setup(t) {
    const e = Fe(!0), n = Fe(null);
    function s(i, u, a) {
      const o = /* @__PURE__ */ new Date();
      o.setTime(o.getTime() + a * 24 * 60 * 60 * 1e3);
      const c = `expires=${o.toUTCString()}`;
      document.cookie = `${i}=${encodeURIComponent(u)}; ${c}; path=/`;
    }
    const r = async () => {
      Gg() || (e.value = !1, await setTimeout(() => {
        s("cookieConsent", !0, 182), e.value = !0;
      }, 12e3));
    };
    return Ct(async () => {
      await r();
    }), Qn(
      () => e.value,
      () => {
        e.value && n.value && (console.log("hide banner"), clearTimeout(n.value));
      }
    ), (i, u) => e.value ? it("", !0) : (ae(), de("section", Xg, [
      j("div", Qg, [
        u[2] || (u[2] = j("p", { class: "white-space-nowrap text-left" }, [
          ft(" We use cookies to provide you with the best online experience. If you continue browsing, we consider that you accept our "),
          j("span", { class: "inline-flex" }, [
            j("a", {
              to: "/cookie-policy",
              class: "underline",
              innerHTML: "Cookie Policy"
            }),
            ft(" , ")
          ]),
          ft(" and also agree to the terms of our "),
          j("span", null, [
            j("a", {
              to: "/privacy-policy",
              class: "underline",
              innerHTML: "Privacy Policy"
            }),
            ft(" and "),
            j("a", {
              to: "/terms-of-service",
              class: "underline",
              innerHTML: "Terms of Use."
            })
          ])
        ], -1)),
        j("button", {
          class: "absolute z-[50] button-close-consent",
          onClick: u[0] || (u[0] = (a) => e.value = !0)
        }, u[1] || (u[1] = [
          j("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "48",
            width: "48",
            fill: "#fff"
          }, [
            j("path", { d: "m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z" })
          ], -1)
        ]))
      ])
    ]));
  }
}), Kg = { class: "stock-symbol" }, Zg = ["href"], Jg = { key: 1 }, e3 = { class: "stock-company" }, t3 = { class: "stock-price-block" }, n3 = { class: "stock-price" }, s3 = { class: "stock-market-cap gap-[12px] !flex-row justify-between" }, r3 = { class: "inline-flex !text-[16px]" }, i3 = { class: "inline-flex !text-[16px]" }, u3 = { class: "stock-market-cap" }, a3 = { class: "flex mb-[4px] justify-between items-center text-[16px]" }, o3 = { class: "text-[16px]" }, c3 = { class: "text-[16px]" }, l3 = { class: "stock-market-balance mb-[4px] text-[16px]" }, d3 = {
  key: 0,
  class: "stock-market-cap !pt-[12px] pb-[0]"
}, Jr = /* @__PURE__ */ ht({
  __name: "referenced-stocks-overlay",
  props: {
    alignment: {},
    market: {},
    symbol: {},
    name: {},
    lastPrice: {},
    netChange: {},
    percentChange: {},
    day_low: {},
    day_high: {},
    volume: {},
    float: {},
    onClickButtonHandler: { type: Function },
    buttonText: {}
  },
  setup(t) {
    function e(i) {
      return i >= 1e9 ? (i / 1e9).toFixed(2) + "B" : i >= 1e6 ? (i / 1e6).toFixed(2) + "M" : i.toString();
    }
    const n = Sn(() => (t.lastPrice - t.day_low) / (t.day_high - t.day_low) * 100), s = Fe(!1), r = Sn(() => window.location.pathname);
    return Ct(() => {
      document.getElementById(t.symbol) && (s.value = !0);
    }), (i, u) => (ae(), de("div", {
      class: Ce({
        "stock-overlay": !0,
        "right-positioned": i.alignment === "right"
      })
    }, [
      u[6] || (u[6] = j("svg", {
        class: "overlay-arrow",
        width: "100",
        height: "66",
        viewBox: "0 0 100 66",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        j("path", {
          d: "M50 5L93.3013 62H6.69873L50 5Z",
          fill: "white"
        }),
        j("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M50 0.0406494L99.3477 65H0.652222L50 0.0406494ZM50 5L6.69872 62H93.3013L50 5Z",
          fill: "#C1C7D0"
        }),
        j("path", {
          d: "M0 59H100V66H0V59Z",
          fill: "white"
        })
      ], -1)),
      j("button", {
        class: "stock-icon-close",
        onClick: u[0] || (u[0] = (a) => i.$emit("close"))
      }, u[2] || (u[2] = [
        j("svg", {
          class: "w-[14px] h-[14px]",
          width: "20",
          height: "20",
          viewBox: "0 0 21 22",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          j("path", {
            d: "M1.4043 20.2886L19.7891 1.9038",
            stroke: "black",
            "stroke-width": "2",
            "stroke-linecap": "round"
          }),
          j("path", {
            d: "M1.21094 1.71143L19.5957 20.0962",
            stroke: "black",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ], -1)
      ])),
      j("span", Kg, [
        s.value ? (ae(), de("a", {
          key: 0,
          href: r.value + "#" + i.symbol
        }, [
          j("b", null, ce(i.symbol), 1)
        ], 8, Zg)) : (ae(), de("b", Jg, ce(i.symbol), 1)),
        ft(" - " + ce(i.market === "NSC" ? "NASDAQ" : "NYSE"), 1)
      ]),
      j("span", e3, ce(i.name), 1),
      j("div", t3, [
        j("span", n3, "$" + ce(i.lastPrice.toFixed(2)), 1),
        j("span", {
          class: Ce([
            "stock-price-change",
            i.netChange > 0 ? "positive" : i.netChange < 0 ? "negative" : ""
          ])
        }, ce(i.netChange > 0 ? "+" : "") + ce(i.netChange.toFixed(2)) + " (" + ce(i.percentChange > 0 ? "+" : "") + ce(i.percentChange.toFixed(2)) + "%) ", 3)
      ]),
      j("span", s3, [
        j("div", r3, [
          u[3] || (u[3] = j("b", null, "Volume: ", -1)),
          ft(" " + ce(e(i.volume)), 1)
        ]),
        j("div", i3, [
          u[4] || (u[4] = j("b", null, "Float: ", -1)),
          ft(" " + ce(e(i.float)), 1)
        ])
      ]),
      j("span", u3, [
        j("div", a3, [
          j("b", o3, "$" + ce(i.day_low.toFixed(2)), 1),
          u[5] || (u[5] = j("b", null, "Day Low/High", -1)),
          j("b", c3, "$" + ce(i.day_high.toFixed(2)), 1)
        ]),
        j("div", l3, [
          j("span", {
            class: "stock-market-balance-ball",
            style: Rl({ left: n.value + "%" })
          }, null, 4)
        ])
      ]),
      i.onClickButtonHandler ? (ae(), de("span", d3, [
        j("button", {
          onClick: u[1] || (u[1] = //@ts-ignore
          (...a) => i.onClickButtonHandler && i.onClickButtonHandler(...a)),
          class: "bg-blue-300 hover:bg-blue-500 text-white py-[8px] px-[12px] rounded-[8px] text-[18px] font-medium text-center font-semibold"
        }, ce(i.buttonText), 1)
      ])) : it("", !0)
    ], 2));
  }
});
function f3(t) {
  return l1() ? (d1(t), !0) : !1;
}
function ca(t) {
  return typeof t == "function" ? t() : Na(t);
}
const h3 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function b3(t, e) {
  var n;
  if (typeof t == "number")
    return t + e;
  const s = ((n = t.match(/^-?\d+\.?\d*/)) == null ? void 0 : n[0]) || "", r = t.slice(s.length), i = Number.parseFloat(s) + e;
  return Number.isNaN(i) ? t : i + r;
}
const of = h3 ? window : void 0;
function x3() {
  const t = Fe(!1), e = h1();
  return e && Ct(() => {
    t.value = !0;
  }, e), t;
}
function m3(t) {
  const e = x3();
  return Sn(() => (e.value, !!t()));
}
function ms(t, e = {}) {
  const { window: n = of } = e, s = m3(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let r;
  const i = Fe(!1), u = (c) => {
    i.value = c.matches;
  }, a = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", u) : r.removeListener(u));
  }, o = f1(() => {
    s.value && (a(), r = n.matchMedia(ca(t)), "addEventListener" in r ? r.addEventListener("change", u) : r.addListener(u), i.value = r.matches);
  });
  return f3(() => {
    o(), a(), r = void 0;
  }), i;
}
function cf(t, e = {}) {
  function n(l, f) {
    let h = ca(t[ca(l)]);
    return f != null && (h = b3(h, f)), typeof h == "number" && (h = `${h}px`), h;
  }
  const { window: s = of, strategy: r = "min-width" } = e;
  function i(l) {
    return s ? s.matchMedia(l).matches : !1;
  }
  const u = (l) => ms(() => `(min-width: ${n(l)})`, e), a = (l) => ms(() => `(max-width: ${n(l)})`, e), o = Object.keys(t).reduce((l, f) => (Object.defineProperty(l, f, {
    get: () => r === "min-width" ? u(f) : a(f),
    enumerable: !0,
    configurable: !0
  }), l), {});
  function c() {
    const l = Object.keys(t).map((f) => [f, u(f)]);
    return Sn(() => l.filter(([, f]) => f.value).map(([f]) => f));
  }
  return Object.assign(o, {
    greaterOrEqual: u,
    smallerOrEqual: a,
    greater(l) {
      return ms(() => `(min-width: ${n(l, 0.1)})`, e);
    },
    smaller(l) {
      return ms(() => `(max-width: ${n(l, -0.1)})`, e);
    },
    between(l, f) {
      return ms(() => `(min-width: ${n(l)}) and (max-width: ${n(f, -0.1)})`, e);
    },
    isGreater(l) {
      return i(`(min-width: ${n(l, 0.1)})`);
    },
    isGreaterOrEqual(l) {
      return i(`(min-width: ${n(l)})`);
    },
    isSmaller(l) {
      return i(`(max-width: ${n(l, -0.1)})`);
    },
    isSmallerOrEqual(l) {
      return i(`(max-width: ${n(l)})`);
    },
    isInBetween(l, f) {
      return i(`(min-width: ${n(l)}) and (max-width: ${n(f, -0.1)})`);
    },
    current: c,
    active() {
      const l = c();
      return Sn(() => l.value.length === 0 ? "" : l.value.at(-1));
    }
  });
}
const p3 = { class: "referenced-symbols" }, g3 = { class: "referenced-symbols-title flex justify-between" }, E3 = {
  key: 0,
  class: "text-sm text-slate-300 font-normal"
}, _3 = { class: "symbols-list" }, T3 = ["onClick"], A3 = { class: "symbol-link" }, y3 = {
  key: 0,
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#4caf50"
}, C3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#f44336"
}, D3 = { class: "flex flex-wrap gap-3" }, kC = /* @__PURE__ */ ht({
  __name: "referenced-stocks",
  props: {
    stocks: {},
    onClickButtonHandler: { type: Function },
    buttonText: {}
  },
  setup(t) {
    const e = Pl(
      cf({
        lg: 1024
      })
    ), n = Fe(null), s = (i) => {
      e.isSmallerOrEqual("lg") && (n.value = i);
    }, r = Sn(() => {
      const i = ue();
      if (t.stocks[Object.keys(t.stocks)[0]]) {
        const a = ue().set("hour", 4).set("minute", 0), o = ue().set("hour", 16).set("minute", 0), c = i.day() >= 1 && i.day() <= 5, l = i.isAfter(a) && i.isBefore(o);
        return c ? !!l : !1;
      }
      return !1;
    });
    return Ct(() => {
      console.log("referenced stocks", { stocks: t.stocks });
    }), (i, u) => (ae(), de("div", p3, [
      Object.keys(i.stocks).length > 0 ? (ae(), de(pt, { key: 0 }, [
        j("h2", g3, [
          u[1] || (u[1] = ft(" In this article ")),
          r.value ? it("", !0) : (ae(), de("span", E3, " Last trade " + ce(Na(ue)(i.stocks[Object.keys(i.stocks)[0]].LAST_TRADE_TIME).format("MMM, DD h:mm A")), 1))
        ]),
        j("ul", _3, [
          (ae(!0), de(pt, null, Yr(i.stocks, (a) => (ae(), de(pt, null, [
            a.NAME ? (ae(), de("li", {
              key: a.SYMBOL,
              class: "symbol-item",
              onClick: () => s(a)
            }, [
              j("span", A3, ce(a.SYMBOL), 1),
              j("span", {
                class: Ce({
                  "symbol-status": !0,
                  up: a.PC_CHG > 0,
                  down: a.PC_CHG < 0
                })
              }, [
                ft(ce(a.PC_CHG > 0 ? "+" : "") + ce(a.PC_CHG.toFixed(2)) + "% ", 1),
                a.PC_CHG !== null && a.PC_CHG !== 0 ? (ae(), de(pt, { key: 0 }, [
                  e.isGreater("lg") && a.PC_CHG > 0 ? (ae(), de("svg", y3, u[2] || (u[2] = [
                    j("path", {
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }, null, -1),
                    j("path", { d: "M7 14l5-5 5 5z" }, null, -1)
                  ]))) : e.isGreater("lg") ? (ae(), de("svg", C3, u[3] || (u[3] = [
                    j("path", {
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }, null, -1),
                    j("path", { d: "M7 10l5 5 5-5z" }, null, -1)
                  ]))) : it("", !0)
                ], 64)) : it("", !0)
              ], 2),
              e.isGreater("lg") ? (ae(), Kn(Jr, {
                key: 0,
                market: a.MARKET ?? "",
                symbol: a.SYMBOL ?? "",
                name: a.NAME ?? "",
                lastPrice: a.LAST ?? 0,
                netChange: a.NET_CHG ?? 0,
                percentChange: a.PC_CHG ?? 0,
                day_low: a.LOW ?? 0,
                day_high: a.HIGH ?? 0,
                volume: a.VOLUME ?? 0,
                float: a.FLOAT ?? 0,
                onClickButtonHandler: i.onClickButtonHandler
              }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler"])) : it("", !0)
            ], 8, T3)) : it("", !0)
          ], 64))), 256))
        ])
      ], 64)) : (ae(), de(pt, { key: 1 }, [
        u[5] || (u[5] = j("div", { class: "w-full h-5 bg-slate-100 rounded-md mb-4 animate-pulse" }, null, -1)),
        j("div", D3, [
          (ae(), de(pt, null, Yr(11, (a) => j("div", {
            key: a,
            class: "flex justify-between items-center gap-1"
          }, u[4] || (u[4] = [
            j("div", { class: "block w-14 h-4 bg-slate-100 rounded animate-pulse" }, null, -1),
            j("div", { class: "block w-6 h-4 bg-slate-100 rounded animate-pulse" }, null, -1)
          ]))), 64))
        ])
      ], 64)),
      e.isSmallerOrEqual("lg") && n.value ? (ae(), Kn(Jr, {
        key: 2,
        class: "active",
        market: n.value?.MARKET ?? "",
        symbol: n.value?.SYMBOL ?? "",
        name: n.value?.NAME ?? "",
        lastPrice: n.value?.LAST ?? 0,
        netChange: n.value?.NET_CHG ?? 0,
        percentChange: n.value?.PC_CHG ?? 0,
        day_low: n.value?.LOW ?? 0,
        day_high: n.value?.HIGH ?? 0,
        volume: n.value?.VOLUME ?? 0,
        float: n.value?.FLOAT ?? 0,
        onClose: u[0] || (u[0] = () => n.value = null),
        onClickButtonHandler: i.onClickButtonHandler,
        buttonText: i.buttonText
      }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler", "buttonText"])) : it("", !0)
    ]));
  }
}), v3 = { class: "referenced-symbols" }, S3 = { class: "symbols-list sidebar" }, w3 = ["onClick"], N3 = { class: "symbol-link" }, I3 = {
  key: 0,
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#4caf50"
}, O3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#f44336"
}, B3 = { class: "grid grid-cols-4 gap-4" }, LC = /* @__PURE__ */ ht({
  __name: "referenced-stocks-sidebar",
  props: {
    stocks: {},
    onClickButtonHandler: { type: Function },
    buttonText: {}
  },
  setup(t) {
    const e = Pl(
      cf({
        lg: 1024
      })
    ), n = Fe(null), s = (r) => {
      e.isSmallerOrEqual("lg") && (n.value = r);
    };
    return (r, i) => (ae(), de("div", v3, [
      Object.keys(r.stocks).length > 0 ? (ae(), de(pt, { key: 0 }, [
        i[3] || (i[3] = j("h2", { class: "referenced-symbols-title" }, "In this article (YTD Performance)", -1)),
        i[4] || (i[4] = j("hr", {
          class: "my-2",
          style: { margin: "8px 0 16px", "background-color": "#98a2b3", opacity: "0.1" }
        }, null, -1)),
        j("ul", S3, [
          (ae(!0), de(pt, null, Yr(r.stocks, (u) => (ae(), de(pt, null, [
            u.NAME ? (ae(), de("li", {
              key: u.SYMBOL,
              class: "symbol-item",
              onClick: () => s(u)
            }, [
              j("span", N3, ce(u.SYMBOL), 1),
              j("span", {
                class: Ce({
                  " symbol-status": !0,
                  up: u.YTD_PCT > 0,
                  down: u.YTD_PCT < 0
                })
              }, [
                ft(ce(u.YTD_PCT > 0 ? "+" : "") + ce(u.YTD_PCT ?? 0) + "% ", 1),
                u.YTD_PCT && u.YTD_PCT !== 0 ? (ae(), de(pt, { key: 0 }, [
                  e.isGreater("lg") && u.YTD_PCT > 0 ? (ae(), de("svg", I3, i[1] || (i[1] = [
                    j("path", {
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }, null, -1),
                    j("path", { d: "M7 14l5-5 5 5z" }, null, -1)
                  ]))) : e.isGreater("lg") ? (ae(), de("svg", O3, i[2] || (i[2] = [
                    j("path", {
                      d: "M0 0h24v24H0z",
                      fill: "none"
                    }, null, -1),
                    j("path", { d: "M7 10l5 5 5-5z" }, null, -1)
                  ]))) : it("", !0)
                ], 64)) : it("", !0)
              ], 2),
              e.isGreater("lg") ? (ae(), Kn(Jr, {
                key: 0,
                market: u.MARKET ?? "",
                symbol: u.SYMBOL ?? "",
                name: u.NAME ?? "",
                lastPrice: u.LAST ?? 0,
                netChange: u.NET_CHG ?? 0,
                percentChange: u.PC_CHG ?? 0,
                day_low: u.LOW ?? 0,
                day_high: u.HIGH ?? 0,
                volume: u.VOLUME ?? 0,
                float: u.FLOAT ?? 0,
                onClickButtonHandler: r.onClickButtonHandler,
                alignment: "right"
              }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler"])) : it("", !0)
            ], 8, w3)) : it("", !0)
          ], 64))), 256))
        ])
      ], 64)) : (ae(), de(pt, { key: 1 }, [
        i[6] || (i[6] = j("div", { class: "w-full h-5 bg-slate-100 rounded-md mb-4 animate-pulse" }, null, -1)),
        i[7] || (i[7] = j("hr", {
          class: "my-2",
          style: { margin: "8px 0 16px", "background-color": "#98a2b3" }
        }, null, -1)),
        j("div", B3, [
          (ae(), de(pt, null, Yr(11, (u) => j("div", {
            key: "ytd" + u,
            class: "flex justify-between items-center gap-1"
          }, i[5] || (i[5] = [
            j("div", { class: "block w-12 h-4 bg-slate-100 rounded animate-pulse" }, null, -1),
            j("div", { class: "block w-4 h-4 bg-slate-100 rounded animate-pulse" }, null, -1)
          ]))), 64))
        ])
      ], 64)),
      e.isSmallerOrEqual("lg") && n.value ? (ae(), Kn(Jr, {
        key: 2,
        class: "active",
        market: n.value?.MARKET ?? "",
        symbol: n.value?.SYMBOL ?? "",
        name: n.value?.NAME ?? "",
        lastPrice: n.value?.LAST ?? 0,
        netChange: n.value?.NET_CHG ?? 0,
        percentChange: n.value?.PC_CHG ?? 0,
        day_low: n.value?.LOW ?? 0,
        day_high: n.value?.HIGH ?? 0,
        volume: n.value?.VOLUME ?? 0,
        float: n.value?.FLOAT ?? 0,
        onClose: i[0] || (i[0] = () => n.value = null),
        onClickButtonHandler: r.onClickButtonHandler,
        buttonText: r.buttonText,
        alignment: "right"
      }, null, 8, ["market", "symbol", "name", "lastPrice", "netChange", "percentChange", "day_low", "day_high", "volume", "float", "onClickButtonHandler", "buttonText"])) : it("", !0)
    ]));
  }
}), MC = /* @__PURE__ */ ht({
  __name: "AdButlerGrid",
  props: {
    adId: { default: "" }
  },
  setup(t) {
    const e = Fe(), n = t;
    Ct(() => {
      if (window.AdButler)
        s();
      else {
        const r = document.createElement("script");
        r.async = !0, r.type = "text/javascript", r.src = "https://servedbyadbutler.com/app.js", e.value && (e.value.parentElement.prepend(r), s());
      }
    });
    const s = () => {
      const r = document.createElement("script"), i = `
	var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
	var abkw = window.abkw || '';
	var plc${n.adId} = window.plc${n.adId} || 0;
	(function(){
		var divs = document.querySelectorAll(".plc${n.adId}:not([id])");
		console.log({divs});
		var div = divs[divs.length-1];
		div.setAttribute("id", "placement_${n.adId}_"+plc${n.adId});
		AdButler.ads.push({handler: function(opt){ AdButler.register(181458, ${n.adId}, [0,0], 'placement_${n.adId}_'+opt.place, opt); }, opt: { place: plc${n.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' }});
	})();`;
      r.innerHTML = i, e.value && e.value.parentNode.appendChild(r);
    };
    return (r, i) => (ae(), de("div", null, [
      j("div", {
        class: Ce(`plc${r.adId}`),
        ref_key: "adPlacement",
        ref: e
      }, null, 2)
    ]));
  }
}), RC = /* @__PURE__ */ ht({
  __name: "AdButlerModal",
  props: {
    adId: {}
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = Fe(), s = t, r = e, i = () => {
      r("close", "closing");
    }, u = Fe(!0);
    Ct(() => {
      if (window.AdButler)
        a();
      else {
        const o = document.createElement("script");
        o.async = !0, o.type = "text/javascript", o.src = "https://servedbyadbutler.com/app.js", n.value && (n.value.parentElement.prepend(o), a());
      }
    });
    const a = () => {
      const o = document.createElement("script"), c = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${s.adId} = window.plc${s.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${s.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${s.adId}_" + plc${s.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${s.adId}, [0, 0], 'placement_${s.adId}_' + opt.place, opt); }, opt: { place: plc${s.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      o.innerHTML = c, n.value && n.value.parentNode.appendChild(o);
    };
    return Qn(n, async (o) => {
      o && await setTimeout(() => {
        const c = document.querySelector(".adblutler-modal-close"), l = document.querySelectorAll(".modal-ad a");
        if (!c) {
          console.log("AdButler Close not found", c), r("close", "closing");
          return;
        }
        u.value = !1;
        const f = document.querySelector(".information-subscribe-button");
        f && f?.addEventListener("click", () => {
          r("close", "closing");
        }), c?.addEventListener("click", () => {
          r("close", "closing");
        }), [...l].forEach((h) => {
          h.setAttribute("target", "_blank");
        });
      }, 500);
    }), (o, c) => (ae(), de("div", {
      class: "modal-ad-container",
      style: Rl({ display: u.value ? "none" : "block" })
    }, [
      j("div", {
        class: Ce(`plc${o.adId} modal-ad`),
        ref_key: "adButlerModal",
        ref: n
      }, null, 2),
      j("div", {
        class: "ad-modal-overlay",
        onClick: i
      })
    ], 4));
  }
}), PC = /* @__PURE__ */ ht({
  __name: "AdButlerItem",
  props: {
    isEndOfArticle: {
      type: Boolean,
      default: !1
    },
    adId: {
      type: Number,
      required: !0
    }
  },
  setup(t) {
    const e = Fe();
    Ct(() => {
      if (window.AdButler)
        n();
      else {
        const s = document.createElement("script");
        s.async = !0, s.type = "text/javascript", s.src = "https://servedbyadbutler.com/app.js", e.value && (e.value.parentElement.prepend(s), n());
      }
    });
    const n = () => {
      const s = document.createElement("script"), r = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${t.adId} = window.plc${t.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${t.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${t.adId}_" + plc${t.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${t.adId}, [0, 0], 'placement_${t.adId}_' + opt.place, opt); }, opt: { place: plc${t.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      s.innerHTML = r, e.value && e.value.parentNode.appendChild(s);
    };
    return Qn(e, async (s, r) => {
      if (s && t.isEndOfArticle) {
        const i = `.plc${t.adId} .related-post-info div p`;
        let u = 0;
        const a = setInterval(() => {
          const o = document.querySelector(i);
          (o || o && u > 10) && (o.innerHTML = o.innerText, clearInterval(a)), u++;
        }, 500);
      }
    }), (s, r) => (ae(), de("div", null, [
      j("div", {
        class: Ce(`plc${t.adId}`),
        ref_key: "adPlacement",
        ref: e
      }, null, 2)
    ]));
  }
}), k3 = "/images/close_dark_blue.svg", L3 = { class: "ad-buttler-ribbon-outer-wrapper" }, M3 = { class: "xl:container" }, FC = /* @__PURE__ */ ht({
  __name: "AdButlerBanner",
  props: {
    adId: {},
    hasSidebar: { type: Boolean }
  },
  emits: ["close"],
  setup(t, { emit: e }) {
    const n = Fe(), s = t, r = e, i = () => {
      r("close", "closing");
    };
    Ct(() => {
      if (window.AdButler)
        u();
      else {
        const a = document.createElement("script");
        a.async = !0, a.type = "text/javascript", a.src = "https://servedbyadbutler.com/app.js", n.value && (n.value.parentElement.prepend(a), u());
      }
    });
    const u = () => {
      const a = document.createElement("script"), o = `
      var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
      var abkw = window.abkw || '';
      var plc${s.adId} = window.plc${s.adId} || 0;
      (function () {
          var divs = document.querySelectorAll(".plc${s.adId}:not([id])");
          var div = divs[divs.length - 1];
          div.setAttribute("id", "placement_${s.adId}_" + plc${s.adId});
          AdButler.ads.push({ handler: function (opt) { AdButler.register(181458, ${s.adId}, [0, 0], 'placement_${s.adId}_' + opt.place, opt); }, opt: { place: plc${s.adId}++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' } });
      })();
    `;
      a.innerHTML = o, n.value && n.value.parentNode.appendChild(a);
    };
    return (a, o) => (ae(), de("div", L3, [
      j("div", {
        class: Ce(["ad-buttler-ribbon-container w-full", {
          "has-sidebar": a.hasSidebar
        }])
      }, [
        j("div", M3, [
          j("div", {
            class: Ce(`plc${a.adId} `),
            ref_key: "adButlerBanner",
            ref: n
          }, null, 2)
        ])
      ], 2),
      j("button", {
        onClick: i,
        class: "adbutler-ribbon-button-close"
      }, o[0] || (o[0] = [
        j("img", {
          src: k3,
          alt: "close button ad ribbon",
          class: "w-[20px] h-[20px]"
        }, null, -1)
      ]))
    ]));
  }
}), R3 = {
  key: 0,
  class: "inline-flex flex-nowrap justify-between items-center bg-transparent text-white whitespace-nowrap"
}, P3 = { class: "text-right ml-3" }, F3 = {
  key: 1,
  class: "inline-flex flex-nowrap justify-between items-center bg-transparent text-white whitespace-nowrap gap-3"
}, HC = /* @__PURE__ */ ht({
  __name: "stock-summary-item",
  props: {
    symbol: { default: "EXP" },
    name: { default: "Example Company, Inc." },
    price: { default: 9.42 },
    net_chg: { default: 1.34 },
    pc_chg: { default: 16.58 },
    theme: { default: "dark" },
    type: { default: "block" }
  },
  setup(t) {
    return (e, n) => e.type === "block" ? (ae(), de("div", R3, [
      j("div", null, [
        j("p", {
          class: Ce([
            "font-bold text-sm leading-tight",
            e.theme === "dark" ? "color-primary-dark" : "color-primary-light"
          ])
        }, ce(e.symbol), 3),
        j("p", {
          class: Ce([
            "text-sm overflow-hidden text-ellipsis whitespace-nowrap max-w-[96px]",
            e.theme === "dark" ? "text-slate-200" : "text-slate-400"
          ])
        }, ce(e.name), 3)
      ]),
      j("div", P3, [
        j("p", {
          class: Ce([
            "text-sm font-semibold",
            e.theme === "dark" ? "color-primary-dark" : "color-primary-light"
          ])
        }, ce(e.price.toFixed(2)), 3),
        j("p", {
          class: Ce(["text-sm", {
            "text-success": e.net_chg > 0,
            "text-red-500": e.net_chg < 0
          }])
        }, [
          ft(ce(e.net_chg.toFixed(2)) + " ", 1),
          j("span", null, "(" + ce(e.pc_chg.toFixed(2)) + "%)", 1)
        ], 2)
      ])
    ])) : (ae(), de("div", F3, [
      j("p", {
        class: Ce([
          "font-bold text-sm leading-tight",
          e.theme === "dark" ? "color-primary-dark" : "color-primary-light"
        ])
      }, ce(e.name), 3),
      j("p", {
        class: Ce(["text-sm text-right", {
          "text-success": e.net_chg > 0,
          "text-red-500": e.net_chg < 0
        }])
      }, [
        ft(ce(e.net_chg.toFixed(2)) + " ", 1),
        j("span", null, "(" + ce(e.pc_chg.toFixed(2)) + "%)", 1)
      ], 2)
    ]));
  }
});
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function ar(t) {
  return t + 0.5 | 0;
}
const un = (t, e, n) => Math.max(Math.min(t, n), e);
function ws(t) {
  return un(ar(t * 2.55), 0, 255);
}
function an(t) {
  return un(ar(t * 255), 0, 255);
}
function jt(t) {
  return un(ar(t / 2.55) / 100, 0, 1);
}
function bo(t) {
  return un(ar(t * 100), 0, 100);
}
const xt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, la = [..."0123456789ABCDEF"], H3 = (t) => la[t & 15], U3 = (t) => la[(t & 240) >> 4] + la[t & 15], gr = (t) => (t & 240) >> 4 === (t & 15), Y3 = (t) => gr(t.r) && gr(t.g) && gr(t.b) && gr(t.a);
function q3(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & xt[t[1]] * 17,
    g: 255 & xt[t[2]] * 17,
    b: 255 & xt[t[3]] * 17,
    a: e === 5 ? xt[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: xt[t[1]] << 4 | xt[t[2]],
    g: xt[t[3]] << 4 | xt[t[4]],
    b: xt[t[5]] << 4 | xt[t[6]],
    a: e === 9 ? xt[t[7]] << 4 | xt[t[8]] : 255
  })), n;
}
const $3 = (t, e) => t < 255 ? e(t) : "";
function W3(t) {
  var e = Y3(t) ? H3 : U3;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + $3(t.a, e) : void 0;
}
const z3 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function lf(t, e, n) {
  const s = e * Math.min(n, 1 - n), r = (i, u = (i + t / 30) % 12) => n - s * Math.max(Math.min(u - 3, 9 - u, 1), -1);
  return [r(0), r(8), r(4)];
}
function V3(t, e, n) {
  const s = (r, i = (r + t / 60) % 6) => n - n * e * Math.max(Math.min(i, 4 - i, 1), 0);
  return [s(5), s(3), s(1)];
}
function j3(t, e, n) {
  const s = lf(t, 1, 0.5);
  let r;
  for (e + n > 1 && (r = 1 / (e + n), e *= r, n *= r), r = 0; r < 3; r++)
    s[r] *= 1 - e - n, s[r] += e;
  return s;
}
function G3(t, e, n, s, r) {
  return t === r ? (e - n) / s + (e < n ? 6 : 0) : e === r ? (n - t) / s + 2 : (t - e) / s + 4;
}
function Ja(t) {
  const n = t.r / 255, s = t.g / 255, r = t.b / 255, i = Math.max(n, s, r), u = Math.min(n, s, r), a = (i + u) / 2;
  let o, c, l;
  return i !== u && (l = i - u, c = a > 0.5 ? l / (2 - i - u) : l / (i + u), o = G3(n, s, r, l, i), o = o * 60 + 0.5), [o | 0, c || 0, a];
}
function e0(t, e, n, s) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, s)).map(an);
}
function t0(t, e, n) {
  return e0(lf, t, e, n);
}
function X3(t, e, n) {
  return e0(j3, t, e, n);
}
function Q3(t, e, n) {
  return e0(V3, t, e, n);
}
function df(t) {
  return (t % 360 + 360) % 360;
}
function K3(t) {
  const e = z3.exec(t);
  let n = 255, s;
  if (!e)
    return;
  e[5] !== s && (n = e[6] ? ws(+e[5]) : an(+e[5]));
  const r = df(+e[2]), i = +e[3] / 100, u = +e[4] / 100;
  return e[1] === "hwb" ? s = X3(r, i, u) : e[1] === "hsv" ? s = Q3(r, i, u) : s = t0(r, i, u), {
    r: s[0],
    g: s[1],
    b: s[2],
    a: n
  };
}
function Z3(t, e) {
  var n = Ja(t);
  n[0] = df(n[0] + e), n = t0(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function J3(t) {
  if (!t)
    return;
  const e = Ja(t), n = e[0], s = bo(e[1]), r = bo(e[2]);
  return t.a < 255 ? `hsla(${n}, ${s}%, ${r}%, ${jt(t.a)})` : `hsl(${n}, ${s}%, ${r}%)`;
}
const xo = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, mo = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function e6() {
  const t = {}, e = Object.keys(mo), n = Object.keys(xo);
  let s, r, i, u, a;
  for (s = 0; s < e.length; s++) {
    for (u = a = e[s], r = 0; r < n.length; r++)
      i = n[r], a = a.replace(i, xo[i]);
    i = parseInt(mo[u], 16), t[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return t;
}
let Er;
function t6(t) {
  Er || (Er = e6(), Er.transparent = [0, 0, 0, 0]);
  const e = Er[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const n6 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function s6(t) {
  const e = n6.exec(t);
  let n = 255, s, r, i;
  if (e) {
    if (e[7] !== s) {
      const u = +e[7];
      n = e[8] ? ws(u) : un(u * 255, 0, 255);
    }
    return s = +e[1], r = +e[3], i = +e[5], s = 255 & (e[2] ? ws(s) : un(s, 0, 255)), r = 255 & (e[4] ? ws(r) : un(r, 0, 255)), i = 255 & (e[6] ? ws(i) : un(i, 0, 255)), {
      r: s,
      g: r,
      b: i,
      a: n
    };
  }
}
function r6(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${jt(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Qi = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, Wn = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function i6(t, e, n) {
  const s = Wn(jt(t.r)), r = Wn(jt(t.g)), i = Wn(jt(t.b));
  return {
    r: an(Qi(s + n * (Wn(jt(e.r)) - s))),
    g: an(Qi(r + n * (Wn(jt(e.g)) - r))),
    b: an(Qi(i + n * (Wn(jt(e.b)) - i))),
    a: t.a + n * (e.a - t.a)
  };
}
function _r(t, e, n) {
  if (t) {
    let s = Ja(t);
    s[e] = Math.max(0, Math.min(s[e] + s[e] * n, e === 0 ? 360 : 1)), s = t0(s), t.r = s[0], t.g = s[1], t.b = s[2];
  }
}
function ff(t, e) {
  return t && Object.assign(e || {}, t);
}
function po(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = an(t[3]))) : (e = ff(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = an(e.a)), e;
}
function u6(t) {
  return t.charAt(0) === "r" ? s6(t) : K3(t);
}
class Xs {
  constructor(e) {
    if (e instanceof Xs)
      return e;
    const n = typeof e;
    let s;
    n === "object" ? s = po(e) : n === "string" && (s = q3(e) || t6(e) || u6(e)), this._rgb = s, this._valid = !!s;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = ff(this._rgb);
    return e && (e.a = jt(e.a)), e;
  }
  set rgb(e) {
    this._rgb = po(e);
  }
  rgbString() {
    return this._valid ? r6(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? W3(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? J3(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const s = this.rgb, r = e.rgb;
      let i;
      const u = n === i ? 0.5 : n, a = 2 * u - 1, o = s.a - r.a, c = ((a * o === -1 ? a : (a + o) / (1 + a * o)) + 1) / 2;
      i = 1 - c, s.r = 255 & c * s.r + i * r.r + 0.5, s.g = 255 & c * s.g + i * r.g + 0.5, s.b = 255 & c * s.b + i * r.b + 0.5, s.a = u * s.a + (1 - u) * r.a, this.rgb = s;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = i6(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new Xs(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = an(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = ar(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return _r(this._rgb, 2, e), this;
  }
  darken(e) {
    return _r(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return _r(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return _r(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return Z3(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function qt() {
}
const a6 = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function Ae(t) {
  return t == null;
}
function Ue(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function be(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function Je(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function St(t, e) {
  return Je(t) ? t : e;
}
function fe(t, e) {
  return typeof t > "u" ? e : t;
}
const o6 = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function ye(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function Ee(t, e, n, s) {
  let r, i, u;
  if (Ue(t))
    for (i = t.length, r = 0; r < i; r++)
      e.call(n, t[r], r);
  else if (be(t))
    for (u = Object.keys(t), i = u.length, r = 0; r < i; r++)
      e.call(n, t[u[r]], u[r]);
}
function ei(t, e) {
  let n, s, r, i;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, s = t.length; n < s; ++n)
    if (r = t[n], i = e[n], r.datasetIndex !== i.datasetIndex || r.index !== i.index)
      return !1;
  return !0;
}
function ti(t) {
  if (Ue(t))
    return t.map(ti);
  if (be(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), s = n.length;
    let r = 0;
    for (; r < s; ++r)
      e[n[r]] = ti(t[n[r]]);
    return e;
  }
  return t;
}
function hf(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function c6(t, e, n, s) {
  if (!hf(t))
    return;
  const r = e[t], i = n[t];
  be(r) && be(i) ? Qs(r, i, s) : e[t] = ti(i);
}
function Qs(t, e, n) {
  const s = Ue(e) ? e : [
    e
  ], r = s.length;
  if (!be(t))
    return t;
  n = n || {};
  const i = n.merger || c6;
  let u;
  for (let a = 0; a < r; ++a) {
    if (u = s[a], !be(u))
      continue;
    const o = Object.keys(u);
    for (let c = 0, l = o.length; c < l; ++c)
      i(o[c], t, u, n);
  }
  return t;
}
function Ps(t, e) {
  return Qs(t, e, {
    merger: l6
  });
}
function l6(t, e, n) {
  if (!hf(t))
    return;
  const s = e[t], r = n[t];
  be(s) && be(r) ? Ps(s, r) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = ti(r));
}
const go = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function d6(t) {
  const e = t.split("."), n = [];
  let s = "";
  for (const r of e)
    s += r, s.endsWith("\\") ? s = s.slice(0, -1) + "." : (n.push(s), s = "");
  return n;
}
function f6(t) {
  const e = d6(t);
  return (n) => {
    for (const s of e) {
      if (s === "")
        break;
      n = n && n[s];
    }
    return n;
  };
}
function ni(t, e) {
  return (go[e] || (go[e] = f6(e)))(t);
}
function n0(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const si = (t) => typeof t < "u", on = (t) => typeof t == "function", Eo = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function h6(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const Ve = Math.PI, yt = 2 * Ve, b6 = yt + Ve, ri = Number.POSITIVE_INFINITY, x6 = Ve / 180, At = Ve / 2, bn = Ve / 4, _o = Ve * 2 / 3, bf = Math.log10, es = Math.sign;
function Fs(t, e, n) {
  return Math.abs(t - e) < n;
}
function To(t) {
  const e = Math.round(t);
  t = Fs(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(bf(t))), s = t / n;
  return (s <= 1 ? 1 : s <= 2 ? 2 : s <= 5 ? 5 : 10) * n;
}
function m6(t) {
  const e = [], n = Math.sqrt(t);
  let s;
  for (s = 1; s < n; s++)
    t % s === 0 && (e.push(s), e.push(t / s));
  return n === (n | 0) && e.push(n), e.sort((r, i) => r - i).pop(), e;
}
function p6(t) {
  return typeof t == "symbol" || typeof t == "object" && t !== null && !(Symbol.toPrimitive in t || "toString" in t || "valueOf" in t);
}
function Ks(t) {
  return !p6(t) && !isNaN(parseFloat(t)) && isFinite(t);
}
function g6(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function E6(t, e, n) {
  let s, r, i;
  for (s = 0, r = t.length; s < r; s++)
    i = t[s][n], isNaN(i) || (e.min = Math.min(e.min, i), e.max = Math.max(e.max, i));
}
function Tn(t) {
  return t * (Ve / 180);
}
function _6(t) {
  return t * (180 / Ve);
}
function Ao(t) {
  if (!Je(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function T6(t, e) {
  const n = e.x - t.x, s = e.y - t.y, r = Math.sqrt(n * n + s * s);
  let i = Math.atan2(s, n);
  return i < -0.5 * Ve && (i += yt), {
    angle: i,
    distance: r
  };
}
function da(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function A6(t, e) {
  return (t - e + b6) % yt - Ve;
}
function Ot(t) {
  return (t % yt + yt) % yt;
}
function xf(t, e, n, s) {
  const r = Ot(t), i = Ot(e), u = Ot(n), a = Ot(i - r), o = Ot(u - r), c = Ot(r - i), l = Ot(r - u);
  return r === i || r === u || s && i === u || a > o && c < l;
}
function gt(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function y6(t) {
  return gt(t, -32768, 32767);
}
function jn(t, e, n, s = 1e-6) {
  return t >= Math.min(e, n) - s && t <= Math.max(e, n) + s;
}
function s0(t, e, n) {
  n = n || ((u) => t[u] < e);
  let s = t.length - 1, r = 0, i;
  for (; s - r > 1; )
    i = r + s >> 1, n(i) ? r = i : s = i;
  return {
    lo: r,
    hi: s
  };
}
const An = (t, e, n, s) => s0(t, n, s ? (r) => {
  const i = t[r][e];
  return i < n || i === n && t[r + 1][e] === n;
} : (r) => t[r][e] < n), C6 = (t, e, n) => s0(t, n, (s) => t[s][e] >= n);
function D6(t, e, n) {
  let s = 0, r = t.length;
  for (; s < r && t[s] < e; )
    s++;
  for (; r > s && t[r - 1] > n; )
    r--;
  return s > 0 || r < t.length ? t.slice(s, r) : t;
}
const mf = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function v6(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), mf.forEach((n) => {
    const s = "_onData" + n0(n), r = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const u = r.apply(this, i);
        return t._chartjs.listeners.forEach((a) => {
          typeof a[s] == "function" && a[s](...i);
        }), u;
      }
    });
  });
}
function yo(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const s = n.listeners, r = s.indexOf(e);
  r !== -1 && s.splice(r, 1), !(s.length > 0) && (mf.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function S6(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const pf = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function gf(t, e) {
  let n = [], s = !1;
  return function(...r) {
    n = r, s || (s = !0, pf.call(window, () => {
      s = !1, t.apply(e, n);
    }));
  };
}
function w6(t, e) {
  let n;
  return function(...s) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, s)) : t.apply(this, s), e;
  };
}
const r0 = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", Qe = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, N6 = (t, e, n, s) => t === (s ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e;
function I6(t, e, n) {
  const s = e.length;
  let r = 0, i = s;
  if (t._sorted) {
    const { iScale: u, vScale: a, _parsed: o } = t, c = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null, l = u.axis, { min: f, max: h, minDefined: x, maxDefined: m } = u.getUserBounds();
    if (x) {
      if (r = Math.min(
        // @ts-expect-error Need to type _parsed
        An(o, l, f).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? s : An(e, l, u.getPixelForValue(f)).lo
      ), c) {
        const p = o.slice(0, r + 1).reverse().findIndex((b) => !Ae(b[a.axis]));
        r -= Math.max(0, p);
      }
      r = gt(r, 0, s - 1);
    }
    if (m) {
      let p = Math.max(
        // @ts-expect-error Need to type _parsed
        An(o, u.axis, h, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : An(e, l, u.getPixelForValue(h), !0).hi + 1
      );
      if (c) {
        const b = o.slice(p - 1).findIndex((E) => !Ae(E[a.axis]));
        p += Math.max(0, b);
      }
      i = gt(p, r, s) - r;
    } else
      i = s - r;
  }
  return {
    start: r,
    count: i
  };
}
function O6(t) {
  const { xScale: e, yScale: n, _scaleRanges: s } = t, r = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!s)
    return t._scaleRanges = r, !0;
  const i = s.xmin !== e.min || s.xmax !== e.max || s.ymin !== n.min || s.ymax !== n.max;
  return Object.assign(s, r), i;
}
const Tr = (t) => t === 0 || t === 1, Co = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * yt / n)), Do = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * yt / n) + 1, Hs = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * At) + 1,
  easeOutSine: (t) => Math.sin(t * At),
  easeInOutSine: (t) => -0.5 * (Math.cos(Ve * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => Tr(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => Tr(t) ? t : Co(t, 0.075, 0.3),
  easeOutElastic: (t) => Tr(t) ? t : Do(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return Tr(t) ? t : t < 0.5 ? 0.5 * Co(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * Do(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - Hs.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? Hs.easeInBounce(t * 2) * 0.5 : Hs.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function i0(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function vo(t) {
  return i0(t) ? t : new Xs(t);
}
function Ki(t) {
  return i0(t) ? t : new Xs(t).saturate(0.5).darken(0.1).hexString();
}
const B6 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], k6 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function L6(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: k6
    },
    numbers: {
      type: "number",
      properties: B6
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function M6(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const So = /* @__PURE__ */ new Map();
function R6(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let s = So.get(n);
  return s || (s = new Intl.NumberFormat(t, e), So.set(n, s)), s;
}
function Ef(t, e, n) {
  return R6(e, n).format(t);
}
const P6 = {
  values(t) {
    return Ue(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const s = this.chart.options.locale;
    let r, i = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (r = "scientific"), i = F6(t, n);
    }
    const u = bf(Math.abs(i)), a = isNaN(u) ? 1 : Math.max(Math.min(-1 * Math.floor(u), 20), 0), o = {
      notation: r,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(o, this.options.ticks.format), Ef(t, s, o);
  }
};
function F6(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var _f = {
  formatters: P6
};
function H6(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: _f.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const In = /* @__PURE__ */ Object.create(null), fa = /* @__PURE__ */ Object.create(null);
function Us(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let s = 0, r = n.length; s < r; ++s) {
    const i = n[s];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Zi(t, e, n) {
  return typeof e == "string" ? Qs(Us(t, e), n) : Qs(Us(t, ""), e);
}
class U6 {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (s) => s.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (s, r) => Ki(r.backgroundColor), this.hoverBorderColor = (s, r) => Ki(r.borderColor), this.hoverColor = (s, r) => Ki(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return Zi(this, e, n);
  }
  get(e) {
    return Us(this, e);
  }
  describe(e, n) {
    return Zi(fa, e, n);
  }
  override(e, n) {
    return Zi(In, e, n);
  }
  route(e, n, s, r) {
    const i = Us(this, e), u = Us(this, s), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const o = this[a], c = u[r];
          return be(o) ? Object.assign({}, c, o) : fe(o, c);
        },
        set(o) {
          this[a] = o;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var Be = /* @__PURE__ */ new U6({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  L6,
  M6,
  H6
]);
function Y6(t) {
  return !t || Ae(t.size) || Ae(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function wo(t, e, n, s, r) {
  let i = e[r];
  return i || (i = e[r] = t.measureText(r).width, n.push(r)), i > s && (s = i), s;
}
function xn(t, e, n) {
  const s = t.currentDevicePixelRatio, r = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - r) * s) / s + r;
}
function No(t, e) {
  !e && !t || (e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore());
}
function ha(t, e, n, s) {
  Tf(t, e, n, s, null);
}
function Tf(t, e, n, s, r) {
  let i, u, a, o, c, l, f, h;
  const x = e.pointStyle, m = e.rotation, p = e.radius;
  let b = (m || 0) * x6;
  if (x && typeof x == "object" && (i = x.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, s), t.rotate(b), t.drawImage(x, -x.width / 2, -x.height / 2, x.width, x.height), t.restore();
    return;
  }
  if (!(isNaN(p) || p <= 0)) {
    switch (t.beginPath(), x) {
      default:
        r ? t.ellipse(n, s, r / 2, p, 0, 0, yt) : t.arc(n, s, p, 0, yt), t.closePath();
        break;
      case "triangle":
        l = r ? r / 2 : p, t.moveTo(n + Math.sin(b) * l, s - Math.cos(b) * p), b += _o, t.lineTo(n + Math.sin(b) * l, s - Math.cos(b) * p), b += _o, t.lineTo(n + Math.sin(b) * l, s - Math.cos(b) * p), t.closePath();
        break;
      case "rectRounded":
        c = p * 0.516, o = p - c, u = Math.cos(b + bn) * o, f = Math.cos(b + bn) * (r ? r / 2 - c : o), a = Math.sin(b + bn) * o, h = Math.sin(b + bn) * (r ? r / 2 - c : o), t.arc(n - f, s - a, c, b - Ve, b - At), t.arc(n + h, s - u, c, b - At, b), t.arc(n + f, s + a, c, b, b + At), t.arc(n - h, s + u, c, b + At, b + Ve), t.closePath();
        break;
      case "rect":
        if (!m) {
          o = Math.SQRT1_2 * p, l = r ? r / 2 : o, t.rect(n - l, s - o, 2 * l, 2 * o);
          break;
        }
        b += bn;
      case "rectRot":
        f = Math.cos(b) * (r ? r / 2 : p), u = Math.cos(b) * p, a = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), t.moveTo(n - f, s - a), t.lineTo(n + h, s - u), t.lineTo(n + f, s + a), t.lineTo(n - h, s + u), t.closePath();
        break;
      case "crossRot":
        b += bn;
      case "cross":
        f = Math.cos(b) * (r ? r / 2 : p), u = Math.cos(b) * p, a = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), t.moveTo(n - f, s - a), t.lineTo(n + f, s + a), t.moveTo(n + h, s - u), t.lineTo(n - h, s + u);
        break;
      case "star":
        f = Math.cos(b) * (r ? r / 2 : p), u = Math.cos(b) * p, a = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), t.moveTo(n - f, s - a), t.lineTo(n + f, s + a), t.moveTo(n + h, s - u), t.lineTo(n - h, s + u), b += bn, f = Math.cos(b) * (r ? r / 2 : p), u = Math.cos(b) * p, a = Math.sin(b) * p, h = Math.sin(b) * (r ? r / 2 : p), t.moveTo(n - f, s - a), t.lineTo(n + f, s + a), t.moveTo(n + h, s - u), t.lineTo(n - h, s + u);
        break;
      case "line":
        u = r ? r / 2 : Math.cos(b) * p, a = Math.sin(b) * p, t.moveTo(n - u, s - a), t.lineTo(n + u, s + a);
        break;
      case "dash":
        t.moveTo(n, s), t.lineTo(n + Math.cos(b) * (r ? r / 2 : p), s + Math.sin(b) * p);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function Zs(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function Ai(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function yi(t) {
  t.restore();
}
function q6(t, e, n, s, r) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (r === "middle") {
    const i = (e.x + n.x) / 2;
    t.lineTo(i, e.y), t.lineTo(i, n.y);
  } else r === "after" != !!s ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function $6(t, e, n, s) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(s ? e.cp1x : e.cp2x, s ? e.cp1y : e.cp2y, s ? n.cp2x : n.cp1x, s ? n.cp2y : n.cp1y, n.x, n.y);
}
function W6(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), Ae(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function z6(t, e, n, s, r) {
  if (r.strikethrough || r.underline) {
    const i = t.measureText(s), u = e - i.actualBoundingBoxLeft, a = e + i.actualBoundingBoxRight, o = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, l = r.strikethrough ? (o + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = r.decorationWidth || 2, t.moveTo(u, l), t.lineTo(a, l), t.stroke();
  }
}
function V6(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function Js(t, e, n, s, r, i = {}) {
  const u = Ue(e) ? e : [
    e
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let o, c;
  for (t.save(), t.font = r.string, W6(t, i), o = 0; o < u.length; ++o)
    c = u[o], i.backdrop && V6(t, i.backdrop), a && (i.strokeColor && (t.strokeStyle = i.strokeColor), Ae(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(c, n, s, i.maxWidth)), t.fillText(c, n, s, i.maxWidth), z6(t, n, s, c, i), s += Number(r.lineHeight);
  t.restore();
}
function ba(t, e) {
  const { x: n, y: s, w: r, h: i, radius: u } = e;
  t.arc(n + u.topLeft, s + u.topLeft, u.topLeft, 1.5 * Ve, Ve, !0), t.lineTo(n, s + i - u.bottomLeft), t.arc(n + u.bottomLeft, s + i - u.bottomLeft, u.bottomLeft, Ve, At, !0), t.lineTo(n + r - u.bottomRight, s + i), t.arc(n + r - u.bottomRight, s + i - u.bottomRight, u.bottomRight, At, 0, !0), t.lineTo(n + r, s + u.topRight), t.arc(n + r - u.topRight, s + u.topRight, u.topRight, 0, -At, !0), t.lineTo(n + u.topLeft, s);
}
const j6 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, G6 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function X6(t, e) {
  const n = ("" + t).match(j6);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const Q6 = (t) => +t || 0;
function Af(t, e) {
  const n = {}, s = be(e), r = s ? Object.keys(e) : e, i = be(t) ? s ? (u) => fe(t[u], t[e[u]]) : (u) => t[u] : () => t;
  for (const u of r)
    n[u] = Q6(i(u));
  return n;
}
function K6(t) {
  return Af(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Ys(t) {
  return Af(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function _t(t) {
  const e = K6(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function Ze(t, e) {
  t = t || {}, e = e || Be.font;
  let n = fe(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let s = fe(t.style, e.style);
  s && !("" + s).match(G6) && (console.warn('Invalid font style specified: "' + s + '"'), s = void 0);
  const r = {
    family: fe(t.family, e.family),
    lineHeight: X6(fe(t.lineHeight, e.lineHeight), n),
    size: n,
    style: s,
    weight: fe(t.weight, e.weight),
    string: ""
  };
  return r.string = Y6(r), r;
}
function Ar(t, e, n, s) {
  let r, i, u;
  for (r = 0, i = t.length; r < i; ++r)
    if (u = t[r], u !== void 0 && u !== void 0)
      return u;
}
function Z6(t, e, n) {
  const { min: s, max: r } = t, i = o6(e, (r - s) / 2), u = (a, o) => n && a === 0 ? 0 : a + o;
  return {
    min: u(s, -Math.abs(i)),
    max: u(r, i)
  };
}
function Ln(t, e) {
  return Object.assign(Object.create(t), e);
}
function u0(t, e = [
  ""
], n, s, r = () => t[0]) {
  const i = n || t;
  typeof s > "u" && (s = vf("_fallback", t));
  const u = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: s,
    _getTarget: r,
    override: (a) => u0([
      a,
      ...t
    ], e, i, s)
  };
  return new Proxy(u, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, o) {
      return delete a[o], delete a._keys, delete t[0][o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, o) {
      return Cf(a, o, () => uE(o, e, t, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, o) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, o) {
      return Oo(a).includes(o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return Oo(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, o, c) {
      const l = a._storage || (a._storage = r());
      return a[o] = l[o] = c, delete a._keys, !0;
    }
  });
}
function ts(t, e, n, s) {
  const r = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: yf(t, s),
    setContext: (i) => ts(t, i, n, s),
    override: (i) => ts(t.override(i), e, n, s)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, u) {
      return delete i[u], delete t[u], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, u, a) {
      return Cf(i, u, () => eE(i, u, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, u) {
      return i._descriptors.allKeys ? Reflect.has(t, u) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, u);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, u) {
      return Reflect.has(t, u);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, u, a) {
      return t[u] = a, delete i[u], !0;
    }
  });
}
function yf(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: s = e.indexable, _allKeys: r = e.allKeys } = t;
  return {
    allKeys: r,
    scriptable: n,
    indexable: s,
    isScriptable: on(n) ? n : () => n,
    isIndexable: on(s) ? s : () => s
  };
}
const J6 = (t, e) => t ? t + n0(e) : e, a0 = (t, e) => be(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function Cf(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e) || e === "constructor")
    return t[e];
  const s = n();
  return t[e] = s, s;
}
function eE(t, e, n) {
  const { _proxy: s, _context: r, _subProxy: i, _descriptors: u } = t;
  let a = s[e];
  return on(a) && u.isScriptable(e) && (a = tE(e, a, t, n)), Ue(a) && a.length && (a = nE(e, a, t, u.isIndexable)), a0(e, a) && (a = ts(a, r, i && i[e], u)), a;
}
function tE(t, e, n, s) {
  const { _proxy: r, _context: i, _subProxy: u, _stack: a } = n;
  if (a.has(t))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + t);
  a.add(t);
  let o = e(i, u || s);
  return a.delete(t), a0(t, o) && (o = o0(r._scopes, r, t, o)), o;
}
function nE(t, e, n, s) {
  const { _proxy: r, _context: i, _subProxy: u, _descriptors: a } = n;
  if (typeof i.index < "u" && s(t))
    return e[i.index % e.length];
  if (be(e[0])) {
    const o = e, c = r._scopes.filter((l) => l !== o);
    e = [];
    for (const l of o) {
      const f = o0(c, r, t, l);
      e.push(ts(f, i, u && u[t], a));
    }
  }
  return e;
}
function Df(t, e, n) {
  return on(t) ? t(e, n) : t;
}
const sE = (t, e) => t === !0 ? e : typeof t == "string" ? ni(e, t) : void 0;
function rE(t, e, n, s, r) {
  for (const i of e) {
    const u = sE(n, i);
    if (u) {
      t.add(u);
      const a = Df(u._fallback, n, r);
      if (typeof a < "u" && a !== n && a !== s)
        return a;
    } else if (u === !1 && typeof s < "u" && n !== s)
      return null;
  }
  return !1;
}
function o0(t, e, n, s) {
  const r = e._rootScopes, i = Df(e._fallback, n, s), u = [
    ...t,
    ...r
  ], a = /* @__PURE__ */ new Set();
  a.add(s);
  let o = Io(a, u, n, i || n, s);
  return o === null || typeof i < "u" && i !== n && (o = Io(a, u, i, o, s), o === null) ? !1 : u0(Array.from(a), [
    ""
  ], r, i, () => iE(e, n, s));
}
function Io(t, e, n, s, r) {
  for (; n; )
    n = rE(t, e, n, s, r);
  return n;
}
function iE(t, e, n) {
  const s = t._getTarget();
  e in s || (s[e] = {});
  const r = s[e];
  return Ue(r) && be(n) ? n : r || {};
}
function uE(t, e, n, s) {
  let r;
  for (const i of e)
    if (r = vf(J6(i, t), n), typeof r < "u")
      return a0(t, r) ? o0(n, s, t, r) : r;
}
function vf(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const s = n[t];
    if (typeof s < "u")
      return s;
  }
}
function Oo(t) {
  let e = t._keys;
  return e || (e = t._keys = aE(t._scopes)), e;
}
function aE(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const s of Object.keys(n).filter((r) => !r.startsWith("_")))
      e.add(s);
  return Array.from(e);
}
const oE = Number.EPSILON || 1e-14, ns = (t, e) => e < t.length && !t[e].skip && t[e], Sf = (t) => t === "x" ? "y" : "x";
function cE(t, e, n, s) {
  const r = t.skip ? e : t, i = e, u = n.skip ? e : n, a = da(i, r), o = da(u, i);
  let c = a / (a + o), l = o / (a + o);
  c = isNaN(c) ? 0 : c, l = isNaN(l) ? 0 : l;
  const f = s * c, h = s * l;
  return {
    previous: {
      x: i.x - f * (u.x - r.x),
      y: i.y - f * (u.y - r.y)
    },
    next: {
      x: i.x + h * (u.x - r.x),
      y: i.y + h * (u.y - r.y)
    }
  };
}
function lE(t, e, n) {
  const s = t.length;
  let r, i, u, a, o, c = ns(t, 0);
  for (let l = 0; l < s - 1; ++l)
    if (o = c, c = ns(t, l + 1), !(!o || !c)) {
      if (Fs(e[l], 0, oE)) {
        n[l] = n[l + 1] = 0;
        continue;
      }
      r = n[l] / e[l], i = n[l + 1] / e[l], a = Math.pow(r, 2) + Math.pow(i, 2), !(a <= 9) && (u = 3 / Math.sqrt(a), n[l] = r * u * e[l], n[l + 1] = i * u * e[l]);
    }
}
function dE(t, e, n = "x") {
  const s = Sf(n), r = t.length;
  let i, u, a, o = ns(t, 0);
  for (let c = 0; c < r; ++c) {
    if (u = a, a = o, o = ns(t, c + 1), !a)
      continue;
    const l = a[n], f = a[s];
    u && (i = (l - u[n]) / 3, a[`cp1${n}`] = l - i, a[`cp1${s}`] = f - i * e[c]), o && (i = (o[n] - l) / 3, a[`cp2${n}`] = l + i, a[`cp2${s}`] = f + i * e[c]);
  }
}
function fE(t, e = "x") {
  const n = Sf(e), s = t.length, r = Array(s).fill(0), i = Array(s);
  let u, a, o, c = ns(t, 0);
  for (u = 0; u < s; ++u)
    if (a = o, o = c, c = ns(t, u + 1), !!o) {
      if (c) {
        const l = c[e] - o[e];
        r[u] = l !== 0 ? (c[n] - o[n]) / l : 0;
      }
      i[u] = a ? c ? es(r[u - 1]) !== es(r[u]) ? 0 : (r[u - 1] + r[u]) / 2 : r[u - 1] : r[u];
    }
  lE(t, r, i), dE(t, i, e);
}
function yr(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function hE(t, e) {
  let n, s, r, i, u, a = Zs(t[0], e);
  for (n = 0, s = t.length; n < s; ++n)
    u = i, i = a, a = n < s - 1 && Zs(t[n + 1], e), i && (r = t[n], u && (r.cp1x = yr(r.cp1x, e.left, e.right), r.cp1y = yr(r.cp1y, e.top, e.bottom)), a && (r.cp2x = yr(r.cp2x, e.left, e.right), r.cp2y = yr(r.cp2y, e.top, e.bottom)));
}
function bE(t, e, n, s, r) {
  let i, u, a, o;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    fE(t, r);
  else {
    let c = s ? t[t.length - 1] : t[0];
    for (i = 0, u = t.length; i < u; ++i)
      a = t[i], o = cE(c, a, t[Math.min(i + 1, u - (s ? 0 : 1)) % u], e.tension), a.cp1x = o.previous.x, a.cp1y = o.previous.y, a.cp2x = o.next.x, a.cp2y = o.next.y, c = a;
  }
  e.capBezierPoints && hE(t, n);
}
function c0() {
  return typeof window < "u" && typeof document < "u";
}
function l0(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function ii(t, e, n) {
  let s;
  return typeof t == "string" ? (s = parseInt(t, 10), t.indexOf("%") !== -1 && (s = s / 100 * e.parentNode[n])) : s = t, s;
}
const Ci = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function xE(t, e) {
  return Ci(t).getPropertyValue(e);
}
const mE = [
  "top",
  "right",
  "bottom",
  "left"
];
function Dn(t, e, n) {
  const s = {};
  n = n ? "-" + n : "";
  for (let r = 0; r < 4; r++) {
    const i = mE[r];
    s[i] = parseFloat(t[e + "-" + i + n]) || 0;
  }
  return s.width = s.left + s.right, s.height = s.top + s.bottom, s;
}
const pE = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function gE(t, e) {
  const n = t.touches, s = n && n.length ? n[0] : t, { offsetX: r, offsetY: i } = s;
  let u = !1, a, o;
  if (pE(r, i, t.target))
    a = r, o = i;
  else {
    const c = e.getBoundingClientRect();
    a = s.clientX - c.left, o = s.clientY - c.top, u = !0;
  }
  return {
    x: a,
    y: o,
    box: u
  };
}
function pn(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: s } = e, r = Ci(n), i = r.boxSizing === "border-box", u = Dn(r, "padding"), a = Dn(r, "border", "width"), { x: o, y: c, box: l } = gE(t, n), f = u.left + (l && a.left), h = u.top + (l && a.top);
  let { width: x, height: m } = e;
  return i && (x -= u.width + a.width, m -= u.height + a.height), {
    x: Math.round((o - f) / x * n.width / s),
    y: Math.round((c - h) / m * n.height / s)
  };
}
function EE(t, e, n) {
  let s, r;
  if (e === void 0 || n === void 0) {
    const i = t && l0(t);
    if (!i)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const u = i.getBoundingClientRect(), a = Ci(i), o = Dn(a, "border", "width"), c = Dn(a, "padding");
      e = u.width - c.width - o.width, n = u.height - c.height - o.height, s = ii(a.maxWidth, i, "clientWidth"), r = ii(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: s || ri,
    maxHeight: r || ri
  };
}
const Cr = (t) => Math.round(t * 10) / 10;
function _E(t, e, n, s) {
  const r = Ci(t), i = Dn(r, "margin"), u = ii(r.maxWidth, t, "clientWidth") || ri, a = ii(r.maxHeight, t, "clientHeight") || ri, o = EE(t, e, n);
  let { width: c, height: l } = o;
  if (r.boxSizing === "content-box") {
    const h = Dn(r, "border", "width"), x = Dn(r, "padding");
    c -= x.width + h.width, l -= x.height + h.height;
  }
  return c = Math.max(0, c - i.width), l = Math.max(0, s ? c / s : l - i.height), c = Cr(Math.min(c, u, o.maxWidth)), l = Cr(Math.min(l, a, o.maxHeight)), c && !l && (l = Cr(c / 2)), (e !== void 0 || n !== void 0) && s && o.height && l > o.height && (l = o.height, c = Cr(Math.floor(l * s))), {
    width: c,
    height: l
  };
}
function Bo(t, e, n) {
  const s = e || 1, r = Math.floor(t.height * s), i = Math.floor(t.width * s);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const u = t.canvas;
  return u.style && (n || !u.style.height && !u.style.width) && (u.style.height = `${t.height}px`, u.style.width = `${t.width}px`), t.currentDevicePixelRatio !== s || u.height !== r || u.width !== i ? (t.currentDevicePixelRatio = s, u.height = r, u.width = i, t.ctx.setTransform(s, 0, 0, s, 0, 0), !0) : !1;
}
const TE = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    c0() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return t;
}();
function ko(t, e) {
  const n = xE(t, e), s = n && n.match(/^(\d+)(\.\d+)?px$/);
  return s ? +s[1] : void 0;
}
function gn(t, e, n, s) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function AE(t, e, n, s) {
  return {
    x: t.x + n * (e.x - t.x),
    y: s === "middle" ? n < 0.5 ? t.y : e.y : s === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function yE(t, e, n, s) {
  const r = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: e.cp1x,
    y: e.cp1y
  }, u = gn(t, r, n), a = gn(r, i, n), o = gn(i, e, n), c = gn(u, a, n), l = gn(a, o, n);
  return gn(c, l, n);
}
const CE = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, s) {
      return n - s;
    },
    leftForLtr(n, s) {
      return n - s;
    }
  };
}, DE = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function Xn(t, e, n) {
  return t ? CE(e, n) : DE();
}
function wf(t, e) {
  let n, s;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, s = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = s);
}
function Nf(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function If(t) {
  return t === "angle" ? {
    between: xf,
    compare: A6,
    normalize: Ot
  } : {
    between: jn,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function Lo({ start: t, end: e, count: n, loop: s, style: r }) {
  return {
    start: t % n,
    end: e % n,
    loop: s && (e - t + 1) % n === 0,
    style: r
  };
}
function vE(t, e, n) {
  const { property: s, start: r, end: i } = n, { between: u, normalize: a } = If(s), o = e.length;
  let { start: c, end: l, loop: f } = t, h, x;
  if (f) {
    for (c += o, l += o, h = 0, x = o; h < x && u(a(e[c % o][s]), r, i); ++h)
      c--, l--;
    c %= o, l %= o;
  }
  return l < c && (l += o), {
    start: c,
    end: l,
    loop: f,
    style: t.style
  };
}
function Of(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: s, start: r, end: i } = n, u = e.length, { compare: a, between: o, normalize: c } = If(s), { start: l, end: f, loop: h, style: x } = vE(t, e, n), m = [];
  let p = !1, b = null, E, g, _;
  const T = () => o(r, _, E) && a(r, _) !== 0, C = () => a(i, E) === 0 || o(i, _, E), y = () => p || T(), v = () => !p || C();
  for (let N = l, O = l; N <= f; ++N)
    g = e[N % u], !g.skip && (E = c(g[s]), E !== _ && (p = o(E, r, i), b === null && y() && (b = a(E, r) === 0 ? N : O), b !== null && v() && (m.push(Lo({
      start: b,
      end: N,
      loop: h,
      count: u,
      style: x
    })), b = null), O = N, _ = E));
  return b !== null && m.push(Lo({
    start: b,
    end: f,
    loop: h,
    count: u,
    style: x
  })), m;
}
function Bf(t, e) {
  const n = [], s = t.segments;
  for (let r = 0; r < s.length; r++) {
    const i = Of(s[r], t.points, e);
    i.length && n.push(...i);
  }
  return n;
}
function SE(t, e, n, s) {
  let r = 0, i = e - 1;
  if (n && !s)
    for (; r < e && !t[r].skip; )
      r++;
  for (; r < e && t[r].skip; )
    r++;
  for (r %= e, n && (i += r); i > r && t[i % e].skip; )
    i--;
  return i %= e, {
    start: r,
    end: i
  };
}
function wE(t, e, n, s) {
  const r = t.length, i = [];
  let u = e, a = t[e], o;
  for (o = e + 1; o <= n; ++o) {
    const c = t[o % r];
    c.skip || c.stop ? a.skip || (s = !1, i.push({
      start: e % r,
      end: (o - 1) % r,
      loop: s
    }), e = u = c.stop ? o : null) : (u = o, a.skip && (e = o)), a = c;
  }
  return u !== null && i.push({
    start: e % r,
    end: u % r,
    loop: s
  }), i;
}
function NE(t, e) {
  const n = t.points, s = t.options.spanGaps, r = n.length;
  if (!r)
    return [];
  const i = !!t._loop, { start: u, end: a } = SE(n, r, i, s);
  if (s === !0)
    return Mo(t, [
      {
        start: u,
        end: a,
        loop: i
      }
    ], n, e);
  const o = a < u ? a + r : a, c = !!t._fullLoop && u === 0 && a === r - 1;
  return Mo(t, wE(n, u, o, c), n, e);
}
function Mo(t, e, n, s) {
  return !s || !s.setContext || !n ? e : IE(t, e, n, s);
}
function IE(t, e, n, s) {
  const r = t._chart.getContext(), i = Ro(t.options), { _datasetIndex: u, options: { spanGaps: a } } = t, o = n.length, c = [];
  let l = i, f = e[0].start, h = f;
  function x(m, p, b, E) {
    const g = a ? -1 : 1;
    if (m !== p) {
      for (m += o; n[m % o].skip; )
        m -= g;
      for (; n[p % o].skip; )
        p += g;
      m % o !== p % o && (c.push({
        start: m % o,
        end: p % o,
        loop: b,
        style: E
      }), l = E, f = p % o);
    }
  }
  for (const m of e) {
    f = a ? f : m.start;
    let p = n[f % o], b;
    for (h = f + 1; h <= m.end; h++) {
      const E = n[h % o];
      b = Ro(s.setContext(Ln(r, {
        type: "segment",
        p0: p,
        p1: E,
        p0DataIndex: (h - 1) % o,
        p1DataIndex: h % o,
        datasetIndex: u
      }))), OE(b, l) && x(f, h - 1, m.loop, l), p = E, l = b;
    }
    f < h - 1 && x(f, h - 1, m.loop, l);
  }
  return c;
}
function Ro(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function OE(t, e) {
  if (!e)
    return !1;
  const n = [], s = function(r, i) {
    return i0(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(t, s) !== JSON.stringify(e, s);
}
function Dr(t, e, n) {
  return t.options.clip ? t[n] : e[n];
}
function BE(t, e) {
  const { xScale: n, yScale: s } = t;
  return n && s ? {
    left: Dr(n, e, "left"),
    right: Dr(n, e, "right"),
    top: Dr(s, e, "top"),
    bottom: Dr(s, e, "bottom")
  } : e;
}
function kf(t, e) {
  const n = e._clip;
  if (n.disabled)
    return !1;
  const s = BE(e, t.chartArea);
  return {
    left: n.left === !1 ? 0 : s.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? t.width : s.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : s.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? t.height : s.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class kE {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, s, r) {
    const i = n.listeners[r], u = n.duration;
    i.forEach((a) => a({
      chart: e,
      initial: n.initial,
      numSteps: u,
      currentStep: Math.min(s - n.start, u)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = pf.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((s, r) => {
      if (!s.running || !s.items.length)
        return;
      const i = s.items;
      let u = i.length - 1, a = !1, o;
      for (; u >= 0; --u)
        o = i[u], o._active ? (o._total > s.duration && (s.duration = o._total), o.tick(e), a = !0) : (i[u] = i[i.length - 1], i.pop());
      a && (r.draw(), this._notify(r, s, e, "progress")), i.length || (s.running = !1, this._notify(r, s, e, "complete"), s.initial = !1), n += i.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let s = n.get(e);
    return s || (s = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, s)), s;
  }
  listen(e, n, s) {
    this._getAnims(e).listeners[n].push(s);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((s, r) => Math.max(s, r._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const s = n.items;
    let r = s.length - 1;
    for (; r >= 0; --r)
      s[r].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var Wt = /* @__PURE__ */ new kE();
const Po = "transparent", LE = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const s = vo(t || Po), r = s.valid && vo(e || Po);
    return r && r.valid ? r.mix(s, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class ME {
  constructor(e, n, s, r) {
    const i = n[s];
    r = Ar([
      e.to,
      r,
      i,
      e.from
    ]);
    const u = Ar([
      e.from,
      i,
      r
    ]);
    this._active = !0, this._fn = e.fn || LE[e.type || typeof u], this._easing = Hs[e.easing] || Hs.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = s, this._from = u, this._to = r, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, s) {
    if (this._active) {
      this._notify(!1);
      const r = this._target[this._prop], i = s - this._start, u = this._duration - i;
      this._start = s, this._duration = Math.floor(Math.max(u, e.duration)), this._total += i, this._loop = !!e.loop, this._to = Ar([
        e.to,
        n,
        r,
        e.from
      ]), this._from = Ar([
        e.from,
        r,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, s = this._duration, r = this._prop, i = this._from, u = this._loop, a = this._to;
    let o;
    if (this._active = i !== a && (u || n < s), !this._active) {
      this._target[r] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[r] = i;
      return;
    }
    o = n / s % 2, o = u && o > 1 ? 2 - o : o, o = this._easing(Math.min(1, Math.max(0, o))), this._target[r] = this._fn(i, a, o);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, s) => {
      e.push({
        res: n,
        rej: s
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", s = this._promises || [];
    for (let r = 0; r < s.length; r++)
      s[r][n]();
  }
}
class Lf {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!be(e))
      return;
    const n = Object.keys(Be.animation), s = this._properties;
    Object.getOwnPropertyNames(e).forEach((r) => {
      const i = e[r];
      if (!be(i))
        return;
      const u = {};
      for (const a of n)
        u[a] = i[a];
      (Ue(i.properties) && i.properties || [
        r
      ]).forEach((a) => {
        (a === r || !s.has(a)) && s.set(a, u);
      });
    });
  }
  _animateOptions(e, n) {
    const s = n.options, r = PE(e, s);
    if (!r)
      return [];
    const i = this._createAnimations(r, s);
    return s.$shared && RE(e.options.$animations, s).then(() => {
      e.options = s;
    }, () => {
    }), i;
  }
  _createAnimations(e, n) {
    const s = this._properties, r = [], i = e.$animations || (e.$animations = {}), u = Object.keys(n), a = Date.now();
    let o;
    for (o = u.length - 1; o >= 0; --o) {
      const c = u[o];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        r.push(...this._animateOptions(e, n));
        continue;
      }
      const l = n[c];
      let f = i[c];
      const h = s.get(c);
      if (f)
        if (h && f.active()) {
          f.update(h, l, a);
          continue;
        } else
          f.cancel();
      if (!h || !h.duration) {
        e[c] = l;
        continue;
      }
      i[c] = f = new ME(h, e, c, l), r.push(f);
    }
    return r;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const s = this._createAnimations(e, n);
    if (s.length)
      return Wt.add(this._chart, s), !0;
  }
}
function RE(t, e) {
  const n = [], s = Object.keys(e);
  for (let r = 0; r < s.length; r++) {
    const i = t[s[r]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function PE(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function Fo(t, e) {
  const n = t && t.options || {}, s = n.reverse, r = n.min === void 0 ? e : 0, i = n.max === void 0 ? e : 0;
  return {
    start: s ? i : r,
    end: s ? r : i
  };
}
function FE(t, e, n) {
  if (n === !1)
    return !1;
  const s = Fo(t, n), r = Fo(e, n);
  return {
    top: r.end,
    right: s.end,
    bottom: r.start,
    left: s.start
  };
}
function HE(t) {
  let e, n, s, r;
  return be(t) ? (e = t.top, n = t.right, s = t.bottom, r = t.left) : e = n = s = r = t, {
    top: e,
    right: n,
    bottom: s,
    left: r,
    disabled: t === !1
  };
}
function Mf(t, e) {
  const n = [], s = t._getSortedDatasetMetas(e);
  let r, i;
  for (r = 0, i = s.length; r < i; ++r)
    n.push(s[r].index);
  return n;
}
function Ho(t, e, n, s = {}) {
  const r = t.keys, i = s.mode === "single";
  let u, a, o, c;
  if (e === null)
    return;
  let l = !1;
  for (u = 0, a = r.length; u < a; ++u) {
    if (o = +r[u], o === n) {
      if (l = !0, s.all)
        continue;
      break;
    }
    c = t.values[o], Je(c) && (i || e === 0 || es(e) === es(c)) && (e += c);
  }
  return !l && !s.all ? 0 : e;
}
function UE(t, e) {
  const { iScale: n, vScale: s } = e, r = n.axis === "x" ? "x" : "y", i = s.axis === "x" ? "x" : "y", u = Object.keys(t), a = new Array(u.length);
  let o, c, l;
  for (o = 0, c = u.length; o < c; ++o)
    l = u[o], a[o] = {
      [r]: l,
      [i]: t[l]
    };
  return a;
}
function Ji(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function YE(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function qE(t) {
  const { min: e, max: n, minDefined: s, maxDefined: r } = t.getUserBounds();
  return {
    min: s ? e : Number.NEGATIVE_INFINITY,
    max: r ? n : Number.POSITIVE_INFINITY
  };
}
function $E(t, e, n) {
  const s = t[e] || (t[e] = {});
  return s[n] || (s[n] = {});
}
function Uo(t, e, n, s) {
  for (const r of e.getMatchingVisibleMetas(s).reverse()) {
    const i = t[r.index];
    if (n && i > 0 || !n && i < 0)
      return r.index;
  }
  return null;
}
function Yo(t, e) {
  const { chart: n, _cachedMeta: s } = t, r = n._stacks || (n._stacks = {}), { iScale: i, vScale: u, index: a } = s, o = i.axis, c = u.axis, l = YE(i, u, s), f = e.length;
  let h;
  for (let x = 0; x < f; ++x) {
    const m = e[x], { [o]: p, [c]: b } = m, E = m._stacks || (m._stacks = {});
    h = E[c] = $E(r, l, p), h[a] = b, h._top = Uo(h, u, !0, s.type), h._bottom = Uo(h, u, !1, s.type);
    const g = h._visualValues || (h._visualValues = {});
    g[a] = b;
  }
}
function eu(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((s) => n[s].axis === e).shift();
}
function WE(t, e) {
  return Ln(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function zE(t, e, n) {
  return Ln(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function ps(t, e) {
  const n = t.controller.index, s = t.vScale && t.vScale.axis;
  if (s) {
    e = e || t._parsed;
    for (const r of e) {
      const i = r._stacks;
      if (!i || i[s] === void 0 || i[s][n] === void 0)
        return;
      delete i[s][n], i[s]._visualValues !== void 0 && i[s]._visualValues[n] !== void 0 && delete i[s]._visualValues[n];
    }
  }
}
const tu = (t) => t === "reset" || t === "none", qo = (t, e) => e ? t : Object.assign({}, t), VE = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: Mf(n, !0),
  values: null
};
class Rf {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = Ji(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && ps(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, s = this.getDataset(), r = (f, h, x, m) => f === "x" ? h : f === "r" ? m : x, i = n.xAxisID = fe(s.xAxisID, eu(e, "x")), u = n.yAxisID = fe(s.yAxisID, eu(e, "y")), a = n.rAxisID = fe(s.rAxisID, eu(e, "r")), o = n.indexAxis, c = n.iAxisID = r(o, i, u, a), l = n.vAxisID = r(o, u, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(u), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(l);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && yo(this._data, this), e._stacked && ps(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), s = this._data;
    if (be(n)) {
      const r = this._cachedMeta;
      this._data = UE(n, r);
    } else if (s !== n) {
      if (s) {
        yo(s, this);
        const r = this._cachedMeta;
        ps(r), r._parsed = [];
      }
      n && Object.isExtensible(n) && v6(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, s = this.getDataset();
    let r = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Ji(n.vScale, n), n.stack !== s.stack && (r = !0, ps(n), n.stack = s.stack), this._resyncElements(e), (r || i !== n._stacked) && (Yo(this, n._parsed), n._stacked = Ji(n.vScale, n));
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), s = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(s, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: s, _data: r } = this, { iScale: i, _stacked: u } = s, a = i.axis;
    let o = e === 0 && n === r.length ? !0 : s._sorted, c = e > 0 && s._parsed[e - 1], l, f, h;
    if (this._parsing === !1)
      s._parsed = r, s._sorted = !0, h = r;
    else {
      Ue(r[e]) ? h = this.parseArrayData(s, r, e, n) : be(r[e]) ? h = this.parseObjectData(s, r, e, n) : h = this.parsePrimitiveData(s, r, e, n);
      const x = () => f[a] === null || c && f[a] < c[a];
      for (l = 0; l < n; ++l)
        s._parsed[l + e] = f = h[l], o && (x() && (o = !1), c = f);
      s._sorted = o;
    }
    u && Yo(this, h);
  }
  parsePrimitiveData(e, n, s, r) {
    const { iScale: i, vScale: u } = e, a = i.axis, o = u.axis, c = i.getLabels(), l = i === u, f = new Array(r);
    let h, x, m;
    for (h = 0, x = r; h < x; ++h)
      m = h + s, f[h] = {
        [a]: l || i.parse(c[m], m),
        [o]: u.parse(n[m], m)
      };
    return f;
  }
  parseArrayData(e, n, s, r) {
    const { xScale: i, yScale: u } = e, a = new Array(r);
    let o, c, l, f;
    for (o = 0, c = r; o < c; ++o)
      l = o + s, f = n[l], a[o] = {
        x: i.parse(f[0], l),
        y: u.parse(f[1], l)
      };
    return a;
  }
  parseObjectData(e, n, s, r) {
    const { xScale: i, yScale: u } = e, { xAxisKey: a = "x", yAxisKey: o = "y" } = this._parsing, c = new Array(r);
    let l, f, h, x;
    for (l = 0, f = r; l < f; ++l)
      h = l + s, x = n[h], c[l] = {
        x: i.parse(ni(x, a), h),
        y: u.parse(ni(x, o), h)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, s) {
    const r = this.chart, i = this._cachedMeta, u = n[e.axis], a = {
      keys: Mf(r, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return Ho(a, u, i.index, {
      mode: s
    });
  }
  updateRangeFromParsed(e, n, s, r) {
    const i = s[n.axis];
    let u = i === null ? NaN : i;
    const a = r && s._stacks[n.axis];
    r && a && (r.values = a, u = Ho(r, i, this._cachedMeta.index)), e.min = Math.min(e.min, u), e.max = Math.max(e.max, u);
  }
  getMinMax(e, n) {
    const s = this._cachedMeta, r = s._parsed, i = s._sorted && e === s.iScale, u = r.length, a = this._getOtherScale(e), o = VE(n, s, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: l, max: f } = qE(a);
    let h, x;
    function m() {
      x = r[h];
      const p = x[a.axis];
      return !Je(x[e.axis]) || l > p || f < p;
    }
    for (h = 0; h < u && !(!m() && (this.updateRangeFromParsed(c, e, x, o), i)); ++h)
      ;
    if (i) {
      for (h = u - 1; h >= 0; --h)
        if (!m()) {
          this.updateRangeFromParsed(c, e, x, o);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, s = [];
    let r, i, u;
    for (r = 0, i = n.length; r < i; ++r)
      u = n[r][e.axis], Je(u) && s.push(u);
    return s;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, s = n.iScale, r = n.vScale, i = this.getParsed(e);
    return {
      label: s ? "" + s.getLabelForValue(i[s.axis]) : "",
      value: r ? "" + r.getLabelForValue(i[r.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = HE(fe(this.options.clip, FE(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, s = this._cachedMeta, r = s.data || [], i = n.chartArea, u = [], a = this._drawStart || 0, o = this._drawCount || r.length - a, c = this.options.drawActiveElementsOnTop;
    let l;
    for (s.dataset && s.dataset.draw(e, i, a, o), l = a; l < a + o; ++l) {
      const f = r[l];
      f.hidden || (f.active && c ? u.push(f) : f.draw(e, i));
    }
    for (l = 0; l < u.length; ++l)
      u[l].draw(e, i);
  }
  getStyle(e, n) {
    const s = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(s) : this.resolveDataElementOptions(e || 0, s);
  }
  getContext(e, n, s) {
    const r = this.getDataset();
    let i;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const u = this._cachedMeta.data[e];
      i = u.$context || (u.$context = zE(this.getContext(), e, u)), i.parsed = this.getParsed(e), i.raw = r.data[e], i.index = i.dataIndex = e;
    } else
      i = this.$context || (this.$context = WE(this.chart.getContext(), this.index)), i.dataset = r, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = s, i;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", s) {
    const r = n === "active", i = this._cachedDataOpts, u = e + "-" + n, a = i[u], o = this.enableOptionSharing && si(s);
    if (a)
      return qo(a, o);
    const c = this.chart.config, l = c.datasetElementScopeKeys(this._type, e), f = r ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], h = c.getOptionScopes(this.getDataset(), l), x = Object.keys(Be.elements[e]), m = () => this.getContext(s, r, n), p = c.resolveNamedOptions(h, x, m, f);
    return p.$shared && (p.$shared = o, i[u] = Object.freeze(qo(p, o))), p;
  }
  _resolveAnimations(e, n, s) {
    const r = this.chart, i = this._cachedDataOpts, u = `animation-${n}`, a = i[u];
    if (a)
      return a;
    let o;
    if (r.options.animation !== !1) {
      const l = this.chart.config, f = l.datasetAnimationScopeKeys(this._type, n), h = l.getOptionScopes(this.getDataset(), f);
      o = l.createResolver(h, this.getContext(e, s, n));
    }
    const c = new Lf(r, o && o.animations);
    return o && o._cacheable && (i[u] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || tu(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const s = this.resolveDataElementOptions(e, n), r = this._sharedOptions, i = this.getSharedOptions(s), u = this.includeOptions(n, i) || i !== r;
    return this.updateSharedOptions(i, n, s), {
      sharedOptions: i,
      includeOptions: u
    };
  }
  updateElement(e, n, s, r) {
    tu(r) ? Object.assign(e, s) : this._resolveAnimations(n, r).update(e, s);
  }
  updateSharedOptions(e, n, s) {
    e && !tu(n) && this._resolveAnimations(void 0, n).update(e, s);
  }
  _setStyle(e, n, s, r) {
    e.active = r;
    const i = this.getStyle(n, r);
    this._resolveAnimations(n, s, r).update(e, {
      options: !r && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(e, n, s) {
    this._setStyle(e, s, "active", !1);
  }
  setHoverStyle(e, n, s) {
    this._setStyle(e, s, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, s = this._cachedMeta.data;
    for (const [a, o, c] of this._syncList)
      this[a](o, c);
    this._syncList = [];
    const r = s.length, i = n.length, u = Math.min(i, r);
    u && this.parse(0, u), i > r ? this._insertElements(r, i - r, e) : i < r && this._removeElements(i, r - i);
  }
  _insertElements(e, n, s = !0) {
    const r = this._cachedMeta, i = r.data, u = e + n;
    let a;
    const o = (c) => {
      for (c.length += n, a = c.length - 1; a >= u; a--)
        c[a] = c[a - n];
    };
    for (o(i), a = e; a < u; ++a)
      i[a] = new this.dataElementType();
    this._parsing && o(r._parsed), this.parse(e, n), s && this.updateElements(i, e, n, "reset");
  }
  updateElements(e, n, s, r) {
  }
  _removeElements(e, n) {
    const s = this._cachedMeta;
    if (this._parsing) {
      const r = s._parsed.splice(e, n);
      s._stacked && ps(s, r);
    }
    s.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, s, r] = e;
      this[n](s, r);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const s = arguments.length - 2;
    s && this._sync([
      "_insertElements",
      e,
      s
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
class jE extends Rf {
  static id = "line";
  static defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: !0,
    spanGaps: !1
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category"
      },
      _value_: {
        type: "linear"
      }
    }
  };
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: s, data: r = [], _dataset: i } = n, u = this.chart._animationsDisabled;
    let { start: a, count: o } = I6(n, r, u);
    this._drawStart = a, this._drawCount = o, O6(n) && (a = 0, o = r.length), s._chart = this.chart, s._datasetIndex = this.index, s._decimated = !!i._decimated, s.points = r;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(s, void 0, {
      animated: !u,
      options: c
    }, e), this.updateElements(r, a, o, e);
  }
  updateElements(e, n, s, r) {
    const i = r === "reset", { iScale: u, vScale: a, _stacked: o, _dataset: c } = this._cachedMeta, { sharedOptions: l, includeOptions: f } = this._getSharedOptions(n, r), h = u.axis, x = a.axis, { spanGaps: m, segment: p } = this.options, b = Ks(m) ? m : Number.POSITIVE_INFINITY, E = this.chart._animationsDisabled || i || r === "none", g = n + s, _ = e.length;
    let T = n > 0 && this.getParsed(n - 1);
    for (let C = 0; C < _; ++C) {
      const y = e[C], v = E ? y : {};
      if (C < n || C >= g) {
        v.skip = !0;
        continue;
      }
      const N = this.getParsed(C), O = Ae(N[x]), w = v[h] = u.getPixelForValue(N[h], C), S = v[x] = i || O ? a.getBasePixel() : a.getPixelForValue(o ? this.applyStack(a, N, o) : N[x], C);
      v.skip = isNaN(w) || isNaN(S) || O, v.stop = C > 0 && Math.abs(N[h] - T[h]) > b, p && (v.parsed = N, v.raw = c.data[C]), f && (v.options = l || this.resolveDataElementOptions(C, y.active ? "active" : r)), E || this.updateElement(y, C, v, r), T = N;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, s = n.options && n.options.borderWidth || 0, r = e.data || [];
    if (!r.length)
      return s;
    const i = r[0].size(this.resolveDataElementOptions(0)), u = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
    return Math.max(s, i, u) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
function mn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class d0 {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(d0.prototype, e);
  }
  options;
  constructor(e) {
    this.options = e || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return mn();
  }
  parse() {
    return mn();
  }
  format() {
    return mn();
  }
  add() {
    return mn();
  }
  diff() {
    return mn();
  }
  startOf() {
    return mn();
  }
  endOf() {
    return mn();
  }
}
var Pf = {
  _date: d0
};
function GE(t, e, n, s) {
  const { controller: r, data: i, _sorted: u } = t, a = r._cachedMeta.iScale, o = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null;
  if (a && e === a.axis && e !== "r" && u && i.length) {
    const c = a._reversePixels ? C6 : An;
    if (s) {
      if (r._sharedOptions) {
        const l = i[0], f = typeof l.getRange == "function" && l.getRange(e);
        if (f) {
          const h = c(i, e, n - f), x = c(i, e, n + f);
          return {
            lo: h.lo,
            hi: x.hi
          };
        }
      }
    } else {
      const l = c(i, e, n);
      if (o) {
        const { vScale: f } = r._cachedMeta, { _parsed: h } = t, x = h.slice(0, l.lo + 1).reverse().findIndex((p) => !Ae(p[f.axis]));
        l.lo -= Math.max(0, x);
        const m = h.slice(l.hi).findIndex((p) => !Ae(p[f.axis]));
        l.hi += Math.max(0, m);
      }
      return l;
    }
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function Di(t, e, n, s, r) {
  const i = t.getSortedVisibleDatasetMetas(), u = n[e];
  for (let a = 0, o = i.length; a < o; ++a) {
    const { index: c, data: l } = i[a], { lo: f, hi: h } = GE(i[a], e, u, r);
    for (let x = f; x <= h; ++x) {
      const m = l[x];
      m.skip || s(m, c, x);
    }
  }
}
function XE(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(s, r) {
    const i = e ? Math.abs(s.x - r.x) : 0, u = n ? Math.abs(s.y - r.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(u, 2));
  };
}
function nu(t, e, n, s, r) {
  const i = [];
  return !r && !t.isPointInArea(e) || Di(t, n, e, function(a, o, c) {
    !r && !Zs(a, t.chartArea, 0) || a.inRange(e.x, e.y, s) && i.push({
      element: a,
      datasetIndex: o,
      index: c
    });
  }, !0), i;
}
function QE(t, e, n, s) {
  let r = [];
  function i(u, a, o) {
    const { startAngle: c, endAngle: l } = u.getProps([
      "startAngle",
      "endAngle"
    ], s), { angle: f } = T6(u, {
      x: e.x,
      y: e.y
    });
    xf(f, c, l) && r.push({
      element: u,
      datasetIndex: a,
      index: o
    });
  }
  return Di(t, n, e, i), r;
}
function KE(t, e, n, s, r, i) {
  let u = [];
  const a = XE(n);
  let o = Number.POSITIVE_INFINITY;
  function c(l, f, h) {
    const x = l.inRange(e.x, e.y, r);
    if (s && !x)
      return;
    const m = l.getCenterPoint(r);
    if (!(!!i || t.isPointInArea(m)) && !x)
      return;
    const b = a(e, m);
    b < o ? (u = [
      {
        element: l,
        datasetIndex: f,
        index: h
      }
    ], o = b) : b === o && u.push({
      element: l,
      datasetIndex: f,
      index: h
    });
  }
  return Di(t, n, e, c), u;
}
function su(t, e, n, s, r, i) {
  return !i && !t.isPointInArea(e) ? [] : n === "r" && !s ? QE(t, e, n, r) : KE(t, e, n, s, r, i);
}
function $o(t, e, n, s, r) {
  const i = [], u = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return Di(t, n, e, (o, c, l) => {
    o[u] && o[u](e[n], r) && (i.push({
      element: o,
      datasetIndex: c,
      index: l
    }), a = a || o.inRange(e.x, e.y, r));
  }), s && !a ? [] : i;
}
var ZE = {
  modes: {
    index(t, e, n, s) {
      const r = pn(e, t), i = n.axis || "x", u = n.includeInvisible || !1, a = n.intersect ? nu(t, r, i, s, u) : su(t, r, i, !1, s, u), o = [];
      return a.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const l = a[0].index, f = c.data[l];
        f && !f.skip && o.push({
          element: f,
          datasetIndex: c.index,
          index: l
        });
      }), o) : [];
    },
    dataset(t, e, n, s) {
      const r = pn(e, t), i = n.axis || "xy", u = n.includeInvisible || !1;
      let a = n.intersect ? nu(t, r, i, s, u) : su(t, r, i, !1, s, u);
      if (a.length > 0) {
        const o = a[0].datasetIndex, c = t.getDatasetMeta(o).data;
        a = [];
        for (let l = 0; l < c.length; ++l)
          a.push({
            element: c[l],
            datasetIndex: o,
            index: l
          });
      }
      return a;
    },
    point(t, e, n, s) {
      const r = pn(e, t), i = n.axis || "xy", u = n.includeInvisible || !1;
      return nu(t, r, i, s, u);
    },
    nearest(t, e, n, s) {
      const r = pn(e, t), i = n.axis || "xy", u = n.includeInvisible || !1;
      return su(t, r, i, n.intersect, s, u);
    },
    x(t, e, n, s) {
      const r = pn(e, t);
      return $o(t, r, "x", n.intersect, s);
    },
    y(t, e, n, s) {
      const r = pn(e, t);
      return $o(t, r, "y", n.intersect, s);
    }
  }
};
const Ff = [
  "left",
  "top",
  "right",
  "bottom"
];
function gs(t, e) {
  return t.filter((n) => n.pos === e);
}
function Wo(t, e) {
  return t.filter((n) => Ff.indexOf(n.pos) === -1 && n.box.axis === e);
}
function Es(t, e) {
  return t.sort((n, s) => {
    const r = e ? s : n, i = e ? n : s;
    return r.weight === i.weight ? r.index - i.index : r.weight - i.weight;
  });
}
function JE(t) {
  const e = [];
  let n, s, r, i, u, a;
  for (n = 0, s = (t || []).length; n < s; ++n)
    r = t[n], { position: i, options: { stack: u, stackWeight: a = 1 } } = r, e.push({
      index: n,
      box: r,
      pos: i,
      horizontal: r.isHorizontal(),
      weight: r.weight,
      stack: u && i + u,
      stackWeight: a
    });
  return e;
}
function e4(t) {
  const e = {};
  for (const n of t) {
    const { stack: s, pos: r, stackWeight: i } = n;
    if (!s || !Ff.includes(r))
      continue;
    const u = e[s] || (e[s] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    u.count++, u.weight += i;
  }
  return e;
}
function t4(t, e) {
  const n = e4(t), { vBoxMaxWidth: s, hBoxMaxHeight: r } = e;
  let i, u, a;
  for (i = 0, u = t.length; i < u; ++i) {
    a = t[i];
    const { fullSize: o } = a.box, c = n[a.stack], l = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = l ? l * s : o && e.availableWidth, a.height = r) : (a.width = s, a.height = l ? l * r : o && e.availableHeight);
  }
  return n;
}
function n4(t) {
  const e = JE(t), n = Es(e.filter((c) => c.box.fullSize), !0), s = Es(gs(e, "left"), !0), r = Es(gs(e, "right")), i = Es(gs(e, "top"), !0), u = Es(gs(e, "bottom")), a = Wo(e, "x"), o = Wo(e, "y");
  return {
    fullSize: n,
    leftAndTop: s.concat(i),
    rightAndBottom: r.concat(o).concat(u).concat(a),
    chartArea: gs(e, "chartArea"),
    vertical: s.concat(r).concat(o),
    horizontal: i.concat(u).concat(a)
  };
}
function zo(t, e, n, s) {
  return Math.max(t[n], e[n]) + Math.max(t[s], e[s]);
}
function Hf(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function s4(t, e, n, s) {
  const { pos: r, box: i } = n, u = t.maxPadding;
  if (!be(r)) {
    n.size && (t[r] -= n.size);
    const f = s[n.stack] || {
      size: 0,
      count: 1
    };
    f.size = Math.max(f.size, n.horizontal ? i.height : i.width), n.size = f.size / f.count, t[r] += n.size;
  }
  i.getPadding && Hf(u, i.getPadding());
  const a = Math.max(0, e.outerWidth - zo(u, t, "left", "right")), o = Math.max(0, e.outerHeight - zo(u, t, "top", "bottom")), c = a !== t.w, l = o !== t.h;
  return t.w = a, t.h = o, n.horizontal ? {
    same: c,
    other: l
  } : {
    same: l,
    other: c
  };
}
function r4(t) {
  const e = t.maxPadding;
  function n(s) {
    const r = Math.max(e[s] - t[s], 0);
    return t[s] += r, r;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function i4(t, e) {
  const n = e.maxPadding;
  function s(r) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return r.forEach((u) => {
      i[u] = Math.max(e[u], n[u]);
    }), i;
  }
  return s(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Ns(t, e, n, s) {
  const r = [];
  let i, u, a, o, c, l;
  for (i = 0, u = t.length, c = 0; i < u; ++i) {
    a = t[i], o = a.box, o.update(a.width || e.w, a.height || e.h, i4(a.horizontal, e));
    const { same: f, other: h } = s4(e, n, a, s);
    c |= f && r.length, l = l || h, o.fullSize || r.push(a);
  }
  return c && Ns(r, e, n, s) || l;
}
function vr(t, e, n, s, r) {
  t.top = n, t.left = e, t.right = e + s, t.bottom = n + r, t.width = s, t.height = r;
}
function Vo(t, e, n, s) {
  const r = n.padding;
  let { x: i, y: u } = e;
  for (const a of t) {
    const o = a.box, c = s[a.stack] || {
      placed: 0,
      weight: 1
    }, l = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const f = e.w * l, h = c.size || o.height;
      si(c.start) && (u = c.start), o.fullSize ? vr(o, r.left, u, n.outerWidth - r.right - r.left, h) : vr(o, e.left + c.placed, u, f, h), c.start = u, c.placed += f, u = o.bottom;
    } else {
      const f = e.h * l, h = c.size || o.width;
      si(c.start) && (i = c.start), o.fullSize ? vr(o, i, r.top, h, n.outerHeight - r.bottom - r.top) : vr(o, i, e.top + c.placed, h, f), c.start = i, c.placed += f, i = o.right;
    }
  }
  e.x = i, e.y = u;
}
var Et = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, s) {
    if (!t)
      return;
    const r = _t(t.options.layout.padding), i = Math.max(e - r.width, 0), u = Math.max(n - r.height, 0), a = n4(t.boxes), o = a.vertical, c = a.horizontal;
    Ee(t.boxes, (p) => {
      typeof p.beforeLayout == "function" && p.beforeLayout();
    });
    const l = o.reduce((p, b) => b.box.options && b.box.options.display === !1 ? p : p + 1, 0) || 1, f = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: r,
      availableWidth: i,
      availableHeight: u,
      vBoxMaxWidth: i / 2 / l,
      hBoxMaxHeight: u / 2
    }), h = Object.assign({}, r);
    Hf(h, _t(s));
    const x = Object.assign({
      maxPadding: h,
      w: i,
      h: u,
      x: r.left,
      y: r.top
    }, r), m = t4(o.concat(c), f);
    Ns(a.fullSize, x, f, m), Ns(o, x, f, m), Ns(c, x, f, m) && Ns(o, x, f, m), r4(x), Vo(a.leftAndTop, x, f, m), x.x += x.w, x.y += x.h, Vo(a.rightAndBottom, x, f, m), t.chartArea = {
      left: x.left,
      top: x.top,
      right: x.left + x.w,
      bottom: x.top + x.h,
      height: x.h,
      width: x.w
    }, Ee(a.chartArea, (p) => {
      const b = p.box;
      Object.assign(b, t.chartArea), b.update(x.w, x.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Uf {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, s) {
  }
  removeEventListener(e, n, s) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, s, r) {
    return n = Math.max(0, n || e.width), s = s || e.height, {
      width: n,
      height: Math.max(0, r ? Math.floor(n / r) : s)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class u4 extends Uf {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Rr = "$chartjs", a4 = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, jo = (t) => t === null || t === "";
function o4(t, e) {
  const n = t.style, s = t.getAttribute("height"), r = t.getAttribute("width");
  if (t[Rr] = {
    initial: {
      height: s,
      width: r,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", jo(r)) {
    const i = ko(t, "width");
    i !== void 0 && (t.width = i);
  }
  if (jo(s))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const i = ko(t, "height");
      i !== void 0 && (t.height = i);
    }
  return t;
}
const Yf = TE ? {
  passive: !0
} : !1;
function c4(t, e, n) {
  t && t.addEventListener(e, n, Yf);
}
function l4(t, e, n) {
  t && t.canvas && t.canvas.removeEventListener(e, n, Yf);
}
function d4(t, e) {
  const n = a4[t.type] || t.type, { x: s, y: r } = pn(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: s !== void 0 ? s : null,
    y: r !== void 0 ? r : null
  };
}
function ui(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function f4(t, e, n) {
  const s = t.canvas, r = new MutationObserver((i) => {
    let u = !1;
    for (const a of i)
      u = u || ui(a.addedNodes, s), u = u && !ui(a.removedNodes, s);
    u && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
function h4(t, e, n) {
  const s = t.canvas, r = new MutationObserver((i) => {
    let u = !1;
    for (const a of i)
      u = u || ui(a.removedNodes, s), u = u && !ui(a.addedNodes, s);
    u && n();
  });
  return r.observe(document, {
    childList: !0,
    subtree: !0
  }), r;
}
const er = /* @__PURE__ */ new Map();
let Go = 0;
function qf() {
  const t = window.devicePixelRatio;
  t !== Go && (Go = t, er.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function b4(t, e) {
  er.size || window.addEventListener("resize", qf), er.set(t, e);
}
function x4(t) {
  er.delete(t), er.size || window.removeEventListener("resize", qf);
}
function m4(t, e, n) {
  const s = t.canvas, r = s && l0(s);
  if (!r)
    return;
  const i = gf((a, o) => {
    const c = r.clientWidth;
    n(a, o), c < r.clientWidth && n();
  }, window), u = new ResizeObserver((a) => {
    const o = a[0], c = o.contentRect.width, l = o.contentRect.height;
    c === 0 && l === 0 || i(c, l);
  });
  return u.observe(r), b4(t, i), u;
}
function ru(t, e, n) {
  n && n.disconnect(), e === "resize" && x4(t);
}
function p4(t, e, n) {
  const s = t.canvas, r = gf((i) => {
    t.ctx !== null && n(d4(i, t));
  }, t);
  return c4(s, e, r), r;
}
class g4 extends Uf {
  acquireContext(e, n) {
    const s = e && e.getContext && e.getContext("2d");
    return s && s.canvas === e ? (o4(e, n), s) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[Rr])
      return !1;
    const s = n[Rr].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const u = s[i];
      Ae(u) ? n.removeAttribute(i) : n.setAttribute(i, u);
    });
    const r = s.style || {};
    return Object.keys(r).forEach((i) => {
      n.style[i] = r[i];
    }), n.width = n.width, delete n[Rr], !0;
  }
  addEventListener(e, n, s) {
    this.removeEventListener(e, n);
    const r = e.$proxies || (e.$proxies = {}), u = {
      attach: f4,
      detach: h4,
      resize: m4
    }[n] || p4;
    r[n] = u(e, n, s);
  }
  removeEventListener(e, n) {
    const s = e.$proxies || (e.$proxies = {}), r = s[n];
    if (!r)
      return;
    ({
      attach: ru,
      detach: ru,
      resize: ru
    }[n] || l4)(e, n, r), s[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, s, r) {
    return _E(e, n, s, r);
  }
  isAttached(e) {
    const n = e && l0(e);
    return !!(n && n.isConnected);
  }
}
function E4(t) {
  return !c0() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? u4 : g4;
}
class Mn {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = !1;
  options;
  $animations;
  tooltipPosition(e) {
    const { x: n, y: s } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: s
    };
  }
  hasValue() {
    return Ks(this.x) && Ks(this.y);
  }
  getProps(e, n) {
    const s = this.$animations;
    if (!n || !s)
      return this;
    const r = {};
    return e.forEach((i) => {
      r[i] = s[i] && s[i].active() ? s[i]._to : this[i];
    }), r;
  }
}
function _4(t, e) {
  const n = t.options.ticks, s = T4(t), r = Math.min(n.maxTicksLimit || s, s), i = n.major.enabled ? y4(e) : [], u = i.length, a = i[0], o = i[u - 1], c = [];
  if (u > r)
    return C4(e, c, i, u / r), c;
  const l = A4(i, e, r);
  if (u > 0) {
    let f, h;
    const x = u > 1 ? Math.round((o - a) / (u - 1)) : null;
    for (Sr(e, c, l, Ae(x) ? 0 : a - x, a), f = 0, h = u - 1; f < h; f++)
      Sr(e, c, l, i[f], i[f + 1]);
    return Sr(e, c, l, o, Ae(x) ? e.length : o + x), c;
  }
  return Sr(e, c, l), c;
}
function T4(t) {
  const e = t.options.offset, n = t._tickSize(), s = t._length / n + (e ? 0 : 1), r = t._maxLength / n;
  return Math.floor(Math.min(s, r));
}
function A4(t, e, n) {
  const s = D4(t), r = e.length / n;
  if (!s)
    return Math.max(r, 1);
  const i = m6(s);
  for (let u = 0, a = i.length - 1; u < a; u++) {
    const o = i[u];
    if (o > r)
      return o;
  }
  return Math.max(r, 1);
}
function y4(t) {
  const e = [];
  let n, s;
  for (n = 0, s = t.length; n < s; n++)
    t[n].major && e.push(n);
  return e;
}
function C4(t, e, n, s) {
  let r = 0, i = n[0], u;
  for (s = Math.ceil(s), u = 0; u < t.length; u++)
    u === i && (e.push(t[u]), r++, i = n[r * s]);
}
function Sr(t, e, n, s, r) {
  const i = fe(s, 0), u = Math.min(fe(r, t.length), t.length);
  let a = 0, o, c, l;
  for (n = Math.ceil(n), r && (o = r - s, n = o / Math.floor(o / n)), l = i; l < 0; )
    a++, l = Math.round(i + a * n);
  for (c = Math.max(i, 0); c < u; c++)
    c === l && (e.push(t[c]), a++, l = Math.round(i + a * n));
}
function D4(t) {
  const e = t.length;
  let n, s;
  if (e < 2)
    return !1;
  for (s = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== s)
      return !1;
  return s;
}
const v4 = (t) => t === "left" ? "right" : t === "right" ? "left" : t, Xo = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, Qo = (t, e) => Math.min(e || t, t);
function Ko(t, e) {
  const n = [], s = t.length / e, r = t.length;
  let i = 0;
  for (; i < r; i += s)
    n.push(t[Math.floor(i)]);
  return n;
}
function S4(t, e, n) {
  const s = t.ticks.length, r = Math.min(e, s - 1), i = t._startPixel, u = t._endPixel, a = 1e-6;
  let o = t.getPixelForTick(r), c;
  if (!(n && (s === 1 ? c = Math.max(o - i, u - o) : e === 0 ? c = (t.getPixelForTick(1) - o) / 2 : c = (o - t.getPixelForTick(r - 1)) / 2, o += r < e ? c : -c, o < i - a || o > u + a)))
    return o;
}
function w4(t, e) {
  Ee(t, (n) => {
    const s = n.gc, r = s.length / 2;
    let i;
    if (r > e) {
      for (i = 0; i < r; ++i)
        delete n.data[s[i]];
      s.splice(0, r);
    }
  });
}
function _s(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function Zo(t, e) {
  if (!t.display)
    return 0;
  const n = Ze(t.font, e), s = _t(t.padding);
  return (Ue(t.text) ? t.text.length : 1) * n.lineHeight + s.height;
}
function N4(t, e) {
  return Ln(t, {
    scale: e,
    type: "scale"
  });
}
function I4(t, e, n) {
  return Ln(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function O4(t, e, n) {
  let s = r0(t);
  return (n && e !== "right" || !n && e === "right") && (s = v4(s)), s;
}
function B4(t, e, n, s) {
  const { top: r, left: i, bottom: u, right: a, chart: o } = t, { chartArea: c, scales: l } = o;
  let f = 0, h, x, m;
  const p = u - r, b = a - i;
  if (t.isHorizontal()) {
    if (x = Qe(s, i, a), be(n)) {
      const E = Object.keys(n)[0], g = n[E];
      m = l[E].getPixelForValue(g) + p - e;
    } else n === "center" ? m = (c.bottom + c.top) / 2 + p - e : m = Xo(t, n, e);
    h = a - i;
  } else {
    if (be(n)) {
      const E = Object.keys(n)[0], g = n[E];
      x = l[E].getPixelForValue(g) - b + e;
    } else n === "center" ? x = (c.left + c.right) / 2 - b + e : x = Xo(t, n, e);
    m = Qe(s, u, r), f = n === "left" ? -At : At;
  }
  return {
    titleX: x,
    titleY: m,
    maxWidth: h,
    rotation: f
  };
}
class os extends Mn {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: s, _suggestedMax: r } = this;
    return e = St(e, Number.POSITIVE_INFINITY), n = St(n, Number.NEGATIVE_INFINITY), s = St(s, Number.POSITIVE_INFINITY), r = St(r, Number.NEGATIVE_INFINITY), {
      min: St(e, s),
      max: St(n, r),
      minDefined: Je(e),
      maxDefined: Je(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: s, minDefined: r, maxDefined: i } = this.getUserBounds(), u;
    if (r && i)
      return {
        min: n,
        max: s
      };
    const a = this.getMatchingVisibleMetas();
    for (let o = 0, c = a.length; o < c; ++o)
      u = a[o].controller.getMinMax(this, e), r || (n = Math.min(n, u.min)), i || (s = Math.max(s, u.max));
    return n = i && n > s ? s : n, s = r && n > s ? n : s, {
      min: St(n, St(s, n)),
      max: St(s, St(n, s))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    ye(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, s) {
    const { beginAtZero: r, grace: i, ticks: u } = this.options, a = u.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = s = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, s), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + s.left + s.right : this.height + s.top + s.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Z6(this, i, r), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const o = a < this.ticks.length;
    this._convertTicksToLabels(o ? Ko(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), u.display && (u.autoSkip || u.source === "auto") && (this.ticks = _4(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), o && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, s;
    this.isHorizontal() ? (n = this.left, s = this.right) : (n = this.top, s = this.bottom, e = !e), this._startPixel = n, this._endPixel = s, this._reversePixels = e, this._length = s - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    ye(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    ye(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    ye(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), ye(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    ye(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let s, r, i;
    for (s = 0, r = e.length; s < r; s++)
      i = e[s], i.label = ye(n.callback, [
        i.value,
        s,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    ye(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    ye(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, s = Qo(this.ticks.length, e.ticks.maxTicksLimit), r = n.minRotation || 0, i = n.maxRotation;
    let u = r, a, o, c;
    if (!this._isVisible() || !n.display || r >= i || s <= 1 || !this.isHorizontal()) {
      this.labelRotation = r;
      return;
    }
    const l = this._getLabelSizes(), f = l.widest.width, h = l.highest.height, x = gt(this.chart.width - f, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / s : x / (s - 1), f + 6 > a && (a = x / (s - (e.offset ? 0.5 : 1)), o = this.maxHeight - _s(e.grid) - n.padding - Zo(e.title, this.chart.options.font), c = Math.sqrt(f * f + h * h), u = _6(Math.min(Math.asin(gt((l.highest.height + 6) / a, -1, 1)), Math.asin(gt(o / c, -1, 1)) - Math.asin(gt(h / c, -1, 1)))), u = Math.max(r, Math.min(i, u))), this.labelRotation = u;
  }
  afterCalculateLabelRotation() {
    ye(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    ye(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: s, title: r, grid: i } } = this, u = this._isVisible(), a = this.isHorizontal();
    if (u) {
      const o = Zo(r, n.options.font);
      if (a ? (e.width = this.maxWidth, e.height = _s(i) + o) : (e.height = this.maxHeight, e.width = _s(i) + o), s.display && this.ticks.length) {
        const { first: c, last: l, widest: f, highest: h } = this._getLabelSizes(), x = s.padding * 2, m = Tn(this.labelRotation), p = Math.cos(m), b = Math.sin(m);
        if (a) {
          const E = s.mirror ? 0 : b * f.width + p * h.height;
          e.height = Math.min(this.maxHeight, e.height + E + x);
        } else {
          const E = s.mirror ? 0 : p * f.width + b * h.height;
          e.width = Math.min(this.maxWidth, e.width + E + x);
        }
        this._calculatePadding(c, l, b, p);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, s, r) {
    const { ticks: { align: i, padding: u }, position: a } = this.options, o = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const l = this.getPixelForTick(0) - this.left, f = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, x = 0;
      o ? c ? (h = r * e.width, x = s * n.height) : (h = s * e.height, x = r * n.width) : i === "start" ? x = n.width : i === "end" ? h = e.width : i !== "inner" && (h = e.width / 2, x = n.width / 2), this.paddingLeft = Math.max((h - l + u) * this.width / (this.width - l), 0), this.paddingRight = Math.max((x - f + u) * this.width / (this.width - f), 0);
    } else {
      let l = n.height / 2, f = e.height / 2;
      i === "start" ? (l = 0, f = e.height) : i === "end" && (l = n.height, f = 0), this.paddingTop = l + u, this.paddingBottom = f + u;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    ye(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, s;
    for (n = 0, s = e.length; n < s; n++)
      Ae(e[n].label) && (e.splice(n, 1), s--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let s = this.ticks;
      n < s.length && (s = Ko(s, n)), this._labelSizes = e = this._computeLabelSizes(s, s.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, s) {
    const { ctx: r, _longestTextCache: i } = this, u = [], a = [], o = Math.floor(n / Qo(n, s));
    let c = 0, l = 0, f, h, x, m, p, b, E, g, _, T, C;
    for (f = 0; f < n; f += o) {
      if (m = e[f].label, p = this._resolveTickFontOptions(f), r.font = b = p.string, E = i[b] = i[b] || {
        data: {},
        gc: []
      }, g = p.lineHeight, _ = T = 0, !Ae(m) && !Ue(m))
        _ = wo(r, E.data, E.gc, _, m), T = g;
      else if (Ue(m))
        for (h = 0, x = m.length; h < x; ++h)
          C = m[h], !Ae(C) && !Ue(C) && (_ = wo(r, E.data, E.gc, _, C), T += g);
      u.push(_), a.push(T), c = Math.max(_, c), l = Math.max(T, l);
    }
    w4(i, n);
    const y = u.indexOf(c), v = a.indexOf(l), N = (O) => ({
      width: u[O] || 0,
      height: a[O] || 0
    });
    return {
      first: N(0),
      last: N(n - 1),
      widest: N(y),
      highest: N(v),
      widths: u,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return y6(this._alignToPixels ? xn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const s = n[e];
      return s.$context || (s.$context = I4(this.getContext(), e, s));
    }
    return this.$context || (this.$context = N4(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = Tn(this.labelRotation), s = Math.abs(Math.cos(n)), r = Math.abs(Math.sin(n)), i = this._getLabelSizes(), u = e.autoSkipPadding || 0, a = i ? i.widest.width + u : 0, o = i ? i.highest.height + u : 0;
    return this.isHorizontal() ? o * s > a * r ? a / s : o / r : o * r < a * s ? o / s : a / r;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, s = this.chart, r = this.options, { grid: i, position: u, border: a } = r, o = i.offset, c = this.isHorizontal(), f = this.ticks.length + (o ? 1 : 0), h = _s(i), x = [], m = a.setContext(this.getContext()), p = m.display ? m.width : 0, b = p / 2, E = function(F) {
      return xn(s, F, p);
    };
    let g, _, T, C, y, v, N, O, w, S, B, M;
    if (u === "top")
      g = E(this.bottom), v = this.bottom - h, O = g - b, S = E(e.top) + b, M = e.bottom;
    else if (u === "bottom")
      g = E(this.top), S = e.top, M = E(e.bottom) - b, v = g + b, O = this.top + h;
    else if (u === "left")
      g = E(this.right), y = this.right - h, N = g - b, w = E(e.left) + b, B = e.right;
    else if (u === "right")
      g = E(this.left), w = e.left, B = E(e.right) - b, y = g + b, N = this.left + h;
    else if (n === "x") {
      if (u === "center")
        g = E((e.top + e.bottom) / 2 + 0.5);
      else if (be(u)) {
        const F = Object.keys(u)[0], V = u[F];
        g = E(this.chart.scales[F].getPixelForValue(V));
      }
      S = e.top, M = e.bottom, v = g + b, O = v + h;
    } else if (n === "y") {
      if (u === "center")
        g = E((e.left + e.right) / 2);
      else if (be(u)) {
        const F = Object.keys(u)[0], V = u[F];
        g = E(this.chart.scales[F].getPixelForValue(V));
      }
      y = g - b, N = y - h, w = e.left, B = e.right;
    }
    const P = fe(r.ticks.maxTicksLimit, f), R = Math.max(1, Math.ceil(f / P));
    for (_ = 0; _ < f; _ += R) {
      const F = this.getContext(_), V = i.setContext(F), W = a.setContext(F), K = V.lineWidth, Q = V.color, L = W.dash || [], Y = W.dashOffset, $ = V.tickWidth, q = V.tickColor, ne = V.tickBorderDash || [], re = V.tickBorderDashOffset;
      T = S4(this, _, o), T !== void 0 && (C = xn(s, T, K), c ? y = N = w = B = C : v = O = S = M = C, x.push({
        tx1: y,
        ty1: v,
        tx2: N,
        ty2: O,
        x1: w,
        y1: S,
        x2: B,
        y2: M,
        width: K,
        color: Q,
        borderDash: L,
        borderDashOffset: Y,
        tickWidth: $,
        tickColor: q,
        tickBorderDash: ne,
        tickBorderDashOffset: re
      }));
    }
    return this._ticksLength = f, this._borderValue = g, x;
  }
  _computeLabelItems(e) {
    const n = this.axis, s = this.options, { position: r, ticks: i } = s, u = this.isHorizontal(), a = this.ticks, { align: o, crossAlign: c, padding: l, mirror: f } = i, h = _s(s.grid), x = h + l, m = f ? -l : x, p = -Tn(this.labelRotation), b = [];
    let E, g, _, T, C, y, v, N, O, w, S, B, M = "middle";
    if (r === "top")
      y = this.bottom - m, v = this._getXAxisLabelAlignment();
    else if (r === "bottom")
      y = this.top + m, v = this._getXAxisLabelAlignment();
    else if (r === "left") {
      const R = this._getYAxisLabelAlignment(h);
      v = R.textAlign, C = R.x;
    } else if (r === "right") {
      const R = this._getYAxisLabelAlignment(h);
      v = R.textAlign, C = R.x;
    } else if (n === "x") {
      if (r === "center")
        y = (e.top + e.bottom) / 2 + x;
      else if (be(r)) {
        const R = Object.keys(r)[0], F = r[R];
        y = this.chart.scales[R].getPixelForValue(F) + x;
      }
      v = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (r === "center")
        C = (e.left + e.right) / 2 - x;
      else if (be(r)) {
        const R = Object.keys(r)[0], F = r[R];
        C = this.chart.scales[R].getPixelForValue(F);
      }
      v = this._getYAxisLabelAlignment(h).textAlign;
    }
    n === "y" && (o === "start" ? M = "top" : o === "end" && (M = "bottom"));
    const P = this._getLabelSizes();
    for (E = 0, g = a.length; E < g; ++E) {
      _ = a[E], T = _.label;
      const R = i.setContext(this.getContext(E));
      N = this.getPixelForTick(E) + i.labelOffset, O = this._resolveTickFontOptions(E), w = O.lineHeight, S = Ue(T) ? T.length : 1;
      const F = S / 2, V = R.color, W = R.textStrokeColor, K = R.textStrokeWidth;
      let Q = v;
      u ? (C = N, v === "inner" && (E === g - 1 ? Q = this.options.reverse ? "left" : "right" : E === 0 ? Q = this.options.reverse ? "right" : "left" : Q = "center"), r === "top" ? c === "near" || p !== 0 ? B = -S * w + w / 2 : c === "center" ? B = -P.highest.height / 2 - F * w + w : B = -P.highest.height + w / 2 : c === "near" || p !== 0 ? B = w / 2 : c === "center" ? B = P.highest.height / 2 - F * w : B = P.highest.height - S * w, f && (B *= -1), p !== 0 && !R.showLabelBackdrop && (C += w / 2 * Math.sin(p))) : (y = N, B = (1 - S) * w / 2);
      let L;
      if (R.showLabelBackdrop) {
        const Y = _t(R.backdropPadding), $ = P.heights[E], q = P.widths[E];
        let ne = B - Y.top, re = 0 - Y.left;
        switch (M) {
          case "middle":
            ne -= $ / 2;
            break;
          case "bottom":
            ne -= $;
            break;
        }
        switch (v) {
          case "center":
            re -= q / 2;
            break;
          case "right":
            re -= q;
            break;
          case "inner":
            E === g - 1 ? re -= q : E > 0 && (re -= q / 2);
            break;
        }
        L = {
          left: re,
          top: ne,
          width: q + Y.width,
          height: $ + Y.height,
          color: R.backdropColor
        };
      }
      b.push({
        label: T,
        font: O,
        textOffset: B,
        options: {
          rotation: p,
          color: V,
          strokeColor: W,
          strokeWidth: K,
          textAlign: Q,
          textBaseline: M,
          translation: [
            C,
            y
          ],
          backdrop: L
        }
      });
    }
    return b;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-Tn(this.labelRotation))
      return e === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: s, mirror: r, padding: i } } = this.options, u = this._getLabelSizes(), a = e + i, o = u.widest.width;
    let c, l;
    return n === "left" ? r ? (l = this.right + i, s === "near" ? c = "left" : s === "center" ? (c = "center", l += o / 2) : (c = "right", l += o)) : (l = this.right - a, s === "near" ? c = "right" : s === "center" ? (c = "center", l -= o / 2) : (c = "left", l = this.left)) : n === "right" ? r ? (l = this.left + i, s === "near" ? c = "right" : s === "center" ? (c = "center", l -= o / 2) : (c = "left", l -= o)) : (l = this.left + a, s === "near" ? c = "left" : s === "center" ? (c = "center", l += o / 2) : (c = "right", l = this.right)) : c = "right", {
      textAlign: c,
      x: l
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: s, top: r, width: i, height: u } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(s, r, i, u), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((i) => i.value === e);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, s = this.ctx, r = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let i, u;
    const a = (o, c, l) => {
      !l.width || !l.color || (s.save(), s.lineWidth = l.width, s.strokeStyle = l.color, s.setLineDash(l.borderDash || []), s.lineDashOffset = l.borderDashOffset, s.beginPath(), s.moveTo(o.x, o.y), s.lineTo(c.x, c.y), s.stroke(), s.restore());
    };
    if (n.display)
      for (i = 0, u = r.length; i < u; ++i) {
        const o = r[i];
        n.drawOnChartArea && a({
          x: o.x1,
          y: o.y1
        }, {
          x: o.x2,
          y: o.y2
        }, o), n.drawTicks && a({
          x: o.tx1,
          y: o.ty1
        }, {
          x: o.tx2,
          y: o.ty2
        }, {
          color: o.tickColor,
          width: o.tickWidth,
          borderDash: o.tickBorderDash,
          borderDashOffset: o.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: s, grid: r } } = this, i = s.setContext(this.getContext()), u = s.display ? i.width : 0;
    if (!u)
      return;
    const a = r.setContext(this.getContext(0)).lineWidth, o = this._borderValue;
    let c, l, f, h;
    this.isHorizontal() ? (c = xn(e, this.left, u) - u / 2, l = xn(e, this.right, a) + a / 2, f = h = o) : (f = xn(e, this.top, u) - u / 2, h = xn(e, this.bottom, a) + a / 2, c = l = o), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, f), n.lineTo(l, h), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const s = this.ctx, r = this._computeLabelArea();
    r && Ai(s, r);
    const i = this.getLabelItems(e);
    for (const u of i) {
      const a = u.options, o = u.font, c = u.label, l = u.textOffset;
      Js(s, c, 0, l, o, a);
    }
    r && yi(s);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: s, reverse: r } } = this;
    if (!s.display)
      return;
    const i = Ze(s.font), u = _t(s.padding), a = s.align;
    let o = i.lineHeight / 2;
    n === "bottom" || n === "center" || be(n) ? (o += u.bottom, Ue(s.text) && (o += i.lineHeight * (s.text.length - 1))) : o += u.top;
    const { titleX: c, titleY: l, maxWidth: f, rotation: h } = B4(this, o, n, a);
    Js(e, s.text, 0, 0, i, {
      color: s.color,
      maxWidth: f,
      rotation: h,
      textAlign: O4(a, n, r),
      textBaseline: "middle",
      translation: [
        c,
        l
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, s = fe(e.grid && e.grid.z, -1), r = fe(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== os.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: s,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: r,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), s = this.axis + "AxisID", r = [];
    let i, u;
    for (i = 0, u = n.length; i < u; ++i) {
      const a = n[i];
      a[s] === this.id && (!e || a.type === e) && r.push(a);
    }
    return r;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return Ze(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class wr {
  constructor(e, n, s) {
    this.type = e, this.scope = n, this.override = s, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let s;
    M4(n) && (s = this.register(n));
    const r = this.items, i = e.id, u = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + e);
    return i in r || (r[i] = e, k4(e, u, s), this.override && Be.override(e.id, e.overrides)), u;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, s = e.id, r = this.scope;
    s in n && delete n[s], r && s in Be[r] && (delete Be[r][s], this.override && delete In[s]);
  }
}
function k4(t, e, n) {
  const s = Qs(/* @__PURE__ */ Object.create(null), [
    n ? Be.get(n) : {},
    Be.get(e),
    t.defaults
  ]);
  Be.set(e, s), t.defaultRoutes && L4(e, t.defaultRoutes), t.descriptors && Be.describe(e, t.descriptors);
}
function L4(t, e) {
  Object.keys(e).forEach((n) => {
    const s = n.split("."), r = s.pop(), i = [
      t
    ].concat(s).join("."), u = e[n].split("."), a = u.pop(), o = u.join(".");
    Be.route(i, r, o, a);
  });
}
function M4(t) {
  return "id" in t && "defaults" in t;
}
class R4 {
  constructor() {
    this.controllers = new wr(Rf, "datasets", !0), this.elements = new wr(Mn, "elements"), this.plugins = new wr(Object, "plugins"), this.scales = new wr(os, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, s) {
    [
      ...n
    ].forEach((r) => {
      const i = s || this._getRegistryForType(r);
      s || i.isForType(r) || i === this.plugins && r.id ? this._exec(e, i, r) : Ee(r, (u) => {
        const a = s || this._getRegistryForType(u);
        this._exec(e, a, u);
      });
    });
  }
  _exec(e, n, s) {
    const r = n0(e);
    ye(s["before" + r], [], s), n[e](s), ye(s["after" + r], [], s);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const s = this._typedRegistries[n];
      if (s.isForType(e))
        return s;
    }
    return this.plugins;
  }
  _get(e, n, s) {
    const r = n.get(e);
    if (r === void 0)
      throw new Error('"' + e + '" is not a registered ' + s + ".");
    return r;
  }
}
var It = /* @__PURE__ */ new R4();
class P4 {
  constructor() {
    this._init = [];
  }
  notify(e, n, s, r) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const i = r ? this._descriptors(e).filter(r) : this._descriptors(e), u = this._notify(i, e, n, s);
    return n === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall")), u;
  }
  _notify(e, n, s, r) {
    r = r || {};
    for (const i of e) {
      const u = i.plugin, a = u[s], o = [
        n,
        r,
        i.options
      ];
      if (ye(a, o, u) === !1 && r.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Ae(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const s = e && e.config, r = fe(s.options && s.options.plugins, {}), i = F4(s);
    return r === !1 && !n ? [] : U4(e, i, r, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], s = this._cache, r = (i, u) => i.filter((a) => !u.some((o) => a.plugin.id === o.plugin.id));
    this._notify(r(n, s), e, "stop"), this._notify(r(s, n), e, "start");
  }
}
function F4(t) {
  const e = {}, n = [], s = Object.keys(It.plugins.items);
  for (let i = 0; i < s.length; i++)
    n.push(It.getPlugin(s[i]));
  const r = t.plugins || [];
  for (let i = 0; i < r.length; i++) {
    const u = r[i];
    n.indexOf(u) === -1 && (n.push(u), e[u.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function H4(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function U4(t, { plugins: e, localIds: n }, s, r) {
  const i = [], u = t.getContext();
  for (const a of e) {
    const o = a.id, c = H4(s[o], r);
    c !== null && i.push({
      plugin: a,
      options: Y4(t.config, {
        plugin: a,
        local: n[o]
      }, c, u)
    });
  }
  return i;
}
function Y4(t, { plugin: e, local: n }, s, r) {
  const i = t.pluginScopeKeys(e), u = t.getOptionScopes(s, i);
  return n && e.defaults && u.push(e.defaults), t.createResolver(u, r, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function xa(t, e) {
  const n = Be.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function q4(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function $4(t, e) {
  return t === e ? "_index_" : "_value_";
}
function Jo(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function W4(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function ma(t, ...e) {
  if (Jo(t))
    return t;
  for (const n of e) {
    const s = n.axis || W4(n.position) || t.length > 1 && Jo(t[0].toLowerCase());
    if (s)
      return s;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function ec(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function z4(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((s) => s.xAxisID === t || s.yAxisID === t);
    if (n.length)
      return ec(t, "x", n[0]) || ec(t, "y", n[0]);
  }
  return {};
}
function V4(t, e) {
  const n = In[t.type] || {
    scales: {}
  }, s = e.scales || {}, r = xa(t.type, e), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(s).forEach((u) => {
    const a = s[u];
    if (!be(a))
      return console.error(`Invalid scale configuration for scale: ${u}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${u}`);
    const o = ma(u, a, z4(u, t), Be.scales[a.type]), c = $4(o, r), l = n.scales || {};
    i[u] = Ps(/* @__PURE__ */ Object.create(null), [
      {
        axis: o
      },
      a,
      l[o],
      l[c]
    ]);
  }), t.data.datasets.forEach((u) => {
    const a = u.type || t.type, o = u.indexAxis || xa(a, e), l = (In[a] || {}).scales || {};
    Object.keys(l).forEach((f) => {
      const h = q4(f, o), x = u[h + "AxisID"] || h;
      i[x] = i[x] || /* @__PURE__ */ Object.create(null), Ps(i[x], [
        {
          axis: h
        },
        s[x],
        l[f]
      ]);
    });
  }), Object.keys(i).forEach((u) => {
    const a = i[u];
    Ps(a, [
      Be.scales[a.type],
      Be.scale
    ]);
  }), i;
}
function $f(t) {
  const e = t.options || (t.options = {});
  e.plugins = fe(e.plugins, {}), e.scales = V4(t, e);
}
function Wf(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function j4(t) {
  return t = t || {}, t.data = Wf(t.data), $f(t), t;
}
const tc = /* @__PURE__ */ new Map(), zf = /* @__PURE__ */ new Set();
function Nr(t, e) {
  let n = tc.get(t);
  return n || (n = e(), tc.set(t, n), zf.add(n)), n;
}
const Ts = (t, e, n) => {
  const s = ni(e, n);
  s !== void 0 && t.add(s);
};
class G4 {
  constructor(e) {
    this._config = j4(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = Wf(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), $f(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return Nr(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return Nr(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return Nr(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, s = this.type;
    return Nr(`${s}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const s = this._scopeCache;
    let r = s.get(e);
    return (!r || n) && (r = /* @__PURE__ */ new Map(), s.set(e, r)), r;
  }
  getOptionScopes(e, n, s) {
    const { options: r, type: i } = this, u = this._cachedScopes(e, s), a = u.get(n);
    if (a)
      return a;
    const o = /* @__PURE__ */ new Set();
    n.forEach((l) => {
      e && (o.add(e), l.forEach((f) => Ts(o, e, f))), l.forEach((f) => Ts(o, r, f)), l.forEach((f) => Ts(o, In[i] || {}, f)), l.forEach((f) => Ts(o, Be, f)), l.forEach((f) => Ts(o, fa, f));
    });
    const c = Array.from(o);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), zf.has(n) && u.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      In[n] || {},
      Be.datasets[n] || {},
      {
        type: n
      },
      Be,
      fa
    ];
  }
  resolveNamedOptions(e, n, s, r = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: u, subPrefixes: a } = nc(this._resolverCache, e, r);
    let o = u;
    if (Q4(u, n)) {
      i.$shared = !1, s = on(s) ? s() : s;
      const c = this.createResolver(e, s, a);
      o = ts(u, s, c);
    }
    for (const c of n)
      i[c] = o[c];
    return i;
  }
  createResolver(e, n, s = [
    ""
  ], r) {
    const { resolver: i } = nc(this._resolverCache, e, s);
    return be(n) ? ts(i, n, void 0, r) : i;
  }
}
function nc(t, e, n) {
  let s = t.get(e);
  s || (s = /* @__PURE__ */ new Map(), t.set(e, s));
  const r = n.join();
  let i = s.get(r);
  return i || (i = {
    resolver: u0(e, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, s.set(r, i)), i;
}
const X4 = (t) => be(t) && Object.getOwnPropertyNames(t).some((e) => on(t[e]));
function Q4(t, e) {
  const { isScriptable: n, isIndexable: s } = yf(t);
  for (const r of e) {
    const i = n(r), u = s(r), a = (u || i) && t[r];
    if (i && (on(a) || X4(a)) || u && Ue(a))
      return !0;
  }
  return !1;
}
var K4 = "4.5.0";
const Z4 = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function sc(t, e) {
  return t === "top" || t === "bottom" || Z4.indexOf(t) === -1 && e === "x";
}
function rc(t, e) {
  return function(n, s) {
    return n[t] === s[t] ? n[e] - s[e] : n[t] - s[t];
  };
}
function ic(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), ye(n && n.onComplete, [
    t
  ], e);
}
function J4(t) {
  const e = t.chart, n = e.options.animation;
  ye(n && n.onProgress, [
    t
  ], e);
}
function Vf(t) {
  return c0() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const Pr = {}, uc = (t) => {
  const e = Vf(t);
  return Object.values(Pr).filter((n) => n.canvas === e).pop();
};
function e8(t, e, n) {
  const s = Object.keys(t);
  for (const r of s) {
    const i = +r;
    if (i >= e) {
      const u = t[r];
      delete t[r], (n > 0 || i > e) && (t[i + n] = u);
    }
  }
}
function t8(t, e, n, s) {
  return !n || t.type === "mouseout" ? null : s ? e : t;
}
let vi = class {
  static defaults = Be;
  static instances = Pr;
  static overrides = In;
  static registry = It;
  static version = K4;
  static getChart = uc;
  static register(...e) {
    It.add(...e), ac();
  }
  static unregister(...e) {
    It.remove(...e), ac();
  }
  constructor(e, n) {
    const s = this.config = new G4(n), r = Vf(e), i = uc(r);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const u = s.createResolver(s.chartOptionScopes(), this.getContext());
    this.platform = new (s.platform || E4(r))(), this.platform.updateConfig(s);
    const a = this.platform.acquireContext(r, u.aspectRatio), o = a && a.canvas, c = o && o.height, l = o && o.width;
    if (this.id = a6(), this.ctx = a, this.canvas = o, this.width = l, this.height = c, this._options = u, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new P4(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = w6((f) => this.update(f), u.resizeDelay || 0), this._dataChanges = [], Pr[this.id] = this, !a || !o) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Wt.listen(this, "complete", ic), Wt.listen(this, "progress", J4), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: s, height: r, _aspectRatio: i } = this;
    return Ae(e) ? n && i ? i : r ? s / r : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return It;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Bo(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return No(this.canvas, this.ctx), this;
  }
  stop() {
    return Wt.stop(this), this;
  }
  resize(e, n) {
    Wt.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const s = this.options, r = this.canvas, i = s.maintainAspectRatio && this.aspectRatio, u = this.platform.getMaximumSize(r, e, n, i), a = s.devicePixelRatio || this.platform.getDevicePixelRatio(), o = this.width ? "resize" : "attach";
    this.width = u.width, this.height = u.height, this._aspectRatio = this.aspectRatio, Bo(this, a, !0) && (this.notifyPlugins("resize", {
      size: u
    }), ye(s.onResize, [
      this,
      u
    ], this), this.attached && this._doResize(o) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Ee(n, (s, r) => {
      s.id = r;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, s = this.scales, r = Object.keys(s).reduce((u, a) => (u[a] = !1, u), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((u) => {
      const a = n[u], o = ma(u, a), c = o === "r", l = o === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : l ? "bottom" : "left",
        dtype: c ? "radialLinear" : l ? "category" : "linear"
      };
    }))), Ee(i, (u) => {
      const a = u.options, o = a.id, c = ma(o, a), l = fe(a.type, u.dtype);
      (a.position === void 0 || sc(a.position, c) !== sc(u.dposition)) && (a.position = u.dposition), r[o] = !0;
      let f = null;
      if (o in s && s[o].type === l)
        f = s[o];
      else {
        const h = It.getScale(l);
        f = new h({
          id: o,
          type: l,
          ctx: this.ctx,
          chart: this
        }), s[f.id] = f;
      }
      f.init(a, e);
    }), Ee(r, (u, a) => {
      u || delete s[a];
    }), Ee(s, (u) => {
      Et.configure(this, u, u.options), Et.addBox(this, u);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, s = e.length;
    if (e.sort((r, i) => r.index - i.index), s > n) {
      for (let r = n; r < s; ++r)
        this._destroyDatasetMeta(r);
      e.splice(n, s - n);
    }
    this._sortedMetasets = e.slice(0).sort(rc("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((s, r) => {
      n.filter((i) => i === s._dataset).length === 0 && this._destroyDatasetMeta(r);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let s, r;
    for (this._removeUnreferencedMetasets(), s = 0, r = n.length; s < r; s++) {
      const i = n[s];
      let u = this.getDatasetMeta(s);
      const a = i.type || this.config.type;
      if (u.type && u.type !== a && (this._destroyDatasetMeta(s), u = this.getDatasetMeta(s)), u.type = a, u.indexAxis = i.indexAxis || xa(a, this.options), u.order = i.order || 0, u.index = s, u.label = "" + i.label, u.visible = this.isDatasetVisible(s), u.controller)
        u.controller.updateIndex(s), u.controller.linkScales();
      else {
        const o = It.getController(a), { datasetElementType: c, dataElementType: l } = Be.datasets[a];
        Object.assign(o, {
          dataElementType: It.getElement(l),
          datasetElementType: c && It.getElement(c)
        }), u.controller = new o(this, s), e.push(u.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    Ee(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const s = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !s.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let u = 0;
    for (let c = 0, l = this.data.datasets.length; c < l; c++) {
      const { controller: f } = this.getDatasetMeta(c), h = !r && i.indexOf(f) === -1;
      f.buildOrUpdateElements(h), u = Math.max(+f.getMaxOverflow(), u);
    }
    u = this._minPadding = s.layout.autoPadding ? u : 0, this._updateLayout(u), r || Ee(i, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(rc("z", "_idx"));
    const { _active: a, _lastEvent: o } = this;
    o ? this._eventHandler(o, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    Ee(this.scales, (e) => {
      Et.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), s = new Set(e.events);
    (!Eo(n, s) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: s, start: r, count: i } of n) {
      const u = s === "_removeElements" ? -i : i;
      e8(e, r, u);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, s = (i) => new Set(e.filter((u) => u[0] === i).map((u, a) => a + "," + u.splice(1).join(","))), r = s(0);
    for (let i = 1; i < n; i++)
      if (!Eo(r, s(i)))
        return;
    return Array.from(r).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Et.update(this, this.width, this.height, e);
    const n = this.chartArea, s = n.width <= 0 || n.height <= 0;
    this._layers = [], Ee(this.boxes, (r) => {
      s && r.position === "chartArea" || (r.configure && r.configure(), this._layers.push(...r._layers()));
    }, this), this._layers.forEach((r, i) => {
      r._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, s = this.data.datasets.length; n < s; ++n)
        this._updateDataset(n, on(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const s = this.getDatasetMeta(e), r = {
      meta: s,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (s.controller._update(n), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (Wt.has(this) ? this.attached && !Wt.running(this) && Wt.start(this) : (this.draw(), ic({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: s, height: r } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(s, r);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, s = [];
    let r, i;
    for (r = 0, i = n.length; r < i; ++r) {
      const u = n[r];
      (!e || u.visible) && s.push(u);
    }
    return s;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, s = {
      meta: e,
      index: e.index,
      cancelable: !0
    }, r = kf(this, e);
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (r && Ai(n, r), e.controller.draw(), r && yi(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(e) {
    return Zs(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, s, r) {
    const i = ZE.modes[n];
    return typeof i == "function" ? i(this, e, s, r) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], s = this._metasets;
    let r = s.filter((i) => i && i._dataset === n).pop();
    return r || (r = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, s.push(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = Ln(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const s = this.getDatasetMeta(e);
    return typeof s.hidden == "boolean" ? !s.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const s = this.getDatasetMeta(e);
    s.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, s) {
    const r = s ? "show" : "hide", i = this.getDatasetMeta(e), u = i.controller._resolveAnimations(void 0, r);
    si(n) ? (i.data[n].hidden = !s, this.update()) : (this.setDatasetVisibility(e, s), u.update(i, {
      visible: s
    }), this.update((a) => a.datasetIndex === e ? r : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), Wt.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), No(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete Pr[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, s = (i, u) => {
      n.addEventListener(this, i, u), e[i] = u;
    }, r = (i, u, a) => {
      i.offsetX = u, i.offsetY = a, this._eventHandler(i);
    };
    Ee(this.options.events, (i) => s(i, r));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, s = (o, c) => {
      n.addEventListener(this, o, c), e[o] = c;
    }, r = (o, c) => {
      e[o] && (n.removeEventListener(this, o, c), delete e[o]);
    }, i = (o, c) => {
      this.canvas && this.resize(o, c);
    };
    let u;
    const a = () => {
      r("attach", a), this.attached = !0, this.resize(), s("resize", i), s("detach", u);
    };
    u = () => {
      this.attached = !1, r("resize", i), this._stop(), this._resize(0, 0), s("attach", a);
    }, n.isAttached(this.canvas) ? a() : u();
  }
  unbindEvents() {
    Ee(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, Ee(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, s) {
    const r = s ? "set" : "remove";
    let i, u, a, o;
    for (n === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + r + "DatasetHoverStyle"]()), a = 0, o = e.length; a < o; ++a) {
      u = e[a];
      const c = u && this.getDatasetMeta(u.datasetIndex).controller;
      c && c[r + "HoverStyle"](u.element, u.datasetIndex, u.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], s = e.map(({ datasetIndex: i, index: u }) => {
      const a = this.getDatasetMeta(i);
      if (!a)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: a.data[u],
        index: u
      };
    });
    !ei(s, n) && (this._active = s, this._lastEvent = null, this._updateHoverStyles(s, n));
  }
  notifyPlugins(e, n, s) {
    return this._plugins.notify(this, e, n, s);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, s) {
    const r = this.options.hover, i = (o, c) => o.filter((l) => !c.some((f) => l.datasetIndex === f.datasetIndex && l.index === f.index)), u = i(n, e), a = s ? e : i(e, n);
    u.length && this.updateHoverStyle(u, r.mode, !1), a.length && r.mode && this.updateHoverStyle(a, r.mode, !0);
  }
  _eventHandler(e, n) {
    const s = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, r = (u) => (u.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", s, r) === !1)
      return;
    const i = this._handleEvent(e, n, s.inChartArea);
    return s.cancelable = !1, this.notifyPlugins("afterEvent", s, r), (i || s.changed) && this.render(), this;
  }
  _handleEvent(e, n, s) {
    const { _active: r = [], options: i } = this, u = n, a = this._getActiveElements(e, r, s, u), o = h6(e), c = t8(e, this._lastEvent, s, o);
    s && (this._lastEvent = null, ye(i.onHover, [
      e,
      a,
      this
    ], this), o && ye(i.onClick, [
      e,
      a,
      this
    ], this));
    const l = !ei(a, r);
    return (l || n) && (this._active = a, this._updateHoverStyles(a, r, n)), this._lastEvent = c, l;
  }
  _getActiveElements(e, n, s, r) {
    if (e.type === "mouseout")
      return [];
    if (!s)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(e, i.mode, i, r);
  }
};
function ac() {
  return Ee(vi.instances, (t) => t._plugins.invalidate());
}
function jf(t, e, n = e) {
  t.lineCap = fe(n.borderCapStyle, e.borderCapStyle), t.setLineDash(fe(n.borderDash, e.borderDash)), t.lineDashOffset = fe(n.borderDashOffset, e.borderDashOffset), t.lineJoin = fe(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = fe(n.borderWidth, e.borderWidth), t.strokeStyle = fe(n.borderColor, e.borderColor);
}
function n8(t, e, n) {
  t.lineTo(n.x, n.y);
}
function s8(t) {
  return t.stepped ? q6 : t.tension || t.cubicInterpolationMode === "monotone" ? $6 : n8;
}
function Gf(t, e, n = {}) {
  const s = t.length, { start: r = 0, end: i = s - 1 } = n, { start: u, end: a } = e, o = Math.max(r, u), c = Math.min(i, a), l = r < u && i < u || r > a && i > a;
  return {
    count: s,
    start: o,
    loop: e.loop,
    ilen: c < o && !l ? s + c - o : c - o
  };
}
function r8(t, e, n, s) {
  const { points: r, options: i } = e, { count: u, start: a, loop: o, ilen: c } = Gf(r, n, s), l = s8(i);
  let { move: f = !0, reverse: h } = s || {}, x, m, p;
  for (x = 0; x <= c; ++x)
    m = r[(a + (h ? c - x : x)) % u], !m.skip && (f ? (t.moveTo(m.x, m.y), f = !1) : l(t, p, m, h, i.stepped), p = m);
  return o && (m = r[(a + (h ? c : 0)) % u], l(t, p, m, h, i.stepped)), !!o;
}
function i8(t, e, n, s) {
  const r = e.points, { count: i, start: u, ilen: a } = Gf(r, n, s), { move: o = !0, reverse: c } = s || {};
  let l = 0, f = 0, h, x, m, p, b, E;
  const g = (T) => (u + (c ? a - T : T)) % i, _ = () => {
    p !== b && (t.lineTo(l, b), t.lineTo(l, p), t.lineTo(l, E));
  };
  for (o && (x = r[g(0)], t.moveTo(x.x, x.y)), h = 0; h <= a; ++h) {
    if (x = r[g(h)], x.skip)
      continue;
    const T = x.x, C = x.y, y = T | 0;
    y === m ? (C < p ? p = C : C > b && (b = C), l = (f * l + T) / ++f) : (_(), t.lineTo(T, C), m = y, f = 0, p = b = C), E = C;
  }
  _();
}
function pa(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? i8 : r8;
}
function u8(t) {
  return t.stepped ? AE : t.tension || t.cubicInterpolationMode === "monotone" ? yE : gn;
}
function a8(t, e, n, s) {
  let r = e._path;
  r || (r = e._path = new Path2D(), e.path(r, n, s) && r.closePath()), jf(t, e.options), t.stroke(r);
}
function o8(t, e, n, s) {
  const { segments: r, options: i } = e, u = pa(e);
  for (const a of r)
    jf(t, i, a.style), t.beginPath(), u(t, e, a, {
      start: n,
      end: n + s - 1
    }) && t.closePath(), t.stroke();
}
const c8 = typeof Path2D == "function";
function l8(t, e, n, s) {
  c8 && !e.options.segment ? a8(t, e, n, s) : o8(t, e, n, s);
}
class Si extends Mn {
  static id = "line";
  static defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: !0,
    cubicInterpolationMode: "default",
    fill: !1,
    spanGaps: !1,
    stepped: !1,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  static descriptors = {
    _scriptable: !0,
    _indexable: (e) => e !== "borderDash" && e !== "fill"
  };
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const s = this.options;
    if ((s.tension || s.cubicInterpolationMode === "monotone") && !s.stepped && !this._pointsUpdated) {
      const r = s.spanGaps ? this._loop : this._fullLoop;
      bE(this._points, s, e, r, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = NE(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, s = e.length;
    return s && n[e[s - 1].end];
  }
  interpolate(e, n) {
    const s = this.options, r = e[n], i = this.points, u = Bf(this, {
      property: n,
      start: r,
      end: r
    });
    if (!u.length)
      return;
    const a = [], o = u8(s);
    let c, l;
    for (c = 0, l = u.length; c < l; ++c) {
      const { start: f, end: h } = u[c], x = i[f], m = i[h];
      if (x === m) {
        a.push(x);
        continue;
      }
      const p = Math.abs((r - x[n]) / (m[n] - x[n])), b = o(x, m, p, s.stepped);
      b[n] = e[n], a.push(b);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(e, n, s) {
    return pa(this)(e, this, n, s);
  }
  path(e, n, s) {
    const r = this.segments, i = pa(this);
    let u = this._loop;
    n = n || 0, s = s || this.points.length - n;
    for (const a of r)
      u &= i(e, this, a, {
        start: n,
        end: n + s - 1
      });
    return !!u;
  }
  draw(e, n, s, r) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (e.save(), l8(e, this, s, r), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
function oc(t, e, n, s) {
  const r = t.options, { [n]: i } = t.getProps([
    n
  ], s);
  return Math.abs(e - i) < r.radius + r.hitRadius;
}
class d8 extends Mn {
  static id = "point";
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(e) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, n, s) {
    const r = this.options, { x: i, y: u } = this.getProps([
      "x",
      "y"
    ], s);
    return Math.pow(e - i, 2) + Math.pow(n - u, 2) < Math.pow(r.hitRadius + r.radius, 2);
  }
  inXRange(e, n) {
    return oc(this, e, "x", n);
  }
  inYRange(e, n) {
    return oc(this, e, "y", n);
  }
  getCenterPoint(e) {
    const { x: n, y: s } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: s
    };
  }
  size(e) {
    e = e || this.options || {};
    let n = e.radius || 0;
    n = Math.max(n, n && e.hoverRadius || 0);
    const s = n && e.borderWidth || 0;
    return (n + s) * 2;
  }
  draw(e, n) {
    const s = this.options;
    this.skip || s.radius < 0.1 || !Zs(this, n, this.size(s) / 2) || (e.strokeStyle = s.borderColor, e.lineWidth = s.borderWidth, e.fillStyle = s.backgroundColor, ha(e, s, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
function f8(t, e, n) {
  const s = t.segments, r = t.points, i = e.points, u = [];
  for (const a of s) {
    let { start: o, end: c } = a;
    c = wi(o, c, r);
    const l = ga(n, r[o], r[c], a.loop);
    if (!e.segments) {
      u.push({
        source: a,
        target: l,
        start: r[o],
        end: r[c]
      });
      continue;
    }
    const f = Bf(e, l);
    for (const h of f) {
      const x = ga(n, i[h.start], i[h.end], h.loop), m = Of(a, r, x);
      for (const p of m)
        u.push({
          source: p,
          target: h,
          start: {
            [n]: cc(l, x, "start", Math.max)
          },
          end: {
            [n]: cc(l, x, "end", Math.min)
          }
        });
    }
  }
  return u;
}
function ga(t, e, n, s) {
  if (s)
    return;
  let r = e[t], i = n[t];
  return t === "angle" && (r = Ot(r), i = Ot(i)), {
    property: t,
    start: r,
    end: i
  };
}
function h8(t, e) {
  const { x: n = null, y: s = null } = t || {}, r = e.points, i = [];
  return e.segments.forEach(({ start: u, end: a }) => {
    a = wi(u, a, r);
    const o = r[u], c = r[a];
    s !== null ? (i.push({
      x: o.x,
      y: s
    }), i.push({
      x: c.x,
      y: s
    })) : n !== null && (i.push({
      x: n,
      y: o.y
    }), i.push({
      x: n,
      y: c.y
    }));
  }), i;
}
function wi(t, e, n) {
  for (; e > t; e--) {
    const s = n[e];
    if (!isNaN(s.x) && !isNaN(s.y))
      break;
  }
  return e;
}
function cc(t, e, n, s) {
  return t && e ? s(t[n], e[n]) : t ? t[n] : e ? e[n] : 0;
}
function Xf(t, e) {
  let n = [], s = !1;
  return Ue(t) ? (s = !0, n = t) : n = h8(t, e), n.length ? new Si({
    points: n,
    options: {
      tension: 0
    },
    _loop: s,
    _fullLoop: s
  }) : null;
}
function lc(t) {
  return t && t.fill !== !1;
}
function b8(t, e, n) {
  let r = t[e].fill;
  const i = [
    e
  ];
  let u;
  if (!n)
    return r;
  for (; r !== !1 && i.indexOf(r) === -1; ) {
    if (!Je(r))
      return r;
    if (u = t[r], !u)
      return !1;
    if (u.visible)
      return r;
    i.push(r), r = u.fill;
  }
  return !1;
}
function x8(t, e, n) {
  const s = E8(t);
  if (be(s))
    return isNaN(s.value) ? !1 : s;
  let r = parseFloat(s);
  return Je(r) && Math.floor(r) === r ? m8(s[0], e, r, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(s) >= 0 && s;
}
function m8(t, e, n, s) {
  return (t === "-" || t === "+") && (n = e + n), n === e || n < 0 || n >= s ? !1 : n;
}
function p8(t, e) {
  let n = null;
  return t === "start" ? n = e.bottom : t === "end" ? n = e.top : be(t) ? n = e.getPixelForValue(t.value) : e.getBasePixel && (n = e.getBasePixel()), n;
}
function g8(t, e, n) {
  let s;
  return t === "start" ? s = n : t === "end" ? s = e.options.reverse ? e.min : e.max : be(t) ? s = t.value : s = e.getBaseValue(), s;
}
function E8(t) {
  const e = t.options, n = e.fill;
  let s = fe(n && n.target, n);
  return s === void 0 && (s = !!e.backgroundColor), s === !1 || s === null ? !1 : s === !0 ? "origin" : s;
}
function _8(t) {
  const { scale: e, index: n, line: s } = t, r = [], i = s.segments, u = s.points, a = T8(e, n);
  a.push(Xf({
    x: null,
    y: e.bottom
  }, s));
  for (let o = 0; o < i.length; o++) {
    const c = i[o];
    for (let l = c.start; l <= c.end; l++)
      A8(r, u[l], a);
  }
  return new Si({
    points: r,
    options: {}
  });
}
function T8(t, e) {
  const n = [], s = t.getMatchingVisibleMetas("line");
  for (let r = 0; r < s.length; r++) {
    const i = s[r];
    if (i.index === e)
      break;
    i.hidden || n.unshift(i.dataset);
  }
  return n;
}
function A8(t, e, n) {
  const s = [];
  for (let r = 0; r < n.length; r++) {
    const i = n[r], { first: u, last: a, point: o } = y8(i, e, "x");
    if (!(!o || u && a)) {
      if (u)
        s.unshift(o);
      else if (t.push(o), !a)
        break;
    }
  }
  t.push(...s);
}
function y8(t, e, n) {
  const s = t.interpolate(e, n);
  if (!s)
    return {};
  const r = s[n], i = t.segments, u = t.points;
  let a = !1, o = !1;
  for (let c = 0; c < i.length; c++) {
    const l = i[c], f = u[l.start][n], h = u[l.end][n];
    if (jn(r, f, h)) {
      a = r === f, o = r === h;
      break;
    }
  }
  return {
    first: a,
    last: o,
    point: s
  };
}
class Qf {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, n, s) {
    const { x: r, y: i, radius: u } = this;
    return n = n || {
      start: 0,
      end: yt
    }, e.arc(r, i, u, n.end, n.start, !0), !s.bounds;
  }
  interpolate(e) {
    const { x: n, y: s, radius: r } = this, i = e.angle;
    return {
      x: n + Math.cos(i) * r,
      y: s + Math.sin(i) * r,
      angle: i
    };
  }
}
function C8(t) {
  const { chart: e, fill: n, line: s } = t;
  if (Je(n))
    return D8(e, n);
  if (n === "stack")
    return _8(t);
  if (n === "shape")
    return !0;
  const r = v8(t);
  return r instanceof Qf ? r : Xf(r, s);
}
function D8(t, e) {
  const n = t.getDatasetMeta(e);
  return n && t.isDatasetVisible(e) ? n.dataset : null;
}
function v8(t) {
  return (t.scale || {}).getPointPositionForValue ? w8(t) : S8(t);
}
function S8(t) {
  const { scale: e = {}, fill: n } = t, s = p8(n, e);
  if (Je(s)) {
    const r = e.isHorizontal();
    return {
      x: r ? s : null,
      y: r ? null : s
    };
  }
  return null;
}
function w8(t) {
  const { scale: e, fill: n } = t, s = e.options, r = e.getLabels().length, i = s.reverse ? e.max : e.min, u = g8(n, e, i), a = [];
  if (s.grid.circular) {
    const o = e.getPointPositionForValue(0, i);
    return new Qf({
      x: o.x,
      y: o.y,
      radius: e.getDistanceFromCenterForValue(u)
    });
  }
  for (let o = 0; o < r; ++o)
    a.push(e.getPointPositionForValue(o, u));
  return a;
}
function iu(t, e, n) {
  const s = C8(e), { chart: r, index: i, line: u, scale: a, axis: o } = e, c = u.options, l = c.fill, f = c.backgroundColor, { above: h = f, below: x = f } = l || {}, m = r.getDatasetMeta(i), p = kf(r, m);
  s && u.points.length && (Ai(t, n), N8(t, {
    line: u,
    target: s,
    above: h,
    below: x,
    area: n,
    scale: a,
    axis: o,
    clip: p
  }), yi(t));
}
function N8(t, e) {
  const { line: n, target: s, above: r, below: i, area: u, scale: a, clip: o } = e, c = n._loop ? "angle" : e.axis;
  t.save();
  let l = i;
  i !== r && (c === "x" ? (dc(t, s, u.top), uu(t, {
    line: n,
    target: s,
    color: r,
    scale: a,
    property: c,
    clip: o
  }), t.restore(), t.save(), dc(t, s, u.bottom)) : c === "y" && (fc(t, s, u.left), uu(t, {
    line: n,
    target: s,
    color: i,
    scale: a,
    property: c,
    clip: o
  }), t.restore(), t.save(), fc(t, s, u.right), l = r)), uu(t, {
    line: n,
    target: s,
    color: l,
    scale: a,
    property: c,
    clip: o
  }), t.restore();
}
function dc(t, e, n) {
  const { segments: s, points: r } = e;
  let i = !0, u = !1;
  t.beginPath();
  for (const a of s) {
    const { start: o, end: c } = a, l = r[o], f = r[wi(o, c, r)];
    i ? (t.moveTo(l.x, l.y), i = !1) : (t.lineTo(l.x, n), t.lineTo(l.x, l.y)), u = !!e.pathSegment(t, a, {
      move: u
    }), u ? t.closePath() : t.lineTo(f.x, n);
  }
  t.lineTo(e.first().x, n), t.closePath(), t.clip();
}
function fc(t, e, n) {
  const { segments: s, points: r } = e;
  let i = !0, u = !1;
  t.beginPath();
  for (const a of s) {
    const { start: o, end: c } = a, l = r[o], f = r[wi(o, c, r)];
    i ? (t.moveTo(l.x, l.y), i = !1) : (t.lineTo(n, l.y), t.lineTo(l.x, l.y)), u = !!e.pathSegment(t, a, {
      move: u
    }), u ? t.closePath() : t.lineTo(n, f.y);
  }
  t.lineTo(n, e.first().y), t.closePath(), t.clip();
}
function uu(t, e) {
  const { line: n, target: s, property: r, color: i, scale: u, clip: a } = e, o = f8(n, s, r);
  for (const { source: c, target: l, start: f, end: h } of o) {
    const { style: { backgroundColor: x = i } = {} } = c, m = s !== !0;
    t.save(), t.fillStyle = x, I8(t, u, a, m && ga(r, f, h)), t.beginPath();
    const p = !!n.pathSegment(t, c);
    let b;
    if (m) {
      p ? t.closePath() : hc(t, s, h, r);
      const E = !!s.pathSegment(t, l, {
        move: p,
        reverse: !0
      });
      b = p && E, b || hc(t, s, f, r);
    }
    t.closePath(), t.fill(b ? "evenodd" : "nonzero"), t.restore();
  }
}
function I8(t, e, n, s) {
  const r = e.chart.chartArea, { property: i, start: u, end: a } = s || {};
  if (i === "x" || i === "y") {
    let o, c, l, f;
    i === "x" ? (o = u, c = r.top, l = a, f = r.bottom) : (o = r.left, c = u, l = r.right, f = a), t.beginPath(), n && (o = Math.max(o, n.left), l = Math.min(l, n.right), c = Math.max(c, n.top), f = Math.min(f, n.bottom)), t.rect(o, c, l - o, f - c), t.clip();
  }
}
function hc(t, e, n, s) {
  const r = e.interpolate(n, s);
  r && t.lineTo(r.x, r.y);
}
var O8 = {
  id: "filler",
  afterDatasetsUpdate(t, e, n) {
    const s = (t.data.datasets || []).length, r = [];
    let i, u, a, o;
    for (u = 0; u < s; ++u)
      i = t.getDatasetMeta(u), a = i.dataset, o = null, a && a.options && a instanceof Si && (o = {
        visible: t.isDatasetVisible(u),
        index: u,
        fill: x8(a, u, s),
        chart: t,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: a
      }), i.$filler = o, r.push(o);
    for (u = 0; u < s; ++u)
      o = r[u], !(!o || o.fill === !1) && (o.fill = b8(r, u, n.propagate));
  },
  beforeDraw(t, e, n) {
    const s = n.drawTime === "beforeDraw", r = t.getSortedVisibleDatasetMetas(), i = t.chartArea;
    for (let u = r.length - 1; u >= 0; --u) {
      const a = r[u].$filler;
      a && (a.line.updateControlPoints(i, a.axis), s && a.fill && iu(t.ctx, a, i));
    }
  },
  beforeDatasetsDraw(t, e, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const s = t.getSortedVisibleDatasetMetas();
    for (let r = s.length - 1; r >= 0; --r) {
      const i = s[r].$filler;
      lc(i) && iu(t.ctx, i, t.chartArea);
    }
  },
  beforeDatasetDraw(t, e, n) {
    const s = e.meta.$filler;
    !lc(s) || n.drawTime !== "beforeDatasetDraw" || iu(t.ctx, s, t.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const bc = (t, e) => {
  let { boxHeight: n = e, boxWidth: s = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), s = t.pointStyleWidth || Math.min(s, e)), {
    boxWidth: s,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, B8 = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class xc extends Mn {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, s) {
    this.maxWidth = e, this.maxHeight = n, this._margins = s, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = ye(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((s) => e.filter(s, this.chart.data))), e.sort && (n = n.sort((s, r) => e.sort(s, r, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const s = e.labels, r = Ze(s.font), i = r.size, u = this._computeTitleHeight(), { boxWidth: a, itemHeight: o } = bc(s, i);
    let c, l;
    n.font = r.string, this.isHorizontal() ? (c = this.maxWidth, l = this._fitRows(u, i, a, o) + 10) : (l = this.maxHeight, c = this._fitCols(u, r, a, o) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(l, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, s, r) {
    const { ctx: i, maxWidth: u, options: { labels: { padding: a } } } = this, o = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], l = r + a;
    let f = e;
    i.textAlign = "left", i.textBaseline = "middle";
    let h = -1, x = -l;
    return this.legendItems.forEach((m, p) => {
      const b = s + n / 2 + i.measureText(m.text).width;
      (p === 0 || c[c.length - 1] + b + 2 * a > u) && (f += l, c[c.length - (p > 0 ? 0 : 1)] = 0, x += l, h++), o[p] = {
        left: 0,
        top: x,
        row: h,
        width: b,
        height: r
      }, c[c.length - 1] += b + a;
    }), f;
  }
  _fitCols(e, n, s, r) {
    const { ctx: i, maxHeight: u, options: { labels: { padding: a } } } = this, o = this.legendHitBoxes = [], c = this.columnSizes = [], l = u - e;
    let f = a, h = 0, x = 0, m = 0, p = 0;
    return this.legendItems.forEach((b, E) => {
      const { itemWidth: g, itemHeight: _ } = k8(s, n, i, b, r);
      E > 0 && x + _ + 2 * a > l && (f += h + a, c.push({
        width: h,
        height: x
      }), m += h + a, p++, h = x = 0), o[E] = {
        left: m,
        top: x,
        col: p,
        width: g,
        height: _
      }, h = Math.max(h, g), x += _ + a;
    }), f += h, c.push({
      width: h,
      height: x
    }), f;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: s, labels: { padding: r }, rtl: i } } = this, u = Xn(i, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, o = Qe(s, this.left + r, this.right - this.lineWidths[a]);
      for (const c of n)
        a !== c.row && (a = c.row, o = Qe(s, this.left + r, this.right - this.lineWidths[a])), c.top += this.top + e + r, c.left = u.leftForLtr(u.x(o), c.width), o += c.width + r;
    } else {
      let a = 0, o = Qe(s, this.top + e + r, this.bottom - this.columnSizes[a].height);
      for (const c of n)
        c.col !== a && (a = c.col, o = Qe(s, this.top + e + r, this.bottom - this.columnSizes[a].height)), c.top = o, c.left += this.left + r, c.left = u.leftForLtr(u.x(c.left), c.width), o += c.height + r;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      Ai(e, this), this._draw(), yi(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: s, ctx: r } = this, { align: i, labels: u } = e, a = Be.color, o = Xn(e.rtl, this.left, this.width), c = Ze(u.font), { padding: l } = u, f = c.size, h = f / 2;
    let x;
    this.drawTitle(), r.textAlign = o.textAlign("left"), r.textBaseline = "middle", r.lineWidth = 0.5, r.font = c.string;
    const { boxWidth: m, boxHeight: p, itemHeight: b } = bc(u, f), E = function(y, v, N) {
      if (isNaN(m) || m <= 0 || isNaN(p) || p < 0)
        return;
      r.save();
      const O = fe(N.lineWidth, 1);
      if (r.fillStyle = fe(N.fillStyle, a), r.lineCap = fe(N.lineCap, "butt"), r.lineDashOffset = fe(N.lineDashOffset, 0), r.lineJoin = fe(N.lineJoin, "miter"), r.lineWidth = O, r.strokeStyle = fe(N.strokeStyle, a), r.setLineDash(fe(N.lineDash, [])), u.usePointStyle) {
        const w = {
          radius: p * Math.SQRT2 / 2,
          pointStyle: N.pointStyle,
          rotation: N.rotation,
          borderWidth: O
        }, S = o.xPlus(y, m / 2), B = v + h;
        Tf(r, w, S, B, u.pointStyleWidth && m);
      } else {
        const w = v + Math.max((f - p) / 2, 0), S = o.leftForLtr(y, m), B = Ys(N.borderRadius);
        r.beginPath(), Object.values(B).some((M) => M !== 0) ? ba(r, {
          x: S,
          y: w,
          w: m,
          h: p,
          radius: B
        }) : r.rect(S, w, m, p), r.fill(), O !== 0 && r.stroke();
      }
      r.restore();
    }, g = function(y, v, N) {
      Js(r, N.text, y, v + b / 2, c, {
        strikethrough: N.hidden,
        textAlign: o.textAlign(N.textAlign)
      });
    }, _ = this.isHorizontal(), T = this._computeTitleHeight();
    _ ? x = {
      x: Qe(i, this.left + l, this.right - s[0]),
      y: this.top + l + T,
      line: 0
    } : x = {
      x: this.left + l,
      y: Qe(i, this.top + T + l, this.bottom - n[0].height),
      line: 0
    }, wf(this.ctx, e.textDirection);
    const C = b + l;
    this.legendItems.forEach((y, v) => {
      r.strokeStyle = y.fontColor, r.fillStyle = y.fontColor;
      const N = r.measureText(y.text).width, O = o.textAlign(y.textAlign || (y.textAlign = u.textAlign)), w = m + h + N;
      let S = x.x, B = x.y;
      o.setWidth(this.width), _ ? v > 0 && S + w + l > this.right && (B = x.y += C, x.line++, S = x.x = Qe(i, this.left + l, this.right - s[x.line])) : v > 0 && B + C > this.bottom && (S = x.x = S + n[x.line].width + l, x.line++, B = x.y = Qe(i, this.top + T + l, this.bottom - n[x.line].height));
      const M = o.x(S);
      if (E(M, B, y), S = N6(O, S + m + h, _ ? S + w : this.right, e.rtl), g(o.x(S), B, y), _)
        x.x += w + l;
      else if (typeof y.text != "string") {
        const P = c.lineHeight;
        x.y += Kf(y, P) + l;
      } else
        x.y += C;
    }), Nf(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, s = Ze(n.font), r = _t(n.padding);
    if (!n.display)
      return;
    const i = Xn(e.rtl, this.left, this.width), u = this.ctx, a = n.position, o = s.size / 2, c = r.top + o;
    let l, f = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), l = this.top + c, f = Qe(e.align, f, this.right - h);
    else {
      const m = this.columnSizes.reduce((p, b) => Math.max(p, b.height), 0);
      l = c + Qe(e.align, this.top, this.bottom - m - e.labels.padding - this._computeTitleHeight());
    }
    const x = Qe(a, f, f + h);
    u.textAlign = i.textAlign(r0(a)), u.textBaseline = "middle", u.strokeStyle = n.color, u.fillStyle = n.color, u.font = s.string, Js(u, n.text, x, l, s);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = Ze(e.font), s = _t(e.padding);
    return e.display ? n.lineHeight + s.height : 0;
  }
  _getLegendItemAt(e, n) {
    let s, r, i;
    if (jn(e, this.left, this.right) && jn(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, s = 0; s < i.length; ++s)
        if (r = i[s], jn(e, r.left, r.left + r.width) && jn(n, r.top, r.top + r.height))
          return this.legendItems[s];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!R8(e.type, n))
      return;
    const s = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const r = this._hoveredItem, i = B8(r, s);
      r && !i && ye(n.onLeave, [
        e,
        r,
        this
      ], this), this._hoveredItem = s, s && !i && ye(n.onHover, [
        e,
        s,
        this
      ], this);
    } else s && ye(n.onClick, [
      e,
      s,
      this
    ], this);
  }
}
function k8(t, e, n, s, r) {
  const i = L8(s, t, e, n), u = M8(r, s, e.lineHeight);
  return {
    itemWidth: i,
    itemHeight: u
  };
}
function L8(t, e, n, s) {
  let r = t.text;
  return r && typeof r != "string" && (r = r.reduce((i, u) => i.length > u.length ? i : u)), e + n.size / 2 + s.measureText(r).width;
}
function M8(t, e, n) {
  let s = t;
  return typeof e.text != "string" && (s = Kf(e, n)), s;
}
function Kf(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function R8(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var P8 = {
  id: "legend",
  _element: xc,
  start(t, e, n) {
    const s = t.legend = new xc({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    Et.configure(t, s, n), Et.addBox(t, s);
  },
  stop(t) {
    Et.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const s = t.legend;
    Et.configure(t, s, n), s.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const s = e.datasetIndex, r = n.chart;
      r.isDatasetVisible(s) ? (r.hide(s), e.hidden = !0) : (r.show(s), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: s, textAlign: r, color: i, useBorderRadius: u, borderRadius: a } } = t.legend.options;
        return t._getSortedDatasetMetas().map((o) => {
          const c = o.controller.getStyle(n ? 0 : void 0), l = _t(c.borderWidth);
          return {
            text: e[o.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !o.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (l.width + l.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: s || c.pointStyle,
            rotation: c.rotation,
            textAlign: r || c.textAlign,
            borderRadius: u && (a || c.borderRadius),
            datasetIndex: o.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
class Zf extends Mn {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n) {
    const s = this.options;
    if (this.left = 0, this.top = 0, !s.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = n;
    const r = Ue(s.text) ? s.text.length : 1;
    this._padding = _t(s.padding);
    const i = r * Ze(s.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: n, left: s, bottom: r, right: i, options: u } = this, a = u.align;
    let o = 0, c, l, f;
    return this.isHorizontal() ? (l = Qe(a, s, i), f = n + e, c = i - s) : (u.position === "left" ? (l = s + e, f = Qe(a, r, n), o = Ve * -0.5) : (l = i - e, f = Qe(a, n, r), o = Ve * 0.5), c = r - n), {
      titleX: l,
      titleY: f,
      maxWidth: c,
      rotation: o
    };
  }
  draw() {
    const e = this.ctx, n = this.options;
    if (!n.display)
      return;
    const s = Ze(n.font), i = s.lineHeight / 2 + this._padding.top, { titleX: u, titleY: a, maxWidth: o, rotation: c } = this._drawArgs(i);
    Js(e, n.text, 0, 0, s, {
      color: n.color,
      maxWidth: o,
      rotation: c,
      textAlign: r0(n.align),
      textBaseline: "middle",
      translation: [
        u,
        a
      ]
    });
  }
}
function F8(t, e) {
  const n = new Zf({
    ctx: t.ctx,
    options: e,
    chart: t
  });
  Et.configure(t, n, e), Et.addBox(t, n), t.titleBlock = n;
}
var H8 = {
  id: "title",
  _element: Zf,
  start(t, e, n) {
    F8(t, n);
  },
  stop(t) {
    const e = t.titleBlock;
    Et.removeBox(t, e), delete t.titleBlock;
  },
  beforeUpdate(t, e, n) {
    const s = t.titleBlock;
    Et.configure(t, s, n), s.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Is = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, s = /* @__PURE__ */ new Set(), r = 0, i = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const a = t[e].element;
      if (a && a.hasValue()) {
        const o = a.tooltipPosition();
        s.add(o.x), r += o.y, ++i;
      }
    }
    return i === 0 || s.size === 0 ? !1 : {
      x: [
        ...s
      ].reduce((a, o) => a + o) / s.size,
      y: r / i
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, s = e.y, r = Number.POSITIVE_INFINITY, i, u, a;
    for (i = 0, u = t.length; i < u; ++i) {
      const o = t[i].element;
      if (o && o.hasValue()) {
        const c = o.getCenterPoint(), l = da(e, c);
        l < r && (r = l, a = o);
      }
    }
    if (a) {
      const o = a.tooltipPosition();
      n = o.x, s = o.y;
    }
    return {
      x: n,
      y: s
    };
  }
};
function Nt(t, e) {
  return e && (Ue(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function zt(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function U8(t, e) {
  const { element: n, datasetIndex: s, index: r } = e, i = t.getDatasetMeta(s).controller, { label: u, value: a } = i.getLabelAndValue(r);
  return {
    chart: t,
    label: u,
    parsed: i.getParsed(r),
    raw: t.data.datasets[s].data[r],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: r,
    datasetIndex: s,
    element: n
  };
}
function mc(t, e) {
  const n = t.chart.ctx, { body: s, footer: r, title: i } = t, { boxWidth: u, boxHeight: a } = e, o = Ze(e.bodyFont), c = Ze(e.titleFont), l = Ze(e.footerFont), f = i.length, h = r.length, x = s.length, m = _t(e.padding);
  let p = m.height, b = 0, E = s.reduce((T, C) => T + C.before.length + C.lines.length + C.after.length, 0);
  if (E += t.beforeBody.length + t.afterBody.length, f && (p += f * c.lineHeight + (f - 1) * e.titleSpacing + e.titleMarginBottom), E) {
    const T = e.displayColors ? Math.max(a, o.lineHeight) : o.lineHeight;
    p += x * T + (E - x) * o.lineHeight + (E - 1) * e.bodySpacing;
  }
  h && (p += e.footerMarginTop + h * l.lineHeight + (h - 1) * e.footerSpacing);
  let g = 0;
  const _ = function(T) {
    b = Math.max(b, n.measureText(T).width + g);
  };
  return n.save(), n.font = c.string, Ee(t.title, _), n.font = o.string, Ee(t.beforeBody.concat(t.afterBody), _), g = e.displayColors ? u + 2 + e.boxPadding : 0, Ee(s, (T) => {
    Ee(T.before, _), Ee(T.lines, _), Ee(T.after, _);
  }), g = 0, n.font = l.string, Ee(t.footer, _), n.restore(), b += m.width, {
    width: b,
    height: p
  };
}
function Y8(t, e) {
  const { y: n, height: s } = e;
  return n < s / 2 ? "top" : n > t.height - s / 2 ? "bottom" : "center";
}
function q8(t, e, n, s) {
  const { x: r, width: i } = s, u = n.caretSize + n.caretPadding;
  if (t === "left" && r + i + u > e.width || t === "right" && r - i - u < 0)
    return !0;
}
function $8(t, e, n, s) {
  const { x: r, width: i } = n, { width: u, chartArea: { left: a, right: o } } = t;
  let c = "center";
  return s === "center" ? c = r <= (a + o) / 2 ? "left" : "right" : r <= i / 2 ? c = "left" : r >= u - i / 2 && (c = "right"), q8(c, t, e, n) && (c = "center"), c;
}
function pc(t, e, n) {
  const s = n.yAlign || e.yAlign || Y8(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || $8(t, e, n, s),
    yAlign: s
  };
}
function W8(t, e) {
  let { x: n, width: s } = t;
  return e === "right" ? n -= s : e === "center" && (n -= s / 2), n;
}
function z8(t, e, n) {
  let { y: s, height: r } = t;
  return e === "top" ? s += n : e === "bottom" ? s -= r + n : s -= r / 2, s;
}
function gc(t, e, n, s) {
  const { caretSize: r, caretPadding: i, cornerRadius: u } = t, { xAlign: a, yAlign: o } = n, c = r + i, { topLeft: l, topRight: f, bottomLeft: h, bottomRight: x } = Ys(u);
  let m = W8(e, a);
  const p = z8(e, o, c);
  return o === "center" ? a === "left" ? m += c : a === "right" && (m -= c) : a === "left" ? m -= Math.max(l, h) + r : a === "right" && (m += Math.max(f, x) + r), {
    x: gt(m, 0, s.width - e.width),
    y: gt(p, 0, s.height - e.height)
  };
}
function Ir(t, e, n) {
  const s = _t(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - s.right : t.x + s.left;
}
function Ec(t) {
  return Nt([], zt(t));
}
function V8(t, e, n) {
  return Ln(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function _c(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Jf = {
  beforeTitle: qt,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, s = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (s > 0 && e.dataIndex < s)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: qt,
  beforeBody: qt,
  beforeLabel: qt,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return Ae(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: qt,
  afterBody: qt,
  beforeFooter: qt,
  footer: qt,
  afterFooter: qt
};
function st(t, e, n, s) {
  const r = t[e].call(n, s);
  return typeof r > "u" ? Jf[e].call(n, s) : r;
}
class Tc extends Mn {
  static positioners = Is;
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, s = this.options.setContext(this.getContext()), r = s.enabled && n.options.animation && s.animations, i = new Lf(this.chart, r);
    return r._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = V8(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: s } = n, r = st(s, "beforeTitle", this, e), i = st(s, "title", this, e), u = st(s, "afterTitle", this, e);
    let a = [];
    return a = Nt(a, zt(r)), a = Nt(a, zt(i)), a = Nt(a, zt(u)), a;
  }
  getBeforeBody(e, n) {
    return Ec(st(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: s } = n, r = [];
    return Ee(e, (i) => {
      const u = {
        before: [],
        lines: [],
        after: []
      }, a = _c(s, i);
      Nt(u.before, zt(st(a, "beforeLabel", this, i))), Nt(u.lines, st(a, "label", this, i)), Nt(u.after, zt(st(a, "afterLabel", this, i))), r.push(u);
    }), r;
  }
  getAfterBody(e, n) {
    return Ec(st(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: s } = n, r = st(s, "beforeFooter", this, e), i = st(s, "footer", this, e), u = st(s, "afterFooter", this, e);
    let a = [];
    return a = Nt(a, zt(r)), a = Nt(a, zt(i)), a = Nt(a, zt(u)), a;
  }
  _createItems(e) {
    const n = this._active, s = this.chart.data, r = [], i = [], u = [];
    let a = [], o, c;
    for (o = 0, c = n.length; o < c; ++o)
      a.push(U8(this.chart, n[o]));
    return e.filter && (a = a.filter((l, f, h) => e.filter(l, f, h, s))), e.itemSort && (a = a.sort((l, f) => e.itemSort(l, f, s))), Ee(a, (l) => {
      const f = _c(e.callbacks, l);
      r.push(st(f, "labelColor", this, l)), i.push(st(f, "labelPointStyle", this, l)), u.push(st(f, "labelTextColor", this, l));
    }), this.labelColors = r, this.labelPointStyles = i, this.labelTextColors = u, this.dataPoints = a, a;
  }
  update(e, n) {
    const s = this.options.setContext(this.getContext()), r = this._active;
    let i, u = [];
    if (!r.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = Is[s.position].call(this, r, this._eventPosition);
      u = this._createItems(s), this.title = this.getTitle(u, s), this.beforeBody = this.getBeforeBody(u, s), this.body = this.getBody(u, s), this.afterBody = this.getAfterBody(u, s), this.footer = this.getFooter(u, s);
      const o = this._size = mc(this, s), c = Object.assign({}, a, o), l = pc(this.chart, s, c), f = gc(s, c, l, this.chart);
      this.xAlign = l.xAlign, this.yAlign = l.yAlign, i = {
        opacity: 1,
        x: f.x,
        y: f.y,
        width: o.width,
        height: o.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = u, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && s.external && s.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, s, r) {
    const i = this.getCaretPosition(e, s, r);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(e, n, s) {
    const { xAlign: r, yAlign: i } = this, { caretSize: u, cornerRadius: a } = s, { topLeft: o, topRight: c, bottomLeft: l, bottomRight: f } = Ys(a), { x: h, y: x } = e, { width: m, height: p } = n;
    let b, E, g, _, T, C;
    return i === "center" ? (T = x + p / 2, r === "left" ? (b = h, E = b - u, _ = T + u, C = T - u) : (b = h + m, E = b + u, _ = T - u, C = T + u), g = b) : (r === "left" ? E = h + Math.max(o, l) + u : r === "right" ? E = h + m - Math.max(c, f) - u : E = this.caretX, i === "top" ? (_ = x, T = _ - u, b = E - u, g = E + u) : (_ = x + p, T = _ + u, b = E + u, g = E - u), C = _), {
      x1: b,
      x2: E,
      x3: g,
      y1: _,
      y2: T,
      y3: C
    };
  }
  drawTitle(e, n, s) {
    const r = this.title, i = r.length;
    let u, a, o;
    if (i) {
      const c = Xn(s.rtl, this.x, this.width);
      for (e.x = Ir(this, s.titleAlign, s), n.textAlign = c.textAlign(s.titleAlign), n.textBaseline = "middle", u = Ze(s.titleFont), a = s.titleSpacing, n.fillStyle = s.titleColor, n.font = u.string, o = 0; o < i; ++o)
        n.fillText(r[o], c.x(e.x), e.y + u.lineHeight / 2), e.y += u.lineHeight + a, o + 1 === i && (e.y += s.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, n, s, r, i) {
    const u = this.labelColors[s], a = this.labelPointStyles[s], { boxHeight: o, boxWidth: c } = i, l = Ze(i.bodyFont), f = Ir(this, "left", i), h = r.x(f), x = o < l.lineHeight ? (l.lineHeight - o) / 2 : 0, m = n.y + x;
    if (i.usePointStyle) {
      const p = {
        radius: Math.min(c, o) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, b = r.leftForLtr(h, c) + c / 2, E = m + o / 2;
      e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, ha(e, p, b, E), e.strokeStyle = u.borderColor, e.fillStyle = u.backgroundColor, ha(e, p, b, E);
    } else {
      e.lineWidth = be(u.borderWidth) ? Math.max(...Object.values(u.borderWidth)) : u.borderWidth || 1, e.strokeStyle = u.borderColor, e.setLineDash(u.borderDash || []), e.lineDashOffset = u.borderDashOffset || 0;
      const p = r.leftForLtr(h, c), b = r.leftForLtr(r.xPlus(h, 1), c - 2), E = Ys(u.borderRadius);
      Object.values(E).some((g) => g !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, ba(e, {
        x: p,
        y: m,
        w: c,
        h: o,
        radius: E
      }), e.fill(), e.stroke(), e.fillStyle = u.backgroundColor, e.beginPath(), ba(e, {
        x: b,
        y: m + 1,
        w: c - 2,
        h: o - 2,
        radius: E
      }), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(p, m, c, o), e.strokeRect(p, m, c, o), e.fillStyle = u.backgroundColor, e.fillRect(b, m + 1, c - 2, o - 2));
    }
    e.fillStyle = this.labelTextColors[s];
  }
  drawBody(e, n, s) {
    const { body: r } = this, { bodySpacing: i, bodyAlign: u, displayColors: a, boxHeight: o, boxWidth: c, boxPadding: l } = s, f = Ze(s.bodyFont);
    let h = f.lineHeight, x = 0;
    const m = Xn(s.rtl, this.x, this.width), p = function(N) {
      n.fillText(N, m.x(e.x + x), e.y + h / 2), e.y += h + i;
    }, b = m.textAlign(u);
    let E, g, _, T, C, y, v;
    for (n.textAlign = u, n.textBaseline = "middle", n.font = f.string, e.x = Ir(this, b, s), n.fillStyle = s.bodyColor, Ee(this.beforeBody, p), x = a && b !== "right" ? u === "center" ? c / 2 + l : c + 2 + l : 0, T = 0, y = r.length; T < y; ++T) {
      for (E = r[T], g = this.labelTextColors[T], n.fillStyle = g, Ee(E.before, p), _ = E.lines, a && _.length && (this._drawColorBox(n, e, T, m, s), h = Math.max(f.lineHeight, o)), C = 0, v = _.length; C < v; ++C)
        p(_[C]), h = f.lineHeight;
      Ee(E.after, p);
    }
    x = 0, h = f.lineHeight, Ee(this.afterBody, p), e.y -= i;
  }
  drawFooter(e, n, s) {
    const r = this.footer, i = r.length;
    let u, a;
    if (i) {
      const o = Xn(s.rtl, this.x, this.width);
      for (e.x = Ir(this, s.footerAlign, s), e.y += s.footerMarginTop, n.textAlign = o.textAlign(s.footerAlign), n.textBaseline = "middle", u = Ze(s.footerFont), n.fillStyle = s.footerColor, n.font = u.string, a = 0; a < i; ++a)
        n.fillText(r[a], o.x(e.x), e.y + u.lineHeight / 2), e.y += u.lineHeight + s.footerSpacing;
    }
  }
  drawBackground(e, n, s, r) {
    const { xAlign: i, yAlign: u } = this, { x: a, y: o } = e, { width: c, height: l } = s, { topLeft: f, topRight: h, bottomLeft: x, bottomRight: m } = Ys(r.cornerRadius);
    n.fillStyle = r.backgroundColor, n.strokeStyle = r.borderColor, n.lineWidth = r.borderWidth, n.beginPath(), n.moveTo(a + f, o), u === "top" && this.drawCaret(e, n, s, r), n.lineTo(a + c - h, o), n.quadraticCurveTo(a + c, o, a + c, o + h), u === "center" && i === "right" && this.drawCaret(e, n, s, r), n.lineTo(a + c, o + l - m), n.quadraticCurveTo(a + c, o + l, a + c - m, o + l), u === "bottom" && this.drawCaret(e, n, s, r), n.lineTo(a + x, o + l), n.quadraticCurveTo(a, o + l, a, o + l - x), u === "center" && i === "left" && this.drawCaret(e, n, s, r), n.lineTo(a, o + f), n.quadraticCurveTo(a, o, a + f, o), n.closePath(), n.fill(), r.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, s = this.$animations, r = s && s.x, i = s && s.y;
    if (r || i) {
      const u = Is[e.position].call(this, this._active, this._eventPosition);
      if (!u)
        return;
      const a = this._size = mc(this, e), o = Object.assign({}, u, this._size), c = pc(n, e, o), l = gc(e, o, c, n);
      (r._to !== l.x || i._to !== l.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = u.x, this.caretY = u.y, this._resolveAnimations().update(this, l));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let s = this.opacity;
    if (!s)
      return;
    this._updateAnimationTarget(n);
    const r = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    s = Math.abs(s) < 1e-3 ? 0 : s;
    const u = _t(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (e.save(), e.globalAlpha = s, this.drawBackground(i, e, r, n), wf(e, n.textDirection), i.y += u.top, this.drawTitle(i, e, n), this.drawBody(i, e, n), this.drawFooter(i, e, n), Nf(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const s = this._active, r = e.map(({ datasetIndex: a, index: o }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[o],
        index: o
      };
    }), i = !ei(s, r), u = this._positionChanged(r, n);
    (i || u) && (this._active = r, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, s = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const r = this.options, i = this._active || [], u = this._getActiveElements(e, i, n, s), a = this._positionChanged(u, e), o = n || !ei(u, i) || a;
    return o && (this._active = u, (r.enabled || r.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), o;
  }
  _getActiveElements(e, n, s, r) {
    const i = this.options;
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n.filter((a) => this.chart.data.datasets[a.datasetIndex] && this.chart.getDatasetMeta(a.datasetIndex).controller.getParsed(a.index) !== void 0);
    const u = this.chart.getElementsAtEventForMode(e, i.mode, i, s);
    return i.reverse && u.reverse(), u;
  }
  _positionChanged(e, n) {
    const { caretX: s, caretY: r, options: i } = this, u = Is[i.position].call(this, e, n);
    return u !== !1 && (s !== u.x || r !== u.y);
  }
}
var j8 = {
  id: "tooltip",
  _element: Tc,
  positioners: Is,
  afterInit(t, e, n) {
    n && (t.tooltip = new Tc({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Jf
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const G8 = (t, e, n, s) => (typeof e == "string" ? (n = t.push(e) - 1, s.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function X8(t, e, n, s) {
  const r = t.indexOf(e);
  if (r === -1)
    return G8(t, e, n, s);
  const i = t.lastIndexOf(e);
  return r !== i ? n : r;
}
const Q8 = (t, e) => t === null ? null : gt(Math.round(t), 0, e);
function Ac(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class K8 extends os {
  static id = "category";
  static defaults = {
    ticks: {
      callback: Ac
    }
  };
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const s = this.getLabels();
      for (const { index: r, label: i } of n)
        s[r] === i && s.splice(r, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (Ae(e))
      return null;
    const s = this.getLabels();
    return n = isFinite(n) && s[n] === e ? n : X8(s, e, fe(n, e), this._addedLabels), Q8(n, s.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: s, max: r } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (s = 0), n || (r = this.getLabels().length - 1)), this.min = s, this.max = r;
  }
  buildTicks() {
    const e = this.min, n = this.max, s = this.options.offset, r = [];
    let i = this.getLabels();
    i = e === 0 && n === i.length - 1 ? i : i.slice(e, n + 1), this._valueRange = Math.max(i.length - (s ? 0 : 1), 1), this._startValue = this.min - (s ? 0.5 : 0);
    for (let u = e; u <= n; u++)
      r.push({
        value: u
      });
    return r;
  }
  getLabelForValue(e) {
    return Ac.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
function Z8(t, e) {
  const n = [], { bounds: r, step: i, min: u, max: a, precision: o, count: c, maxTicks: l, maxDigits: f, includeBounds: h } = t, x = i || 1, m = l - 1, { min: p, max: b } = e, E = !Ae(u), g = !Ae(a), _ = !Ae(c), T = (b - p) / (f + 1);
  let C = To((b - p) / m / x) * x, y, v, N, O;
  if (C < 1e-14 && !E && !g)
    return [
      {
        value: p
      },
      {
        value: b
      }
    ];
  O = Math.ceil(b / C) - Math.floor(p / C), O > m && (C = To(O * C / m / x) * x), Ae(o) || (y = Math.pow(10, o), C = Math.ceil(C * y) / y), r === "ticks" ? (v = Math.floor(p / C) * C, N = Math.ceil(b / C) * C) : (v = p, N = b), E && g && i && g6((a - u) / i, C / 1e3) ? (O = Math.round(Math.min((a - u) / C, l)), C = (a - u) / O, v = u, N = a) : _ ? (v = E ? u : v, N = g ? a : N, O = c - 1, C = (N - v) / O) : (O = (N - v) / C, Fs(O, Math.round(O), C / 1e3) ? O = Math.round(O) : O = Math.ceil(O));
  const w = Math.max(Ao(C), Ao(v));
  y = Math.pow(10, Ae(o) ? w : o), v = Math.round(v * y) / y, N = Math.round(N * y) / y;
  let S = 0;
  for (E && (h && v !== u ? (n.push({
    value: u
  }), v < u && S++, Fs(Math.round((v + S * C) * y) / y, u, yc(u, T, t)) && S++) : v < u && S++); S < O; ++S) {
    const B = Math.round((v + S * C) * y) / y;
    if (g && B > a)
      break;
    n.push({
      value: B
    });
  }
  return g && h && N !== a ? n.length && Fs(n[n.length - 1].value, a, yc(a, T, t)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!g || N === a) && n.push({
    value: N
  }), n;
}
function yc(t, e, { horizontal: n, minRotation: s }) {
  const r = Tn(s), i = (n ? Math.sin(r) : Math.cos(r)) || 1e-3, u = 0.75 * e * ("" + t).length;
  return Math.min(e / i, u);
}
class J8 extends os {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return Ae(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: s } = this.getUserBounds();
    let { min: r, max: i } = this;
    const u = (o) => r = n ? r : o, a = (o) => i = s ? i : o;
    if (e) {
      const o = es(r), c = es(i);
      o < 0 && c < 0 ? a(0) : o > 0 && c > 0 && u(0);
    }
    if (r === i) {
      let o = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + o), e || u(r - o);
    }
    this.min = r, this.max = i;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: s } = e, r;
    return s ? (r = Math.ceil(this.max / s) - Math.floor(this.min / s) + 1, r > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${s} would result generating up to ${r} ticks. Limiting to 1000.`), r = 1e3)) : (r = this.computeTickLimit(), n = n || 11), n && (r = Math.min(n, r)), r;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let s = this.getTickLimit();
    s = Math.max(2, s);
    const r = {
      maxTicks: s,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, u = Z8(r, i);
    return e.bounds === "ticks" && E6(u, this, "value"), e.reverse ? (u.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), u;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, s = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const r = (s - n) / Math.max(e.length - 1, 1) / 2;
      n -= r, s += r;
    }
    this._startValue = n, this._endValue = s, this._valueRange = s - n;
  }
  getLabelForValue(e) {
    return Ef(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class e_ extends J8 {
  static id = "linear";
  static defaults = {
    ticks: {
      callback: _f.formatters.numeric
    }
  };
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = Je(e) ? e : 0, this.max = Je(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, s = Tn(this.options.ticks.minRotation), r = (e ? Math.sin(s) : Math.cos(s)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / r));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
const Ni = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, at = /* @__PURE__ */ Object.keys(Ni);
function Cc(t, e) {
  return t - e;
}
function Dc(t, e) {
  if (Ae(e))
    return null;
  const n = t._adapter, { parser: s, round: r, isoWeekday: i } = t._parseOpts;
  let u = e;
  return typeof s == "function" && (u = s(u)), Je(u) || (u = typeof s == "string" ? n.parse(u, s) : n.parse(u)), u === null ? null : (r && (u = r === "week" && (Ks(i) || i === !0) ? n.startOf(u, "isoWeek", i) : n.startOf(u, r)), +u);
}
function vc(t, e, n, s) {
  const r = at.length;
  for (let i = at.indexOf(t); i < r - 1; ++i) {
    const u = Ni[at[i]], a = u.steps ? u.steps : Number.MAX_SAFE_INTEGER;
    if (u.common && Math.ceil((n - e) / (a * u.size)) <= s)
      return at[i];
  }
  return at[r - 1];
}
function t_(t, e, n, s, r) {
  for (let i = at.length - 1; i >= at.indexOf(n); i--) {
    const u = at[i];
    if (Ni[u].common && t._adapter.diff(r, s, u) >= e - 1)
      return u;
  }
  return at[n ? at.indexOf(n) : 0];
}
function n_(t) {
  for (let e = at.indexOf(t) + 1, n = at.length; e < n; ++e)
    if (Ni[at[e]].common)
      return at[e];
}
function Sc(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: s, hi: r } = s0(n, e), i = n[s] >= e ? n[s] : n[r];
    t[i] = !0;
  }
}
function s_(t, e, n, s) {
  const r = t._adapter, i = +r.startOf(e[0].value, s), u = e[e.length - 1].value;
  let a, o;
  for (a = i; a <= u; a = +r.add(a, 1, s))
    o = n[a], o >= 0 && (e[o].major = !0);
  return e;
}
function wc(t, e, n) {
  const s = [], r = {}, i = e.length;
  let u, a;
  for (u = 0; u < i; ++u)
    a = e[u], r[a] = u, s.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? s : s_(t, s, r, n);
}
class Ea extends os {
  static id = "time";
  static defaults = {
    bounds: "data",
    adapters: {},
    time: {
      parser: !1,
      unit: !1,
      round: !1,
      isoWeekday: !1,
      minUnit: "millisecond",
      displayFormats: {}
    },
    ticks: {
      source: "auto",
      callback: !1,
      major: {
        enabled: !1
      }
    }
  };
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const s = e.time || (e.time = {}), r = this._adapter = new Pf._date(e.adapters.date);
    r.init(n), Ps(s.displayFormats, r.formats()), this._parseOpts = {
      parser: s.parser,
      round: s.round,
      isoWeekday: s.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : Dc(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, s = e.time.unit || "day";
    let { min: r, max: i, minDefined: u, maxDefined: a } = this.getUserBounds();
    function o(c) {
      !u && !isNaN(c.min) && (r = Math.min(r, c.min)), !a && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!u || !a) && (o(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && o(this.getMinMax(!1))), r = Je(r) && !isNaN(r) ? r : +n.startOf(Date.now(), s), i = Je(i) && !isNaN(i) ? i : +n.endOf(Date.now(), s) + 1, this.min = Math.min(r, i - 1), this.max = Math.max(r + 1, i);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, s = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], s = e[e.length - 1]), {
      min: n,
      max: s
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, s = e.ticks, r = s.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
    const i = this.min, u = this.max, a = D6(r, i, u);
    return this._unit = n.unit || (s.autoSkip ? vc(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : t_(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !s.major.enabled || this._unit === "year" ? void 0 : n_(this._unit), this.initOffsets(r), e.reverse && a.reverse(), wc(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, s = 0, r, i;
    this.options.offset && e.length && (r = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - r : n = (this.getDecimalForValue(e[1]) - r) / 2, i = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? s = i : s = (i - this.getDecimalForValue(e[e.length - 2])) / 2);
    const u = e.length < 3 ? 0.5 : 0.25;
    n = gt(n, 0, u), s = gt(s, 0, u), this._offsets = {
      start: n,
      end: s,
      factor: 1 / (n + 1 + s)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, s = this.max, r = this.options, i = r.time, u = i.unit || vc(i.minUnit, n, s, this._getLabelCapacity(n)), a = fe(r.ticks.stepSize, 1), o = u === "week" ? i.isoWeekday : !1, c = Ks(o) || o === !0, l = {};
    let f = n, h, x;
    if (c && (f = +e.startOf(f, "isoWeek", o)), f = +e.startOf(f, c ? "day" : u), e.diff(s, n, u) > 1e5 * a)
      throw new Error(n + " and " + s + " are too far apart with stepSize of " + a + " " + u);
    const m = r.ticks.source === "data" && this.getDataTimestamps();
    for (h = f, x = 0; h < s; h = +e.add(h, a, u), x++)
      Sc(l, h, m);
    return (h === s || r.bounds === "ticks" || x === 1) && Sc(l, h, m), Object.keys(l).sort(Cc).map((p) => +p);
  }
  getLabelForValue(e) {
    const n = this._adapter, s = this.options.time;
    return s.tooltipFormat ? n.format(e, s.tooltipFormat) : n.format(e, s.displayFormats.datetime);
  }
  format(e, n) {
    const r = this.options.time.displayFormats, i = this._unit, u = n || r[i];
    return this._adapter.format(e, u);
  }
  _tickFormatFunction(e, n, s, r) {
    const i = this.options, u = i.ticks.callback;
    if (u)
      return ye(u, [
        e,
        n,
        s
      ], this);
    const a = i.time.displayFormats, o = this._unit, c = this._majorUnit, l = o && a[o], f = c && a[c], h = s[n], x = c && f && h && h.major;
    return this._adapter.format(e, r || (x ? f : l));
  }
  generateTickLabels(e) {
    let n, s, r;
    for (n = 0, s = e.length; n < s; ++n)
      r = e[n], r.label = this._tickFormatFunction(r.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, s = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + s) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, s = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + s * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, s = this.ctx.measureText(e).width, r = Tn(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(r), u = Math.sin(r), a = this._resolveTickFontOptions(0).size;
    return {
      w: s * i + a * u,
      h: s * u + a * i
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, s = n.displayFormats, r = s[n.unit] || s.millisecond, i = this._tickFormatFunction(e, 0, wc(this, [
      e
    ], this._majorUnit), r), u = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / u.w : this.height / u.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, s;
    if (e.length)
      return e;
    const r = this.getMatchingVisibleMetas();
    if (this._normalized && r.length)
      return this._cache.data = r[0].controller.getAllParsedValues(this);
    for (n = 0, s = r.length; n < s; ++n)
      e = e.concat(r[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, s;
    if (e.length)
      return e;
    const r = this.getLabels();
    for (n = 0, s = r.length; n < s; ++n)
      e.push(Dc(this, r[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return S6(e.sort(Cc));
  }
}
function Or(t, e, n) {
  let s = 0, r = t.length - 1, i, u, a, o;
  n ? (e >= t[s].pos && e <= t[r].pos && ({ lo: s, hi: r } = An(t, "pos", e)), { pos: i, time: a } = t[s], { pos: u, time: o } = t[r]) : (e >= t[s].time && e <= t[r].time && ({ lo: s, hi: r } = An(t, "time", e)), { time: i, pos: a } = t[s], { time: u, pos: o } = t[r]);
  const c = u - i;
  return c ? a + (o - a) * (e - i) / c : a;
}
class YC extends Ea {
  static id = "timeseries";
  static defaults = Ea.defaults;
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = Or(n, this.min), this._tableRange = Or(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: s } = this, r = [], i = [];
    let u, a, o, c, l;
    for (u = 0, a = e.length; u < a; ++u)
      c = e[u], c >= n && c <= s && r.push(c);
    if (r.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: s,
          pos: 1
        }
      ];
    for (u = 0, a = r.length; u < a; ++u)
      l = r[u + 1], o = r[u - 1], c = r[u], Math.round((l + o) / 2) !== c && i.push({
        time: c,
        pos: u / (a - 1)
      });
    return i;
  }
  _generate() {
    const e = this.min, n = this.max;
    let s = super.getDataTimestamps();
    return (!s.includes(e) || !s.length) && s.splice(0, 0, e), (!s.includes(n) || s.length === 1) && s.push(n), s.sort((r, i) => r - i);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), s = this.getLabelTimestamps();
    return n.length && s.length ? e = this.normalize(n.concat(s)) : e = n.length ? n : s, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Or(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, s = this.getDecimalForPixel(e) / n.factor - n.end;
    return Or(this._table, s * this._tableRange + this._minPos, !0);
  }
}
const eh = 6048e5, r_ = 864e5, or = 6e4, cr = 36e5, i_ = 1e3, Nc = Symbol.for("constructDateFrom");
function Ie(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Nc in t ? t[Nc](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function se(t, e) {
  return Ie(e || t, t);
}
function Ii(t, e, n) {
  const s = se(t, n?.in);
  return isNaN(e) ? Ie(n?.in || t, NaN) : (e && s.setDate(s.getDate() + e), s);
}
function f0(t, e, n) {
  const s = se(t, n?.in);
  if (isNaN(e)) return Ie(t, NaN);
  if (!e)
    return s;
  const r = s.getDate(), i = Ie(t, s.getTime());
  i.setMonth(s.getMonth() + e + 1, 0);
  const u = i.getDate();
  return r >= u ? i : (s.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), s);
}
function h0(t, e, n) {
  return Ie(t, +se(t) + e);
}
function u_(t, e, n) {
  return h0(t, e * cr);
}
let a_ = {};
function Rn() {
  return a_;
}
function Ft(t, e) {
  const n = Rn(), s = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = se(t, e?.in), i = r.getDay(), u = (i < s ? 7 : 0) + i - s;
  return r.setDate(r.getDate() - u), r.setHours(0, 0, 0, 0), r;
}
function ss(t, e) {
  return Ft(t, { ...e, weekStartsOn: 1 });
}
function th(t, e) {
  const n = se(t, e?.in), s = n.getFullYear(), r = Ie(n, 0);
  r.setFullYear(s + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = ss(r), u = Ie(n, 0);
  u.setFullYear(s, 0, 4), u.setHours(0, 0, 0, 0);
  const a = ss(u);
  return n.getTime() >= i.getTime() ? s + 1 : n.getTime() >= a.getTime() ? s : s - 1;
}
function ai(t) {
  const e = se(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Pn(t, ...e) {
  const n = Ie.bind(
    null,
    e.find((s) => typeof s == "object")
  );
  return e.map(n);
}
function _a(t, e) {
  const n = se(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function nh(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  ), i = _a(s), u = _a(r), a = +i - ai(i), o = +u - ai(u);
  return Math.round((a - o) / r_);
}
function o_(t, e) {
  const n = th(t, e), s = Ie(t, 0);
  return s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0), ss(s);
}
function c_(t, e, n) {
  const s = se(t, n?.in);
  return s.setTime(s.getTime() + e * or), s;
}
function l_(t, e, n) {
  return f0(t, e * 3, n);
}
function d_(t, e, n) {
  return h0(t, e * 1e3);
}
function f_(t, e, n) {
  return Ii(t, e * 7, n);
}
function h_(t, e, n) {
  return f0(t, e * 12, n);
}
function qs(t, e) {
  const n = +se(t) - +se(e);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function b_(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function sh(t) {
  return !(!b_(t) && typeof t != "number" || isNaN(+se(t)));
}
function x_(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  ), i = s.getFullYear() - r.getFullYear(), u = s.getMonth() - r.getMonth();
  return i * 12 + u;
}
function m_(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  );
  return s.getFullYear() - r.getFullYear();
}
function rh(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  ), i = Ic(s, r), u = Math.abs(
    nh(s, r)
  );
  s.setDate(s.getDate() - i * u);
  const a = +(Ic(s, r) === -i), o = i * (u - a);
  return o === 0 ? 0 : o;
}
function Ic(t, e) {
  const n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function lr(t) {
  return (e) => {
    const s = (t ? Math[t] : Math.trunc)(e);
    return s === 0 ? 0 : s;
  };
}
function p_(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  ), i = (+s - +r) / cr;
  return lr(n?.roundingMethod)(i);
}
function b0(t, e) {
  return +se(t) - +se(e);
}
function g_(t, e, n) {
  const s = b0(t, e) / or;
  return lr(n?.roundingMethod)(s);
}
function ih(t, e) {
  const n = se(t, e?.in);
  return n.setHours(23, 59, 59, 999), n;
}
function uh(t, e) {
  const n = se(t, e?.in), s = n.getMonth();
  return n.setFullYear(n.getFullYear(), s + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function E_(t, e) {
  const n = se(t, e?.in);
  return +ih(n, e) == +uh(n, e);
}
function ah(t, e, n) {
  const [s, r, i] = Pn(
    n?.in,
    t,
    t,
    e
  ), u = qs(r, i), a = Math.abs(
    x_(r, i)
  );
  if (a < 1) return 0;
  r.getMonth() === 1 && r.getDate() > 27 && r.setDate(30), r.setMonth(r.getMonth() - u * a);
  let o = qs(r, i) === -u;
  E_(s) && a === 1 && qs(s, i) === 1 && (o = !1);
  const c = u * (a - +o);
  return c === 0 ? 0 : c;
}
function __(t, e, n) {
  const s = ah(t, e, n) / 3;
  return lr(n?.roundingMethod)(s);
}
function T_(t, e, n) {
  const s = b0(t, e) / 1e3;
  return lr(n?.roundingMethod)(s);
}
function A_(t, e, n) {
  const s = rh(t, e, n) / 7;
  return lr(n?.roundingMethod)(s);
}
function y_(t, e, n) {
  const [s, r] = Pn(
    n?.in,
    t,
    e
  ), i = qs(s, r), u = Math.abs(m_(s, r));
  s.setFullYear(1584), r.setFullYear(1584);
  const a = qs(s, r) === -i, o = i * (u - +a);
  return o === 0 ? 0 : o;
}
function C_(t, e) {
  const n = se(t, e?.in), s = n.getMonth(), r = s - s % 3;
  return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
}
function D_(t, e) {
  const n = se(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function v_(t, e) {
  const n = se(t, e?.in), s = n.getFullYear();
  return n.setFullYear(s + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function oh(t, e) {
  const n = se(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function S_(t, e) {
  const n = se(t, e?.in);
  return n.setMinutes(59, 59, 999), n;
}
function w_(t, e) {
  const n = Rn(), s = n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = se(t, e?.in), i = r.getDay(), u = (i < s ? -7 : 0) + 6 - (i - s);
  return r.setDate(r.getDate() + u), r.setHours(23, 59, 59, 999), r;
}
function N_(t, e) {
  const n = se(t, e?.in);
  return n.setSeconds(59, 999), n;
}
function I_(t, e) {
  const n = se(t, e?.in), s = n.getMonth(), r = s - s % 3 + 3;
  return n.setMonth(r, 0), n.setHours(23, 59, 59, 999), n;
}
function O_(t, e) {
  const n = se(t, e?.in);
  return n.setMilliseconds(999), n;
}
const B_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, k_ = (t, e, n) => {
  let s;
  const r = B_[t];
  return typeof r == "string" ? s = r : e === 1 ? s = r.one : s = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + s : s + " ago" : s;
};
function au(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const L_ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, M_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, R_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, P_ = {
  date: au({
    formats: L_,
    defaultWidth: "full"
  }),
  time: au({
    formats: M_,
    defaultWidth: "full"
  }),
  dateTime: au({
    formats: R_,
    defaultWidth: "full"
  })
}, F_ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, H_ = (t, e, n, s) => F_[t];
function As(t) {
  return (e, n) => {
    const s = n?.context ? String(n.context) : "standalone";
    let r;
    if (s === "formatting" && t.formattingValues) {
      const u = t.defaultFormattingWidth || t.defaultWidth, a = n?.width ? String(n.width) : u;
      r = t.formattingValues[a] || t.formattingValues[u];
    } else {
      const u = t.defaultWidth, a = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[a] || t.values[u];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const U_ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Y_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, q_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, $_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, W_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, z_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, V_ = (t, e) => {
  const n = Number(t), s = n % 100;
  if (s > 20 || s < 10)
    switch (s % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, j_ = {
  ordinalNumber: V_,
  era: As({
    values: U_,
    defaultWidth: "wide"
  }),
  quarter: As({
    values: Y_,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: As({
    values: q_,
    defaultWidth: "wide"
  }),
  day: As({
    values: $_,
    defaultWidth: "wide"
  }),
  dayPeriod: As({
    values: W_,
    defaultWidth: "wide",
    formattingValues: z_,
    defaultFormattingWidth: "wide"
  })
};
function ys(t) {
  return (e, n = {}) => {
    const s = n.width, r = s && t.matchPatterns[s] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const u = i[0], a = s && t.parsePatterns[s] || t.parsePatterns[t.defaultParseWidth], o = Array.isArray(a) ? X_(a, (f) => f.test(u)) : (
      // [TODO] -- I challenge you to fix the type
      G_(a, (f) => f.test(u))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(o) : o, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const l = e.slice(u.length);
    return { value: c, rest: l };
  };
}
function G_(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function X_(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Q_(t) {
  return (e, n = {}) => {
    const s = e.match(t.matchPattern);
    if (!s) return null;
    const r = s[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let u = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    u = n.valueCallback ? n.valueCallback(u) : u;
    const a = e.slice(r.length);
    return { value: u, rest: a };
  };
}
const K_ = /^(\d+)(th|st|nd|rd)?/i, Z_ = /\d+/i, J_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, eT = {
  any: [/^b/i, /^(a|c)/i]
}, tT = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, nT = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sT = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, rT = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iT = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, uT = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aT = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, oT = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cT = {
  ordinalNumber: Q_({
    matchPattern: K_,
    parsePattern: Z_,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: ys({
    matchPatterns: J_,
    defaultMatchWidth: "wide",
    parsePatterns: eT,
    defaultParseWidth: "any"
  }),
  quarter: ys({
    matchPatterns: tT,
    defaultMatchWidth: "wide",
    parsePatterns: nT,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: ys({
    matchPatterns: sT,
    defaultMatchWidth: "wide",
    parsePatterns: rT,
    defaultParseWidth: "any"
  }),
  day: ys({
    matchPatterns: iT,
    defaultMatchWidth: "wide",
    parsePatterns: uT,
    defaultParseWidth: "any"
  }),
  dayPeriod: ys({
    matchPatterns: aT,
    defaultMatchWidth: "any",
    parsePatterns: oT,
    defaultParseWidth: "any"
  })
}, ch = {
  code: "en-US",
  formatDistance: k_,
  formatLong: P_,
  formatRelative: H_,
  localize: j_,
  match: cT,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function lT(t, e) {
  const n = se(t, e?.in);
  return nh(n, oh(n)) + 1;
}
function lh(t, e) {
  const n = se(t, e?.in), s = +ss(n) - +o_(n);
  return Math.round(s / eh) + 1;
}
function x0(t, e) {
  const n = se(t, e?.in), s = n.getFullYear(), r = Rn(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, u = Ie(e?.in || t, 0);
  u.setFullYear(s + 1, 0, i), u.setHours(0, 0, 0, 0);
  const a = Ft(u, e), o = Ie(e?.in || t, 0);
  o.setFullYear(s, 0, i), o.setHours(0, 0, 0, 0);
  const c = Ft(o, e);
  return +n >= +a ? s + 1 : +n >= +c ? s : s - 1;
}
function dT(t, e) {
  const n = Rn(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = x0(t, e), i = Ie(e?.in || t, 0);
  return i.setFullYear(r, 0, s), i.setHours(0, 0, 0, 0), Ft(i, e);
}
function dh(t, e) {
  const n = se(t, e?.in), s = +Ft(n, e) - +dT(n, e);
  return Math.round(s / eh) + 1;
}
function ge(t, e) {
  const n = t < 0 ? "-" : "", s = Math.abs(t).toString().padStart(e, "0");
  return n + s;
}
const Jt = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), s = n > 0 ? n : 1 - n;
    return ge(e === "yy" ? s % 100 : s, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : ge(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return ge(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return ge(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return ge(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return ge(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return ge(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, s = t.getMilliseconds(), r = Math.trunc(
      s * Math.pow(10, n - 3)
    );
    return ge(r, e.length);
  }
}, zn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Oc = {
  // Era
  G: function(t, e, n) {
    const s = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(s, { width: "abbreviated" });
      case "GGGGG":
        return n.era(s, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(s, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const s = t.getFullYear(), r = s > 0 ? s : 1 - s;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Jt.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, s) {
    const r = x0(t, s), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const u = i % 100;
      return ge(u, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : ge(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = th(t);
    return ge(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return ge(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const s = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(s);
      case "QQ":
        return ge(s, 2);
      case "Qo":
        return n.ordinalNumber(s, { unit: "quarter" });
      case "QQQ":
        return n.quarter(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(s, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const s = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(s);
      case "qq":
        return ge(s, 2);
      case "qo":
        return n.ordinalNumber(s, { unit: "quarter" });
      case "qqq":
        return n.quarter(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(s, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const s = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Jt.M(t, e);
      case "Mo":
        return n.ordinalNumber(s + 1, { unit: "month" });
      case "MMM":
        return n.month(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(s, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(s, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const s = t.getMonth();
    switch (e) {
      case "L":
        return String(s + 1);
      case "LL":
        return ge(s + 1, 2);
      case "Lo":
        return n.ordinalNumber(s + 1, { unit: "month" });
      case "LLL":
        return n.month(s, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(s, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(s, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, s) {
    const r = dh(t, s);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : ge(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const s = lh(t);
    return e === "Io" ? n.ordinalNumber(s, { unit: "week" }) : ge(s, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Jt.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const s = lT(t);
    return e === "Do" ? n.ordinalNumber(s, { unit: "dayOfYear" }) : ge(s, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const s = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, s) {
    const r = t.getDay(), i = (r - s.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return ge(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, s) {
    const r = t.getDay(), i = (r - s.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return ge(i, e.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const s = t.getDay(), r = s === 0 ? 7 : s;
    switch (e) {
      case "i":
        return String(r);
      case "ii":
        return ge(r, e.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(s, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(s, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const s = t.getHours();
    let r;
    switch (s === 12 ? r = zn.noon : s === 0 ? r = zn.midnight : r = s / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const s = t.getHours();
    let r;
    switch (s >= 17 ? r = zn.evening : s >= 12 ? r = zn.afternoon : s >= 4 ? r = zn.morning : r = zn.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let s = t.getHours() % 12;
      return s === 0 && (s = 12), n.ordinalNumber(s, { unit: "hour" });
    }
    return Jt.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Jt.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const s = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(s, { unit: "hour" }) : ge(s, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let s = t.getHours();
    return s === 0 && (s = 24), e === "ko" ? n.ordinalNumber(s, { unit: "hour" }) : ge(s, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Jt.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Jt.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Jt.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const s = t.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (e) {
      case "X":
        return kc(s);
      case "XXXX":
      case "XX":
        return En(s);
      case "XXXXX":
      case "XXX":
      default:
        return En(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const s = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return kc(s);
      case "xxxx":
      case "xx":
        return En(s);
      case "xxxxx":
      case "xxx":
      default:
        return En(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const s = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Bc(s, ":");
      case "OOOO":
      default:
        return "GMT" + En(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const s = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Bc(s, ":");
      case "zzzz":
      default:
        return "GMT" + En(s, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const s = Math.trunc(+t / 1e3);
    return ge(s, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return ge(+t, e.length);
  }
};
function Bc(t, e = "") {
  const n = t > 0 ? "-" : "+", s = Math.abs(t), r = Math.trunc(s / 60), i = s % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + ge(i, 2);
}
function kc(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + ge(Math.abs(t) / 60, 2) : En(t, e);
}
function En(t, e = "") {
  const n = t > 0 ? "-" : "+", s = Math.abs(t), r = ge(Math.trunc(s / 60), 2), i = ge(s % 60, 2);
  return n + r + e + i;
}
const Lc = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, fh = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, fT = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], s = n[1], r = n[2];
  if (!r)
    return Lc(t, e);
  let i;
  switch (s) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Lc(s, e)).replace("{{time}}", fh(r, e));
}, Ta = {
  p: fh,
  P: fT
}, hT = /^D+$/, bT = /^Y+$/, xT = ["D", "DD", "YY", "YYYY"];
function hh(t) {
  return hT.test(t);
}
function bh(t) {
  return bT.test(t);
}
function Aa(t, e, n) {
  const s = mT(t, e, n);
  if (console.warn(s), xT.includes(t)) throw new RangeError(s);
}
function mT(t, e, n) {
  const s = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${s} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const pT = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ET = /^'([^]*?)'?$/, _T = /''/g, TT = /[a-zA-Z]/;
function AT(t, e, n) {
  const s = Rn(), r = n?.locale ?? s.locale ?? ch, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? s.firstWeekContainsDate ?? s.locale?.options?.firstWeekContainsDate ?? 1, u = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? s.weekStartsOn ?? s.locale?.options?.weekStartsOn ?? 0, a = se(t, n?.in);
  if (!sh(a))
    throw new RangeError("Invalid time value");
  let o = e.match(gT).map((l) => {
    const f = l[0];
    if (f === "p" || f === "P") {
      const h = Ta[f];
      return h(l, r.formatLong);
    }
    return l;
  }).join("").match(pT).map((l) => {
    if (l === "''")
      return { isToken: !1, value: "'" };
    const f = l[0];
    if (f === "'")
      return { isToken: !1, value: yT(l) };
    if (Oc[f])
      return { isToken: !0, value: l };
    if (f.match(TT))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: l };
  });
  r.localize.preprocessor && (o = r.localize.preprocessor(a, o));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: u,
    locale: r
  };
  return o.map((l) => {
    if (!l.isToken) return l.value;
    const f = l.value;
    (!n?.useAdditionalWeekYearTokens && bh(f) || !n?.useAdditionalDayOfYearTokens && hh(f)) && Aa(f, e, String(t));
    const h = Oc[f[0]];
    return h(a, f, r.localize, c);
  }).join("");
}
function yT(t) {
  const e = t.match(ET);
  return e ? e[1].replace(_T, "'") : t;
}
function CT() {
  return Object.assign({}, Rn());
}
function DT(t, e) {
  const n = se(t, e?.in).getDay();
  return n === 0 ? 7 : n;
}
function vT(t, e) {
  const n = ST(e) ? new e(0) : Ie(e, 0);
  return n.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
function ST(t) {
  return typeof t == "function" && t.prototype?.constructor === t;
}
const wT = 10;
class xh {
  subPriority = 0;
  validate(e, n) {
    return !0;
  }
}
class NT extends xh {
  constructor(e, n, s, r, i) {
    super(), this.value = e, this.validateValue = n, this.setValue = s, this.priority = r, i && (this.subPriority = i);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, s) {
    return this.setValue(e, n, this.value, s);
  }
}
class IT extends xh {
  priority = wT;
  subPriority = -1;
  constructor(e, n) {
    super(), this.context = e || ((s) => Ie(n, s));
  }
  set(e, n) {
    return n.timestampIsSet ? e : Ie(e, vT(e, this.context));
  }
}
class pe {
  run(e, n, s, r) {
    const i = this.parse(e, n, s, r);
    return i ? {
      setter: new NT(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(e, n, s) {
    return !0;
  }
}
class OT extends pe {
  priority = 140;
  parse(e, n, s) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return s.era(e, { width: "abbreviated" }) || s.era(e, { width: "narrow" });
      case "GGGGG":
        return s.era(e, { width: "narrow" });
      case "GGGG":
      default:
        return s.era(e, { width: "wide" }) || s.era(e, { width: "abbreviated" }) || s.era(e, { width: "narrow" });
    }
  }
  set(e, n, s) {
    return n.era = s, e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const ke = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Mt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Le(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function we(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function Rt(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const s = n[1] === "+" ? 1 : -1, r = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, u = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: s * (r * cr + i * or + u * i_),
    rest: e.slice(n[0].length)
  };
}
function mh(t) {
  return we(ke.anyDigitsSigned, t);
}
function Oe(t, e) {
  switch (t) {
    case 1:
      return we(ke.singleDigit, e);
    case 2:
      return we(ke.twoDigits, e);
    case 3:
      return we(ke.threeDigits, e);
    case 4:
      return we(ke.fourDigits, e);
    default:
      return we(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function oi(t, e) {
  switch (t) {
    case 1:
      return we(ke.singleDigitSigned, e);
    case 2:
      return we(ke.twoDigitsSigned, e);
    case 3:
      return we(ke.threeDigitsSigned, e);
    case 4:
      return we(ke.fourDigitsSigned, e);
    default:
      return we(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function m0(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function ph(t, e) {
  const n = e > 0, s = n ? e : 1 - e;
  let r;
  if (s <= 50)
    r = t || 100;
  else {
    const i = s + 50, u = Math.trunc(i / 100) * 100, a = t >= i % 100;
    r = t + u - (a ? 100 : 0);
  }
  return n ? r : 1 - r;
}
function gh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class BT extends pe {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(e, n, s) {
    const r = (i) => ({
      year: i,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Le(Oe(4, e), r);
      case "yo":
        return Le(
          s.ordinalNumber(e, {
            unit: "year"
          }),
          r
        );
      default:
        return Le(Oe(n.length, e), r);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, s) {
    const r = e.getFullYear();
    if (s.isTwoDigitYear) {
      const u = ph(
        s.year,
        r
      );
      return e.setFullYear(u, 0, 1), e.setHours(0, 0, 0, 0), e;
    }
    const i = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class kT extends pe {
  priority = 130;
  parse(e, n, s) {
    const r = (i) => ({
      year: i,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Le(Oe(4, e), r);
      case "Yo":
        return Le(
          s.ordinalNumber(e, {
            unit: "year"
          }),
          r
        );
      default:
        return Le(Oe(n.length, e), r);
    }
  }
  validate(e, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(e, n, s, r) {
    const i = x0(e, r);
    if (s.isTwoDigitYear) {
      const a = ph(
        s.year,
        i
      );
      return e.setFullYear(
        a,
        0,
        r.firstWeekContainsDate
      ), e.setHours(0, 0, 0, 0), Ft(e, r);
    }
    const u = !("era" in n) || n.era === 1 ? s.year : 1 - s.year;
    return e.setFullYear(u, 0, r.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Ft(e, r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class LT extends pe {
  priority = 130;
  parse(e, n) {
    return oi(n === "R" ? 4 : n.length, e);
  }
  set(e, n, s) {
    const r = Ie(e, 0);
    return r.setFullYear(s, 0, 4), r.setHours(0, 0, 0, 0), ss(r);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class MT extends pe {
  priority = 130;
  parse(e, n) {
    return oi(n === "u" ? 4 : n.length, e);
  }
  set(e, n, s) {
    return e.setFullYear(s, 0, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class RT extends pe {
  priority = 120;
  parse(e, n, s) {
    switch (n) {
      case "Q":
      case "QQ":
        return Oe(n.length, e);
      case "Qo":
        return s.ordinalNumber(e, { unit: "quarter" });
      case "QQQ":
        return s.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return s.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return s.quarter(e, {
          width: "wide",
          context: "formatting"
        }) || s.quarter(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.quarter(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, s) {
    return e.setMonth((s - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class PT extends pe {
  priority = 120;
  parse(e, n, s) {
    switch (n) {
      case "q":
      case "qq":
        return Oe(n.length, e);
      case "qo":
        return s.ordinalNumber(e, { unit: "quarter" });
      case "qqq":
        return s.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return s.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return s.quarter(e, {
          width: "wide",
          context: "standalone"
        }) || s.quarter(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.quarter(e, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 4;
  }
  set(e, n, s) {
    return e.setMonth((s - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class FT extends pe {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(e, n, s) {
    const r = (i) => i - 1;
    switch (n) {
      case "M":
        return Le(
          we(ke.month, e),
          r
        );
      case "MM":
        return Le(Oe(2, e), r);
      case "Mo":
        return Le(
          s.ordinalNumber(e, {
            unit: "month"
          }),
          r
        );
      case "MMM":
        return s.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(e, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return s.month(e, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return s.month(e, { width: "wide", context: "formatting" }) || s.month(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.month(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, s) {
    return e.setMonth(s, 1), e.setHours(0, 0, 0, 0), e;
  }
}
class HT extends pe {
  priority = 110;
  parse(e, n, s) {
    const r = (i) => i - 1;
    switch (n) {
      case "L":
        return Le(
          we(ke.month, e),
          r
        );
      case "LL":
        return Le(Oe(2, e), r);
      case "Lo":
        return Le(
          s.ordinalNumber(e, {
            unit: "month"
          }),
          r
        );
      case "LLL":
        return s.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(e, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return s.month(e, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return s.month(e, { width: "wide", context: "standalone" }) || s.month(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.month(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, s) {
    return e.setMonth(s, 1), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function UT(t, e, n) {
  const s = se(t, n?.in), r = dh(s, n) - e;
  return s.setDate(s.getDate() - r * 7), se(s, n?.in);
}
class YT extends pe {
  priority = 100;
  parse(e, n, s) {
    switch (n) {
      case "w":
        return we(ke.week, e);
      case "wo":
        return s.ordinalNumber(e, { unit: "week" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, s, r) {
    return Ft(UT(e, s, r), r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function qT(t, e, n) {
  const s = se(t, n?.in), r = lh(s, n) - e;
  return s.setDate(s.getDate() - r * 7), s;
}
class $T extends pe {
  priority = 100;
  parse(e, n, s) {
    switch (n) {
      case "I":
        return we(ke.week, e);
      case "Io":
        return s.ordinalNumber(e, { unit: "week" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 53;
  }
  set(e, n, s) {
    return ss(qT(e, s));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const WT = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], zT = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class VT extends pe {
  priority = 90;
  subPriority = 1;
  parse(e, n, s) {
    switch (n) {
      case "d":
        return we(ke.date, e);
      case "do":
        return s.ordinalNumber(e, { unit: "date" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    const s = e.getFullYear(), r = gh(s), i = e.getMonth();
    return r ? n >= 1 && n <= zT[i] : n >= 1 && n <= WT[i];
  }
  set(e, n, s) {
    return e.setDate(s), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class jT extends pe {
  priority = 90;
  subpriority = 1;
  parse(e, n, s) {
    switch (n) {
      case "D":
      case "DD":
        return we(ke.dayOfYear, e);
      case "Do":
        return s.ordinalNumber(e, { unit: "date" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    const s = e.getFullYear();
    return gh(s) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(e, n, s) {
    return e.setMonth(0, s), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function p0(t, e, n) {
  const s = Rn(), r = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? s.weekStartsOn ?? s.locale?.options?.weekStartsOn ?? 0, i = se(t, n?.in), u = i.getDay(), o = (e % 7 + 7) % 7, c = 7 - r, l = e < 0 || e > 6 ? e - (u + c) % 7 : (o + c) % 7 - (u + c) % 7;
  return Ii(i, l, n);
}
class GT extends pe {
  priority = 90;
  parse(e, n, s) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return s.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return s.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return s.day(e, { width: "wide", context: "formatting" }) || s.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, s, r) {
    return e = p0(e, s, r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class XT extends pe {
  priority = 90;
  parse(e, n, s, r) {
    const i = (u) => {
      const a = Math.floor((u - 1) / 7) * 7;
      return (u + r.weekStartsOn + 6) % 7 + a;
    };
    switch (n) {
      case "e":
      case "ee":
        return Le(Oe(n.length, e), i);
      case "eo":
        return Le(
          s.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return s.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
      case "eeeee":
        return s.day(e, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return s.day(e, { width: "wide", context: "formatting" }) || s.day(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.day(e, { width: "short", context: "formatting" }) || s.day(e, { width: "narrow", context: "formatting" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, s, r) {
    return e = p0(e, s, r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class QT extends pe {
  priority = 90;
  parse(e, n, s, r) {
    const i = (u) => {
      const a = Math.floor((u - 1) / 7) * 7;
      return (u + r.weekStartsOn + 6) % 7 + a;
    };
    switch (n) {
      case "c":
      case "cc":
        return Le(Oe(n.length, e), i);
      case "co":
        return Le(
          s.ordinalNumber(e, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return s.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(e, { width: "short", context: "standalone" }) || s.day(e, { width: "narrow", context: "standalone" });
      case "ccccc":
        return s.day(e, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return s.day(e, { width: "short", context: "standalone" }) || s.day(e, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return s.day(e, { width: "wide", context: "standalone" }) || s.day(e, {
          width: "abbreviated",
          context: "standalone"
        }) || s.day(e, { width: "short", context: "standalone" }) || s.day(e, { width: "narrow", context: "standalone" });
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 6;
  }
  set(e, n, s, r) {
    return e = p0(e, s, r), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function KT(t, e, n) {
  const s = se(t, n?.in), r = DT(s, n), i = e - r;
  return Ii(s, i, n);
}
class ZT extends pe {
  priority = 90;
  parse(e, n, s) {
    const r = (i) => i === 0 ? 7 : i;
    switch (n) {
      case "i":
      case "ii":
        return Oe(n.length, e);
      case "io":
        return s.ordinalNumber(e, { unit: "day" });
      case "iii":
        return Le(
          s.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(e, {
            width: "short",
            context: "formatting"
          }) || s.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiii":
        return Le(
          s.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiiii":
        return Le(
          s.day(e, {
            width: "short",
            context: "formatting"
          }) || s.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiii":
      default:
        return Le(
          s.day(e, {
            width: "wide",
            context: "formatting"
          }) || s.day(e, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(e, {
            width: "short",
            context: "formatting"
          }) || s.day(e, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 7;
  }
  set(e, n, s) {
    return e = KT(e, s), e.setHours(0, 0, 0, 0), e;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class JT extends pe {
  priority = 80;
  parse(e, n, s) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, s) {
    return e.setHours(m0(s), 0, 0, 0), e;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class eA extends pe {
  priority = 80;
  parse(e, n, s) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, s) {
    return e.setHours(m0(s), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class tA extends pe {
  priority = 80;
  parse(e, n, s) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(e, {
          width: "wide",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "abbreviated",
          context: "formatting"
        }) || s.dayPeriod(e, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(e, n, s) {
    return e.setHours(m0(s), 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class nA extends pe {
  priority = 70;
  parse(e, n, s) {
    switch (n) {
      case "h":
        return we(ke.hour12h, e);
      case "ho":
        return s.ordinalNumber(e, { unit: "hour" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 12;
  }
  set(e, n, s) {
    const r = e.getHours() >= 12;
    return r && s < 12 ? e.setHours(s + 12, 0, 0, 0) : !r && s === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(s, 0, 0, 0), e;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class sA extends pe {
  priority = 70;
  parse(e, n, s) {
    switch (n) {
      case "H":
        return we(ke.hour23h, e);
      case "Ho":
        return s.ordinalNumber(e, { unit: "hour" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 23;
  }
  set(e, n, s) {
    return e.setHours(s, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class rA extends pe {
  priority = 70;
  parse(e, n, s) {
    switch (n) {
      case "K":
        return we(ke.hour11h, e);
      case "Ko":
        return s.ordinalNumber(e, { unit: "hour" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 11;
  }
  set(e, n, s) {
    return e.getHours() >= 12 && s < 12 ? e.setHours(s + 12, 0, 0, 0) : e.setHours(s, 0, 0, 0), e;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class iA extends pe {
  priority = 70;
  parse(e, n, s) {
    switch (n) {
      case "k":
        return we(ke.hour24h, e);
      case "ko":
        return s.ordinalNumber(e, { unit: "hour" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 1 && n <= 24;
  }
  set(e, n, s) {
    const r = s <= 24 ? s % 24 : s;
    return e.setHours(r, 0, 0, 0), e;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class uA extends pe {
  priority = 60;
  parse(e, n, s) {
    switch (n) {
      case "m":
        return we(ke.minute, e);
      case "mo":
        return s.ordinalNumber(e, { unit: "minute" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, s) {
    return e.setMinutes(s, 0, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class aA extends pe {
  priority = 50;
  parse(e, n, s) {
    switch (n) {
      case "s":
        return we(ke.second, e);
      case "so":
        return s.ordinalNumber(e, { unit: "second" });
      default:
        return Oe(n.length, e);
    }
  }
  validate(e, n) {
    return n >= 0 && n <= 59;
  }
  set(e, n, s) {
    return e.setSeconds(s, 0), e;
  }
  incompatibleTokens = ["t", "T"];
}
class oA extends pe {
  priority = 30;
  parse(e, n) {
    const s = (r) => Math.trunc(r * Math.pow(10, -n.length + 3));
    return Le(Oe(n.length, e), s);
  }
  set(e, n, s) {
    return e.setMilliseconds(s), e;
  }
  incompatibleTokens = ["t", "T"];
}
class cA extends pe {
  priority = 10;
  parse(e, n) {
    switch (n) {
      case "X":
        return Rt(
          Mt.basicOptionalMinutes,
          e
        );
      case "XX":
        return Rt(Mt.basic, e);
      case "XXXX":
        return Rt(
          Mt.basicOptionalSeconds,
          e
        );
      case "XXXXX":
        return Rt(
          Mt.extendedOptionalSeconds,
          e
        );
      case "XXX":
      default:
        return Rt(Mt.extended, e);
    }
  }
  set(e, n, s) {
    return n.timestampIsSet ? e : Ie(
      e,
      e.getTime() - ai(e) - s
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class lA extends pe {
  priority = 10;
  parse(e, n) {
    switch (n) {
      case "x":
        return Rt(
          Mt.basicOptionalMinutes,
          e
        );
      case "xx":
        return Rt(Mt.basic, e);
      case "xxxx":
        return Rt(
          Mt.basicOptionalSeconds,
          e
        );
      case "xxxxx":
        return Rt(
          Mt.extendedOptionalSeconds,
          e
        );
      case "xxx":
      default:
        return Rt(Mt.extended, e);
    }
  }
  set(e, n, s) {
    return n.timestampIsSet ? e : Ie(
      e,
      e.getTime() - ai(e) - s
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class dA extends pe {
  priority = 40;
  parse(e) {
    return mh(e);
  }
  set(e, n, s) {
    return [Ie(e, s * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class fA extends pe {
  priority = 20;
  parse(e) {
    return mh(e);
  }
  set(e, n, s) {
    return [Ie(e, s), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const hA = {
  G: new OT(),
  y: new BT(),
  Y: new kT(),
  R: new LT(),
  u: new MT(),
  Q: new RT(),
  q: new PT(),
  M: new FT(),
  L: new HT(),
  w: new YT(),
  I: new $T(),
  d: new VT(),
  D: new jT(),
  E: new GT(),
  e: new XT(),
  c: new QT(),
  i: new ZT(),
  a: new JT(),
  b: new eA(),
  B: new tA(),
  h: new nA(),
  H: new sA(),
  K: new rA(),
  k: new iA(),
  m: new uA(),
  s: new aA(),
  S: new oA(),
  X: new cA(),
  x: new lA(),
  t: new dA(),
  T: new fA()
}, bA = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xA = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, mA = /^'([^]*?)'?$/, pA = /''/g, gA = /\S/, EA = /[a-zA-Z]/;
function _A(t, e, n, s) {
  const r = () => Ie(s?.in || n, NaN), i = CT(), u = s?.locale ?? i.locale ?? ch, a = s?.firstWeekContainsDate ?? s?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = s?.weekStartsOn ?? s?.locale?.options?.weekStartsOn ?? i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0;
  if (!e)
    return t ? r() : se(n, s?.in);
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: u
  }, l = [new IT(s?.in, n)], f = e.match(xA).map((b) => {
    const E = b[0];
    if (E in Ta) {
      const g = Ta[E];
      return g(b, u.formatLong);
    }
    return b;
  }).join("").match(bA), h = [];
  for (let b of f) {
    !s?.useAdditionalWeekYearTokens && bh(b) && Aa(b, e, t), !s?.useAdditionalDayOfYearTokens && hh(b) && Aa(b, e, t);
    const E = b[0], g = hA[E];
    if (g) {
      const { incompatibleTokens: _ } = g;
      if (Array.isArray(_)) {
        const C = h.find(
          (y) => _.includes(y.token) || y.token === E
        );
        if (C)
          throw new RangeError(
            `The format string mustn't contain \`${C.fullToken}\` and \`${b}\` at the same time`
          );
      } else if (g.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${b}\` and any other token at the same time`
        );
      h.push({ token: E, fullToken: b });
      const T = g.run(
        t,
        b,
        u.match,
        c
      );
      if (!T)
        return r();
      l.push(T.setter), t = T.rest;
    } else {
      if (E.match(EA))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + E + "`"
        );
      if (b === "''" ? b = "'" : E === "'" && (b = TA(b)), t.indexOf(b) === 0)
        t = t.slice(b.length);
      else
        return r();
    }
  }
  if (t.length > 0 && gA.test(t))
    return r();
  const x = l.map((b) => b.priority).sort((b, E) => E - b).filter((b, E, g) => g.indexOf(b) === E).map(
    (b) => l.filter((E) => E.priority === b).sort((E, g) => g.subPriority - E.subPriority)
  ).map((b) => b[0]);
  let m = se(n, s?.in);
  if (isNaN(+m)) return r();
  const p = {};
  for (const b of x) {
    if (!b.validate(m, c))
      return r();
    const E = b.set(m, p, c);
    Array.isArray(E) ? (m = E[0], Object.assign(p, E[1])) : m = E;
  }
  return m;
}
function TA(t) {
  return t.match(mA)[1].replace(pA, "'");
}
function AA(t, e) {
  const n = se(t, e?.in);
  return n.setMinutes(0, 0, 0), n;
}
function yA(t, e) {
  const n = se(t, e?.in);
  return n.setSeconds(0, 0), n;
}
function CA(t, e) {
  const n = se(t, e?.in);
  return n.setMilliseconds(0), n;
}
function DA(t, e) {
  const n = () => Ie(e?.in, NaN), s = e?.additionalDigits ?? 2, r = NA(t);
  let i;
  if (r.date) {
    const c = IA(r.date, s);
    i = OA(c.restDateString, c.year);
  }
  if (!i || isNaN(+i)) return n();
  const u = +i;
  let a = 0, o;
  if (r.time && (a = BA(r.time), isNaN(a)))
    return n();
  if (r.timezone) {
    if (o = kA(r.timezone), isNaN(o)) return n();
  } else {
    const c = new Date(u + a), l = se(0, e?.in);
    return l.setFullYear(
      c.getUTCFullYear(),
      c.getUTCMonth(),
      c.getUTCDate()
    ), l.setHours(
      c.getUTCHours(),
      c.getUTCMinutes(),
      c.getUTCSeconds(),
      c.getUTCMilliseconds()
    ), l;
  }
  return se(u + a + o, e?.in);
}
const Br = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, vA = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, SA = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, wA = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function NA(t) {
  const e = {}, n = t.split(Br.dateTimeDelimiter);
  let s;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? s = n[0] : (e.date = n[0], s = n[1], Br.timeZoneDelimiter.test(e.date) && (e.date = t.split(Br.timeZoneDelimiter)[0], s = t.substr(
    e.date.length,
    t.length
  ))), s) {
    const r = Br.timezone.exec(s);
    r ? (e.time = s.replace(r[1], ""), e.timezone = r[1]) : e.time = s;
  }
  return e;
}
function IA(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), s = t.match(n);
  if (!s) return { year: NaN, restDateString: "" };
  const r = s[1] ? parseInt(s[1]) : null, i = s[2] ? parseInt(s[2]) : null;
  return {
    year: i === null ? r : i * 100,
    restDateString: t.slice((s[1] || s[2]).length)
  };
}
function OA(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(vA);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const s = !!n[4], r = Cs(n[1]), i = Cs(n[2]) - 1, u = Cs(n[3]), a = Cs(n[4]), o = Cs(n[5]) - 1;
  if (s)
    return FA(e, a, o) ? LA(e, a, o) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !RA(e, i, u) || !PA(e, r) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, i, Math.max(r, u)), c);
  }
}
function Cs(t) {
  return t ? parseInt(t) : 1;
}
function BA(t) {
  const e = t.match(SA);
  if (!e) return NaN;
  const n = ou(e[1]), s = ou(e[2]), r = ou(e[3]);
  return HA(n, s, r) ? n * cr + s * or + r * 1e3 : NaN;
}
function ou(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function kA(t) {
  if (t === "Z") return 0;
  const e = t.match(wA);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, s = parseInt(e[2]), r = e[3] && parseInt(e[3]) || 0;
  return UA(s, r) ? n * (s * cr + r * or) : NaN;
}
function LA(t, e, n) {
  const s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(t, 0, 4);
  const r = s.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - r;
  return s.setUTCDate(s.getUTCDate() + i), s;
}
const MA = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Eh(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function RA(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (MA[e] || (Eh(t) ? 29 : 28));
}
function PA(t, e) {
  return e >= 1 && e <= (Eh(t) ? 366 : 365);
}
function FA(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function HA(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function UA(t, e) {
  return e >= 0 && e <= 59;
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const YA = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
Pf._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return YA;
  },
  parse: function(t, e) {
    if (t === null || typeof t > "u")
      return null;
    const n = typeof t;
    return n === "number" || t instanceof Date ? t = se(t) : n === "string" && (typeof e == "string" ? t = _A(t, e, /* @__PURE__ */ new Date(), this.options) : t = DA(t, this.options)), sh(t) ? t.getTime() : null;
  },
  format: function(t, e) {
    return AT(t, e, this.options);
  },
  add: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return h0(t, e);
      case "second":
        return d_(t, e);
      case "minute":
        return c_(t, e);
      case "hour":
        return u_(t, e);
      case "day":
        return Ii(t, e);
      case "week":
        return f_(t, e);
      case "month":
        return f0(t, e);
      case "quarter":
        return l_(t, e);
      case "year":
        return h_(t, e);
      default:
        return t;
    }
  },
  diff: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return b0(t, e);
      case "second":
        return T_(t, e);
      case "minute":
        return g_(t, e);
      case "hour":
        return p_(t, e);
      case "day":
        return rh(t, e);
      case "week":
        return A_(t, e);
      case "month":
        return ah(t, e);
      case "quarter":
        return __(t, e);
      case "year":
        return y_(t, e);
      default:
        return 0;
    }
  },
  startOf: function(t, e, n) {
    switch (e) {
      case "second":
        return CA(t);
      case "minute":
        return yA(t);
      case "hour":
        return AA(t);
      case "day":
        return _a(t);
      case "week":
        return Ft(t);
      case "isoWeek":
        return Ft(t, { weekStartsOn: +n });
      case "month":
        return D_(t);
      case "quarter":
        return C_(t);
      case "year":
        return oh(t);
      default:
        return t;
    }
  },
  endOf: function(t, e) {
    switch (e) {
      case "second":
        return O_(t);
      case "minute":
        return N_(t);
      case "hour":
        return S_(t);
      case "day":
        return ih(t);
      case "week":
        return w_(t);
      case "month":
        return uh(t);
      case "quarter":
        return I_(t);
      case "year":
        return v_(t);
      default:
        return t;
    }
  }
});
const _h = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, qA = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, $A = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ..._h,
  ...qA
}, WA = m1[0] === "2" ? (t, e) => Object.assign(t, {
  attrs: e
}) : (t, e) => Object.assign(t, e);
function Vn(t) {
  return Hl(t) ? Gu(t) : t;
}
function zA(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t;
  return Hl(e) ? new Proxy(t, {}) : t;
}
function VA(t, e) {
  const n = t.options;
  n && e && Object.assign(n, e);
}
function Th(t, e) {
  t.labels = e;
}
function Ah(t, e, n) {
  const s = [];
  t.datasets = e.map((r) => {
    const i = t.datasets.find((u) => u[n] === r[n]);
    return !i || !r.data || s.includes(i) ? {
      ...r
    } : (s.push(i), Object.assign(i, r), i);
  });
}
function jA(t, e) {
  const n = {
    labels: [],
    datasets: []
  };
  return Th(n, t.labels), Ah(n, t.datasets, e), n;
}
const GA = ht({
  props: $A,
  setup(t, e) {
    let { expose: n, slots: s } = e;
    const r = Fe(null), i = Fl(null);
    n({
      chart: i
    });
    const u = () => {
      if (!r.value) return;
      const { type: c, data: l, options: f, plugins: h, datasetIdKey: x } = t, m = jA(l, x), p = zA(m, l);
      i.value = new vi(r.value, {
        type: c,
        data: p,
        options: {
          ...f
        },
        plugins: h
      });
    }, a = () => {
      const c = Gu(i.value);
      c && (t.destroyDelay > 0 ? setTimeout(() => {
        c.destroy(), i.value = null;
      }, t.destroyDelay) : (c.destroy(), i.value = null));
    }, o = (c) => {
      c.update(t.updateMode);
    };
    return Ct(u), b1(a), Qn([
      () => t.options,
      () => t.data
    ], (c, l) => {
      let [f, h] = c, [x, m] = l;
      const p = Gu(i.value);
      if (!p)
        return;
      let b = !1;
      if (f) {
        const E = Vn(f), g = Vn(x);
        E && E !== g && (VA(p, E), b = !0);
      }
      if (h) {
        const E = Vn(h.labels), g = Vn(m.labels), _ = Vn(h.datasets), T = Vn(m.datasets);
        E !== g && (Th(p.config.data, E), b = !0), _ && _ !== T && (Ah(p.config.data, _, t.datasetIdKey), b = !0);
      }
      b && x1(() => {
        o(p);
      });
    }, {
      deep: !0
    }), () => ju("canvas", {
      role: "img",
      ariaLabel: t.ariaLabel,
      ariaDescribedby: t.ariaDescribedby,
      ref: r
    }, [
      ju("p", {}, [
        s.default ? s.default() : ""
      ])
    ]);
  }
});
function XA(t, e) {
  return vi.register(e), ht({
    props: _h,
    setup(n, s) {
      let { expose: r } = s;
      const i = Fl(null), u = (a) => {
        i.value = a?.chart;
      };
      return r({
        chart: i
      }), () => ju(GA, WA({
        ref: u
      }, {
        type: t,
        ...n
      }));
    }
  });
}
const QA = /* @__PURE__ */ XA("line", jE), KA = { class: "top-gainer-chart" }, Mc = "#01b885", Rc = "#ff5252", Pc = "1, 184, 133", Fc = "255, 82, 82", Hc = /* @__PURE__ */ ht({
  __name: "top-gainer-chart",
  props: {
    currentNetChange: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    vi.register(
      K8,
      e_,
      d8,
      Si,
      H8,
      j8,
      P8,
      Ea,
      O8
    );
    const e = t, n = Sn(() => ({
      labels: e.data.labels,
      datasets: [
        {
          data: e.data.prices,
          borderColor: e.currentNetChange < 0 ? Rc : Mc,
          // scriptable backgroundColor:
          backgroundColor: (i) => {
            const u = i.chart, { ctx: a, chartArea: o } = u;
            if (!o) return null;
            const c = a.createLinearGradient(0, o.top, 0, o.bottom);
            return c.addColorStop(
              0,
              e.currentNetChange < 0 ? `rgba( ${Fc}, 0.3)` : `rgba(${Pc}, 0.3)`
            ), c.addColorStop(
              1,
              e.currentNetChange < 0 ? `rgba( ${Fc}, 0)` : `rgba(${Pc}, 0)`
            ), c;
          },
          fill: "start",
          // ← tells Chart.js to fill from the line down to the x-axis
          pointRadius: (i) => i.dataIndex === i.dataset.data.length - 1 ? 3 : 0,
          pointBackgroundColor: e.currentNetChange < 0 ? Rc : Mc,
          tension: 0.3
        }
      ]
    })), s = {
      responsive: !0,
      maintainAspectRatio: !1,
      elements: {
        point: {
          borderWidth: 0
        }
      },
      scales: {
        x: {
          display: !1,
          grid: {
            display: !1
          }
        },
        y: {
          display: !1,
          grid: {
            display: !1
          }
        }
      },
      plugins: {
        legend: { display: !1 },
        tooltip: { enabled: !1 }
      }
    }, r = QA;
    return (i, u) => (ae(), de("div", KA, [
      p1(Na(r), {
        data: n.value,
        options: s
      }, null, 8, ["data"])
    ]));
  }
}), ZA = {
  key: 0,
  class: "stock-info-card"
}, JA = { class: "flex items-center flex-row gap-3" }, e5 = ["src"], t5 = { class: "flex flex-col" }, n5 = { class: "font-regular text-base text-black" }, s5 = { class: "text-slate-400 text-xs overflow-hidden text-ellipsis whitespace-nowrap max-w-[88px]" }, r5 = { class: "flex justify-between items-end" }, i5 = { class: "text-black text-base font-regular" }, u5 = /* @__PURE__ */ ht({
  __name: "top-gainer-block",
  props: {
    size: {
      type: String,
      default: "md"
    },
    theme: {
      type: String,
      default: "dark"
    },
    symbol: {
      type: String
    },
    name: {
      type: String
    },
    pc_chg: {
      type: Number
    },
    net_chg: {
      type: Number
    },
    price: {
      type: Number
    },
    labels: {
      type: Array,
      required: !0
    },
    prices: {
      type: Array,
      required: !0
    },
    appearance: {
      type: String,
      default: "inline"
      // 'inline' or 'card'
    }
  },
  setup(t) {
    const e = (n) => {
      console.log("onImgError", n.target.src);
      const s = n.target.src.replace(".svg", ".png");
      n.target.src = s;
    };
    return Ct(() => {
      console.log("onMounted top-gainer-block");
    }), (n, s) => t.appearance === "card" ? (ae(), de("div", ZA, [
      j("div", JA, [
        j("img", {
          src: `https://stt-ts-resources.s3.us-east-1.amazonaws.com/stock-symbols/${t.symbol}`,
          alt: "logo",
          class: "w-10 h-10 rounded-full bg-white",
          onError: e
        }, null, 40, e5),
        j("div", t5, [
          j("div", n5, ce(t.symbol), 1),
          j("div", s5, ce(t.name), 1)
        ])
      ]),
      t.prices.length ? (ae(), Kn(Hc, {
        key: 0,
        data: { labels: t.labels, prices: t.prices },
        "current-net-change": t.net_chg,
        class: "w-full h-[66px]"
      }, null, 8, ["data", "current-net-change"])) : it("", !0),
      j("div", r5, [
        j("span", i5, "$" + ce(t.price?.toFixed(2) || 0), 1),
        j("span", {
          class: Ce(["text-sm", t.pc_chg && t.pc_chg >= 0 ? "text-success" : "text-negative"])
        }, ce(t.pc_chg && t.pc_chg >= 0 ? "+" : "") + ce(t.pc_chg?.toFixed(2) || 0) + "% ", 3)
      ])
    ])) : (ae(), de("div", {
      key: 1,
      class: Ce([
        "flex justify-between items-center w-full max-w-md bg-transparent text-white border-b py-3",
        t.theme === "dark" ? "border-primary-200/[0.2]" : "border-slate-200"
      ])
    }, [
      j("div", {
        class: Ce([t.size === "sm" ? "w-[68px]" : "w-[140px]"])
      }, [
        j("p", {
          class: Ce([
            "text-primary-200 font-bold text-sm leading-tight",
            t.theme === "dark" ? "color-primary-dark" : "text-black"
          ])
        }, ce(t.symbol), 3),
        j("p", {
          class: Ce([
            "text-sm overflow-hidden text-ellipsis whitespace-nowrap max-w-[130px]",
            t.theme === "dark" ? "text-slate-200" : "text-slate-400"
          ])
        }, ce(t.name), 3)
      ], 2),
      t.prices.length === 0 ? (ae(), de("div", {
        key: 0,
        class: Ce(["text-right ", t.size === "sm" ? "" : "min-w-[112px] ml-3"])
      }, null, 2)) : (ae(), Kn(Hc, {
        key: 1,
        class: Ce([t.size === "sm" ? "max-w-[68px] h-[40px]" : "ml-auto"]),
        "current-net-change": t.net_chg,
        data: {
          labels: t.labels,
          prices: t.prices
        }
      }, null, 8, ["class", "current-net-change", "data"])),
      j("div", {
        class: Ce(["text-right ml-3 ", t.size === "sm" ? "" : "min-w-[112px]"])
      }, [
        j("p", {
          class: Ce(["text-sm font-semibold", t.theme === "dark" ? "text-white" : "text-black"])
        }, ce(t.price?.toFixed(2) || 0), 3),
        j("p", {
          class: Ce(["text-sm", {
            "text-success": t.pc_chg && t.pc_chg >= 0,
            "text-negative": t.pc_chg && t.pc_chg <= 0,
            "text-slate-400": !t.pc_chg || t.pc_chg == 0
          }])
        }, [
          ft(ce(t.net_chg?.toFixed(2)) + " ", 1),
          j("span", null, "(" + ce(t.pc_chg?.toFixed(2) || 0) + "%)", 1)
        ], 2)
      ], 2)
    ], 2));
  }
}), a5 = (t, e) => {
  const n = t.__vccOpts || t;
  for (const [s, r] of e)
    n[s] = r;
  return n;
}, qC = /* @__PURE__ */ a5(u5, [["__scopeId", "data-v-d7b86526"]]);
function yh(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: o5 } = Object.prototype, { getPrototypeOf: g0 } = Object, { iterator: Oi, toStringTag: Ch } = Symbol, Bi = /* @__PURE__ */ ((t) => (e) => {
  const n = o5.call(e);
  return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), vt = (t) => (t = t.toLowerCase(), (e) => Bi(e) === t), ki = (t) => (e) => typeof e === t, { isArray: cs } = Array, tr = ki("undefined");
function c5(t) {
  return t !== null && !tr(t) && t.constructor !== null && !tr(t.constructor) && ot(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Dh = vt("ArrayBuffer");
function l5(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Dh(t.buffer), e;
}
const d5 = ki("string"), ot = ki("function"), vh = ki("number"), Li = (t) => t !== null && typeof t == "object", f5 = (t) => t === !0 || t === !1, Fr = (t) => {
  if (Bi(t) !== "object")
    return !1;
  const e = g0(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Ch in t) && !(Oi in t);
}, h5 = vt("Date"), b5 = vt("File"), x5 = vt("Blob"), m5 = vt("FileList"), p5 = (t) => Li(t) && ot(t.pipe), g5 = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || ot(t.append) && ((e = Bi(t)) === "formdata" || // detect form-data instance
  e === "object" && ot(t.toString) && t.toString() === "[object FormData]"));
}, E5 = vt("URLSearchParams"), [_5, T5, A5, y5] = ["ReadableStream", "Request", "Response", "Headers"].map(vt), C5 = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function dr(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, r;
  if (typeof t != "object" && (t = [t]), cs(t))
    for (s = 0, r = t.length; s < r; s++)
      e.call(null, t[s], s, t);
  else {
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), u = i.length;
    let a;
    for (s = 0; s < u; s++)
      a = i[s], e.call(null, t[a], a, t);
  }
}
function Sh(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let s = n.length, r;
  for (; s-- > 0; )
    if (r = n[s], e === r.toLowerCase())
      return r;
  return null;
}
const yn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, wh = (t) => !tr(t) && t !== yn;
function ya() {
  const { caseless: t } = wh(this) && this || {}, e = {}, n = (s, r) => {
    const i = t && Sh(e, r) || r;
    Fr(e[i]) && Fr(s) ? e[i] = ya(e[i], s) : Fr(s) ? e[i] = ya({}, s) : cs(s) ? e[i] = s.slice() : e[i] = s;
  };
  for (let s = 0, r = arguments.length; s < r; s++)
    arguments[s] && dr(arguments[s], n);
  return e;
}
const D5 = (t, e, n, { allOwnKeys: s } = {}) => (dr(e, (r, i) => {
  n && ot(r) ? t[i] = yh(r, n) : t[i] = r;
}, { allOwnKeys: s }), t), v5 = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), S5 = (t, e, n, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), n && Object.assign(t.prototype, n);
}, w5 = (t, e, n, s) => {
  let r, i, u;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (r = Object.getOwnPropertyNames(t), i = r.length; i-- > 0; )
      u = r[i], (!s || s(u, t, e)) && !a[u] && (e[u] = t[u], a[u] = !0);
    t = n !== !1 && g0(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, N5 = (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const s = t.indexOf(e, n);
  return s !== -1 && s === n;
}, I5 = (t) => {
  if (!t) return null;
  if (cs(t)) return t;
  let e = t.length;
  if (!vh(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; )
    n[e] = t[e];
  return n;
}, O5 = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && g0(Uint8Array)), B5 = (t, e) => {
  const s = (t && t[Oi]).call(t);
  let r;
  for (; (r = s.next()) && !r.done; ) {
    const i = r.value;
    e.call(t, i[0], i[1]);
  }
}, k5 = (t, e) => {
  let n;
  const s = [];
  for (; (n = t.exec(e)) !== null; )
    s.push(n);
  return s;
}, L5 = vt("HTMLFormElement"), M5 = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, s, r) {
    return s.toUpperCase() + r;
  }
), Uc = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), R5 = vt("RegExp"), Nh = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), s = {};
  dr(n, (r, i) => {
    let u;
    (u = e(r, i, t)) !== !1 && (s[i] = u || r);
  }), Object.defineProperties(t, s);
}, P5 = (t) => {
  Nh(t, (e, n) => {
    if (ot(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const s = t[n];
    if (ot(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, F5 = (t, e) => {
  const n = {}, s = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return cs(t) ? s(t) : s(String(t).split(e)), n;
}, H5 = () => {
}, U5 = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function Y5(t) {
  return !!(t && ot(t.append) && t[Ch] === "FormData" && t[Oi]);
}
const q5 = (t) => {
  const e = new Array(10), n = (s, r) => {
    if (Li(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        e[r] = s;
        const i = cs(s) ? [] : {};
        return dr(s, (u, a) => {
          const o = n(u, r + 1);
          !tr(o) && (i[a] = o);
        }), e[r] = void 0, i;
      }
    }
    return s;
  };
  return n(t, 0);
}, $5 = vt("AsyncFunction"), W5 = (t) => t && (Li(t) || ot(t)) && ot(t.then) && ot(t.catch), Ih = ((t, e) => t ? setImmediate : e ? ((n, s) => (yn.addEventListener("message", ({ source: r, data: i }) => {
  r === yn && i === n && s.length && s.shift()();
}, !1), (r) => {
  s.push(r), yn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ot(yn.postMessage)
), z5 = typeof queueMicrotask < "u" ? queueMicrotask.bind(yn) : typeof process < "u" && process.nextTick || Ih, V5 = (t) => t != null && ot(t[Oi]), H = {
  isArray: cs,
  isArrayBuffer: Dh,
  isBuffer: c5,
  isFormData: g5,
  isArrayBufferView: l5,
  isString: d5,
  isNumber: vh,
  isBoolean: f5,
  isObject: Li,
  isPlainObject: Fr,
  isReadableStream: _5,
  isRequest: T5,
  isResponse: A5,
  isHeaders: y5,
  isUndefined: tr,
  isDate: h5,
  isFile: b5,
  isBlob: x5,
  isRegExp: R5,
  isFunction: ot,
  isStream: p5,
  isURLSearchParams: E5,
  isTypedArray: O5,
  isFileList: m5,
  forEach: dr,
  merge: ya,
  extend: D5,
  trim: C5,
  stripBOM: v5,
  inherits: S5,
  toFlatObject: w5,
  kindOf: Bi,
  kindOfTest: vt,
  endsWith: N5,
  toArray: I5,
  forEachEntry: B5,
  matchAll: k5,
  isHTMLForm: L5,
  hasOwnProperty: Uc,
  hasOwnProp: Uc,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Nh,
  freezeMethods: P5,
  toObjectSet: F5,
  toCamelCase: M5,
  noop: H5,
  toFiniteNumber: U5,
  findKey: Sh,
  global: yn,
  isContextDefined: wh,
  isSpecCompliantForm: Y5,
  toJSONObject: q5,
  isAsyncFn: $5,
  isThenable: W5,
  setImmediate: Ih,
  asap: z5,
  isIterable: V5
};
function oe(t, e, n, s, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), s && (this.request = s), r && (this.response = r, this.status = r.status ? r.status : null);
}
H.inherits(oe, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: H.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Oh = oe.prototype, Bh = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Bh[t] = { value: t };
});
Object.defineProperties(oe, Bh);
Object.defineProperty(Oh, "isAxiosError", { value: !0 });
oe.from = (t, e, n, s, r, i) => {
  const u = Object.create(Oh);
  return H.toFlatObject(t, u, function(o) {
    return o !== Error.prototype;
  }, (a) => a !== "isAxiosError"), oe.call(u, t.message, e, n, s, r), u.cause = t, u.name = t.name, i && Object.assign(u, i), u;
};
const j5 = null;
function Ca(t) {
  return H.isPlainObject(t) || H.isArray(t);
}
function kh(t) {
  return H.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Yc(t, e, n) {
  return t ? t.concat(e).map(function(r, i) {
    return r = kh(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
function G5(t) {
  return H.isArray(t) && !t.some(Ca);
}
const X5 = H.toFlatObject(H, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Mi(t, e, n) {
  if (!H.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), n = H.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, b) {
    return !H.isUndefined(b[p]);
  });
  const s = n.metaTokens, r = n.visitor || l, i = n.dots, u = n.indexes, o = (n.Blob || typeof Blob < "u" && Blob) && H.isSpecCompliantForm(e);
  if (!H.isFunction(r))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null) return "";
    if (H.isDate(m))
      return m.toISOString();
    if (H.isBoolean(m))
      return m.toString();
    if (!o && H.isBlob(m))
      throw new oe("Blob is not supported. Use a Buffer instead.");
    return H.isArrayBuffer(m) || H.isTypedArray(m) ? o && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function l(m, p, b) {
    let E = m;
    if (m && !b && typeof m == "object") {
      if (H.endsWith(p, "{}"))
        p = s ? p : p.slice(0, -2), m = JSON.stringify(m);
      else if (H.isArray(m) && G5(m) || (H.isFileList(m) || H.endsWith(p, "[]")) && (E = H.toArray(m)))
        return p = kh(p), E.forEach(function(_, T) {
          !(H.isUndefined(_) || _ === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            u === !0 ? Yc([p], T, i) : u === null ? p : p + "[]",
            c(_)
          );
        }), !1;
    }
    return Ca(m) ? !0 : (e.append(Yc(b, p, i), c(m)), !1);
  }
  const f = [], h = Object.assign(X5, {
    defaultVisitor: l,
    convertValue: c,
    isVisitable: Ca
  });
  function x(m, p) {
    if (!H.isUndefined(m)) {
      if (f.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      f.push(m), H.forEach(m, function(E, g) {
        (!(H.isUndefined(E) || E === null) && r.call(
          e,
          E,
          H.isString(g) ? g.trim() : g,
          p,
          h
        )) === !0 && x(E, p ? p.concat(g) : [g]);
      }), f.pop();
    }
  }
  if (!H.isObject(t))
    throw new TypeError("data must be an object");
  return x(t), e;
}
function qc(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function E0(t, e) {
  this._pairs = [], t && Mi(t, this, e);
}
const Lh = E0.prototype;
Lh.append = function(e, n) {
  this._pairs.push([e, n]);
};
Lh.toString = function(e) {
  const n = e ? function(s) {
    return e.call(this, s, qc);
  } : qc;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function Q5(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Mh(t, e, n) {
  if (!e)
    return t;
  const s = n && n.encode || Q5;
  H.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(e, n) : i = H.isURLSearchParams(e) ? e.toString() : new E0(e, n).toString(s), i) {
    const u = t.indexOf("#");
    u !== -1 && (t = t.slice(0, u)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
class $c {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: n,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    H.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const Rh = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, K5 = typeof URLSearchParams < "u" ? URLSearchParams : E0, Z5 = typeof FormData < "u" ? FormData : null, J5 = typeof Blob < "u" ? Blob : null, ey = {
  isBrowser: !0,
  classes: {
    URLSearchParams: K5,
    FormData: Z5,
    Blob: J5
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, _0 = typeof window < "u" && typeof document < "u", Da = typeof navigator == "object" && navigator || void 0, ty = _0 && (!Da || ["ReactNative", "NativeScript", "NS"].indexOf(Da.product) < 0), ny = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", sy = _0 && window.location.href || "http://localhost", ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: _0,
  hasStandardBrowserEnv: ty,
  hasStandardBrowserWebWorkerEnv: ny,
  navigator: Da,
  origin: sy
}, Symbol.toStringTag, { value: "Module" })), Ke = {
  ...ry,
  ...ey
};
function iy(t, e) {
  return Mi(t, new Ke.classes.URLSearchParams(), Object.assign({
    visitor: function(n, s, r, i) {
      return Ke.isNode && H.isBuffer(n) ? (this.append(s, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function uy(t) {
  return H.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function ay(t) {
  const e = {}, n = Object.keys(t);
  let s;
  const r = n.length;
  let i;
  for (s = 0; s < r; s++)
    i = n[s], e[i] = t[i];
  return e;
}
function Ph(t) {
  function e(n, s, r, i) {
    let u = n[i++];
    if (u === "__proto__") return !0;
    const a = Number.isFinite(+u), o = i >= n.length;
    return u = !u && H.isArray(r) ? r.length : u, o ? (H.hasOwnProp(r, u) ? r[u] = [r[u], s] : r[u] = s, !a) : ((!r[u] || !H.isObject(r[u])) && (r[u] = []), e(n, s, r[u], i) && H.isArray(r[u]) && (r[u] = ay(r[u])), !a);
  }
  if (H.isFormData(t) && H.isFunction(t.entries)) {
    const n = {};
    return H.forEachEntry(t, (s, r) => {
      e(uy(s), r, n, 0);
    }), n;
  }
  return null;
}
function oy(t, e, n) {
  if (H.isString(t))
    try {
      return (e || JSON.parse)(t), H.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (n || JSON.stringify)(t);
}
const fr = {
  transitional: Rh,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, n) {
    const s = n.getContentType() || "", r = s.indexOf("application/json") > -1, i = H.isObject(e);
    if (i && H.isHTMLForm(e) && (e = new FormData(e)), H.isFormData(e))
      return r ? JSON.stringify(Ph(e)) : e;
    if (H.isArrayBuffer(e) || H.isBuffer(e) || H.isStream(e) || H.isFile(e) || H.isBlob(e) || H.isReadableStream(e))
      return e;
    if (H.isArrayBufferView(e))
      return e.buffer;
    if (H.isURLSearchParams(e))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let a;
    if (i) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return iy(e, this.formSerializer).toString();
      if ((a = H.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return Mi(
          a ? { "files[]": e } : e,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), oy(e)) : e;
  }],
  transformResponse: [function(e) {
    const n = this.transitional || fr.transitional, s = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (H.isResponse(e) || H.isReadableStream(e))
      return e;
    if (e && H.isString(e) && (s && !this.responseType || r)) {
      const u = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(e);
      } catch (a) {
        if (u)
          throw a.name === "SyntaxError" ? oe.from(a, oe.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ke.classes.FormData,
    Blob: Ke.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
H.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  fr.headers[t] = {};
});
const cy = H.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ly = (t) => {
  const e = {};
  let n, s, r;
  return t && t.split(`
`).forEach(function(u) {
    r = u.indexOf(":"), n = u.substring(0, r).trim().toLowerCase(), s = u.substring(r + 1).trim(), !(!n || e[n] && cy[n]) && (n === "set-cookie" ? e[n] ? e[n].push(s) : e[n] = [s] : e[n] = e[n] ? e[n] + ", " + s : s);
  }), e;
}, Wc = Symbol("internals");
function Ds(t) {
  return t && String(t).trim().toLowerCase();
}
function Hr(t) {
  return t === !1 || t == null ? t : H.isArray(t) ? t.map(Hr) : String(t);
}
function dy(t) {
  const e = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = n.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const fy = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function cu(t, e, n, s, r) {
  if (H.isFunction(s))
    return s.call(this, e, n);
  if (r && (e = n), !!H.isString(e)) {
    if (H.isString(s))
      return e.indexOf(s) !== -1;
    if (H.isRegExp(s))
      return s.test(e);
  }
}
function hy(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, n, s) => n.toUpperCase() + s);
}
function by(t, e) {
  const n = H.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + n, {
      value: function(r, i, u) {
        return this[s].call(this, e, r, i, u);
      },
      configurable: !0
    });
  });
}
let ct = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, s) {
    const r = this;
    function i(a, o, c) {
      const l = Ds(o);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const f = H.findKey(r, l);
      (!f || r[f] === void 0 || c === !0 || c === void 0 && r[f] !== !1) && (r[f || o] = Hr(a));
    }
    const u = (a, o) => H.forEach(a, (c, l) => i(c, l, o));
    if (H.isPlainObject(e) || e instanceof this.constructor)
      u(e, n);
    else if (H.isString(e) && (e = e.trim()) && !fy(e))
      u(ly(e), n);
    else if (H.isObject(e) && H.isIterable(e)) {
      let a = {}, o, c;
      for (const l of e) {
        if (!H.isArray(l))
          throw TypeError("Object iterator must return a key-value pair");
        a[c = l[0]] = (o = a[c]) ? H.isArray(o) ? [...o, l[1]] : [o, l[1]] : l[1];
      }
      u(a, n);
    } else
      e != null && i(n, e, s);
    return this;
  }
  get(e, n) {
    if (e = Ds(e), e) {
      const s = H.findKey(this, e);
      if (s) {
        const r = this[s];
        if (!n)
          return r;
        if (n === !0)
          return dy(r);
        if (H.isFunction(n))
          return n.call(this, r, s);
        if (H.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = Ds(e), e) {
      const s = H.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!n || cu(this, this[s], s, n)));
    }
    return !1;
  }
  delete(e, n) {
    const s = this;
    let r = !1;
    function i(u) {
      if (u = Ds(u), u) {
        const a = H.findKey(s, u);
        a && (!n || cu(s, s[a], a, n)) && (delete s[a], r = !0);
      }
    }
    return H.isArray(e) ? e.forEach(i) : i(e), r;
  }
  clear(e) {
    const n = Object.keys(this);
    let s = n.length, r = !1;
    for (; s--; ) {
      const i = n[s];
      (!e || cu(this, this[i], i, e, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(e) {
    const n = this, s = {};
    return H.forEach(this, (r, i) => {
      const u = H.findKey(s, i);
      if (u) {
        n[u] = Hr(r), delete n[i];
        return;
      }
      const a = e ? hy(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Hr(r), s[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return H.forEach(this, (s, r) => {
      s != null && s !== !1 && (n[r] = e && H.isArray(s) ? s.join(", ") : s);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const s = new this(e);
    return n.forEach((r) => s.set(r)), s;
  }
  static accessor(e) {
    const s = (this[Wc] = this[Wc] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(u) {
      const a = Ds(u);
      s[a] || (by(r, u), s[a] = !0);
    }
    return H.isArray(e) ? e.forEach(i) : i(e), this;
  }
};
ct.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
H.reduceDescriptors(ct.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[n] = s;
    }
  };
});
H.freezeMethods(ct);
function lu(t, e) {
  const n = this || fr, s = e || n, r = ct.from(s.headers);
  let i = s.data;
  return H.forEach(t, function(a) {
    i = a.call(n, i, r.normalize(), e ? e.status : void 0);
  }), r.normalize(), i;
}
function Fh(t) {
  return !!(t && t.__CANCEL__);
}
function ls(t, e, n) {
  oe.call(this, t ?? "canceled", oe.ERR_CANCELED, e, n), this.name = "CanceledError";
}
H.inherits(ls, oe, {
  __CANCEL__: !0
});
function Hh(t, e, n) {
  const s = n.config.validateStatus;
  !n.status || !s || s(n.status) ? t(n) : e(new oe(
    "Request failed with status code " + n.status,
    [oe.ERR_BAD_REQUEST, oe.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function xy(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function my(t, e) {
  t = t || 10;
  const n = new Array(t), s = new Array(t);
  let r = 0, i = 0, u;
  return e = e !== void 0 ? e : 1e3, function(o) {
    const c = Date.now(), l = s[i];
    u || (u = c), n[r] = o, s[r] = c;
    let f = i, h = 0;
    for (; f !== r; )
      h += n[f++], f = f % t;
    if (r = (r + 1) % t, r === i && (i = (i + 1) % t), c - u < e)
      return;
    const x = l && c - l;
    return x ? Math.round(h * 1e3 / x) : void 0;
  };
}
function py(t, e) {
  let n = 0, s = 1e3 / e, r, i;
  const u = (c, l = Date.now()) => {
    n = l, r = null, i && (clearTimeout(i), i = null), t.apply(null, c);
  };
  return [(...c) => {
    const l = Date.now(), f = l - n;
    f >= s ? u(c, l) : (r = c, i || (i = setTimeout(() => {
      i = null, u(r);
    }, s - f)));
  }, () => r && u(r)];
}
const ci = (t, e, n = 3) => {
  let s = 0;
  const r = my(50, 250);
  return py((i) => {
    const u = i.loaded, a = i.lengthComputable ? i.total : void 0, o = u - s, c = r(o), l = u <= a;
    s = u;
    const f = {
      loaded: u,
      total: a,
      progress: a ? u / a : void 0,
      bytes: o,
      rate: c || void 0,
      estimated: c && a && l ? (a - u) / c : void 0,
      event: i,
      lengthComputable: a != null,
      [e ? "download" : "upload"]: !0
    };
    t(f);
  }, n);
}, zc = (t, e) => {
  const n = t != null;
  return [(s) => e[0]({
    lengthComputable: n,
    total: t,
    loaded: s
  }), e[1]];
}, Vc = (t) => (...e) => H.asap(() => t(...e)), gy = Ke.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, Ke.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(
  new URL(Ke.origin),
  Ke.navigator && /(msie|trident)/i.test(Ke.navigator.userAgent)
) : () => !0, Ey = Ke.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, n, s, r, i) {
      const u = [t + "=" + encodeURIComponent(e)];
      H.isNumber(n) && u.push("expires=" + new Date(n).toGMTString()), H.isString(s) && u.push("path=" + s), H.isString(r) && u.push("domain=" + r), i === !0 && u.push("secure"), document.cookie = u.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function _y(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function Ty(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function Uh(t, e, n) {
  let s = !_y(e);
  return t && (s || n == !1) ? Ty(t, e) : e;
}
const jc = (t) => t instanceof ct ? { ...t } : t;
function On(t, e) {
  e = e || {};
  const n = {};
  function s(c, l, f, h) {
    return H.isPlainObject(c) && H.isPlainObject(l) ? H.merge.call({ caseless: h }, c, l) : H.isPlainObject(l) ? H.merge({}, l) : H.isArray(l) ? l.slice() : l;
  }
  function r(c, l, f, h) {
    if (H.isUndefined(l)) {
      if (!H.isUndefined(c))
        return s(void 0, c, f, h);
    } else return s(c, l, f, h);
  }
  function i(c, l) {
    if (!H.isUndefined(l))
      return s(void 0, l);
  }
  function u(c, l) {
    if (H.isUndefined(l)) {
      if (!H.isUndefined(c))
        return s(void 0, c);
    } else return s(void 0, l);
  }
  function a(c, l, f) {
    if (f in e)
      return s(c, l);
    if (f in t)
      return s(void 0, c);
  }
  const o = {
    url: i,
    method: i,
    data: i,
    baseURL: u,
    transformRequest: u,
    transformResponse: u,
    paramsSerializer: u,
    timeout: u,
    timeoutMessage: u,
    withCredentials: u,
    withXSRFToken: u,
    adapter: u,
    responseType: u,
    xsrfCookieName: u,
    xsrfHeaderName: u,
    onUploadProgress: u,
    onDownloadProgress: u,
    decompress: u,
    maxContentLength: u,
    maxBodyLength: u,
    beforeRedirect: u,
    transport: u,
    httpAgent: u,
    httpsAgent: u,
    cancelToken: u,
    socketPath: u,
    responseEncoding: u,
    validateStatus: a,
    headers: (c, l, f) => r(jc(c), jc(l), f, !0)
  };
  return H.forEach(Object.keys(Object.assign({}, t, e)), function(l) {
    const f = o[l] || r, h = f(t[l], e[l], l);
    H.isUndefined(h) && f !== a || (n[l] = h);
  }), n;
}
const Yh = (t) => {
  const e = On({}, t);
  let { data: n, withXSRFToken: s, xsrfHeaderName: r, xsrfCookieName: i, headers: u, auth: a } = e;
  e.headers = u = ct.from(u), e.url = Mh(Uh(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && u.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let o;
  if (H.isFormData(n)) {
    if (Ke.hasStandardBrowserEnv || Ke.hasStandardBrowserWebWorkerEnv)
      u.setContentType(void 0);
    else if ((o = u.getContentType()) !== !1) {
      const [c, ...l] = o ? o.split(";").map((f) => f.trim()).filter(Boolean) : [];
      u.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (Ke.hasStandardBrowserEnv && (s && H.isFunction(s) && (s = s(e)), s || s !== !1 && gy(e.url))) {
    const c = r && i && Ey.read(i);
    c && u.set(r, c);
  }
  return e;
}, Ay = typeof XMLHttpRequest < "u", yy = Ay && function(t) {
  return new Promise(function(n, s) {
    const r = Yh(t);
    let i = r.data;
    const u = ct.from(r.headers).normalize();
    let { responseType: a, onUploadProgress: o, onDownloadProgress: c } = r, l, f, h, x, m;
    function p() {
      x && x(), m && m(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
    }
    let b = new XMLHttpRequest();
    b.open(r.method.toUpperCase(), r.url, !0), b.timeout = r.timeout;
    function E() {
      if (!b)
        return;
      const _ = ct.from(
        "getAllResponseHeaders" in b && b.getAllResponseHeaders()
      ), C = {
        data: !a || a === "text" || a === "json" ? b.responseText : b.response,
        status: b.status,
        statusText: b.statusText,
        headers: _,
        config: t,
        request: b
      };
      Hh(function(v) {
        n(v), p();
      }, function(v) {
        s(v), p();
      }, C), b = null;
    }
    "onloadend" in b ? b.onloadend = E : b.onreadystatechange = function() {
      !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(E);
    }, b.onabort = function() {
      b && (s(new oe("Request aborted", oe.ECONNABORTED, t, b)), b = null);
    }, b.onerror = function() {
      s(new oe("Network Error", oe.ERR_NETWORK, t, b)), b = null;
    }, b.ontimeout = function() {
      let T = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const C = r.transitional || Rh;
      r.timeoutErrorMessage && (T = r.timeoutErrorMessage), s(new oe(
        T,
        C.clarifyTimeoutError ? oe.ETIMEDOUT : oe.ECONNABORTED,
        t,
        b
      )), b = null;
    }, i === void 0 && u.setContentType(null), "setRequestHeader" in b && H.forEach(u.toJSON(), function(T, C) {
      b.setRequestHeader(C, T);
    }), H.isUndefined(r.withCredentials) || (b.withCredentials = !!r.withCredentials), a && a !== "json" && (b.responseType = r.responseType), c && ([h, m] = ci(c, !0), b.addEventListener("progress", h)), o && b.upload && ([f, x] = ci(o), b.upload.addEventListener("progress", f), b.upload.addEventListener("loadend", x)), (r.cancelToken || r.signal) && (l = (_) => {
      b && (s(!_ || _.type ? new ls(null, t, b) : _), b.abort(), b = null);
    }, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
    const g = xy(r.url);
    if (g && Ke.protocols.indexOf(g) === -1) {
      s(new oe("Unsupported protocol " + g + ":", oe.ERR_BAD_REQUEST, t));
      return;
    }
    b.send(i || null);
  });
}, Cy = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let s = new AbortController(), r;
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof oe ? l : new ls(l instanceof Error ? l.message : l));
      }
    };
    let u = e && setTimeout(() => {
      u = null, i(new oe(`timeout ${e} of ms exceeded`, oe.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (u && clearTimeout(u), u = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: o } = s;
    return o.unsubscribe = () => H.asap(a), o;
  }
}, Dy = function* (t, e) {
  let n = t.byteLength;
  if (n < e) {
    yield t;
    return;
  }
  let s = 0, r;
  for (; s < n; )
    r = s + e, yield t.slice(s, r), s = r;
}, vy = async function* (t, e) {
  for await (const n of Sy(t))
    yield* Dy(n, e);
}, Sy = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: n, value: s } = await e.read();
      if (n)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, Gc = (t, e, n, s) => {
  const r = vy(t, e);
  let i = 0, u, a = (o) => {
    u || (u = !0, s && s(o));
  };
  return new ReadableStream({
    async pull(o) {
      try {
        const { done: c, value: l } = await r.next();
        if (c) {
          a(), o.close();
          return;
        }
        let f = l.byteLength;
        if (n) {
          let h = i += f;
          n(h);
        }
        o.enqueue(new Uint8Array(l));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(o) {
      return a(o), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ri = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", qh = Ri && typeof ReadableStream == "function", wy = Ri && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), $h = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Ny = qh && $h(() => {
  let t = !1;
  const e = new Request(Ke.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
}), Xc = 64 * 1024, va = qh && $h(() => H.isReadableStream(new Response("").body)), li = {
  stream: va && ((t) => t.body)
};
Ri && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !li[e] && (li[e] = H.isFunction(t[e]) ? (n) => n[e]() : (n, s) => {
      throw new oe(`Response type '${e}' is not supported`, oe.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const Iy = async (t) => {
  if (t == null)
    return 0;
  if (H.isBlob(t))
    return t.size;
  if (H.isSpecCompliantForm(t))
    return (await new Request(Ke.origin, {
      method: "POST",
      body: t
    }).arrayBuffer()).byteLength;
  if (H.isArrayBufferView(t) || H.isArrayBuffer(t))
    return t.byteLength;
  if (H.isURLSearchParams(t) && (t = t + ""), H.isString(t))
    return (await wy(t)).byteLength;
}, Oy = async (t, e) => {
  const n = H.toFiniteNumber(t.getContentLength());
  return n ?? Iy(e);
}, By = Ri && (async (t) => {
  let {
    url: e,
    method: n,
    data: s,
    signal: r,
    cancelToken: i,
    timeout: u,
    onDownloadProgress: a,
    onUploadProgress: o,
    responseType: c,
    headers: l,
    withCredentials: f = "same-origin",
    fetchOptions: h
  } = Yh(t);
  c = c ? (c + "").toLowerCase() : "text";
  let x = Cy([r, i && i.toAbortSignal()], u), m;
  const p = x && x.unsubscribe && (() => {
    x.unsubscribe();
  });
  let b;
  try {
    if (o && Ny && n !== "get" && n !== "head" && (b = await Oy(l, s)) !== 0) {
      let C = new Request(e, {
        method: "POST",
        body: s,
        duplex: "half"
      }), y;
      if (H.isFormData(s) && (y = C.headers.get("content-type")) && l.setContentType(y), C.body) {
        const [v, N] = zc(
          b,
          ci(Vc(o))
        );
        s = Gc(C.body, Xc, v, N);
      }
    }
    H.isString(f) || (f = f ? "include" : "omit");
    const E = "credentials" in Request.prototype;
    m = new Request(e, {
      ...h,
      signal: x,
      method: n.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: E ? f : void 0
    });
    let g = await fetch(m, h);
    const _ = va && (c === "stream" || c === "response");
    if (va && (a || _ && p)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((O) => {
        C[O] = g[O];
      });
      const y = H.toFiniteNumber(g.headers.get("content-length")), [v, N] = a && zc(
        y,
        ci(Vc(a), !0)
      ) || [];
      g = new Response(
        Gc(g.body, Xc, v, () => {
          N && N(), p && p();
        }),
        C
      );
    }
    c = c || "text";
    let T = await li[H.findKey(li, c) || "text"](g, t);
    return !_ && p && p(), await new Promise((C, y) => {
      Hh(C, y, {
        data: T,
        headers: ct.from(g.headers),
        status: g.status,
        statusText: g.statusText,
        config: t,
        request: m
      });
    });
  } catch (E) {
    throw p && p(), E && E.name === "TypeError" && /Load failed|fetch/i.test(E.message) ? Object.assign(
      new oe("Network Error", oe.ERR_NETWORK, t, m),
      {
        cause: E.cause || E
      }
    ) : oe.from(E, E && E.code, t, m);
  }
}), Sa = {
  http: j5,
  xhr: yy,
  fetch: By
};
H.forEach(Sa, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Qc = (t) => `- ${t}`, ky = (t) => H.isFunction(t) || t === null || t === !1, Wh = {
  getAdapter: (t) => {
    t = H.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, s;
    const r = {};
    for (let i = 0; i < e; i++) {
      n = t[i];
      let u;
      if (s = n, !ky(n) && (s = Sa[(u = String(n)).toLowerCase()], s === void 0))
        throw new oe(`Unknown adapter '${u}'`);
      if (s)
        break;
      r[u || "#" + i] = s;
    }
    if (!s) {
      const i = Object.entries(r).map(
        ([a, o]) => `adapter ${a} ` + (o === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let u = e ? i.length > 1 ? `since :
` + i.map(Qc).join(`
`) : " " + Qc(i[0]) : "as no adapter specified";
      throw new oe(
        "There is no suitable adapter to dispatch the request " + u,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: Sa
};
function du(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new ls(null, t);
}
function Kc(t) {
  return du(t), t.headers = ct.from(t.headers), t.data = lu.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Wh.getAdapter(t.adapter || fr.adapter)(t).then(function(s) {
    return du(t), s.data = lu.call(
      t,
      t.transformResponse,
      s
    ), s.headers = ct.from(s.headers), s;
  }, function(s) {
    return Fh(s) || (du(t), s && s.response && (s.response.data = lu.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = ct.from(s.response.headers))), Promise.reject(s);
  });
}
const zh = "1.10.0", Pi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Pi[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Zc = {};
Pi.transitional = function(e, n, s) {
  function r(i, u) {
    return "[Axios v" + zh + "] Transitional option '" + i + "'" + u + (s ? ". " + s : "");
  }
  return (i, u, a) => {
    if (e === !1)
      throw new oe(
        r(u, " has been removed" + (n ? " in " + n : "")),
        oe.ERR_DEPRECATED
      );
    return n && !Zc[u] && (Zc[u] = !0, console.warn(
      r(
        u,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), e ? e(i, u, a) : !0;
  };
};
Pi.spelling = function(e) {
  return (n, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function Ly(t, e, n) {
  if (typeof t != "object")
    throw new oe("options must be an object", oe.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let r = s.length;
  for (; r-- > 0; ) {
    const i = s[r], u = e[i];
    if (u) {
      const a = t[i], o = a === void 0 || u(a, i, t);
      if (o !== !0)
        throw new oe("option " + i + " must be " + o, oe.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new oe("Unknown option " + i, oe.ERR_BAD_OPTION);
  }
}
const Ur = {
  assertOptions: Ly,
  validators: Pi
}, wt = Ur.validators;
let vn = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new $c(),
      response: new $c()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (s) {
      if (s instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? i && !String(s.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + i) : s.stack = i;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}, n.url = e) : n = e || {}, n = On(this.defaults, n);
    const { transitional: s, paramsSerializer: r, headers: i } = n;
    s !== void 0 && Ur.assertOptions(s, {
      silentJSONParsing: wt.transitional(wt.boolean),
      forcedJSONParsing: wt.transitional(wt.boolean),
      clarifyTimeoutError: wt.transitional(wt.boolean)
    }, !1), r != null && (H.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : Ur.assertOptions(r, {
      encode: wt.function,
      serialize: wt.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Ur.assertOptions(n, {
      baseUrl: wt.spelling("baseURL"),
      withXsrfToken: wt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let u = i && H.merge(
      i.common,
      i[n.method]
    );
    i && H.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete i[m];
      }
    ), n.headers = ct.concat(u, i);
    const a = [];
    let o = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(n) === !1 || (o = o && p.synchronous, a.unshift(p.fulfilled, p.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(p) {
      c.push(p.fulfilled, p.rejected);
    });
    let l, f = 0, h;
    if (!o) {
      const m = [Kc.bind(this), void 0];
      for (m.unshift.apply(m, a), m.push.apply(m, c), h = m.length, l = Promise.resolve(n); f < h; )
        l = l.then(m[f++], m[f++]);
      return l;
    }
    h = a.length;
    let x = n;
    for (f = 0; f < h; ) {
      const m = a[f++], p = a[f++];
      try {
        x = m(x);
      } catch (b) {
        p.call(this, b);
        break;
      }
    }
    try {
      l = Kc.call(this, x);
    } catch (m) {
      return Promise.reject(m);
    }
    for (f = 0, h = c.length; f < h; )
      l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    e = On(this.defaults, e);
    const n = Uh(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Mh(n, e.params, e.paramsSerializer);
  }
};
H.forEach(["delete", "get", "head", "options"], function(e) {
  vn.prototype[e] = function(n, s) {
    return this.request(On(s || {}, {
      method: e,
      url: n,
      data: (s || {}).data
    }));
  };
});
H.forEach(["post", "put", "patch"], function(e) {
  function n(s) {
    return function(i, u, a) {
      return this.request(On(a || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: u
      }));
    };
  }
  vn.prototype[e] = n(), vn.prototype[e + "Form"] = n(!0);
});
let My = class Vh {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const s = this;
    this.promise.then((r) => {
      if (!s._listeners) return;
      let i = s._listeners.length;
      for (; i-- > 0; )
        s._listeners[i](r);
      s._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const u = new Promise((a) => {
        s.subscribe(a), i = a;
      }).then(r);
      return u.cancel = function() {
        s.unsubscribe(i);
      }, u;
    }, e(function(i, u, a) {
      s.reason || (s.reason = new ls(i, u, a), n(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (s) => {
      e.abort(s);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Vh(function(r) {
        e = r;
      }),
      cancel: e
    };
  }
};
function Ry(t) {
  return function(n) {
    return t.apply(null, n);
  };
}
function Py(t) {
  return H.isObject(t) && t.isAxiosError === !0;
}
const wa = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(wa).forEach(([t, e]) => {
  wa[e] = t;
});
function jh(t) {
  const e = new vn(t), n = yh(vn.prototype.request, e);
  return H.extend(n, vn.prototype, e, { allOwnKeys: !0 }), H.extend(n, e, null, { allOwnKeys: !0 }), n.create = function(r) {
    return jh(On(t, r));
  }, n;
}
const Te = jh(fr);
Te.Axios = vn;
Te.CanceledError = ls;
Te.CancelToken = My;
Te.isCancel = Fh;
Te.VERSION = zh;
Te.toFormData = Mi;
Te.AxiosError = oe;
Te.Cancel = Te.CanceledError;
Te.all = function(e) {
  return Promise.all(e);
};
Te.spread = Ry;
Te.isAxiosError = Py;
Te.mergeConfig = On;
Te.AxiosHeaders = ct;
Te.formToJSON = (t) => Ph(H.isHTMLForm(t) ? new FormData(t) : t);
Te.getAdapter = Wh.getAdapter;
Te.HttpStatusCode = wa;
Te.default = Te;
const {
  Axios: zC,
  AxiosError: VC,
  CanceledError: jC,
  isCancel: GC,
  CancelToken: XC,
  VERSION: QC,
  all: KC,
  Cancel: ZC,
  isAxiosError: JC,
  spread: e9,
  toFormData: t9,
  AxiosHeaders: n9,
  HttpStatusCode: s9,
  formToJSON: r9,
  getAdapter: i9,
  mergeConfig: u9
} = Te;
var Gh = { exports: {} };
function Fy(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var fu = { exports: {} };
const Hy = {}, Uy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hy
}, Symbol.toStringTag, { value: "Module" })), Yy = /* @__PURE__ */ g1(Uy);
var Jc;
function he() {
  return Jc || (Jc = 1, function(t, e) {
    (function(n, s) {
      t.exports = s();
    })(ie, function() {
      var n = n || function(s, r) {
        var i;
        if (typeof window < "u" && window.crypto && (i = window.crypto), typeof self < "u" && self.crypto && (i = self.crypto), typeof globalThis < "u" && globalThis.crypto && (i = globalThis.crypto), !i && typeof window < "u" && window.msCrypto && (i = window.msCrypto), !i && typeof ie < "u" && ie.crypto && (i = ie.crypto), !i && typeof Fy == "function")
          try {
            i = Yy;
          } catch {
          }
        var u = function() {
          if (i) {
            if (typeof i.getRandomValues == "function")
              try {
                return i.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof i.randomBytes == "function")
              try {
                return i.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, a = Object.create || /* @__PURE__ */ function() {
          function g() {
          }
          return function(_) {
            var T;
            return g.prototype = _, T = new g(), g.prototype = null, T;
          };
        }(), o = {}, c = o.lib = {}, l = c.Base = /* @__PURE__ */ function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(g) {
              var _ = a(this);
              return g && _.mixIn(g), (!_.hasOwnProperty("init") || this.init === _.init) && (_.init = function() {
                _.$super.init.apply(this, arguments);
              }), _.init.prototype = _, _.$super = this, _;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var g = this.extend();
              return g.init.apply(g, arguments), g;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(g) {
              for (var _ in g)
                g.hasOwnProperty(_) && (this[_] = g[_]);
              g.hasOwnProperty("toString") && (this.toString = g.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), f = c.WordArray = l.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(g, _) {
            g = this.words = g || [], _ != r ? this.sigBytes = _ : this.sigBytes = g.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(g) {
            return (g || x).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(g) {
            var _ = this.words, T = g.words, C = this.sigBytes, y = g.sigBytes;
            if (this.clamp(), C % 4)
              for (var v = 0; v < y; v++) {
                var N = T[v >>> 2] >>> 24 - v % 4 * 8 & 255;
                _[C + v >>> 2] |= N << 24 - (C + v) % 4 * 8;
              }
            else
              for (var O = 0; O < y; O += 4)
                _[C + O >>> 2] = T[O >>> 2];
            return this.sigBytes += y, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var g = this.words, _ = this.sigBytes;
            g[_ >>> 2] &= 4294967295 << 32 - _ % 4 * 8, g.length = s.ceil(_ / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var g = l.clone.call(this);
            return g.words = this.words.slice(0), g;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(g) {
            for (var _ = [], T = 0; T < g; T += 4)
              _.push(u());
            return new f.init(_, g);
          }
        }), h = o.enc = {}, x = h.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(g) {
            for (var _ = g.words, T = g.sigBytes, C = [], y = 0; y < T; y++) {
              var v = _[y >>> 2] >>> 24 - y % 4 * 8 & 255;
              C.push((v >>> 4).toString(16)), C.push((v & 15).toString(16));
            }
            return C.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(g) {
            for (var _ = g.length, T = [], C = 0; C < _; C += 2)
              T[C >>> 3] |= parseInt(g.substr(C, 2), 16) << 24 - C % 8 * 4;
            return new f.init(T, _ / 2);
          }
        }, m = h.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(g) {
            for (var _ = g.words, T = g.sigBytes, C = [], y = 0; y < T; y++) {
              var v = _[y >>> 2] >>> 24 - y % 4 * 8 & 255;
              C.push(String.fromCharCode(v));
            }
            return C.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(g) {
            for (var _ = g.length, T = [], C = 0; C < _; C++)
              T[C >>> 2] |= (g.charCodeAt(C) & 255) << 24 - C % 4 * 8;
            return new f.init(T, _);
          }
        }, p = h.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(g) {
            try {
              return decodeURIComponent(escape(m.stringify(g)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(g) {
            return m.parse(unescape(encodeURIComponent(g)));
          }
        }, b = c.BufferedBlockAlgorithm = l.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new f.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(g) {
            typeof g == "string" && (g = p.parse(g)), this._data.concat(g), this._nDataBytes += g.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(g) {
            var _, T = this._data, C = T.words, y = T.sigBytes, v = this.blockSize, N = v * 4, O = y / N;
            g ? O = s.ceil(O) : O = s.max((O | 0) - this._minBufferSize, 0);
            var w = O * v, S = s.min(w * 4, y);
            if (w) {
              for (var B = 0; B < w; B += v)
                this._doProcessBlock(C, B);
              _ = C.splice(0, w), T.sigBytes -= S;
            }
            return new f.init(_, S);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var g = l.clone.call(this);
            return g._data = this._data.clone(), g;
          },
          _minBufferSize: 0
        });
        c.Hasher = b.extend({
          /**
           * Configuration options.
           */
          cfg: l.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(g) {
            this.cfg = this.cfg.extend(g), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            b.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(g) {
            return this._append(g), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(g) {
            g && this._append(g);
            var _ = this._doFinalize();
            return _;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(g) {
            return function(_, T) {
              return new g.init(T).finalize(_);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(g) {
            return function(_, T) {
              return new E.HMAC.init(g, T).finalize(_);
            };
          }
        });
        var E = o.algo = {};
        return o;
      }(Math);
      return n;
    });
  }(fu)), fu.exports;
}
var hu = { exports: {} }, el;
function Fi() {
  return el || (el = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function(s) {
        var r = n, i = r.lib, u = i.Base, a = i.WordArray, o = r.x64 = {};
        o.Word = u.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(c, l) {
            this.high = c, this.low = l;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), o.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(c, l) {
            c = this.words = c || [], l != s ? this.sigBytes = l : this.sigBytes = c.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var c = this.words, l = c.length, f = [], h = 0; h < l; h++) {
              var x = c[h];
              f.push(x.high), f.push(x.low);
            }
            return a.create(f, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var c = u.clone.call(this), l = c.words = this.words.slice(0), f = l.length, h = 0; h < f; h++)
              l[h] = l[h].clone();
            return c;
          }
        });
      }(), n;
    });
  }(hu)), hu.exports;
}
var bu = { exports: {} }, tl;
function qy() {
  return tl || (tl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var s = n, r = s.lib, i = r.WordArray, u = i.init, a = i.init = function(o) {
            if (o instanceof ArrayBuffer && (o = new Uint8Array(o)), (o instanceof Int8Array || typeof Uint8ClampedArray < "u" && o instanceof Uint8ClampedArray || o instanceof Int16Array || o instanceof Uint16Array || o instanceof Int32Array || o instanceof Uint32Array || o instanceof Float32Array || o instanceof Float64Array) && (o = new Uint8Array(o.buffer, o.byteOffset, o.byteLength)), o instanceof Uint8Array) {
              for (var c = o.byteLength, l = [], f = 0; f < c; f++)
                l[f >>> 2] |= o[f] << 24 - f % 4 * 8;
              u.call(this, l, c);
            } else
              u.apply(this, arguments);
          };
          a.prototype = i;
        }
      }(), n.lib.WordArray;
    });
  }(bu)), bu.exports;
}
var xu = { exports: {} }, nl;
function $y() {
  return nl || (nl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = s.enc;
        u.Utf16 = u.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(o) {
            for (var c = o.words, l = o.sigBytes, f = [], h = 0; h < l; h += 2) {
              var x = c[h >>> 2] >>> 16 - h % 4 * 8 & 65535;
              f.push(String.fromCharCode(x));
            }
            return f.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(o) {
            for (var c = o.length, l = [], f = 0; f < c; f++)
              l[f >>> 1] |= o.charCodeAt(f) << 16 - f % 2 * 16;
            return i.create(l, c * 2);
          }
        }, u.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(o) {
            for (var c = o.words, l = o.sigBytes, f = [], h = 0; h < l; h += 2) {
              var x = a(c[h >>> 2] >>> 16 - h % 4 * 8 & 65535);
              f.push(String.fromCharCode(x));
            }
            return f.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(o) {
            for (var c = o.length, l = [], f = 0; f < c; f++)
              l[f >>> 1] |= a(o.charCodeAt(f) << 16 - f % 2 * 16);
            return i.create(l, c * 2);
          }
        };
        function a(o) {
          return o << 8 & 4278255360 | o >>> 8 & 16711935;
        }
      }(), n.enc.Utf16;
    });
  }(xu)), xu.exports;
}
var mu = { exports: {} }, sl;
function Fn() {
  return sl || (sl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = s.enc;
        u.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(o) {
            var c = o.words, l = o.sigBytes, f = this._map;
            o.clamp();
            for (var h = [], x = 0; x < l; x += 3)
              for (var m = c[x >>> 2] >>> 24 - x % 4 * 8 & 255, p = c[x + 1 >>> 2] >>> 24 - (x + 1) % 4 * 8 & 255, b = c[x + 2 >>> 2] >>> 24 - (x + 2) % 4 * 8 & 255, E = m << 16 | p << 8 | b, g = 0; g < 4 && x + g * 0.75 < l; g++)
                h.push(f.charAt(E >>> 6 * (3 - g) & 63));
            var _ = f.charAt(64);
            if (_)
              for (; h.length % 4; )
                h.push(_);
            return h.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(o) {
            var c = o.length, l = this._map, f = this._reverseMap;
            if (!f) {
              f = this._reverseMap = [];
              for (var h = 0; h < l.length; h++)
                f[l.charCodeAt(h)] = h;
            }
            var x = l.charAt(64);
            if (x) {
              var m = o.indexOf(x);
              m !== -1 && (c = m);
            }
            return a(o, c, f);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function a(o, c, l) {
          for (var f = [], h = 0, x = 0; x < c; x++)
            if (x % 4) {
              var m = l[o.charCodeAt(x - 1)] << x % 4 * 2, p = l[o.charCodeAt(x)] >>> 6 - x % 4 * 2, b = m | p;
              f[h >>> 2] |= b << 24 - h % 4 * 8, h++;
            }
          return i.create(f, h);
        }
      }(), n.enc.Base64;
    });
  }(mu)), mu.exports;
}
var pu = { exports: {} }, rl;
function Wy() {
  return rl || (rl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = s.enc;
        u.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(o, c) {
            c === void 0 && (c = !0);
            var l = o.words, f = o.sigBytes, h = c ? this._safe_map : this._map;
            o.clamp();
            for (var x = [], m = 0; m < f; m += 3)
              for (var p = l[m >>> 2] >>> 24 - m % 4 * 8 & 255, b = l[m + 1 >>> 2] >>> 24 - (m + 1) % 4 * 8 & 255, E = l[m + 2 >>> 2] >>> 24 - (m + 2) % 4 * 8 & 255, g = p << 16 | b << 8 | E, _ = 0; _ < 4 && m + _ * 0.75 < f; _++)
                x.push(h.charAt(g >>> 6 * (3 - _) & 63));
            var T = h.charAt(64);
            if (T)
              for (; x.length % 4; )
                x.push(T);
            return x.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(o, c) {
            c === void 0 && (c = !0);
            var l = o.length, f = c ? this._safe_map : this._map, h = this._reverseMap;
            if (!h) {
              h = this._reverseMap = [];
              for (var x = 0; x < f.length; x++)
                h[f.charCodeAt(x)] = x;
            }
            var m = f.charAt(64);
            if (m) {
              var p = o.indexOf(m);
              p !== -1 && (l = p);
            }
            return a(o, l, h);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function a(o, c, l) {
          for (var f = [], h = 0, x = 0; x < c; x++)
            if (x % 4) {
              var m = l[o.charCodeAt(x - 1)] << x % 4 * 2, p = l[o.charCodeAt(x)] >>> 6 - x % 4 * 2, b = m | p;
              f[h >>> 2] |= b << 24 - h % 4 * 8, h++;
            }
          return i.create(f, h);
        }
      }(), n.enc.Base64url;
    });
  }(pu)), pu.exports;
}
var gu = { exports: {} }, il;
function Hn() {
  return il || (il = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function(s) {
        var r = n, i = r.lib, u = i.WordArray, a = i.Hasher, o = r.algo, c = [];
        (function() {
          for (var p = 0; p < 64; p++)
            c[p] = s.abs(s.sin(p + 1)) * 4294967296 | 0;
        })();
        var l = o.MD5 = a.extend({
          _doReset: function() {
            this._hash = new u.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(p, b) {
            for (var E = 0; E < 16; E++) {
              var g = b + E, _ = p[g];
              p[g] = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360;
            }
            var T = this._hash.words, C = p[b + 0], y = p[b + 1], v = p[b + 2], N = p[b + 3], O = p[b + 4], w = p[b + 5], S = p[b + 6], B = p[b + 7], M = p[b + 8], P = p[b + 9], R = p[b + 10], F = p[b + 11], V = p[b + 12], W = p[b + 13], K = p[b + 14], Q = p[b + 15], L = T[0], Y = T[1], $ = T[2], q = T[3];
            L = f(L, Y, $, q, C, 7, c[0]), q = f(q, L, Y, $, y, 12, c[1]), $ = f($, q, L, Y, v, 17, c[2]), Y = f(Y, $, q, L, N, 22, c[3]), L = f(L, Y, $, q, O, 7, c[4]), q = f(q, L, Y, $, w, 12, c[5]), $ = f($, q, L, Y, S, 17, c[6]), Y = f(Y, $, q, L, B, 22, c[7]), L = f(L, Y, $, q, M, 7, c[8]), q = f(q, L, Y, $, P, 12, c[9]), $ = f($, q, L, Y, R, 17, c[10]), Y = f(Y, $, q, L, F, 22, c[11]), L = f(L, Y, $, q, V, 7, c[12]), q = f(q, L, Y, $, W, 12, c[13]), $ = f($, q, L, Y, K, 17, c[14]), Y = f(Y, $, q, L, Q, 22, c[15]), L = h(L, Y, $, q, y, 5, c[16]), q = h(q, L, Y, $, S, 9, c[17]), $ = h($, q, L, Y, F, 14, c[18]), Y = h(Y, $, q, L, C, 20, c[19]), L = h(L, Y, $, q, w, 5, c[20]), q = h(q, L, Y, $, R, 9, c[21]), $ = h($, q, L, Y, Q, 14, c[22]), Y = h(Y, $, q, L, O, 20, c[23]), L = h(L, Y, $, q, P, 5, c[24]), q = h(q, L, Y, $, K, 9, c[25]), $ = h($, q, L, Y, N, 14, c[26]), Y = h(Y, $, q, L, M, 20, c[27]), L = h(L, Y, $, q, W, 5, c[28]), q = h(q, L, Y, $, v, 9, c[29]), $ = h($, q, L, Y, B, 14, c[30]), Y = h(Y, $, q, L, V, 20, c[31]), L = x(L, Y, $, q, w, 4, c[32]), q = x(q, L, Y, $, M, 11, c[33]), $ = x($, q, L, Y, F, 16, c[34]), Y = x(Y, $, q, L, K, 23, c[35]), L = x(L, Y, $, q, y, 4, c[36]), q = x(q, L, Y, $, O, 11, c[37]), $ = x($, q, L, Y, B, 16, c[38]), Y = x(Y, $, q, L, R, 23, c[39]), L = x(L, Y, $, q, W, 4, c[40]), q = x(q, L, Y, $, C, 11, c[41]), $ = x($, q, L, Y, N, 16, c[42]), Y = x(Y, $, q, L, S, 23, c[43]), L = x(L, Y, $, q, P, 4, c[44]), q = x(q, L, Y, $, V, 11, c[45]), $ = x($, q, L, Y, Q, 16, c[46]), Y = x(Y, $, q, L, v, 23, c[47]), L = m(L, Y, $, q, C, 6, c[48]), q = m(q, L, Y, $, B, 10, c[49]), $ = m($, q, L, Y, K, 15, c[50]), Y = m(Y, $, q, L, w, 21, c[51]), L = m(L, Y, $, q, V, 6, c[52]), q = m(q, L, Y, $, N, 10, c[53]), $ = m($, q, L, Y, R, 15, c[54]), Y = m(Y, $, q, L, y, 21, c[55]), L = m(L, Y, $, q, M, 6, c[56]), q = m(q, L, Y, $, Q, 10, c[57]), $ = m($, q, L, Y, S, 15, c[58]), Y = m(Y, $, q, L, W, 21, c[59]), L = m(L, Y, $, q, O, 6, c[60]), q = m(q, L, Y, $, F, 10, c[61]), $ = m($, q, L, Y, v, 15, c[62]), Y = m(Y, $, q, L, P, 21, c[63]), T[0] = T[0] + L | 0, T[1] = T[1] + Y | 0, T[2] = T[2] + $ | 0, T[3] = T[3] + q | 0;
          },
          _doFinalize: function() {
            var p = this._data, b = p.words, E = this._nDataBytes * 8, g = p.sigBytes * 8;
            b[g >>> 5] |= 128 << 24 - g % 32;
            var _ = s.floor(E / 4294967296), T = E;
            b[(g + 64 >>> 9 << 4) + 15] = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360, b[(g + 64 >>> 9 << 4) + 14] = (T << 8 | T >>> 24) & 16711935 | (T << 24 | T >>> 8) & 4278255360, p.sigBytes = (b.length + 1) * 4, this._process();
            for (var C = this._hash, y = C.words, v = 0; v < 4; v++) {
              var N = y[v];
              y[v] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360;
            }
            return C;
          },
          clone: function() {
            var p = a.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        function f(p, b, E, g, _, T, C) {
          var y = p + (b & E | ~b & g) + _ + C;
          return (y << T | y >>> 32 - T) + b;
        }
        function h(p, b, E, g, _, T, C) {
          var y = p + (b & g | E & ~g) + _ + C;
          return (y << T | y >>> 32 - T) + b;
        }
        function x(p, b, E, g, _, T, C) {
          var y = p + (b ^ E ^ g) + _ + C;
          return (y << T | y >>> 32 - T) + b;
        }
        function m(p, b, E, g, _, T, C) {
          var y = p + (E ^ (b | ~g)) + _ + C;
          return (y << T | y >>> 32 - T) + b;
        }
        r.MD5 = a._createHelper(l), r.HmacMD5 = a._createHmacHelper(l);
      }(Math), n.MD5;
    });
  }(gu)), gu.exports;
}
var Eu = { exports: {} }, ul;
function Xh() {
  return ul || (ul = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = r.Hasher, a = s.algo, o = [], c = a.SHA1 = u.extend({
          _doReset: function() {
            this._hash = new i.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(l, f) {
            for (var h = this._hash.words, x = h[0], m = h[1], p = h[2], b = h[3], E = h[4], g = 0; g < 80; g++) {
              if (g < 16)
                o[g] = l[f + g] | 0;
              else {
                var _ = o[g - 3] ^ o[g - 8] ^ o[g - 14] ^ o[g - 16];
                o[g] = _ << 1 | _ >>> 31;
              }
              var T = (x << 5 | x >>> 27) + E + o[g];
              g < 20 ? T += (m & p | ~m & b) + 1518500249 : g < 40 ? T += (m ^ p ^ b) + 1859775393 : g < 60 ? T += (m & p | m & b | p & b) - 1894007588 : T += (m ^ p ^ b) - 899497514, E = b, b = p, p = m << 30 | m >>> 2, m = x, x = T;
            }
            h[0] = h[0] + x | 0, h[1] = h[1] + m | 0, h[2] = h[2] + p | 0, h[3] = h[3] + b | 0, h[4] = h[4] + E | 0;
          },
          _doFinalize: function() {
            var l = this._data, f = l.words, h = this._nDataBytes * 8, x = l.sigBytes * 8;
            return f[x >>> 5] |= 128 << 24 - x % 32, f[(x + 64 >>> 9 << 4) + 14] = Math.floor(h / 4294967296), f[(x + 64 >>> 9 << 4) + 15] = h, l.sigBytes = f.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var l = u.clone.call(this);
            return l._hash = this._hash.clone(), l;
          }
        });
        s.SHA1 = u._createHelper(c), s.HmacSHA1 = u._createHmacHelper(c);
      }(), n.SHA1;
    });
  }(Eu)), Eu.exports;
}
var _u = { exports: {} }, al;
function T0() {
  return al || (al = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      return function(s) {
        var r = n, i = r.lib, u = i.WordArray, a = i.Hasher, o = r.algo, c = [], l = [];
        (function() {
          function x(E) {
            for (var g = s.sqrt(E), _ = 2; _ <= g; _++)
              if (!(E % _))
                return !1;
            return !0;
          }
          function m(E) {
            return (E - (E | 0)) * 4294967296 | 0;
          }
          for (var p = 2, b = 0; b < 64; )
            x(p) && (b < 8 && (c[b] = m(s.pow(p, 1 / 2))), l[b] = m(s.pow(p, 1 / 3)), b++), p++;
        })();
        var f = [], h = o.SHA256 = a.extend({
          _doReset: function() {
            this._hash = new u.init(c.slice(0));
          },
          _doProcessBlock: function(x, m) {
            for (var p = this._hash.words, b = p[0], E = p[1], g = p[2], _ = p[3], T = p[4], C = p[5], y = p[6], v = p[7], N = 0; N < 64; N++) {
              if (N < 16)
                f[N] = x[m + N] | 0;
              else {
                var O = f[N - 15], w = (O << 25 | O >>> 7) ^ (O << 14 | O >>> 18) ^ O >>> 3, S = f[N - 2], B = (S << 15 | S >>> 17) ^ (S << 13 | S >>> 19) ^ S >>> 10;
                f[N] = w + f[N - 7] + B + f[N - 16];
              }
              var M = T & C ^ ~T & y, P = b & E ^ b & g ^ E & g, R = (b << 30 | b >>> 2) ^ (b << 19 | b >>> 13) ^ (b << 10 | b >>> 22), F = (T << 26 | T >>> 6) ^ (T << 21 | T >>> 11) ^ (T << 7 | T >>> 25), V = v + F + M + l[N] + f[N], W = R + P;
              v = y, y = C, C = T, T = _ + V | 0, _ = g, g = E, E = b, b = V + W | 0;
            }
            p[0] = p[0] + b | 0, p[1] = p[1] + E | 0, p[2] = p[2] + g | 0, p[3] = p[3] + _ | 0, p[4] = p[4] + T | 0, p[5] = p[5] + C | 0, p[6] = p[6] + y | 0, p[7] = p[7] + v | 0;
          },
          _doFinalize: function() {
            var x = this._data, m = x.words, p = this._nDataBytes * 8, b = x.sigBytes * 8;
            return m[b >>> 5] |= 128 << 24 - b % 32, m[(b + 64 >>> 9 << 4) + 14] = s.floor(p / 4294967296), m[(b + 64 >>> 9 << 4) + 15] = p, x.sigBytes = m.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var x = a.clone.call(this);
            return x._hash = this._hash.clone(), x;
          }
        });
        r.SHA256 = a._createHelper(h), r.HmacSHA256 = a._createHmacHelper(h);
      }(Math), n.SHA256;
    });
  }(_u)), _u.exports;
}
var Tu = { exports: {} }, ol;
function zy() {
  return ol || (ol = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), T0());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = s.algo, a = u.SHA256, o = u.SHA224 = a.extend({
          _doReset: function() {
            this._hash = new i.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var c = a._doFinalize.call(this);
            return c.sigBytes -= 4, c;
          }
        });
        s.SHA224 = a._createHelper(o), s.HmacSHA224 = a._createHmacHelper(o);
      }(), n.SHA224;
    });
  }(Tu)), Tu.exports;
}
var Au = { exports: {} }, cl;
function Qh() {
  return cl || (cl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fi());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.Hasher, u = s.x64, a = u.Word, o = u.WordArray, c = s.algo;
        function l() {
          return a.create.apply(a, arguments);
        }
        var f = [
          l(1116352408, 3609767458),
          l(1899447441, 602891725),
          l(3049323471, 3964484399),
          l(3921009573, 2173295548),
          l(961987163, 4081628472),
          l(1508970993, 3053834265),
          l(2453635748, 2937671579),
          l(2870763221, 3664609560),
          l(3624381080, 2734883394),
          l(310598401, 1164996542),
          l(607225278, 1323610764),
          l(1426881987, 3590304994),
          l(1925078388, 4068182383),
          l(2162078206, 991336113),
          l(2614888103, 633803317),
          l(3248222580, 3479774868),
          l(3835390401, 2666613458),
          l(4022224774, 944711139),
          l(264347078, 2341262773),
          l(604807628, 2007800933),
          l(770255983, 1495990901),
          l(1249150122, 1856431235),
          l(1555081692, 3175218132),
          l(1996064986, 2198950837),
          l(2554220882, 3999719339),
          l(2821834349, 766784016),
          l(2952996808, 2566594879),
          l(3210313671, 3203337956),
          l(3336571891, 1034457026),
          l(3584528711, 2466948901),
          l(113926993, 3758326383),
          l(338241895, 168717936),
          l(666307205, 1188179964),
          l(773529912, 1546045734),
          l(1294757372, 1522805485),
          l(1396182291, 2643833823),
          l(1695183700, 2343527390),
          l(1986661051, 1014477480),
          l(2177026350, 1206759142),
          l(2456956037, 344077627),
          l(2730485921, 1290863460),
          l(2820302411, 3158454273),
          l(3259730800, 3505952657),
          l(3345764771, 106217008),
          l(3516065817, 3606008344),
          l(3600352804, 1432725776),
          l(4094571909, 1467031594),
          l(275423344, 851169720),
          l(430227734, 3100823752),
          l(506948616, 1363258195),
          l(659060556, 3750685593),
          l(883997877, 3785050280),
          l(958139571, 3318307427),
          l(1322822218, 3812723403),
          l(1537002063, 2003034995),
          l(1747873779, 3602036899),
          l(1955562222, 1575990012),
          l(2024104815, 1125592928),
          l(2227730452, 2716904306),
          l(2361852424, 442776044),
          l(2428436474, 593698344),
          l(2756734187, 3733110249),
          l(3204031479, 2999351573),
          l(3329325298, 3815920427),
          l(3391569614, 3928383900),
          l(3515267271, 566280711),
          l(3940187606, 3454069534),
          l(4118630271, 4000239992),
          l(116418474, 1914138554),
          l(174292421, 2731055270),
          l(289380356, 3203993006),
          l(460393269, 320620315),
          l(685471733, 587496836),
          l(852142971, 1086792851),
          l(1017036298, 365543100),
          l(1126000580, 2618297676),
          l(1288033470, 3409855158),
          l(1501505948, 4234509866),
          l(1607167915, 987167468),
          l(1816402316, 1246189591)
        ], h = [];
        (function() {
          for (var m = 0; m < 80; m++)
            h[m] = l();
        })();
        var x = c.SHA512 = i.extend({
          _doReset: function() {
            this._hash = new o.init([
              new a.init(1779033703, 4089235720),
              new a.init(3144134277, 2227873595),
              new a.init(1013904242, 4271175723),
              new a.init(2773480762, 1595750129),
              new a.init(1359893119, 2917565137),
              new a.init(2600822924, 725511199),
              new a.init(528734635, 4215389547),
              new a.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(m, p) {
            for (var b = this._hash.words, E = b[0], g = b[1], _ = b[2], T = b[3], C = b[4], y = b[5], v = b[6], N = b[7], O = E.high, w = E.low, S = g.high, B = g.low, M = _.high, P = _.low, R = T.high, F = T.low, V = C.high, W = C.low, K = y.high, Q = y.low, L = v.high, Y = v.low, $ = N.high, q = N.low, ne = O, re = w, De = S, te = B, Ge = M, ve = P, Xe = R, tt = F, Re = V, Ye = W, Ht = K, Ut = Q, Qt = L, Yt = Y, fn = $, Un = q, Tt = 0; Tt < 80; Tt++) {
              var bt, Kt, hr = h[Tt];
              if (Tt < 16)
                Kt = hr.high = m[p + Tt * 2] | 0, bt = hr.low = m[p + Tt * 2 + 1] | 0;
              else {
                var y0 = h[Tt - 15], Yn = y0.high, ds = y0.low, Kh = (Yn >>> 1 | ds << 31) ^ (Yn >>> 8 | ds << 24) ^ Yn >>> 7, C0 = (ds >>> 1 | Yn << 31) ^ (ds >>> 8 | Yn << 24) ^ (ds >>> 7 | Yn << 25), D0 = h[Tt - 2], qn = D0.high, fs = D0.low, Zh = (qn >>> 19 | fs << 13) ^ (qn << 3 | fs >>> 29) ^ qn >>> 6, v0 = (fs >>> 19 | qn << 13) ^ (fs << 3 | qn >>> 29) ^ (fs >>> 6 | qn << 26), S0 = h[Tt - 7], Jh = S0.high, e1 = S0.low, w0 = h[Tt - 16], t1 = w0.high, N0 = w0.low;
                bt = C0 + e1, Kt = Kh + Jh + (bt >>> 0 < C0 >>> 0 ? 1 : 0), bt = bt + v0, Kt = Kt + Zh + (bt >>> 0 < v0 >>> 0 ? 1 : 0), bt = bt + N0, Kt = Kt + t1 + (bt >>> 0 < N0 >>> 0 ? 1 : 0), hr.high = Kt, hr.low = bt;
              }
              var n1 = Re & Ht ^ ~Re & Qt, I0 = Ye & Ut ^ ~Ye & Yt, s1 = ne & De ^ ne & Ge ^ De & Ge, r1 = re & te ^ re & ve ^ te & ve, i1 = (ne >>> 28 | re << 4) ^ (ne << 30 | re >>> 2) ^ (ne << 25 | re >>> 7), O0 = (re >>> 28 | ne << 4) ^ (re << 30 | ne >>> 2) ^ (re << 25 | ne >>> 7), u1 = (Re >>> 14 | Ye << 18) ^ (Re >>> 18 | Ye << 14) ^ (Re << 23 | Ye >>> 9), a1 = (Ye >>> 14 | Re << 18) ^ (Ye >>> 18 | Re << 14) ^ (Ye << 23 | Re >>> 9), B0 = f[Tt], o1 = B0.high, k0 = B0.low, lt = Un + a1, Zt = fn + u1 + (lt >>> 0 < Un >>> 0 ? 1 : 0), lt = lt + I0, Zt = Zt + n1 + (lt >>> 0 < I0 >>> 0 ? 1 : 0), lt = lt + k0, Zt = Zt + o1 + (lt >>> 0 < k0 >>> 0 ? 1 : 0), lt = lt + bt, Zt = Zt + Kt + (lt >>> 0 < bt >>> 0 ? 1 : 0), L0 = O0 + r1, c1 = i1 + s1 + (L0 >>> 0 < O0 >>> 0 ? 1 : 0);
              fn = Qt, Un = Yt, Qt = Ht, Yt = Ut, Ht = Re, Ut = Ye, Ye = tt + lt | 0, Re = Xe + Zt + (Ye >>> 0 < tt >>> 0 ? 1 : 0) | 0, Xe = Ge, tt = ve, Ge = De, ve = te, De = ne, te = re, re = lt + L0 | 0, ne = Zt + c1 + (re >>> 0 < lt >>> 0 ? 1 : 0) | 0;
            }
            w = E.low = w + re, E.high = O + ne + (w >>> 0 < re >>> 0 ? 1 : 0), B = g.low = B + te, g.high = S + De + (B >>> 0 < te >>> 0 ? 1 : 0), P = _.low = P + ve, _.high = M + Ge + (P >>> 0 < ve >>> 0 ? 1 : 0), F = T.low = F + tt, T.high = R + Xe + (F >>> 0 < tt >>> 0 ? 1 : 0), W = C.low = W + Ye, C.high = V + Re + (W >>> 0 < Ye >>> 0 ? 1 : 0), Q = y.low = Q + Ut, y.high = K + Ht + (Q >>> 0 < Ut >>> 0 ? 1 : 0), Y = v.low = Y + Yt, v.high = L + Qt + (Y >>> 0 < Yt >>> 0 ? 1 : 0), q = N.low = q + Un, N.high = $ + fn + (q >>> 0 < Un >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var m = this._data, p = m.words, b = this._nDataBytes * 8, E = m.sigBytes * 8;
            p[E >>> 5] |= 128 << 24 - E % 32, p[(E + 128 >>> 10 << 5) + 30] = Math.floor(b / 4294967296), p[(E + 128 >>> 10 << 5) + 31] = b, m.sigBytes = p.length * 4, this._process();
            var g = this._hash.toX32();
            return g;
          },
          clone: function() {
            var m = i.clone.call(this);
            return m._hash = this._hash.clone(), m;
          },
          blockSize: 1024 / 32
        });
        s.SHA512 = i._createHelper(x), s.HmacSHA512 = i._createHmacHelper(x);
      }(), n.SHA512;
    });
  }(Au)), Au.exports;
}
var yu = { exports: {} }, ll;
function Vy() {
  return ll || (ll = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fi(), Qh());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.x64, i = r.Word, u = r.WordArray, a = s.algo, o = a.SHA512, c = a.SHA384 = o.extend({
          _doReset: function() {
            this._hash = new u.init([
              new i.init(3418070365, 3238371032),
              new i.init(1654270250, 914150663),
              new i.init(2438529370, 812702999),
              new i.init(355462360, 4144912697),
              new i.init(1731405415, 4290775857),
              new i.init(2394180231, 1750603025),
              new i.init(3675008525, 1694076839),
              new i.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var l = o._doFinalize.call(this);
            return l.sigBytes -= 16, l;
          }
        });
        s.SHA384 = o._createHelper(c), s.HmacSHA384 = o._createHmacHelper(c);
      }(), n.SHA384;
    });
  }(yu)), yu.exports;
}
var Cu = { exports: {} }, dl;
function jy() {
  return dl || (dl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fi());
    })(ie, function(n) {
      return function(s) {
        var r = n, i = r.lib, u = i.WordArray, a = i.Hasher, o = r.x64, c = o.Word, l = r.algo, f = [], h = [], x = [];
        (function() {
          for (var b = 1, E = 0, g = 0; g < 24; g++) {
            f[b + 5 * E] = (g + 1) * (g + 2) / 2 % 64;
            var _ = E % 5, T = (2 * b + 3 * E) % 5;
            b = _, E = T;
          }
          for (var b = 0; b < 5; b++)
            for (var E = 0; E < 5; E++)
              h[b + 5 * E] = E + (2 * b + 3 * E) % 5 * 5;
          for (var C = 1, y = 0; y < 24; y++) {
            for (var v = 0, N = 0, O = 0; O < 7; O++) {
              if (C & 1) {
                var w = (1 << O) - 1;
                w < 32 ? N ^= 1 << w : v ^= 1 << w - 32;
              }
              C & 128 ? C = C << 1 ^ 113 : C <<= 1;
            }
            x[y] = c.create(v, N);
          }
        })();
        var m = [];
        (function() {
          for (var b = 0; b < 25; b++)
            m[b] = c.create();
        })();
        var p = l.SHA3 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: a.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var b = this._state = [], E = 0; E < 25; E++)
              b[E] = new c.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(b, E) {
            for (var g = this._state, _ = this.blockSize / 2, T = 0; T < _; T++) {
              var C = b[E + 2 * T], y = b[E + 2 * T + 1];
              C = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, y = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360;
              var v = g[T];
              v.high ^= y, v.low ^= C;
            }
            for (var N = 0; N < 24; N++) {
              for (var O = 0; O < 5; O++) {
                for (var w = 0, S = 0, B = 0; B < 5; B++) {
                  var v = g[O + 5 * B];
                  w ^= v.high, S ^= v.low;
                }
                var M = m[O];
                M.high = w, M.low = S;
              }
              for (var O = 0; O < 5; O++)
                for (var P = m[(O + 4) % 5], R = m[(O + 1) % 5], F = R.high, V = R.low, w = P.high ^ (F << 1 | V >>> 31), S = P.low ^ (V << 1 | F >>> 31), B = 0; B < 5; B++) {
                  var v = g[O + 5 * B];
                  v.high ^= w, v.low ^= S;
                }
              for (var W = 1; W < 25; W++) {
                var w, S, v = g[W], K = v.high, Q = v.low, L = f[W];
                L < 32 ? (w = K << L | Q >>> 32 - L, S = Q << L | K >>> 32 - L) : (w = Q << L - 32 | K >>> 64 - L, S = K << L - 32 | Q >>> 64 - L);
                var Y = m[h[W]];
                Y.high = w, Y.low = S;
              }
              var $ = m[0], q = g[0];
              $.high = q.high, $.low = q.low;
              for (var O = 0; O < 5; O++)
                for (var B = 0; B < 5; B++) {
                  var W = O + 5 * B, v = g[W], ne = m[W], re = m[(O + 1) % 5 + 5 * B], De = m[(O + 2) % 5 + 5 * B];
                  v.high = ne.high ^ ~re.high & De.high, v.low = ne.low ^ ~re.low & De.low;
                }
              var v = g[0], te = x[N];
              v.high ^= te.high, v.low ^= te.low;
            }
          },
          _doFinalize: function() {
            var b = this._data, E = b.words;
            this._nDataBytes * 8;
            var g = b.sigBytes * 8, _ = this.blockSize * 32;
            E[g >>> 5] |= 1 << 24 - g % 32, E[(s.ceil((g + 1) / _) * _ >>> 5) - 1] |= 128, b.sigBytes = E.length * 4, this._process();
            for (var T = this._state, C = this.cfg.outputLength / 8, y = C / 8, v = [], N = 0; N < y; N++) {
              var O = T[N], w = O.high, S = O.low;
              w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, S = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, v.push(S), v.push(w);
            }
            return new u.init(v, C);
          },
          clone: function() {
            for (var b = a.clone.call(this), E = b._state = this._state.slice(0), g = 0; g < 25; g++)
              E[g] = E[g].clone();
            return b;
          }
        });
        r.SHA3 = a._createHelper(p), r.HmacSHA3 = a._createHmacHelper(p);
      }(Math), n.SHA3;
    });
  }(Cu)), Cu.exports;
}
var Du = { exports: {} }, fl;
function Gy() {
  return fl || (fl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(s) {
        var r = n, i = r.lib, u = i.WordArray, a = i.Hasher, o = r.algo, c = u.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), l = u.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), f = u.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), h = u.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), x = u.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), m = u.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), p = o.RIPEMD160 = a.extend({
          _doReset: function() {
            this._hash = u.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(y, v) {
            for (var N = 0; N < 16; N++) {
              var O = v + N, w = y[O];
              y[O] = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360;
            }
            var S = this._hash.words, B = x.words, M = m.words, P = c.words, R = l.words, F = f.words, V = h.words, W, K, Q, L, Y, $, q, ne, re, De;
            $ = W = S[0], q = K = S[1], ne = Q = S[2], re = L = S[3], De = Y = S[4];
            for (var te, N = 0; N < 80; N += 1)
              te = W + y[v + P[N]] | 0, N < 16 ? te += b(K, Q, L) + B[0] : N < 32 ? te += E(K, Q, L) + B[1] : N < 48 ? te += g(K, Q, L) + B[2] : N < 64 ? te += _(K, Q, L) + B[3] : te += T(K, Q, L) + B[4], te = te | 0, te = C(te, F[N]), te = te + Y | 0, W = Y, Y = L, L = C(Q, 10), Q = K, K = te, te = $ + y[v + R[N]] | 0, N < 16 ? te += T(q, ne, re) + M[0] : N < 32 ? te += _(q, ne, re) + M[1] : N < 48 ? te += g(q, ne, re) + M[2] : N < 64 ? te += E(q, ne, re) + M[3] : te += b(q, ne, re) + M[4], te = te | 0, te = C(te, V[N]), te = te + De | 0, $ = De, De = re, re = C(ne, 10), ne = q, q = te;
            te = S[1] + Q + re | 0, S[1] = S[2] + L + De | 0, S[2] = S[3] + Y + $ | 0, S[3] = S[4] + W + q | 0, S[4] = S[0] + K + ne | 0, S[0] = te;
          },
          _doFinalize: function() {
            var y = this._data, v = y.words, N = this._nDataBytes * 8, O = y.sigBytes * 8;
            v[O >>> 5] |= 128 << 24 - O % 32, v[(O + 64 >>> 9 << 4) + 14] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360, y.sigBytes = (v.length + 1) * 4, this._process();
            for (var w = this._hash, S = w.words, B = 0; B < 5; B++) {
              var M = S[B];
              S[B] = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360;
            }
            return w;
          },
          clone: function() {
            var y = a.clone.call(this);
            return y._hash = this._hash.clone(), y;
          }
        });
        function b(y, v, N) {
          return y ^ v ^ N;
        }
        function E(y, v, N) {
          return y & v | ~y & N;
        }
        function g(y, v, N) {
          return (y | ~v) ^ N;
        }
        function _(y, v, N) {
          return y & N | v & ~N;
        }
        function T(y, v, N) {
          return y ^ (v | ~N);
        }
        function C(y, v) {
          return y << v | y >>> 32 - v;
        }
        r.RIPEMD160 = a._createHelper(p), r.HmacRIPEMD160 = a._createHmacHelper(p);
      }(), n.RIPEMD160;
    });
  }(Du)), Du.exports;
}
var vu = { exports: {} }, hl;
function A0() {
  return hl || (hl = 1, function(t, e) {
    (function(n, s) {
      t.exports = s(he());
    })(ie, function(n) {
      (function() {
        var s = n, r = s.lib, i = r.Base, u = s.enc, a = u.Utf8, o = s.algo;
        o.HMAC = i.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(c, l) {
            c = this._hasher = new c.init(), typeof l == "string" && (l = a.parse(l));
            var f = c.blockSize, h = f * 4;
            l.sigBytes > h && (l = c.finalize(l)), l.clamp();
            for (var x = this._oKey = l.clone(), m = this._iKey = l.clone(), p = x.words, b = m.words, E = 0; E < f; E++)
              p[E] ^= 1549556828, b[E] ^= 909522486;
            x.sigBytes = m.sigBytes = h, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var c = this._hasher;
            c.reset(), c.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(c) {
            return this._hasher.update(c), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(c) {
            var l = this._hasher, f = l.finalize(c);
            l.reset();
            var h = l.finalize(this._oKey.clone().concat(f));
            return h;
          }
        });
      })();
    });
  }(vu)), vu.exports;
}
var Su = { exports: {} }, bl;
function Xy() {
  return bl || (bl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), T0(), A0());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.Base, u = r.WordArray, a = s.algo, o = a.SHA256, c = a.HMAC, l = a.PBKDF2 = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: o,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(f) {
            this.cfg = this.cfg.extend(f);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(f, h) {
            for (var x = this.cfg, m = c.create(x.hasher, f), p = u.create(), b = u.create([1]), E = p.words, g = b.words, _ = x.keySize, T = x.iterations; E.length < _; ) {
              var C = m.update(h).finalize(b);
              m.reset();
              for (var y = C.words, v = y.length, N = C, O = 1; O < T; O++) {
                N = m.finalize(N), m.reset();
                for (var w = N.words, S = 0; S < v; S++)
                  y[S] ^= w[S];
              }
              p.concat(C), g[0]++;
            }
            return p.sigBytes = _ * 4, p;
          }
        });
        s.PBKDF2 = function(f, h, x) {
          return l.create(x).compute(f, h);
        };
      }(), n.PBKDF2;
    });
  }(Su)), Su.exports;
}
var wu = { exports: {} }, xl;
function dn() {
  return xl || (xl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Xh(), A0());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.Base, u = r.WordArray, a = s.algo, o = a.MD5, c = a.EvpKDF = i.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: i.extend({
            keySize: 128 / 32,
            hasher: o,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(l, f) {
            for (var h, x = this.cfg, m = x.hasher.create(), p = u.create(), b = p.words, E = x.keySize, g = x.iterations; b.length < E; ) {
              h && m.update(h), h = m.update(l).finalize(f), m.reset();
              for (var _ = 1; _ < g; _++)
                h = m.finalize(h), m.reset();
              p.concat(h);
            }
            return p.sigBytes = E * 4, p;
          }
        });
        s.EvpKDF = function(l, f, h) {
          return c.create(h).compute(l, f);
        };
      }(), n.EvpKDF;
    });
  }(wu)), wu.exports;
}
var Nu = { exports: {} }, ml;
function je() {
  return ml || (ml = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), dn());
    })(ie, function(n) {
      n.lib.Cipher || function(s) {
        var r = n, i = r.lib, u = i.Base, a = i.WordArray, o = i.BufferedBlockAlgorithm, c = r.enc;
        c.Utf8;
        var l = c.Base64, f = r.algo, h = f.EvpKDF, x = i.Cipher = o.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: u.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(w, S) {
            return this.create(this._ENC_XFORM_MODE, w, S);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(w, S) {
            return this.create(this._DEC_XFORM_MODE, w, S);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(w, S, B) {
            this.cfg = this.cfg.extend(B), this._xformMode = w, this._key = S, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            o.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(w) {
            return this._append(w), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(w) {
            w && this._append(w);
            var S = this._doFinalize();
            return S;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: /* @__PURE__ */ function() {
            function w(S) {
              return typeof S == "string" ? O : y;
            }
            return function(S) {
              return {
                encrypt: function(B, M, P) {
                  return w(M).encrypt(S, B, M, P);
                },
                decrypt: function(B, M, P) {
                  return w(M).decrypt(S, B, M, P);
                }
              };
            };
          }()
        });
        i.StreamCipher = x.extend({
          _doFinalize: function() {
            var w = this._process(!0);
            return w;
          },
          blockSize: 1
        });
        var m = r.mode = {}, p = i.BlockCipherMode = u.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(w, S) {
            return this.Encryptor.create(w, S);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(w, S) {
            return this.Decryptor.create(w, S);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(w, S) {
            this._cipher = w, this._iv = S;
          }
        }), b = m.CBC = function() {
          var w = p.extend();
          w.Encryptor = w.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, M) {
              var P = this._cipher, R = P.blockSize;
              S.call(this, B, M, R), P.encryptBlock(B, M), this._prevBlock = B.slice(M, M + R);
            }
          }), w.Decryptor = w.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(B, M) {
              var P = this._cipher, R = P.blockSize, F = B.slice(M, M + R);
              P.decryptBlock(B, M), S.call(this, B, M, R), this._prevBlock = F;
            }
          });
          function S(B, M, P) {
            var R, F = this._iv;
            F ? (R = F, this._iv = s) : R = this._prevBlock;
            for (var V = 0; V < P; V++)
              B[M + V] ^= R[V];
          }
          return w;
        }(), E = r.pad = {}, g = E.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(w, S) {
            for (var B = S * 4, M = B - w.sigBytes % B, P = M << 24 | M << 16 | M << 8 | M, R = [], F = 0; F < M; F += 4)
              R.push(P);
            var V = a.create(R, M);
            w.concat(V);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(w) {
            var S = w.words[w.sigBytes - 1 >>> 2] & 255;
            w.sigBytes -= S;
          }
        };
        i.BlockCipher = x.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: x.cfg.extend({
            mode: b,
            padding: g
          }),
          reset: function() {
            var w;
            x.reset.call(this);
            var S = this.cfg, B = S.iv, M = S.mode;
            this._xformMode == this._ENC_XFORM_MODE ? w = M.createEncryptor : (w = M.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == w ? this._mode.init(this, B && B.words) : (this._mode = w.call(M, this, B && B.words), this._mode.__creator = w);
          },
          _doProcessBlock: function(w, S) {
            this._mode.processBlock(w, S);
          },
          _doFinalize: function() {
            var w, S = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (S.pad(this._data, this.blockSize), w = this._process(!0)) : (w = this._process(!0), S.unpad(w)), w;
          },
          blockSize: 128 / 32
        });
        var _ = i.CipherParams = u.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(w) {
            this.mixIn(w);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(w) {
            return (w || this.formatter).stringify(this);
          }
        }), T = r.format = {}, C = T.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(w) {
            var S, B = w.ciphertext, M = w.salt;
            return M ? S = a.create([1398893684, 1701076831]).concat(M).concat(B) : S = B, S.toString(l);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(w) {
            var S, B = l.parse(w), M = B.words;
            return M[0] == 1398893684 && M[1] == 1701076831 && (S = a.create(M.slice(2, 4)), M.splice(0, 4), B.sigBytes -= 16), _.create({ ciphertext: B, salt: S });
          }
        }, y = i.SerializableCipher = u.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: u.extend({
            format: C
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(w, S, B, M) {
            M = this.cfg.extend(M);
            var P = w.createEncryptor(B, M), R = P.finalize(S), F = P.cfg;
            return _.create({
              ciphertext: R,
              key: B,
              iv: F.iv,
              algorithm: w,
              mode: F.mode,
              padding: F.padding,
              blockSize: w.blockSize,
              formatter: M.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(w, S, B, M) {
            M = this.cfg.extend(M), S = this._parse(S, M.format);
            var P = w.createDecryptor(B, M).finalize(S.ciphertext);
            return P;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(w, S) {
            return typeof w == "string" ? S.parse(w, this) : w;
          }
        }), v = r.kdf = {}, N = v.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(w, S, B, M, P) {
            if (M || (M = a.random(64 / 8)), P)
              var R = h.create({ keySize: S + B, hasher: P }).compute(w, M);
            else
              var R = h.create({ keySize: S + B }).compute(w, M);
            var F = a.create(R.words.slice(S), B * 4);
            return R.sigBytes = S * 4, _.create({ key: R, iv: F, salt: M });
          }
        }, O = i.PasswordBasedCipher = y.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: y.cfg.extend({
            kdf: N
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(w, S, B, M) {
            M = this.cfg.extend(M);
            var P = M.kdf.execute(B, w.keySize, w.ivSize, M.salt, M.hasher);
            M.iv = P.iv;
            var R = y.encrypt.call(this, w, S, P.key, M);
            return R.mixIn(P), R;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(w, S, B, M) {
            M = this.cfg.extend(M), S = this._parse(S, M.format);
            var P = M.kdf.execute(B, w.keySize, w.ivSize, S.salt, M.hasher);
            M.iv = P.iv;
            var R = y.decrypt.call(this, w, S, P.key, M);
            return R;
          }
        });
      }();
    });
  }(Nu)), Nu.exports;
}
var Iu = { exports: {} }, pl;
function Qy() {
  return pl || (pl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.mode.CFB = function() {
        var s = n.lib.BlockCipherMode.extend();
        s.Encryptor = s.extend({
          processBlock: function(i, u) {
            var a = this._cipher, o = a.blockSize;
            r.call(this, i, u, o, a), this._prevBlock = i.slice(u, u + o);
          }
        }), s.Decryptor = s.extend({
          processBlock: function(i, u) {
            var a = this._cipher, o = a.blockSize, c = i.slice(u, u + o);
            r.call(this, i, u, o, a), this._prevBlock = c;
          }
        });
        function r(i, u, a, o) {
          var c, l = this._iv;
          l ? (c = l.slice(0), this._iv = void 0) : c = this._prevBlock, o.encryptBlock(c, 0);
          for (var f = 0; f < a; f++)
            i[u + f] ^= c[f];
        }
        return s;
      }(), n.mode.CFB;
    });
  }(Iu)), Iu.exports;
}
var Ou = { exports: {} }, gl;
function Ky() {
  return gl || (gl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.mode.CTR = function() {
        var s = n.lib.BlockCipherMode.extend(), r = s.Encryptor = s.extend({
          processBlock: function(i, u) {
            var a = this._cipher, o = a.blockSize, c = this._iv, l = this._counter;
            c && (l = this._counter = c.slice(0), this._iv = void 0);
            var f = l.slice(0);
            a.encryptBlock(f, 0), l[o - 1] = l[o - 1] + 1 | 0;
            for (var h = 0; h < o; h++)
              i[u + h] ^= f[h];
          }
        });
        return s.Decryptor = r, s;
      }(), n.mode.CTR;
    });
  }(Ou)), Ou.exports;
}
var Bu = { exports: {} }, El;
function Zy() {
  return El || (El = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return n.mode.CTRGladman = function() {
        var s = n.lib.BlockCipherMode.extend();
        function r(a) {
          if ((a >> 24 & 255) === 255) {
            var o = a >> 16 & 255, c = a >> 8 & 255, l = a & 255;
            o === 255 ? (o = 0, c === 255 ? (c = 0, l === 255 ? l = 0 : ++l) : ++c) : ++o, a = 0, a += o << 16, a += c << 8, a += l;
          } else
            a += 1 << 24;
          return a;
        }
        function i(a) {
          return (a[0] = r(a[0])) === 0 && (a[1] = r(a[1])), a;
        }
        var u = s.Encryptor = s.extend({
          processBlock: function(a, o) {
            var c = this._cipher, l = c.blockSize, f = this._iv, h = this._counter;
            f && (h = this._counter = f.slice(0), this._iv = void 0), i(h);
            var x = h.slice(0);
            c.encryptBlock(x, 0);
            for (var m = 0; m < l; m++)
              a[o + m] ^= x[m];
          }
        });
        return s.Decryptor = u, s;
      }(), n.mode.CTRGladman;
    });
  }(Bu)), Bu.exports;
}
var ku = { exports: {} }, _l;
function Jy() {
  return _l || (_l = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.mode.OFB = function() {
        var s = n.lib.BlockCipherMode.extend(), r = s.Encryptor = s.extend({
          processBlock: function(i, u) {
            var a = this._cipher, o = a.blockSize, c = this._iv, l = this._keystream;
            c && (l = this._keystream = c.slice(0), this._iv = void 0), a.encryptBlock(l, 0);
            for (var f = 0; f < o; f++)
              i[u + f] ^= l[f];
          }
        });
        return s.Decryptor = r, s;
      }(), n.mode.OFB;
    });
  }(ku)), ku.exports;
}
var Lu = { exports: {} }, Tl;
function eC() {
  return Tl || (Tl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.mode.ECB = function() {
        var s = n.lib.BlockCipherMode.extend();
        return s.Encryptor = s.extend({
          processBlock: function(r, i) {
            this._cipher.encryptBlock(r, i);
          }
        }), s.Decryptor = s.extend({
          processBlock: function(r, i) {
            this._cipher.decryptBlock(r, i);
          }
        }), s;
      }(), n.mode.ECB;
    });
  }(Lu)), Lu.exports;
}
var Mu = { exports: {} }, Al;
function tC() {
  return Al || (Al = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.pad.AnsiX923 = {
        pad: function(s, r) {
          var i = s.sigBytes, u = r * 4, a = u - i % u, o = i + a - 1;
          s.clamp(), s.words[o >>> 2] |= a << 24 - o % 4 * 8, s.sigBytes += a;
        },
        unpad: function(s) {
          var r = s.words[s.sigBytes - 1 >>> 2] & 255;
          s.sigBytes -= r;
        }
      }, n.pad.Ansix923;
    });
  }(Mu)), Mu.exports;
}
var Ru = { exports: {} }, yl;
function nC() {
  return yl || (yl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.pad.Iso10126 = {
        pad: function(s, r) {
          var i = r * 4, u = i - s.sigBytes % i;
          s.concat(n.lib.WordArray.random(u - 1)).concat(n.lib.WordArray.create([u << 24], 1));
        },
        unpad: function(s) {
          var r = s.words[s.sigBytes - 1 >>> 2] & 255;
          s.sigBytes -= r;
        }
      }, n.pad.Iso10126;
    });
  }(Ru)), Ru.exports;
}
var Pu = { exports: {} }, Cl;
function sC() {
  return Cl || (Cl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.pad.Iso97971 = {
        pad: function(s, r) {
          s.concat(n.lib.WordArray.create([2147483648], 1)), n.pad.ZeroPadding.pad(s, r);
        },
        unpad: function(s) {
          n.pad.ZeroPadding.unpad(s), s.sigBytes--;
        }
      }, n.pad.Iso97971;
    });
  }(Pu)), Pu.exports;
}
var Fu = { exports: {} }, Dl;
function rC() {
  return Dl || (Dl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.pad.ZeroPadding = {
        pad: function(s, r) {
          var i = r * 4;
          s.clamp(), s.sigBytes += i - (s.sigBytes % i || i);
        },
        unpad: function(s) {
          for (var r = s.words, i = s.sigBytes - 1, i = s.sigBytes - 1; i >= 0; i--)
            if (r[i >>> 2] >>> 24 - i % 4 * 8 & 255) {
              s.sigBytes = i + 1;
              break;
            }
        }
      }, n.pad.ZeroPadding;
    });
  }(Fu)), Fu.exports;
}
var Hu = { exports: {} }, vl;
function iC() {
  return vl || (vl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return n.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, n.pad.NoPadding;
    });
  }(Hu)), Hu.exports;
}
var Uu = { exports: {} }, Sl;
function uC() {
  return Sl || (Sl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), je());
    })(ie, function(n) {
      return function(s) {
        var r = n, i = r.lib, u = i.CipherParams, a = r.enc, o = a.Hex, c = r.format;
        c.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(l) {
            return l.ciphertext.toString(o);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(l) {
            var f = o.parse(l);
            return u.create({ ciphertext: f });
          }
        };
      }(), n.format.Hex;
    });
  }(Uu)), Uu.exports;
}
var Yu = { exports: {} }, wl;
function aC() {
  return wl || (wl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.BlockCipher, u = s.algo, a = [], o = [], c = [], l = [], f = [], h = [], x = [], m = [], p = [], b = [];
        (function() {
          for (var _ = [], T = 0; T < 256; T++)
            T < 128 ? _[T] = T << 1 : _[T] = T << 1 ^ 283;
          for (var C = 0, y = 0, T = 0; T < 256; T++) {
            var v = y ^ y << 1 ^ y << 2 ^ y << 3 ^ y << 4;
            v = v >>> 8 ^ v & 255 ^ 99, a[C] = v, o[v] = C;
            var N = _[C], O = _[N], w = _[O], S = _[v] * 257 ^ v * 16843008;
            c[C] = S << 24 | S >>> 8, l[C] = S << 16 | S >>> 16, f[C] = S << 8 | S >>> 24, h[C] = S;
            var S = w * 16843009 ^ O * 65537 ^ N * 257 ^ C * 16843008;
            x[v] = S << 24 | S >>> 8, m[v] = S << 16 | S >>> 16, p[v] = S << 8 | S >>> 24, b[v] = S, C ? (C = N ^ _[_[_[w ^ N]]], y ^= _[_[y]]) : C = y = 1;
          }
        })();
        var E = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], g = u.AES = i.extend({
          _doReset: function() {
            var _;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var T = this._keyPriorReset = this._key, C = T.words, y = T.sigBytes / 4, v = this._nRounds = y + 6, N = (v + 1) * 4, O = this._keySchedule = [], w = 0; w < N; w++)
                w < y ? O[w] = C[w] : (_ = O[w - 1], w % y ? y > 6 && w % y == 4 && (_ = a[_ >>> 24] << 24 | a[_ >>> 16 & 255] << 16 | a[_ >>> 8 & 255] << 8 | a[_ & 255]) : (_ = _ << 8 | _ >>> 24, _ = a[_ >>> 24] << 24 | a[_ >>> 16 & 255] << 16 | a[_ >>> 8 & 255] << 8 | a[_ & 255], _ ^= E[w / y | 0] << 24), O[w] = O[w - y] ^ _);
              for (var S = this._invKeySchedule = [], B = 0; B < N; B++) {
                var w = N - B;
                if (B % 4)
                  var _ = O[w];
                else
                  var _ = O[w - 4];
                B < 4 || w <= 4 ? S[B] = _ : S[B] = x[a[_ >>> 24]] ^ m[a[_ >>> 16 & 255]] ^ p[a[_ >>> 8 & 255]] ^ b[a[_ & 255]];
              }
            }
          },
          encryptBlock: function(_, T) {
            this._doCryptBlock(_, T, this._keySchedule, c, l, f, h, a);
          },
          decryptBlock: function(_, T) {
            var C = _[T + 1];
            _[T + 1] = _[T + 3], _[T + 3] = C, this._doCryptBlock(_, T, this._invKeySchedule, x, m, p, b, o);
            var C = _[T + 1];
            _[T + 1] = _[T + 3], _[T + 3] = C;
          },
          _doCryptBlock: function(_, T, C, y, v, N, O, w) {
            for (var S = this._nRounds, B = _[T] ^ C[0], M = _[T + 1] ^ C[1], P = _[T + 2] ^ C[2], R = _[T + 3] ^ C[3], F = 4, V = 1; V < S; V++) {
              var W = y[B >>> 24] ^ v[M >>> 16 & 255] ^ N[P >>> 8 & 255] ^ O[R & 255] ^ C[F++], K = y[M >>> 24] ^ v[P >>> 16 & 255] ^ N[R >>> 8 & 255] ^ O[B & 255] ^ C[F++], Q = y[P >>> 24] ^ v[R >>> 16 & 255] ^ N[B >>> 8 & 255] ^ O[M & 255] ^ C[F++], L = y[R >>> 24] ^ v[B >>> 16 & 255] ^ N[M >>> 8 & 255] ^ O[P & 255] ^ C[F++];
              B = W, M = K, P = Q, R = L;
            }
            var W = (w[B >>> 24] << 24 | w[M >>> 16 & 255] << 16 | w[P >>> 8 & 255] << 8 | w[R & 255]) ^ C[F++], K = (w[M >>> 24] << 24 | w[P >>> 16 & 255] << 16 | w[R >>> 8 & 255] << 8 | w[B & 255]) ^ C[F++], Q = (w[P >>> 24] << 24 | w[R >>> 16 & 255] << 16 | w[B >>> 8 & 255] << 8 | w[M & 255]) ^ C[F++], L = (w[R >>> 24] << 24 | w[B >>> 16 & 255] << 16 | w[M >>> 8 & 255] << 8 | w[P & 255]) ^ C[F++];
            _[T] = W, _[T + 1] = K, _[T + 2] = Q, _[T + 3] = L;
          },
          keySize: 256 / 32
        });
        s.AES = i._createHelper(g);
      }(), n.AES;
    });
  }(Yu)), Yu.exports;
}
var qu = { exports: {} }, Nl;
function oC() {
  return Nl || (Nl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.WordArray, u = r.BlockCipher, a = s.algo, o = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], c = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], l = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], f = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], h = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], x = a.DES = u.extend({
          _doReset: function() {
            for (var E = this._key, g = E.words, _ = [], T = 0; T < 56; T++) {
              var C = o[T] - 1;
              _[T] = g[C >>> 5] >>> 31 - C % 32 & 1;
            }
            for (var y = this._subKeys = [], v = 0; v < 16; v++) {
              for (var N = y[v] = [], O = l[v], T = 0; T < 24; T++)
                N[T / 6 | 0] |= _[(c[T] - 1 + O) % 28] << 31 - T % 6, N[4 + (T / 6 | 0)] |= _[28 + (c[T + 24] - 1 + O) % 28] << 31 - T % 6;
              N[0] = N[0] << 1 | N[0] >>> 31;
              for (var T = 1; T < 7; T++)
                N[T] = N[T] >>> (T - 1) * 4 + 3;
              N[7] = N[7] << 5 | N[7] >>> 27;
            }
            for (var w = this._invSubKeys = [], T = 0; T < 16; T++)
              w[T] = y[15 - T];
          },
          encryptBlock: function(E, g) {
            this._doCryptBlock(E, g, this._subKeys);
          },
          decryptBlock: function(E, g) {
            this._doCryptBlock(E, g, this._invSubKeys);
          },
          _doCryptBlock: function(E, g, _) {
            this._lBlock = E[g], this._rBlock = E[g + 1], m.call(this, 4, 252645135), m.call(this, 16, 65535), p.call(this, 2, 858993459), p.call(this, 8, 16711935), m.call(this, 1, 1431655765);
            for (var T = 0; T < 16; T++) {
              for (var C = _[T], y = this._lBlock, v = this._rBlock, N = 0, O = 0; O < 8; O++)
                N |= f[O][((v ^ C[O]) & h[O]) >>> 0];
              this._lBlock = v, this._rBlock = y ^ N;
            }
            var w = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = w, m.call(this, 1, 1431655765), p.call(this, 8, 16711935), p.call(this, 2, 858993459), m.call(this, 16, 65535), m.call(this, 4, 252645135), E[g] = this._lBlock, E[g + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function m(E, g) {
          var _ = (this._lBlock >>> E ^ this._rBlock) & g;
          this._rBlock ^= _, this._lBlock ^= _ << E;
        }
        function p(E, g) {
          var _ = (this._rBlock >>> E ^ this._lBlock) & g;
          this._lBlock ^= _, this._rBlock ^= _ << E;
        }
        s.DES = u._createHelper(x);
        var b = a.TripleDES = u.extend({
          _doReset: function() {
            var E = this._key, g = E.words;
            if (g.length !== 2 && g.length !== 4 && g.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var _ = g.slice(0, 2), T = g.length < 4 ? g.slice(0, 2) : g.slice(2, 4), C = g.length < 6 ? g.slice(0, 2) : g.slice(4, 6);
            this._des1 = x.createEncryptor(i.create(_)), this._des2 = x.createEncryptor(i.create(T)), this._des3 = x.createEncryptor(i.create(C));
          },
          encryptBlock: function(E, g) {
            this._des1.encryptBlock(E, g), this._des2.decryptBlock(E, g), this._des3.encryptBlock(E, g);
          },
          decryptBlock: function(E, g) {
            this._des3.decryptBlock(E, g), this._des2.encryptBlock(E, g), this._des1.decryptBlock(E, g);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        s.TripleDES = u._createHelper(b);
      }(), n.TripleDES;
    });
  }(qu)), qu.exports;
}
var $u = { exports: {} }, Il;
function cC() {
  return Il || (Il = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.StreamCipher, u = s.algo, a = u.RC4 = i.extend({
          _doReset: function() {
            for (var l = this._key, f = l.words, h = l.sigBytes, x = this._S = [], m = 0; m < 256; m++)
              x[m] = m;
            for (var m = 0, p = 0; m < 256; m++) {
              var b = m % h, E = f[b >>> 2] >>> 24 - b % 4 * 8 & 255;
              p = (p + x[m] + E) % 256;
              var g = x[m];
              x[m] = x[p], x[p] = g;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(l, f) {
            l[f] ^= o.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function o() {
          for (var l = this._S, f = this._i, h = this._j, x = 0, m = 0; m < 4; m++) {
            f = (f + 1) % 256, h = (h + l[f]) % 256;
            var p = l[f];
            l[f] = l[h], l[h] = p, x |= l[(l[f] + l[h]) % 256] << 24 - m * 8;
          }
          return this._i = f, this._j = h, x;
        }
        s.RC4 = i._createHelper(a);
        var c = u.RC4Drop = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: a.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            a._doReset.call(this);
            for (var l = this.cfg.drop; l > 0; l--)
              o.call(this);
          }
        });
        s.RC4Drop = i._createHelper(c);
      }(), n.RC4;
    });
  }($u)), $u.exports;
}
var Wu = { exports: {} }, Ol;
function lC() {
  return Ol || (Ol = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.StreamCipher, u = s.algo, a = [], o = [], c = [], l = u.Rabbit = i.extend({
          _doReset: function() {
            for (var h = this._key.words, x = this.cfg.iv, m = 0; m < 4; m++)
              h[m] = (h[m] << 8 | h[m] >>> 24) & 16711935 | (h[m] << 24 | h[m] >>> 8) & 4278255360;
            var p = this._X = [
              h[0],
              h[3] << 16 | h[2] >>> 16,
              h[1],
              h[0] << 16 | h[3] >>> 16,
              h[2],
              h[1] << 16 | h[0] >>> 16,
              h[3],
              h[2] << 16 | h[1] >>> 16
            ], b = this._C = [
              h[2] << 16 | h[2] >>> 16,
              h[0] & 4294901760 | h[1] & 65535,
              h[3] << 16 | h[3] >>> 16,
              h[1] & 4294901760 | h[2] & 65535,
              h[0] << 16 | h[0] >>> 16,
              h[2] & 4294901760 | h[3] & 65535,
              h[1] << 16 | h[1] >>> 16,
              h[3] & 4294901760 | h[0] & 65535
            ];
            this._b = 0;
            for (var m = 0; m < 4; m++)
              f.call(this);
            for (var m = 0; m < 8; m++)
              b[m] ^= p[m + 4 & 7];
            if (x) {
              var E = x.words, g = E[0], _ = E[1], T = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, C = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360, y = T >>> 16 | C & 4294901760, v = C << 16 | T & 65535;
              b[0] ^= T, b[1] ^= y, b[2] ^= C, b[3] ^= v, b[4] ^= T, b[5] ^= y, b[6] ^= C, b[7] ^= v;
              for (var m = 0; m < 4; m++)
                f.call(this);
            }
          },
          _doProcessBlock: function(h, x) {
            var m = this._X;
            f.call(this), a[0] = m[0] ^ m[5] >>> 16 ^ m[3] << 16, a[1] = m[2] ^ m[7] >>> 16 ^ m[5] << 16, a[2] = m[4] ^ m[1] >>> 16 ^ m[7] << 16, a[3] = m[6] ^ m[3] >>> 16 ^ m[1] << 16;
            for (var p = 0; p < 4; p++)
              a[p] = (a[p] << 8 | a[p] >>> 24) & 16711935 | (a[p] << 24 | a[p] >>> 8) & 4278255360, h[x + p] ^= a[p];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function f() {
          for (var h = this._X, x = this._C, m = 0; m < 8; m++)
            o[m] = x[m];
          x[0] = x[0] + 1295307597 + this._b | 0, x[1] = x[1] + 3545052371 + (x[0] >>> 0 < o[0] >>> 0 ? 1 : 0) | 0, x[2] = x[2] + 886263092 + (x[1] >>> 0 < o[1] >>> 0 ? 1 : 0) | 0, x[3] = x[3] + 1295307597 + (x[2] >>> 0 < o[2] >>> 0 ? 1 : 0) | 0, x[4] = x[4] + 3545052371 + (x[3] >>> 0 < o[3] >>> 0 ? 1 : 0) | 0, x[5] = x[5] + 886263092 + (x[4] >>> 0 < o[4] >>> 0 ? 1 : 0) | 0, x[6] = x[6] + 1295307597 + (x[5] >>> 0 < o[5] >>> 0 ? 1 : 0) | 0, x[7] = x[7] + 3545052371 + (x[6] >>> 0 < o[6] >>> 0 ? 1 : 0) | 0, this._b = x[7] >>> 0 < o[7] >>> 0 ? 1 : 0;
          for (var m = 0; m < 8; m++) {
            var p = h[m] + x[m], b = p & 65535, E = p >>> 16, g = ((b * b >>> 17) + b * E >>> 15) + E * E, _ = ((p & 4294901760) * p | 0) + ((p & 65535) * p | 0);
            c[m] = g ^ _;
          }
          h[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, h[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, h[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, h[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, h[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, h[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, h[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, h[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        s.Rabbit = i._createHelper(l);
      }(), n.Rabbit;
    });
  }(Wu)), Wu.exports;
}
var zu = { exports: {} }, Bl;
function dC() {
  return Bl || (Bl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.StreamCipher, u = s.algo, a = [], o = [], c = [], l = u.RabbitLegacy = i.extend({
          _doReset: function() {
            var h = this._key.words, x = this.cfg.iv, m = this._X = [
              h[0],
              h[3] << 16 | h[2] >>> 16,
              h[1],
              h[0] << 16 | h[3] >>> 16,
              h[2],
              h[1] << 16 | h[0] >>> 16,
              h[3],
              h[2] << 16 | h[1] >>> 16
            ], p = this._C = [
              h[2] << 16 | h[2] >>> 16,
              h[0] & 4294901760 | h[1] & 65535,
              h[3] << 16 | h[3] >>> 16,
              h[1] & 4294901760 | h[2] & 65535,
              h[0] << 16 | h[0] >>> 16,
              h[2] & 4294901760 | h[3] & 65535,
              h[1] << 16 | h[1] >>> 16,
              h[3] & 4294901760 | h[0] & 65535
            ];
            this._b = 0;
            for (var b = 0; b < 4; b++)
              f.call(this);
            for (var b = 0; b < 8; b++)
              p[b] ^= m[b + 4 & 7];
            if (x) {
              var E = x.words, g = E[0], _ = E[1], T = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, C = (_ << 8 | _ >>> 24) & 16711935 | (_ << 24 | _ >>> 8) & 4278255360, y = T >>> 16 | C & 4294901760, v = C << 16 | T & 65535;
              p[0] ^= T, p[1] ^= y, p[2] ^= C, p[3] ^= v, p[4] ^= T, p[5] ^= y, p[6] ^= C, p[7] ^= v;
              for (var b = 0; b < 4; b++)
                f.call(this);
            }
          },
          _doProcessBlock: function(h, x) {
            var m = this._X;
            f.call(this), a[0] = m[0] ^ m[5] >>> 16 ^ m[3] << 16, a[1] = m[2] ^ m[7] >>> 16 ^ m[5] << 16, a[2] = m[4] ^ m[1] >>> 16 ^ m[7] << 16, a[3] = m[6] ^ m[3] >>> 16 ^ m[1] << 16;
            for (var p = 0; p < 4; p++)
              a[p] = (a[p] << 8 | a[p] >>> 24) & 16711935 | (a[p] << 24 | a[p] >>> 8) & 4278255360, h[x + p] ^= a[p];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function f() {
          for (var h = this._X, x = this._C, m = 0; m < 8; m++)
            o[m] = x[m];
          x[0] = x[0] + 1295307597 + this._b | 0, x[1] = x[1] + 3545052371 + (x[0] >>> 0 < o[0] >>> 0 ? 1 : 0) | 0, x[2] = x[2] + 886263092 + (x[1] >>> 0 < o[1] >>> 0 ? 1 : 0) | 0, x[3] = x[3] + 1295307597 + (x[2] >>> 0 < o[2] >>> 0 ? 1 : 0) | 0, x[4] = x[4] + 3545052371 + (x[3] >>> 0 < o[3] >>> 0 ? 1 : 0) | 0, x[5] = x[5] + 886263092 + (x[4] >>> 0 < o[4] >>> 0 ? 1 : 0) | 0, x[6] = x[6] + 1295307597 + (x[5] >>> 0 < o[5] >>> 0 ? 1 : 0) | 0, x[7] = x[7] + 3545052371 + (x[6] >>> 0 < o[6] >>> 0 ? 1 : 0) | 0, this._b = x[7] >>> 0 < o[7] >>> 0 ? 1 : 0;
          for (var m = 0; m < 8; m++) {
            var p = h[m] + x[m], b = p & 65535, E = p >>> 16, g = ((b * b >>> 17) + b * E >>> 15) + E * E, _ = ((p & 4294901760) * p | 0) + ((p & 65535) * p | 0);
            c[m] = g ^ _;
          }
          h[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, h[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, h[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, h[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, h[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, h[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, h[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, h[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        s.RabbitLegacy = i._createHelper(l);
      }(), n.RabbitLegacy;
    });
  }(zu)), zu.exports;
}
var Vu = { exports: {} }, kl;
function fC() {
  return kl || (kl = 1, function(t, e) {
    (function(n, s, r) {
      t.exports = s(he(), Fn(), Hn(), dn(), je());
    })(ie, function(n) {
      return function() {
        var s = n, r = s.lib, i = r.BlockCipher, u = s.algo;
        const a = 16, o = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], c = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var l = {
          pbox: [],
          sbox: []
        };
        function f(b, E) {
          let g = E >> 24 & 255, _ = E >> 16 & 255, T = E >> 8 & 255, C = E & 255, y = b.sbox[0][g] + b.sbox[1][_];
          return y = y ^ b.sbox[2][T], y = y + b.sbox[3][C], y;
        }
        function h(b, E, g) {
          let _ = E, T = g, C;
          for (let y = 0; y < a; ++y)
            _ = _ ^ b.pbox[y], T = f(b, _) ^ T, C = _, _ = T, T = C;
          return C = _, _ = T, T = C, T = T ^ b.pbox[a], _ = _ ^ b.pbox[a + 1], { left: _, right: T };
        }
        function x(b, E, g) {
          let _ = E, T = g, C;
          for (let y = a + 1; y > 1; --y)
            _ = _ ^ b.pbox[y], T = f(b, _) ^ T, C = _, _ = T, T = C;
          return C = _, _ = T, T = C, T = T ^ b.pbox[1], _ = _ ^ b.pbox[0], { left: _, right: T };
        }
        function m(b, E, g) {
          for (let v = 0; v < 4; v++) {
            b.sbox[v] = [];
            for (let N = 0; N < 256; N++)
              b.sbox[v][N] = c[v][N];
          }
          let _ = 0;
          for (let v = 0; v < a + 2; v++)
            b.pbox[v] = o[v] ^ E[_], _++, _ >= g && (_ = 0);
          let T = 0, C = 0, y = 0;
          for (let v = 0; v < a + 2; v += 2)
            y = h(b, T, C), T = y.left, C = y.right, b.pbox[v] = T, b.pbox[v + 1] = C;
          for (let v = 0; v < 4; v++)
            for (let N = 0; N < 256; N += 2)
              y = h(b, T, C), T = y.left, C = y.right, b.sbox[v][N] = T, b.sbox[v][N + 1] = C;
          return !0;
        }
        var p = u.Blowfish = i.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var b = this._keyPriorReset = this._key, E = b.words, g = b.sigBytes / 4;
              m(l, E, g);
            }
          },
          encryptBlock: function(b, E) {
            var g = h(l, b[E], b[E + 1]);
            b[E] = g.left, b[E + 1] = g.right;
          },
          decryptBlock: function(b, E) {
            var g = x(l, b[E], b[E + 1]);
            b[E] = g.left, b[E + 1] = g.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        s.Blowfish = i._createHelper(p);
      }(), n.Blowfish;
    });
  }(Vu)), Vu.exports;
}
(function(t, e) {
  (function(n, s, r) {
    t.exports = s(he(), Fi(), qy(), $y(), Fn(), Wy(), Hn(), Xh(), T0(), zy(), Qh(), Vy(), jy(), Gy(), A0(), Xy(), dn(), je(), Qy(), Ky(), Zy(), Jy(), eC(), tC(), nC(), sC(), rC(), iC(), uC(), aC(), oC(), cC(), lC(), dC(), fC());
  })(ie, function(n) {
    return n;
  });
})(Gh);
var hC = Gh.exports;
const vs = /* @__PURE__ */ rs(hC);
ue.extend($l);
ue.extend(zl);
ue.locale("en");
ue.tz.setDefault("America/New_York");
const Ll = /* @__PURE__ */ new Set(), Ml = /* @__PURE__ */ new Set(), kr = /* @__PURE__ */ new Set(), a9 = ({
  symbols: t = [],
  stock_filters: e = [],
  abortMounted: n = !1,
  server_urls: s = {},
  fetchHistoricalData: r,
  useExternalSecretToken: i
}) => {
  const u = Fe({}), a = Fe([]), o = Fe([]), c = Fe([]), l = Fe(!1), f = () => {
    const y = ue.tz(Date.now(), "America/New_York").format("ddd, D MMM YYYY");
    return vs.MD5(y).toString();
  }, h = async (y) => {
    try {
      const v = ue.tz(Date.now(), "America/New_York").format("ddd, D MMM YYYY"), N = vs.MD5(v).toString(), O = {
        secretToken: i || N,
        Accept: "application/json"
      }, w = {
        mtd: "getCompanyBySymbol.json",
        method: "proxy",
        symbol: y,
        fromDB: "off",
        secret: O.secretToken
      }, S = await Te.get(s["/proxyServerAddress"], {
        params: w,
        headers: O
      });
      if (!S.data || typeof S.data != "object")
        return kr.has(y) || (console.error(`[YTD] Malformed or non-JSON response for symbol: ${y}`, S.data), kr.add(y)), null;
      if (S.status !== 200) throw new Error("error fething stock ytd data");
      let B = 0, M = 0;
      if (S.data.results && S.data.results.company && S.data.results.company[0]) {
        const { pricechange: P } = S.data.results.company[0].shareinfo;
        B = typeof P.yeartodatepct == "number" ? P.yeartodatepct.toFixed(2) : 0, M = typeof P.yeartodate == "number" ? P.yeartodate.toFixed(2) : 0;
      }
      return {
        YTD_CHG: M,
        YTD_PCT: B
      };
    } catch (v) {
      Ml.has(y) || (console.error(`${y} STOCK ERROR`, v), Ml.add(y));
    }
  }, x = async (y, v) => {
    try {
      const N = {
        filter: `SYMBOL IN (${y})`,
        limit: 1,
        fields: "BID,PE_RATIO, VOLUME, TRADES, FLOAT, SHORT_INTEREST,SHORT_INTEREST_RATIO, SYMBOL, NAME, LAST,LAST_TRADE_TIME, NET_CHG, PC_CHG, MARKET_CAP, HIGH_52W, LOW_52W, LOW, HIGH, DAY_RANGE, MARKET, YTD_CHG, YTD_PCT",
        prevDay: ue.tz(Date.now(), "America/New_York").isBefore(ue.tz(Date.now(), "America/New_York").hour(8).minute(0).second(0))
      };
      return await Te.post(s["/httpQueryBasedFilterServer"], N, {
        headers: v
      });
    } catch (N) {
      return console.error("Error fetching stocks data:", N), { data: [] };
    }
  }, m = async ({ newSymbols: y }) => {
    const v = ue.tz(Date.now(), "America/New_York").format("ddd, D MMM YYYY"), O = {
      secretToken: vs.MD5(v).toString(),
      Accept: "application/json"
    }, w = y.map((B) => `'${B}'`).join(","), S = await x(w, O);
    if (S.data.length > 0) {
      const B = {};
      let M = S.data.map((P) => {
        const R = u.value[P.SYMBOL]?.YTD_CHG || 0, F = u.value[P.SYMBOL]?.YTD_PCT || 0, V = u.value[P.SYMBOL]?.HISTORIC_DATA || null, W = V?.map((Q) => Q.close) || [], K = V?.map((Q) => Q.date) || [];
        return {
          ...P,
          symbol: P.SYMBOL,
          HISTORIC_DATA: V,
          prices: W,
          labels: K,
          YTD_CHG: R,
          YTD_PCT: F
        };
      });
      if (r) {
        const P = S.data.map(async (R) => {
          const F = R.SYMBOL;
          let V = null;
          r || (V = await g(F));
          const W = V?.map((Q) => Q.close) || [], K = V?.map((Q) => Q.date) || [];
          return { symbol: F, item: R, HISTORIC_DATA: V, prices: W, labels: K };
        });
        M = await Promise.all(P);
      }
      M.forEach((P) => {
        B[P.symbol] = { ...P };
      }), u.value = { ...B };
    }
  }, p = async () => {
    const v = {
      secretToken: f(),
      Accept: "application/json"
    }, N = {
      filter: "VOLUME > 5000000 AND MARKET_CAP > 2000000000 AND MARKET IN ('NGS', 'NYE', 'AMX') ORDER BY VOLUME DESC LIMIT 20",
      fields: "SYMBOL,NAME,PC_CHG,NET_CHG, BID",
      prevDay: ue.tz(Date.now(), "America/New_York").isBefore(ue.tz(Date.now(), "America/New_York").hour(8).minute(0).second(0))
    };
    return (await Te.post(s["/httpQueryBasedFilterServer"], N, {
      headers: v
    })).data;
  }, b = async () => {
    const v = {
      secretToken: f(),
      Accept: "application/json"
    }, N = {
      filter: "VOLUME > 5000000 AND MARKET_CAP > 2000000000 AND MARKET IN ('NGS', 'NYE', 'AMX') AND PC_CHG > 0 ORDER BY PC_CHG DESC LIMIT 20",
      fields: "SYMBOL,NAME,PC_CHG,NET_CHG,BID",
      prevDay: ue().isBefore(ue().hour(8).minute(0).second(0))
    };
    return (await Te.post(s["/httpQueryBasedFilterServer"], N, {
      headers: v
    })).data;
  }, E = async () => {
    const v = {
      secretToken: f(),
      Accept: "application/json"
    }, N = {
      filter: "PC_CHG < -2.5 AND MARKET_CAP > 1000000000 AND MARKET_CAP < 10000000000000 AND VOLUME > 20000 AND MARKET IN ('NGS', 'NYE', 'AMX') ORDER BY PC_CHG ASC LIMIT 20",
      fields: "SYMBOL,NAME,PC_CHG,NET_CHG,BID",
      prevDay: ue().isBefore(ue().hour(8).minute(0).second(0))
    };
    return (await Te.post(s["/httpQueryBasedFilterServer"], N, {
      headers: v
    })).data;
  }, g = async (y, v = "15D") => {
    try {
      const N = ue(Date.now()).format("ddd, D MMM YYYY"), O = vs.MD5(N).toString(), w = {
        secretToken: O,
        Accept: "application/json"
      }, S = ue().format("YYYY-MM-DD");
      let B;
      switch (v) {
        case "1D":
          B = ue().subtract(1, "day").format("YYYY-MM-DD");
          break;
        case "5D":
          B = ue().subtract(5, "day").format("YYYY-MM-DD");
          break;
        case "1M":
          B = ue().subtract(1, "month").format("YYYY-MM-DD");
          break;
        case "6M":
          B = ue().subtract(6, "month").format("YYYY-MM-DD");
          break;
        case "1Y":
          B = ue().subtract(1, "year").format("YYYY-MM-DD");
          break;
        case "5Y":
          B = ue().subtract(5, "year").format("YYYY-MM-DD");
          break;
        case "ALL":
          B = "1900-01-01";
          break;
        case "15D":
        default:
          B = ue().subtract(15, "day").format("YYYY-MM-DD");
      }
      if (ue(S).isAfter(ue()))
        return console.warn("[fetchHistoricalData] End date is in the future", { symbol: y, end: S }), null;
      const M = ue(S).day();
      [6, 0].includes(M) && console.warn("[fetchHistoricalData] End date is a weekend", { symbol: y, end: S, endDay: M });
      const P = await Te.get(s["/proxyServerAddress"], {
        headers: w,
        params: {
          mtd: "getEnhancedChartData.json",
          start: B,
          end: S,
          symbol: y,
          method: "proxy",
          dataType: "eod",
          secret: O,
          volume: !0,
          freq: "day"
        },
        timeout: 15e3
      });
      return !P.data || typeof P.data != "object" ? (kr.has(y) || (console.error(
        `[Historical] Malformed or non-JSON response for symbol: ${y}`,
        P.data
      ), kr.add(y)), null) : P.data?.results ? P.data.results.history[0].eoddata : [];
    } catch (N) {
      return console.error(`[fetchHistoricalData] ERROR for symbol: ${y}`, N), Ll.has(y) || Ll.add(y), null;
    }
  }, _ = async (y) => {
    const v = ue.tz(Date.now(), "America/New_York").format("ddd, D MMM YYYY"), O = {
      secretToken: vs.MD5(v).toString(),
      Accept: "application/json"
    }, w = {
      filter: `SECTOR = '${y}' AND VOLUME > 20000 AND MARKET_CAP > 1000000000 ORDER BY ABS(PC_CHG) DESC LIMIT 10`,
      fields: "SYMBOL,NAME,PC_CHG,NET_CHG,BID,SECTOR",
      prevDay: ue.tz(Date.now(), "America/New_York").isBefore(ue.tz(Date.now(), "America/New_York").hour(8).minute(0).second(0))
    };
    return (await Te.post(s["/httpQueryBasedFilterServer"], w, {
      headers: O
    })).data;
  }, T = () => ({
    secretToken: f(),
    Accept: "application/json"
  }), C = Fe(1);
  return Qn(
    t,
    async (y, v) => {
      if (typeof y > "u" || y && y.length === 0)
        return;
      await m({ newSymbols: y });
      const N = setInterval(async () => {
        C.value++;
        try {
          await m({ newSymbols: y });
        } catch (O) {
          clearInterval(N), console.error("Interval error:", O);
        }
      }, 1e4);
    },
    {
      immediate: !0
      // deep: true
    }
  ), Qn(u, (y) => {
    l.value || (Object.keys(y).forEach(async (v) => {
      const N = await h(v);
      if (N) {
        const O = u.value[v];
        u.value[v] = { ...O, ...N };
      }
    }), l.value = !0);
  }), Ct(async () => {
    if (n) return;
    const y = sessionStorage.getItem("mostActive");
    y && (a.value = JSON.parse(y));
    const v = sessionStorage.getItem("topGainers");
    v && (o.value = JSON.parse(v));
    const N = sessionStorage.getItem("topLosers");
    if (N && (c.value = JSON.parse(N)), e.includes("most_active"))
      try {
        const O = await p();
        if (O) {
          const w = O.map(async (M) => {
            const P = await g(M.SYMBOL, "5D");
            return {
              ...M,
              HISTORIC_DATA: P
            };
          }), S = await Promise.all(w);
          sessionStorage.setItem("mostActive", JSON.stringify(S));
          const B = S.map((M) => ({
            ...M,
            BID: M.BID * (Math.random() * 2 + 0.5)
          }));
          a.value = B;
        }
      } catch {
      }
    if (e.includes("top_gainers"))
      try {
        const O = await b();
        if (O) {
          const w = O.map(async (B) => {
            const M = await g(B.SYMBOL, "5D");
            return {
              ...B,
              HISTORIC_DATA: M
            };
          }), S = await Promise.all(w);
          sessionStorage.setItem("topGainers", JSON.stringify(S)), o.value = S;
        }
      } catch (O) {
        console.error("Interval error:", O);
      }
    if (e.includes("top_losers"))
      try {
        const O = await E();
        if (O) {
          const w = O.map(async (B) => {
            const M = await g(B.SYMBOL, "5D");
            return {
              ...B,
              HISTORIC_DATA: M
            };
          }), S = await Promise.all(w);
          sessionStorage.setItem("topLosers", JSON.stringify(S)), c.value = S;
        }
      } catch (O) {
        console.error("Interval error:", O);
      }
  }), {
    stocks: u,
    getStocksYTD: h,
    taskFetchInfo: m,
    fetchStocksData: x,
    getHistoricalData: g,
    createSecretToken: f,
    mostActiveStocks: a,
    topGainerStocks: o,
    topLoserStocks: c,
    fetchStocksBySector: _,
    createHeaders: T
  };
};
export {
  FC as AdButlerBanner,
  MC as AdButlerGrid,
  PC as AdButlerItem,
  RC as AdButlerModal,
  BC as CookieConsent,
  kC as ReferencedStocks,
  LC as ReferencedStocksSidebar,
  HC as StockSummaryItem,
  qC as TopGainerBlock,
  Hc as TopGainerChart,
  DC as calculateReadingTime,
  Gg as checkCookieConsent,
  AC as dateFormat,
  IC as extractStockSymbols,
  wC as filterCategory,
  TC as formatCommentDate,
  SC as formatLink,
  NC as formatNumber,
  jg as getCookie,
  yC as isResolution,
  _C as isWithinTimeRanges,
  vC as shuffleArray,
  OC as stockSymbolMatcherRegex,
  CC as truncateText,
  a9 as useStockInfo
};
